const de = {
  "artworkModals": {
    "common": {
      "cancel": "Abbrechen",
      "add": "Hinzufügen",
      "save": "Speichern",
      "delete": "Löschen",
      "close": "Schließen",
      "browse": "Durchsuchen",
      "uploading": "Wird hochgeladen…",
      "saving": "Wird gespeichert…",
      "notes": "Notizen",
      "height": "Höhe (H)",
      "width": "Breite (B)",
      "depth": "Tiefe (T)",
      "unit": "Einheit",
      "centimeters": "Zentimeter",
      "inches": "Zoll",
      "inchesHelp": "Verwenden Sie für Zollmaße Dezimalzahlen, zum Beispiel 10,5 statt 10 1/2.",
      "dimensionsPositive": "Die Maße müssen größer als null sein."
    },
    "document": {
      "title": "Dokument hinzufügen",
      "types": {
        "certificate": "Echtheitszertifikat",
        "invoice": "Rechnung",
        "conditionReport": "Zustandsbericht",
        "exhibition": "Ausstellungsunterlagen",
        "other": "Sonstiges"
      },
      "errors": {
        "tooLarge": "Die Datei {{name}} überschreitet die maximale Größe von 30 MB.",
        "nameRequired": "Geben Sie einen Dokumentnamen ein.",
        "typeRequired": "Wählen Sie einen Dokumenttyp aus.",
        "fileRequired": "Wählen Sie eine Datei aus.",
        "upload": "Fehler beim Hochladen: {{message}}"
      },
      "fields": {
        "type": "Dokumenttyp",
        "selectType": "Typ auswählen…",
        "name": "Dokumentname",
        "namePlaceholder": "Dokumentname"
      },
      "actions": {
        "remove": "Entfernen"
      },
      "dropzone": "Datei hierher ziehen und ablegen",
      "maxSize": "Maximale Größe: 30 MB"
    },
    "donation": {
      "title": "Dieses Kunstwerk spenden",
      "errors": {
        "save": "Fehler beim Speichern der Spende."
      },
      "fields": {
        "valuation": "Geschätzter Wert (€)",
        "recipient": "Empfänger",
        "date": "Spendendatum"
      },
      "receiptHelp": "Für die Spendenbescheinigung",
      "placeholders": {
        "recipient": "Museum, Stiftung, Verein…",
        "notes": "Zusätzliche Informationen zur Spende"
      },
      "actions": {
        "confirm": "Spende bestätigen"
      }
    },
    "duration": {
      "title": "Dauer hinzufügen",
      "description": "Geben Sie die Dauer dieses Kunstwerks an. Dies gilt für Videos, Performances, temporäre Installationen und Klangkunst.",
      "inputFormat": "Eingabeformat",
      "simple": "Freitext",
      "detailed": "Detailliert (h/min/s)",
      "duration": "Dauer",
      "placeholder": "Z. B. 12 Min. 30 Sek., 1 Std. 45 Min., Endlosschleife…",
      "examples": "Beispiele: „12 Min.“, „1 Std. 30 Min.“, „2 Std. 45 Min. 30 Sek.“, „Endlosschleife“…",
      "presets": "Vordefinierte Dauer",
      "infiniteLoop": "Endlosschleife",
      "hours": "Stunden",
      "minutes": "Minuten",
      "seconds": "Sekunden",
      "preview": "Vorschau:",
      "none": "(Keine Dauer angegeben)",
      "errors": {
        "required": "Geben Sie eine Dauer an."
      }
    },
    "frameSize": {
      "title": "Gerahmte Maße hinzufügen",
      "description": "Geben Sie die Maße des Kunstwerks einschließlich Rahmen ein. Standardmäßig schlagen wir Maße vor, die 20 % größer als das Kunstwerk selbst sind."
    },
    "imageUpload": {
      "title": "Bilder hinzufügen",
      "errors": {
        "unsupported": "Die Datei {{name}} hat kein unterstütztes Bildformat.",
        "tooLarge": "Die Datei {{name}} überschreitet die maximale Größe von 30 MB.",
        "required": "Wählen Sie mindestens ein Bild aus.",
        "uploadFile": "Fehler beim Hochladen von {{name}}: {{message}}",
        "publicUrl": "Die öffentliche URL für {{name}} konnte nicht abgerufen werden.",
        "noneUploaded": "Es konnte kein Bild hochgeladen werden.",
        "upload": "Beim Hochladen der Bilder ist ein Fehler aufgetreten."
      },
      "dropzone": "Bilder hierher ziehen und ablegen",
      "limits": "Bis zu 10 Bilder. Maximale Größe: 30 MB pro Bild.",
      "formats": "Unterstützte Formate: JPEG, PNG, WEBP",
      "selected": "Ausgewählte Bilder ({{count}})",
      "progress": "Fortschritt",
      "actions": {
        "upload": "Bilder hochladen"
      }
    },
    "insurance": {
      "title": "Versicherungsdetails",
      "notProvided": "Nicht angegeben",
      "notSpecified": "Nicht näher angegeben",
      "notSpecifiedFeminine": "Nicht angegeben",
      "invalidDate": "Ungültiges Format",
      "fields": {
        "insurer": "Versicherer",
        "policyNumber": "Policennummer",
        "period": "Versicherungszeitraum",
        "coverageAmount": "Versicherungssumme",
        "coverage": "Deckung",
        "premium": "Jahresprämie",
        "deductible": "Selbstbehalt"
      },
      "actions": {
        "manage": "Versicherung verwalten"
      }
    },
    "loan": {
      "title": "Leihgabe erfassen",
      "returnTitle": "Leihgabe beenden",
      "errors": {
        "save": "Fehler beim Speichern."
      },
      "currentInfo": "Dieses Kunstwerk ist derzeit an {{institution}} ausgeliehen. Durch die Rückgabebestätigung wird es als verfügbar markiert.",
      "unknownInstitution": "eine Institution",
      "fields": {
        "institution": "Institution / Empfänger",
        "contact": "Kontakt vor Ort",
        "startDate": "Beginn der Leihgabe",
        "endDate": "Ende der Leihgabe",
        "contractReference": "Vertragsreferenz",
        "insuranceRequired": "Versicherung erforderlich"
      },
      "placeholders": {
        "institution": "Museum für Moderne Kunst, Kunstverein, Galerie…",
        "contact": "Name, E-Mail oder Telefonnummer",
        "contractReference": "Nummer des Leihvertrags",
        "notes": "Besondere Bedingungen, Klauseln, Einschränkungen…"
      },
      "actions": {
        "confirmLoan": "Leihgabe bestätigen",
        "confirmReturn": "Rückgabe bestätigen"
      }
    },
    "location": {
      "title": "Standort ändern",
      "description": "Wählen Sie den neuen Standort für dieses Kunstwerk aus.",
      "loading": "Standorte werden geladen…",
      "unspecifiedType": "Typ nicht angegeben",
      "empty": "Kein anderer Standort verfügbar",
      "actions": {
        "add": "Neuen Standort hinzufügen"
      }
    },
    "paperSize": {
      "title": "Papiermaße hinzufügen",
      "description": "Geben Sie die Maße des Papierträgers dieses Kunstwerks ein. Sie sind in der Regel größer als das Bild selbst.",
      "standardFormats": "Standardformate (optional)",
      "standardHelp": "Wählen Sie ein Standardformat aus, um dessen Maße automatisch zu übernehmen."
    },
    "provenance": {
      "addTitle": "Provenienzeintrag hinzufügen",
      "editTitle": "Provenienzeintrag bearbeiten",
      "fields": {
        "type": "Provenienztyp",
        "date": "Datum",
        "description": "Beschreibung",
        "location": "Ort / Kommentar"
      },
      "required": "(erforderlich)",
      "placeholders": {
        "description": "Galerie La Rive, Paris, Privatverkauf, 2018…",
        "location": "Stadt, Land, Rechnungsnummer… (optional)"
      },
      "types": {
        "select": "— Typ auswählen —",
        "direct_artiste": "Direkt vom Künstler",
        "echange_production": "Tausch / Produktion",
        "galerie": "Galerie",
        "vente_privee": "Privatverkauf",
        "encheres": "Auktion",
        "succession": "Erbschaft / Nachlass",
        "don": "Schenkung",
        "collection_privee": "Privatsammlung",
        "autre": "Sonstiges"
      }
    },
    "size": {
      "dimensionsTitle": "Maße hinzufügen",
      "durationLabel": "Dauer (Format: HH:MM:SS)",
      "durationPlaceholder": "00:00:00",
      "durationHelp": "Format: Stunden:Minuten:Sekunden, zum Beispiel 01:30:00 für 1 Std. 30 Min."
    },
    "deleteConfirm": {
      "title": "Kunstwerk löschen",
      "messageBefore": "Möchten Sie das Kunstwerk wirklich löschen",
      "messageAfter": "Diese Aktion kann nicht rückgängig gemacht werden und entfernt das Kunstwerk dauerhaft aus Ihrer Sammlung."
    }
  },
  "invoicesPage": {
    "title": "Meine Rechnungen & Zahlungen",
    "facturxNote": "Ihre offizielle Rechnung liegt im elektronischen Format (Factur-X) vor. Sie wird über unsere zugelassene E-Rechnungs-Plattform ausgestellt und übermittelt, gemäß den Vorschriften zur elektronischen Rechnungsstellung. Die untenstehenden Dokumente sind die entsprechenden Zahlungsbelege.",
    "colNumber": "Nummer",
    "colStatus": "Status",
    "colAmount": "Betrag",
    "colReceipt": "Zahlungsbeleg",
    "colDetail": "Details",
    "download": "Herunterladen",
    "view": "Ansehen",
    "loading": "Wird geladen…",
    "empty": "Noch keine Rechnungen.",
    "loginPrompt": "Melden Sie sich an, um Ihre Rechnungen zu sehen.",
    "error": "Fehler beim Laden der Rechnungen."
  },
  "aiConsent": {
    "accept": "Einwilligung erteilen",
    "description": "Durch die Aktivierung erlauben Sie Artkiv, KI-gestützte Analysen Ihrer Daten durchzuführen.",
    "error": "Der Status der KI-Einwilligung konnte nicht aktualisiert werden",
    "status": {
      "accepted": "Einwilligung erteilt",
      "notAccepted": "Keine Einwilligung"
    },
    "subtitle": "Transparenz und Kontrolle über den Einsatz von KI",
    "title": "KI-Einwilligung",
    "withdraw": "Einwilligung widerrufen"
  },
  "artwork": {
    "access": {
      "cta": "Zurück zu meiner Sammlung",
      "description": "Einige Werke auf Artkiv sind durch private Zugriffsrechte geschützt.\n\nUm Sicherheit, Nachvollziehbarkeit und eine klare Zugriffshistorie zu gewährleisten, sind Werkseiten nur für eingeladene Personen sichtbar.",
      "hint": "Wenn Sie glauben, Zugriff haben zu sollten, bitten Sie einfach um eine Einladung.",
      "title": "Dieses Werk ist derzeit nicht zugänglich",
      "granted": "Zugang gewährt",
      "pending": "Zugang ausstehend",
      "revoked": "Zugang widerrufen"
    },
    "accessPrivacy": {
      "badgePrivate": "Privat",
      "body": "Dieses Kunstwerk ist standardmäßig privat. Nur Personen, die du einlädst, können es ansehen.",
      "hint": "Du kannst Zugriffe jederzeit unter „Freigaben“ ändern oder entfernen.",
      "pill1": "Kontrollierte Freigabe",
      "pill2": "Zugriffe protokolliert",
      "pill3": "Artkiv greift nur auf Anfrage zu",
      "title": "Zugriff & Datenschutz"
    },
    "availability": {
      "available": "Verfügbar",
      "in_restoration": "In Restaurierung",
      "not_found": "Nicht gefunden",
      "on_loan": "Verliehen",
      "unavailable": "Nicht verfügbar",
      "loaned": "Verliehen",
      "reserved": "Reserviert",
      "sold": "Verkauft",
      "lost_or_stolen": "Verloren / gestohlen",
      "to_destroy": "Zu vernichten"
    },
    "mediumCategories": {
      "design": "Design",
      "nft": "NFT / Digitale Kunst",
      "other": "Sonstiges"
    },
    "mediums": {
      "painting": "Malerei",
      "sculpture": "Skulptur",
      "photography": "Fotografie",
      "drawing": "Zeichnung",
      "print": "Druckgrafik",
      "mixed_media": "Mischtechnik",
      "installation": "Installation",
      "video": "Video",
      "textile": "Textil",
      "ceramic": "Keramik",
      "nft": "NFT / Digitale Kunst",
      "other": "Sonstiges",
      "oil_on_canvas": "Öl auf Leinwand",
      "acrylic_on_canvas": "Acryl auf Leinwand",
      "oil_on_wood": "Öl auf Holz",
      "acrylic_on_wood": "Acryl auf Holz",
      "painting_generic": "Gemälde",
      "paper_maroufle": "Maroufliertes Papier",
      "ink_on_paper": "Tinte auf Papier",
      "watercolor_on_paper": "Aquarell auf Papier",
      "gouache_on_paper": "Gouache auf Papier",
      "pencil_on_paper": "Bleistift auf Papier",
      "charcoal_on_paper": "Kohle auf Papier",
      "pastel_on_paper": "Pastell auf Papier",
      "collage_on_paper": "Collage auf Papier",
      "mixed_media_on_paper": "Mischtechnik auf Papier",
      "work_on_paper": "Arbeit auf Papier",
      "lithograph": "Lithographie",
      "screenprint": "Siebdruck",
      "engraving": "Gravur",
      "etching": "Radierung",
      "aquatint": "Aquatinta",
      "photographic_print": "Fotografischer Abzug",
      "silver_gelatin_print": "Silbergelatineabzug",
      "lambda_print": "Lambda-Abzug",
      "pigment_print": "Pigmentabzug",
      "inkjet_print": "Tintenstrahldruck",
      "digital_print": "Digitaldruck",
      "bronze": "Bronze",
      "marble": "Marmor",
      "resin": "Harz",
      "wood": "Holz",
      "steel": "Stahl",
      "aluminium": "Aluminium",
      "porcelain": "Porzellan",
      "ceramic_glazed": "Glasierte Keramik",
      "textile_fiber": "Textil / Faser",
      "video_installation": "Videoinstallation",
      "digital": "Digital",
      "nft_art": "NFT-Kunst",
      "oil_on_panel": "Öl auf Holztafel",
      "oil_on_paper": "Öl auf Papier",
      "acrylic_on_paper": "Acryl auf Papier",
      "acrylic_on_panel": "Acryl auf Holztafel",
      "watercolor": "Aquarell",
      "gouache": "Gouache",
      "ink_on_canvas": "Tusche auf Leinwand",
      "mixed_media_on_canvas": "Mischtechnik auf Leinwand",
      "collage": "Collage",
      "serigraph": "Siebdruck",
      "photography_generic": "Fotografie",
      "c_print": "C-Print",
      "iron": "Eisen",
      "glass": "Glas",
      "fresco": "Fresko",
      "tempera": "Tempera",
      "oil_on_linen": "Öl auf Leinen",
      "pencil_on_canvas": "Bleistift auf Leinwand",
      "crayon": "Kreide",
      "pen_and_ink": "Feder und Tusche"
    },
    "condition": {
      "excellent": "Ausgezeichnet",
      "very_good": "Sehr gut",
      "good": "Gut",
      "fair": "Mittel",
      "poor": "Schlecht",
      "damaged": "Beschädigt",
      "to_restore": "Zu restaurieren",
      "unknown": "Unbekannt",
      "very_poor": "Unterdurchschnittlich",
      "heavily_damaged": "Stark beschädigt (restaurierbar)",
      "partially_restorable": "Teilweise restaurierbar",
      "irreparable": "Irreparabel"
    },
    "typeOfArt": {
      "contemporary_art": "Zeitgenössische Kunst",
      "modern_art": "Moderne Kunst",
      "postwar_art": "Nachkriegskunst",
      "impressionism": "Impressionismus",
      "ancient_art": "Antike Kunst",
      "design": "Design",
      "old_masters": "Alte Meister",
      "asian_art": "Asiatische Kunst",
      "african_art": "Afrikanische Kunst",
      "middle_eastern_art": "Nahöstliche Kunst",
      "latin_american_art": "Lateinamerikanische Kunst",
      "tribal_art": "Stammeskunst",
      "street_art": "Street Art",
      "decorative_arts": "Dekorative Kunst",
      "antiquities": "Antiken",
      "other": "Andere",
      "photography": "Fotografie",
      "nineteenth_century_art": "Kunst des 19. Jahrhunderts",
      "prints_multiples": "Druckgrafik & Multiples",
      "digital_art": "Digitale Kunst / NFT",
      "unknown": "Nicht angegeben"
    },
    "history": {
      "noViews": "Noch keine Aufrufe",
      "viewedBy": "Aufgerufen von"
    }
  },
  "artworkAccess": {
    "active": {
      "canEdit": "Kann bearbeiten",
      "empty": "Kein geteilter Zugriff",
      "emptyDescription": "Dieses Kunstwerk wird derzeit mit niemandem geteilt",
      "revoke": "Zugriff widerrufen",
      "sharedAt": "Geteilt",
      "title": "Aktive Zugriffe"
    },
    "confirm": {
      "revoke": "Zugriff für {{name}} widerrufen?"
    },
    "error": {
      "invite": "Fehler beim Senden der Einladung",
      "revoke": "Fehler beim Widerrufen des Zugriffs"
    },
    "invite": {
      "button": "Einladen",
      "description": "Laden Sie Experten, Konservatoren oder Partner ein, diesen Datensatz anzusehen",
      "emailLabel": "E-Mail-Adresse",
      "messageLabel": "Nachricht (optional)",
      "messagePlaceholder": "Persönliche Nachricht hinzufügen...",
      "roleLabel": "Rolle",
      "send": "Einladung senden",
      "sending": "Wird gesendet...",
      "title": "Dieses Kunstwerk teilen"
    }
  },
  "artworkDetail": {
    "acquisition": {
      "date": "Erwerbsdatum",
      "inventoryNumber": "Inventarnummer",
      "price": "Erwerbspreis",
      "source": "Quelle",
      "title": "Erwerbsdetails",
      "type": "Erwerbsart"
    },
    "actions": {
      "aiTracking": "KI-Tracking",
      "conservation": "Konservierung",
      "costs": "Kosten",
      "curatorialReading": "Curatorial reading",
      "curatorialReadingSubtext": "Partner expert service",
      "requestExpertValuation": "Bewertung durch Expertin/Experten anfragen",
      "requestExpertValuationSubtext": "Dieses Werk an eine benannte Partnerexpertin/einen Partnerexperten senden",
      "delete": "Löschen",
      "donation": "Schenkung",
      "downloadZip": "Download file bundle",
      "downloadZipSubtext": "Images + documents in one ZIP file",
      "edit": "Bearbeiten",
      "insurance": "Versicherung",
      "maintenance": "Wartung",
      "proposeExhibition": "Propose the artwork",
      "proposeToMuseum": "Museum vorschlagen",
      "qrCode": "QR-Code",
      "registerDonation": "Schenkung erfassen",
      "registerSale": "Verkauf erfassen",
      "sale": "Verkauf",
      "showQr": "QR-Code anzeigen",
      "transport": "Transport",
      "zipping": "Preparing ZIP…",
      "requestInsurance": "Versicherung anfragen",
      "requestTransport": "Transport anfragen",
      "exportDossier": "Werkdossier exportieren",
      "loanArtwork": "Kunstwerk verleihen",
      "removeFromLoan": "Leihe beenden",
      "declareLoss": "Verlust oder Diebstahl melden",
      "estimateComparables": "Anhand von Vergleichswerten schätzen",
      "duplicateArtwork": "Datensatz duplizieren",
      "duplicating": "Wird dupliziert…",
      "transportTitle": "Transport anfragen (Hin- und Rücktransport)",
      "addToLot": "Zu einem Los hinzufügen",
      "addToLotTitle": "Dieses Kunstwerk zu einem Los zusammenfassen",
      "removeFromLotTitle": "Dieses Kunstwerk aus dem Los entfernen",
      "removeFromLotConfirm": "Dieses Kunstwerk aus dem Los entfernen?",
      "removeFromLotError": "Das Kunstwerk konnte nicht aus dem Los entfernt werden."
    },
    "ai": {
      "analyzeButton": "Run AI analysis",
      "description": "Use AI to analyze this artwork, enrich its metadata, and refine its valuation.",
      "eligible": "Für das Artkiv-KI-Modul geeignet.",
      "title": "KI-Analyse"
    },
    "ocr": {
      "button": "Mit OCR anreichern",
      "loading": "Wird angereichert…",
      "blockedPlan": "Die KI-gestützte OCR-Anreicherung ist ab dem Premium-Tarif verfügbar.",
      "blockedConsent": "Sie haben den Nutzungsbedingungen für KI noch nicht zugestimmt.",
      "blockedDisabled": "KI ist in Ihrem Konto deaktiviert. Aktivieren Sie sie in Ihren Einstellungen.",
      "viewPlans": "Tarife ansehen →",
      "profile": "Mein Profil →"
    },
    "visualAi": {
      "title": "Visuelle KI-Analyse",
      "description": "Bilder des Kunstwerks über Vision.artkiv.com analysieren",
      "launch": "Analyse starten →"
    },
    "lot": {
      "fallbackName": "Los",
      "copySingular": "{{count}} Exemplar",
      "copyPlural": "{{count}} Exemplare",
      "show": "anzeigen",
      "collapse": "einklappen",
      "duplicateTitle": "Dieses Exemplar im Los duplizieren",
      "duplicate": "Duplizieren",
      "edit": "Los bearbeiten",
      "referenceAlt": "Referenzbild des Loses",
      "referenceLabel": "Referenzbild des Loses",
      "referenceLabelUpper": "REFERENZBILD DES LOSES",
      "useAsPrimaryTitle": "Das Losbild als Hauptbild dieses Kunstwerks verwenden",
      "useAsPrimary": "Als Hauptbild verwenden",
      "setAsPrimary": "Dieses Bild als Hauptbild festlegen",
      "sharedVisualTitle": "Dieses Bild wird von allen Kunstwerken des Loses verwendet",
      "uploading": "Wird hochgeladen…",
      "changeVisual": "Losbild ändern",
      "addVisual": "Losbild hinzufügen",
      "applyAllTitle": "Dieses Bild als Hauptbild auf alle Kunstwerke des Loses anwenden",
      "applying": "Wird angewendet…",
      "applyAll": "Auf das gesamte Los anwenden",
      "applySuccess": "✓ Bild auf {{count}} Kunstwerk(e) des Loses angewendet.",
      "applyPartial": "⚠ Auf {{count}} von {{total}} angewendet. {{errors}} Fehler.",
      "uploadError": "Fehler beim Hochladen des Losbildes: {{message}}",
      "usePrimaryError": "Fehler: {{message}}",
      "applyConfirm": "Dieses Bild als Hauptbild auf alle Kunstwerke des Loses anwenden?\n\nKunstwerke mit eigenem Foto erhalten dieses Bild an erster Position. Vorhandene Bilder werden nicht gelöscht.",
      "globalPriceTitle": "Gesamtpreis des Loses (Installation)",
      "globalPriceDescription": "Dieser Preis gilt für die gesamte Installation ({{count}} Abzüge). Er kann nicht pro Exemplar aufgeteilt werden."
    },
    "loanBanner": {
      "status": "Verliehen",
      "manage": "Unter Depots & Leihen verwalten →"
    },
    "loss": {
      "badges": {
        "vol": "Gestohlenes Kunstwerk",
        "perte": "Verlorenes Kunstwerk",
        "destruction": "Zerstörtes Kunstwerk",
        "incendie": "Brandschaden",
        "inondation": "Überschwemmungsschaden",
        "autre": "Gemeldeter Schaden",
        "generic": "Verloren / Gestohlen"
      },
      "viewRegister": "Unter Verluste & Diebstähle ansehen →",
      "saveError": "Die Meldung konnte nicht gespeichert werden.",
      "types": {
        "vol": "Diebstahl",
        "perte": "Verlust",
        "destruction": "Zerstörung",
        "incendie": "Brand",
        "inondation": "Überschwemmung",
        "autre": "Sonstiges"
      },
      "modal": {
        "title": "Verlust oder Diebstahl melden",
        "artwork": "Kunstwerk",
        "type": "Typ",
        "declaredValue": "Deklarierter Wert (EUR)",
        "estimatedValue": "Geschätzter Wert",
        "policeReport": "Polizeianzeige erstattet",
        "insuranceClaim": "Versicherungsfall gemeldet",
        "notes": "Notizen",
        "notesPlaceholder": "Beschreiben Sie die Umstände…",
        "notice": "Das Kunstwerk wird als „{{status}}“ markiert und aus dem aktiven Inventar entfernt. Verfolgen Sie den Fall unter Verluste & Diebstähle.",
        "cancel": "Abbrechen",
        "saving": "Wird gespeichert…",
        "confirm": "Meldung bestätigen"
      }
    },
    "duplicate": {
      "confirm": "Diesen Datensatz duplizieren?",
      "error": "Fehler beim Duplizieren: {{message}}"
    },
    "catalogImport": {
      "title": "Unvollständiger Datensatz — aus einem Katalog importiert",
      "description": "Technik, Maße und Bild fehlen. Fotografieren Sie die entsprechende Doppelseite.",
      "enrich": "Anreichern →"
    },
    "pricing": {
      "atPurchaseRate": "zum Wechselkurs des Kaufs"
    },
    "loginRequired": "Sie müssen angemeldet sein.",
    "viewArtistWorks": "Alle Werke von {{artist}} ansehen",
    "backToCollection": "Zurück zur Sammlung",
    "badges": {
      "archived": "Archiviert",
      "blockchain": "Echtheitsnachweis",
      "donated": "Gespendet (Archiv)",
      "heirAssigned": "Erbe zugewiesen",
      "insured": "Versichert",
      "notCertified": "Nicht zertifiziert",
      "notInsured": "Nicht versichert",
      "sold": "Verkauft (Archiv)"
    },
    "blockchain": {
      "badgeCertified": "Echtheitsnachweis",
      "badgeNotCertified": "Nicht zertifiziert",
      "blockchain": "Technologie:",
      "contract": "Vertrag:",
      "link": "Link:",
      "linkLabel": "Ansehen",
      "title": "Echtheitsnachweis — technisches Detail",
      "tokenId": "Kennung:",
      "type": "Typ:"
    },
    "proof": {
      "title": "Digitaler Fingerabdruck",
      "loading": "Ihr Abonnement wird geladen…",
      "lockedText": "Erstellen Sie einen datierten SHA-256-Fingerabdruck dieser Werkakte. Verfügbar für Premium-Konten.",
      "upgradeButton": "Auf Premium upgraden",
      "statusPending": "Fingerabdruck erstellt",
      "statusCertified": "Auf Blockchain verankert",
      "emptyText": "Für dieses Kunstwerk existiert noch kein digitaler ARTKIV-Fingerabdruck.",
      "generateButton": "Digitalen Fingerabdruck erstellen",
      "generating": "Wird erstellt…",
      "generateSuccess": "Digitaler Fingerabdruck erstellt.",
      "premiumRequired": "Diese Funktion erfordert einen Premium-Plan oder höher.",
      "generateError": "Fehler beim Erstellen des Fingerabdrucks.",
      "certificateId": "Kennung:",
      "fingerprint": "Digitaler Fingerabdruck:",
      "createdAt": "Erstellt am:",
      "technology": "Technologie:",
      "ecoFriendly": "Umweltfreundlich",
      "pendingInfo": "Der SHA-256-Fingerabdruck ist in ARTKIV gespeichert. Er ist noch nicht auf einer öffentlichen Blockchain verankert.",
      "downloadPdf": "PDF-Dokument herunterladen",
      "pdfSoon": "PDF (demnächst)",
      "verifySoon": "Öffentliche Prüfung (bald)",
      "viewOnChain": "Auf Blockchain ansehen",
      "notAnchored": "Nicht verankert",
      "loadError": "Der digitale Fingerabdruck konnte nicht geladen werden.",
      "howItWorksTitle": "Wozu dient dieser Fingerabdruck?",
      "how": {
        "unique": "Einzigartiger Fingerabdruck: Ihr Nachweis wird durch einen für dieses Werk spezifischen Code identifiziert.",
        "tamperproof": "Fälschungssicher: Jede Änderung wäre sofort erkennbar.",
        "timestamped": "Zeitgestempelt: Das Erstellungsdatum wird dauerhaft gespeichert.",
        "verifiable": "Überprüfbar: Die Echtheit kann jederzeit bestätigt werden.",
        "comingSoon": "Demnächst: Dieser Nachweis wird zusätzlich auf einer öffentlichen Blockchain für dauerhafte Rückverfolgbarkeit gespeichert."
      }
    },
    "defaultTitle": "Ohne Titel",
    "delete": {
      "confirm": "Möchten Sie dieses Kunstwerk wirklich löschen?",
      "error": "Fehler beim Löschen des Kunstwerks."
    },
    "description": {
      "title": "Beschreibung"
    },
    "details": {
      "availability": "Verfügbarkeit",
      "condition": "Zustand",
      "conditionNotes": "Notizen",
      "dimensions": "Maße",
      "duration": "Dauer",
      "edition": "Edition",
      "editionMultiple": "Edition (Multiple)",
      "editionUnique": "Unikat",
      "location": "Standort",
      "subject": "Motiv / Thema",
      "type": "Typ",
      "value": "Wert"
    },
    "health": {
      "docsMissing": "Dokumente hinzufügen",
      "docsOk": "{{count}} Dokument(e)",
      "locationMissing": "Standort fehlt",
      "locationOk": "Standort hinterlegt",
      "ok": "Dossier aktuell",
      "purchaseMissing": "Kaufpreis fehlt",
      "purchaseOk": "Kaufpreis hinterlegt",
      "todo": "{{count}} Punkt(e) zu ergänzen"
    },
    "loading": "Wird geladen…",
    "locationMissingCta": "Standort hinzufügen (sofort wiederfinden)",
    "locationMissingReadonly": "Standort nicht angegeben",
    "login": {
      "title": "Anmeldung",
      "subtitle": "Zugriff auf Ihre Artkiv-Sammlung",
      "email": "E-Mail",
      "password": "Passwort",
      "forgot": "Passwort vergessen?",
      "submit": "Einloggen",
      "loading": "Anmeldung läuft...",
      "noAccount": "Noch kein Konto?",
      "signup": "Konto erstellen",
      "error": {
        "invalid": "Ungültige E-Mail oder Passwort",
        "required": "Bitte alle Felder ausfüllen",
        "unknown": "Ein Fehler ist aufgetreten, bitte erneut versuchen"
      }
    },
    "media": {
      "noImages": "Diesem Kunstwerk sind keine Bilder zugeordnet.",
      "noMainImage": "Kein Bild",
      "title": "Werkbilder"
    },
    "meta": {
      "artistLabel": "Künstler:",
      "blockchainCertified": "Echtheitsnachweis",
      "condition": "Zustand",
      "conditionNotes": "Notizen",
      "dimensions": "Maße",
      "duration": "Dauer:",
      "edition": "Edition",
      "location": "Standort",
      "locationUnknown": "Nicht angegeben",
      "mediumLabel": "Medium:",
      "notSet": "Nicht angegeben",
      "ownerStatus": {
        "owner": "Sie sind Eigentümer",
        "ownerShared": "Dieses Dossier ist geteilt",
        "sharedAccess": "Zugriff vom Eigentümer geteilt"
      },
      "subjectMatter": "Motiv / Thema",
      "typeOfArt": "Kunsttyp:",
      "yearLabel": "Jahr:"
    },
    "nextAction": {
      "docs": {
        "cta": "Dokument hinzufügen",
        "desc": "Fügen Sie mindestens ein Dokument hinzu (Rechnung, Zertifikat, E-Mail, Foto).",
        "title": "Dossier in 1 Minute absichern"
      },
      "location": {
        "cta": "Standort hinzufügen",
        "desc": "Fügen Sie einen Standort für Logistik und Rückverfolgbarkeit hinzu.",
        "title": "Werk sofort wiederfinden"
      },
      "ok": {
        "cta": "Historie ansehen",
        "desc": "Ihr Dossier ist vollständig. Sie können die Aktivität verfolgen und den Zugriff teilen.",
        "title": "Alles bereit"
      },
      "purchase": {
        "cta": "Kaufpreis hinzufügen",
        "desc": "Hinterlegen Sie den Kaufpreis, um die Wertentwicklung zu verfolgen.",
        "title": "Wertzuwachs berechnen"
      },
      "viewTab": "Tab ansehen"
    },
    "noDescription": "Für dieses Kunstwerk wurde noch keine Beschreibung hinzugefügt.",
    "noDescriptionCta": "Beschreibung hinzufügen (30 Sek.)",
    "noImage": "Kein Bild verfügbar",
    "noLocation": "Nicht angegeben",
    "notFound": {
      "back": "Zurück zum Dashboard",
      "cta": "Zurück zu meiner Sammlung",
      "description": "Einige Werke auf Artkiv sind durch private Zugriffsrechte geschützt.\n\nUm Sicherheit, Nachvollziehbarkeit und eine klare Zugriffshistorie zu gewährleisten, sind Werkseiten nur für eingeladene Personen sichtbar.",
      "hint": "Wenn Sie glauben, Zugriff haben zu sollten, bitten Sie einfach um eine Einladung.",
      "subtitle": "Kein Kunstwerk mit dieser ID gefunden",
      "title": "Dieses Werk ist derzeit nicht zugänglich"
    },
    "qr": {
      "download": "Herunterladen",
      "scanText": "Scannen Sie diesen QR-Code.",
      "title": "QR-Code"
    },
    "story": {
      "acquisition": "Erwerb",
      "action": "Änderung",
      "empty": "Noch keine Einträge. Fügen Sie ein Dokument oder eine Provenienz hinzu.",
      "event": "Ereignis",
      "provenance": "Provenienz",
      "subtitle": "Eine klare Spur auf einen Blick",
      "title": "Werk-Story",
      "unknownDate": "Unbekanntes Datum",
      "view": "Ansicht"
    },
    "tabs": {
      "details": "Details",
      "documents": "Dokumente",
      "history": "Historie",
      "images": "Bilder",
      "location": "Standort",
      "medias": "Medien",
      "provenance": "Provenienz",
      "specifications": "Spezifikationen",
      "valuations": "Bewertungen",
      "access": "Zugang & Rückverfolgbarkeit"
    },
    "tags": {
      "title": "Schlagwörter"
    },
    "value": {
      "acquiredOn": "Erworben am ",
      "noValue": "Nicht verfügbar",
      "premiumBadge": "Erweiterte Funktionen nur für Premium-Konten",
      "title": "Wert",
      "vsPurchase": "Berechnung: Wert – Kaufpreis."
    },
    "history": {
      "emptyDesc": "Die Aktivität auf diesem Kunstwerk wird hier angezeigt",
      "fullHistory": "Vollständige Historie",
      "itemTitle": "Aktivität",
      "noThirdParty": "Kein Drittparteizugang",
      "noThirdPartyDesc": "Konsultationen durch Experten oder Partner werden hier angezeigt",
      "showAll": "{{count}} weitere Ereignisse anzeigen",
      "showLess": "Weniger anzeigen",
      "thirdPartyAccess": "Drittparteizugang",
      "empty": "Noch keine Aktivität. Starten Sie eine Aktion (Provenienz hinzufügen, Künstlerzertifikat, Kunstwerk bewegen), um einen Verlauf zu erstellen.",
      "loading": "Wird geladen…",
      "loadingFallback": "Historie wird geladen…",
      "actionViewed": "hat den Datensatz angesehen",
      "actionUpdated": "hat Informationen aktualisiert",
      "actionDocumentAdded": "hat ein Dokument hinzugefügt",
      "actionImageAdded": "hat ein Bild hinzugefügt",
      "actionShared": "hat den Zugriff geteilt",
      "actionRevoked": "hat den Zugriff widerrufen",
      "actionGenericNamed": "hat eine Aktion ausgeführt ({{action}})",
      "actionGeneric": "hat eine Aktion ausgeführt",
      "thirdPartyBadge": "Drittpartei",
      "actorYou": "Sie",
      "actorUnknown": "Eine beteiligte Person",
      "before": "Vorher",
      "after": "Nachher"
    },
    "inventoryNumber": "Inventarnummer",
    "shared": {
      "description": "Dieses Kunstwerk wurde mit Ihnen geteilt.",
      "title": "Mit Ihnen geteilt"
    },
    "access": {
      "blockchain": "Jede Einsicht wird fälschungssicher erfasst, um Rückverfolgbarkeit, Vertraulichkeit und Datenintegrität zu gewährleisten.",
      "cta": "Zugang verwalten",
      "description": "Dieses Kunstwerk ist ausschließlich für explizit autorisierte Personen zugänglich.",
      "empty": "Noch nichts zu melden. Sobald ein Dritter dieses Kunstwerk aufruft, erscheint es hier.",
      "hint": "Sie behalten die volle Kontrolle darüber, wer dieses Kunstwerk wann und in welchem Rahmen einsehen kann.",
      "loading": "Zugänge werden geladen…",
      "log": "Zugänge sind zeitgestempelt und einem Rolle zugeordnet (Sammler, Experte, Berater, Partner).",
      "whyArtkiv": "Aus Sicherheits- und Compliance-Gründen erfolgt der Zugang zu diesem Kunstwerk ausschließlich über Artkiv."
    },
    "info": {
      "estimatedValue": "Wert:",
      "locationLabel": "Standort:"
    },
    "services": {
      "aiInsights": "KI-Empfehlungen",
      "conservation": "Konservierung & Restaurierung",
      "costManagement": "Kostenverwaltung",
      "donationOption": "🎁 Schenkung vornehmen",
      "insurance": "Versicherung & Abdeckung",
      "insuranceDesc": "Bereiten Sie ein vollständiges Dossier für Ihren Versicherer oder unsere Versicherungspartner vor.",
      "museumProposal": "Museumsvorschlag",
      "saleDonation": "Verkauf / Schenkung",
      "saleDonationDesc": "Strukturieren Sie einen Verkauf, eine Schenkung oder ein Vermächtnis mit Artkiv und Ihren Beratern.",
      "saleOption": "📈 Zum Verkauf anbieten",
      "title": "Leistungen rund um dieses Kunstwerk",
      "transport": "Transport & Logistik",
      "valuation": "Bewertung & Schätzung",
      "valuationDesc": "Fordern Sie eine aktualisierte Schätzung mit Artkiv KI und unseren Expertenpartnern an."
    },
    "valuations": {
      "acquisitionDateLabel": "Datum:",
      "acquisitionPrice": "Erwerbspreis",
      "acquisitionSourceLabel": "Quelle:",
      "acquisitionTypeLabel": "Typ:",
      "acquisitionUnknown": "Nicht angegeben",
      "current": "Aktueller Wert",
      "currentHint": "Indikativer Wert.",
      "currentUnknown": "Nicht angegeben",
      "plusValue": "Wertsteigerung",
      "plusValueHint": "Berechnung: Wert – Kaufpreis.",
      "plusValueNA": "N/V",
      "title": "Bewertungen"
    }
  },
  "artworkDocuments": {
    "addDocument": "Dokument hinzufügen",
    "addedOn": "Hinzugefügt am {{date}}",
    "iaScore": {
      "label": "KI-Score:"
    },
    "noDocuments": "Kein Dokument ist diesem Kunstwerk zugeordnet",
    "title": "Dokumente",
    "view": "Ansehen"
  },
  "importJournal": {
    "title": "Import-Journal",
    "subtitle": "Ihre letzten Importe. Sie können einen Import rückgängig machen (die erstellten Werke werden gelöscht).",
    "undo": "Import rückgängig machen",
    "undoing": "Wird rückgängig gemacht…",
    "undone": "{{n}} Werk(e) gelöscht.",
    "error": "Rückgängig machen fehlgeschlagen.",
    "confirm": "Diesen Import rückgängig machen und die {{n}} erstellten Werke löschen? Nicht umkehrbar.",
    "skipped": "übersprungen",
    "col": { "file": "Datei", "collection": "Sammlung", "date": "Datum", "result": "Ergebnis", "status": "Status" },
    "status": { "running": "Läuft", "completed": "Abgeschlossen", "completed_with_errors": "Abgeschlossen (mit Fehlern)", "cancelled": "Abgebrochen" }
  },
  "concentration": {
    "eyebrow": "Analyse",
    "title": "Sammlungskonzentration",
    "subtitle": "Wertverteilung — ein Vermögensindikator, kein Finanzindex.",
    "top5": "Gewicht der Top 5",
    "stale": "Ohne aktuelle Bewertung",
    "insured": "Versichert",
    "byArtist": "Nach Künstler (Top 5)",
    "byMedium": "Nach Medium (Top 5)",
    "confidence": "Wert-Konfidenz",
    "confHigh": "hoch",
    "confMedium": "mittel",
    "confLow": "niedrig"
  },
  "valuationHistory": {
    "eyebrow": "Nachverfolgbarkeit",
    "title": "Wertverlauf",
    "add": "Wert hinzufügen",
    "cancel": "Abbrechen",
    "save": "Wert speichern",
    "saving": "Speichern…",
    "empty": "Noch kein Wert erfasst.",
    "showHistory": "Vollständigen Verlauf anzeigen ({{n}})",
    "hideHistory": "Vollständigen Verlauf ausblenden",
    "type": {
      "acquisition": "Anschaffungspreis",
      "market_estimate": "Marktschätzung",
      "algorithmic": "Algorithmischer Wert",
      "expert": "Gutachterwert",
      "retained": "Festgelegter Wert",
      "insurance": "Versicherungswert"
    },
    "field": {
      "type": "Art", "min": "Min. Betrag", "max": "Max. Betrag", "retained": "Festgelegt",
      "currency": "Währung", "date": "Datum", "source": "Quelle",
      "sourcePh": "Rechnung, Gutachter, Artprice…", "confidence": "Konfidenz"
    },
    "confidence": { "low": "Niedrig", "medium": "Mittel", "high": "Hoch" },
    "col": { "date": "Datum", "type": "Art", "amount": "Betrag", "source": "Quelle", "confidence": "Konfidenz" }
  },
  "aiDisclosure": {
    "type": {
      "generated": "KI-generiert",
      "extracted": "Automatisch extrahiert · bitte prüfen",
      "suggested": "KI-Vorschlag",
      "assisted": "KI-gestützt",
      "simulation": "Unverbindliche Simulation · keine automatisierte Entscheidung"
    },
    "status": { "reviewed": "Vom Nutzer geprüft", "expertValidated": "Von einem Experten validiert" },
    "confidence": "Konfidenz: {{n}} %",
    "learnMore": "Mehr über KI bei ARTKIV"
  },
  "artworkEdit": {
    "artist": {
      "living": "lebend",
      "rank": "Artprice #{{n}}",
      "hint": "Vorschläge aus dem Preis-Referenzverzeichnis — freie Eingabe möglich.",
      "linked": "Referenzierter Künstler",
      "best": "Höchstergebnis"
    },
    "edit": {
      "cancel": "Abbrechen",
      "confidentialLocationBody": "Der genaue Standort dieses Kunstwerks ist vertraulich und mit Ihren aktuellen Zugriffsrechten nicht verfügbar.",
      "confidentialLocationTitle": "Vertraulicher Standort",
      "consentNote": "Diese Daten werden ausschließlich aggregiert und anonymisiert verwendet.",
      "consentText": "Dieses Kunstwerk in aggregierte Statistiken und Analysen von Artkiv einbeziehen.",
      "consentTitle": "Verwendung in Artkiv-Statistiken",
      "editTitle": "„{{title}}“ bearbeiten",
      "loadError": "Fehler beim Laden des Kunstwerks.",
      "loading": "Kunstwerk wird geladen…",
      "noEditRights": "Sie haben keine Berechtigung, dieses Kunstwerk zu bearbeiten.",
      "notFound": "Kunstwerk nicht gefunden oder Zugriff nicht autorisiert.",
      "save": "Speichern",
      "saveError": "Fehler beim Speichern des Kunstwerks.",
      "saving": "Wird gespeichert…",
      "sharedNotice": "Sie bearbeiten ein geteiltes Kunstwerk entsprechend den vom Eigentümer erteilten Berechtigungen.",
      "tabDetails": "Details",
      "tabDocuments": "Dokumente",
      "tabExpertise": "CUP-Expertise",
      "tabLocation": "Standort",
      "tabNft": "NFT / Blockchain",
      "tabProvenance": "Provenienz & Erwerb",
      "tabSpecifications": "Spezifikationen",
      "untitled": "Ohne Titel",
      "updated": "Kunstwerk aktualisiert.",
      "imageUploadError": "Beim Hochladen der Bilder ist ein Fehler aufgetreten.",
      "imageDeleteError": "Beim Löschen des Bildes ist ein Fehler aufgetreten.",
      "imagePrimaryError": "Das Hauptbild konnte nicht festgelegt werden.",
      "saveErrorDetailed": "Fehler beim Speichern des Kunstwerks. {{message}}",
      "noRowUpdated": "Es wurde keine Zeile aktualisiert. Prüfen Sie Ihre Berechtigung, dieses Kunstwerk zu bearbeiten."
    },
    "detail": {
      "acquisition": "Erwerbungsdetails",
      "acquisitionDate": "Erwerbungsdatum",
      "acquisitionPrice": "Kaufpreis",
      "acquisitionSource": "Quelle (Galerie, Auktionshaus, Künstler...)",
      "acquisitionType": "Erwerbungsart",
      "artist": "Künstler",
      "availability": "Verfügbarkeit",
      "subject": "Motiv / Thema",
      "subjectPlaceholder": "Porträt, Landschaft, Abstraktion...",
      "priceGallery": "Preis / Galerie",
      "priceLow": "Untere Preisspanne",
      "priceHigh": "Obere Preisspanne",
      "salePriceGallery": "Gewünschter Galerieverkaufspreis",
      "salePriceGallerySlash": "Gewünschter Verkaufspreis / Galerie",
      "expertValuation": "Expertenbewertung",
      "valuationRange": "Bewertungsspanne",
      "galleryCap": "Obere Galeriegrenze",
      "indicative": "unverbindlich",
      "publicForSale": "Dieses Werk als zum Verkauf / über eine Galerie verfügbar anzeigen",
      "priceGalleryHelp": "Getrennte Felder: Preisspanne, gewünschter Galerieverkaufspreis und öffentliche Sichtbarkeit.",
      "currencyGalleryHelp": "Diese Währung gilt für Galeriepreise: untere Spanne, obere Spanne und gewünschter Verkaufspreis.",
      "conditionSection": "Zustand des Werks",
      "condition": "Erhaltungszustand",
      "conditionLabel": "Zustand",
      "conditionPlaceholder": "— Auswählen —",
      "conditionDecoteWarning": "Ein Abschlag wird automatisch auf die CUP-Bewertung angewendet.",
      "conditionFair": "Mittel (−20%)",
      "conditionVeryPoor": "Unterdurchschnittlich (−30%)",
      "conditionHeavilyDamaged": "Stark beschädigt, restaurierbar (−50%)",
      "conditionPartiallyRestorable": "Teilweise restaurierbar (−65%)",
      "conditionIrreparable": "Irreparabel — vollständige Abschreibung",
      "conditionNotes": "Zustandsnotizen",
      "conditionNotesPlaceholder": "Kratzer, Restaurierungen, Schäden...",
      "currency": "Währung",
      "description": "Beschreibung",
      "descriptionPlaceholder": "Werkbeschreibung, Kontext, Ausstellung usw.",
      "edition": "Auflage / Mehrfachexemplare (Lithographie, Fotografie, Skulptur...)",
      "inventoryNumber": "Inventarnummer",
      "medium": "Medium",
      "noDescription": "Keine Beschreibung verfügbar.",
      "notSpecified": "Nicht angegeben",
      "notSpecifiedF": "Nicht angegeben",
      "select": "Auswählen",
      "signature": "Signatur",
      "statsTitle": "Teilnahme an anonymen Statistiken",
      "tagsAdd": "Hinzufügen",
      "tagsAI": "KI-Vorschläge",
      "tagsApiSettings": "API-Einstellungen",
      "tagsClear": "Alle Schlagwörter entfernen",
      "tagsCount": "/ 10 Schlagwörter verwendet",
      "tagsLocal": "Lokale Vorschläge",
      "tagsManual": "Manuell",
      "tagsMode": "Modus:",
      "tagsPlaceholder": "Schlagwort eingeben und Enter drücken",
      "tagsRemove": "Entfernen",
      "tagsTitle": "Schlagwörter / Tags",
      "titleLabel": "Titel des Werkes",
      "typeOfArt": "Kunstgattung",
      "valueLabel": "Aktueller Schätzwert",
      "year": "Jahr",
      "yearHint": "Geschätztes Datum auf den 1. Januar gesetzt — bitte korrigieren, wenn das genaue Datum bekannt ist.",
      "mediumCategory": "Medienkategorie",
      "mediumCategoryCeramics": "Keramik",
      "mediumCategoryDesign": "Design",
      "mediumCategoryDrawing": "Zeichnung",
      "mediumCategoryFilmVideo": "Film/Video",
      "mediumCategoryInstallation": "Installation",
      "mediumCategoryMixedMedia": "Mixed Media",
      "mediumCategoryNft": "NFT/Digital",
      "mediumCategoryOther": "Sonstiges",
      "mediumCategoryPainting": "Gemälde",
      "mediumCategoryPhotography": "Fotografie",
      "mediumCategoryPrints": "Druckgrafik",
      "mediumCategorySculpture": "Skulptur",
      "mediumCategoryTextile": "Textil",
      "mediumCategoryWorkOnPaper": "Arbeit auf Papier",
      "mediumPlaceholder": "Medium auswählen…"
    },
    "yearModal": {
      "body": "Nur das Jahr ist eingetragen. In der zeitgenössischen Kunst ist das oft ausreichend. Möchten Sie dennoch den",
      "bodyEnd": "als Referenzdatum festlegen?",
      "jan1": "1. Januar {{year}}",
      "confirm": "Auf {{date}} setzen",
      "hint": "Sie können dieses Datum jederzeit korrigieren, wenn Sie die genaue Information haben.",
      "keepYear": "Nur das Jahr behalten",
      "label": "Entstehungsjahr"
    },
    "provenanceTab": {
      "entryEyebrow": "Erwerb & Provenienz",
      "entryTitle": "Aufnahme in die Sammlung",
      "entryHelp": "Erfassen Sie die Angaben zum aktuellen Erwerb des Werks. Frühere Eigentumsverhältnisse werden separat in der Provenienz dokumentiert.",
      "historyEyebrow": "Historie",
      "historyTitle": "Frühere Provenienz",
      "historyHelp": "Dokumentieren Sie frühere Eigentümer, Sammlungen, Verkäufe und Übertragungen vor der Aufnahme des Werks in Ihre Sammlung.",
      "journeyEyebrow": "Werdegang des Kunstwerks",
      "journeyTitle": "Provenienzverlauf",
      "journeyHelp": "Dokumentieren Sie die aufeinanderfolgenden Eigentümer, Sammlungen, Verkäufe und Übertragungen des Kunstwerks.",
      "addHistory": "Provenienzeintrag hinzufügen",
      "emptyHistory": "Es wurde noch keine frühere Provenienz erfasst."
    },
    "acquisitionForm": {
      "type": "Erwerbsart",
      "date": "Erwerbsdatum",
      "sourceGeneric": "Quelle / Verkäufer",
      "sourcePlaceholder": "Galerie, Auktionshaus, Künstler, Privatsammlung…",
      "purchaseCurrency": "Erwerbswährung",
      "price": "Erwerbspreis",
      "pricePlaceholder": "Gezahlter Betrag ohne Gebühren",
      "city": "Erwerbsort",
      "country": "Erwerbsland",
      "exchangeRate": "Wechselkurs zum Euro",
      "priceEur": "In EUR umgerechneter Erwerbspreis",
      "selectType": "— Auswählen —",
      "typeGallery": "Galerie",
      "typeAuction": "Auktion",
      "typePrivate": "Privatverkauf",
      "typeArtist": "Direktkauf beim Künstler",
      "typeDonation": "Schenkung",
      "typeInheritance": "Erbschaft / Nachlass",
      "typeExchange": "Tausch",
      "typeCommission": "Auftragsarbeit",
      "typePurchase": "Kauf",
      "typeOther": "Sonstiges",
      "currencyEUR": "Euro",
      "currencyUSD": "US-Dollar",
      "currencyGBP": "Pfund Sterling",
      "currencyCHF": "Schweizer Franken",
      "currencyJPY": "Japanischer Yen",
      "currencyCNY": "Chinesischer Yuan",
      "currencyHKD": "Hongkong-Dollar",
      "currency": {
        "EUR": "Euro",
        "USD": "US-Dollar",
        "GBP": "Pfund Sterling",
        "CHF": "Schweizer Franken",
        "JPY": "Japanischer Yen",
        "CNY": "Chinesischer Yuan",
        "HKD": "Hongkong-Dollar"
      },
      "currencies": {
        "EUR": "Euro",
        "USD": "US-Dollar",
        "GBP": "Pfund Sterling",
        "CHF": "Schweizer Franken",
        "JPY": "Japanischer Yen",
        "CNY": "Chinesischer Yuan",
        "HKD": "Hongkong-Dollar"
      },
      "currencyLabels": {
        "EUR": "Euro",
        "USD": "US-Dollar",
        "GBP": "Pfund Sterling",
        "CHF": "Schweizer Franken",
        "JPY": "Japanischer Yen",
        "CNY": "Chinesischer Yuan",
        "HKD": "Hongkong-Dollar"
      },
      "currencyNames": {
        "EUR": "Euro",
        "USD": "US-Dollar",
        "GBP": "Pfund Sterling",
        "CHF": "Schweizer Franken",
        "JPY": "Japanischer Yen",
        "CNY": "Chinesischer Yuan",
        "HKD": "Hongkong-Dollar"
      },
      "currencyOptions": {
        "EUR": "Euro",
        "USD": "US-Dollar",
        "GBP": "Pfund Sterling",
        "CHF": "Schweizer Franken",
        "JPY": "Japanischer Yen",
        "CNY": "Chinesischer Yuan",
        "HKD": "Hongkong-Dollar"
      },
      "currencyLabelEUR": "Euro",
      "currencyLabelUSD": "US-Dollar",
      "currencyLabelGBP": "Pfund Sterling",
      "currencyLabelCHF": "Schweizer Franken",
      "currencyLabelJPY": "Japanischer Yen",
      "currencyLabelCNY": "Chinesischer Yuan",
      "currencyLabelHKD": "Hongkong-Dollar",
      "currencyNameEUR": "Euro",
      "currencyNameUSD": "US-Dollar",
      "currencyNameGBP": "Pfund Sterling",
      "currencyNameCHF": "Schweizer Franken",
      "currencyNameJPY": "Japanischer Yen",
      "currencyNameCNY": "Chinesischer Yuan",
      "currencyNameHKD": "Hongkong-Dollar",
      "currencyOptionEUR": "Euro",
      "currencyOptionUSD": "US-Dollar",
      "currencyOptionGBP": "Pfund Sterling",
      "currencyOptionCHF": "Schweizer Franken",
      "currencyOptionJPY": "Japanischer Yen",
      "currencyOptionCNY": "Chinesischer Yuan",
      "currencyOptionHKD": "Hongkong-Dollar",
      "currencyHelp": "Diese Währung gilt nur für den Erwerbspreis. Sie ist von der Währung für Galerie- und Verkaufspreise getrennt.",
      "exchangeRateHelp": "Geben Sie bei einer anderen Währung als EUR den Umrechnungskurs zum Euro am Erwerbsdatum an."
    }
  },
  "artworksDashboard": {
    "action": {
      "open": "Öffnen →"
    },
    "addArtwork": "Kunstwerk hinzufügen",
    "addFirstArtwork": "Mein erstes Kunstwerk hinzufügen",
    "empty": "Kein Kunstwerk entspricht Ihren Kriterien",
    "importPremiumTitle": "Kunstwerke importieren",
    "of": "–",
    "artworks": "Kunstwerk(e)",
    "pagination": {
      "previous": "← Zurück",
      "next": "Weiter →",
      "page": "Seite {{page}} / {{total}}"
    },
    "count": "{{count}} Kunstwerk(e) gefunden",
    "fallback": {
      "noTitle": "(Ohne Titel)"
    },
    "draftBadge": "Entwurf",
    "filter": {
      "allCollections": "Alle Sammlungen",
      "artist": "Künstler",
      "artistPlaceholder": "Künstler suchen",
      "collection": "Sammlung",
      "maxValue": "Höchstwert (€)",
      "minValue": "Mindestwert (€)",
      "tags": "Tags",
      "tagsPlaceholder": "tag1, tag2",
      "category": "Kategorie",
      "medium": "Medium",
      "location": "Standort",
      "inventory": "Inventar",
      "inventoryPlaceholder": "Inventarnummer suchen",
      "condition": "Zustand",
      "conditionAll": "Alle Zustände",
      "conditionExcellent": "Ausgezeichnet",
      "conditionGood": "Gut",
      "conditionFair": "Mittel",
      "conditionPoor": "Schlecht"
    },
    "importNeedCollection": "Für den Import müssen Sie zuerst eine Sammlung auswählen.",
    "importPremium": "CSV/XLSX importieren",
    "importWithExpert": "Import (mit Experte)",
    "loading": "Kunstwerke werden geladen...",
    "noResults": {
      "subtitle": "Passen Sie die Filter an oder fügen Sie neue Kunstwerke hinzu.",
      "title": "Keine Kunstwerke entsprechen Ihren Kriterien"
    },
    "sort": {
      "dateAsc": "Älteste zuerst",
      "dateDesc": "Neueste zuerst",
      "label": "Sortieren nach:",
      "titleAsc": "Titel A–Z",
      "titleDesc": "Titel Z–A",
      "inventoryAsc": "Inventar A–Z",
      "valueAsc": "Wert aufsteigend",
      "valueDesc": "Wert absteigend"
    },
    "table": {
      "actions": "Aktionen",
      "artist": "Künstler",
      "artwork": "Kunstwerk",
      "date": "Datum",
      "type": "Typ",
      "value": "Wert"
    },
    "title": "Kunstwerke",
    "view": {
      "grid": "Rasteransicht",
      "label": "Ansicht:",
      "list": "Listenansicht",
      "mosaic": "Mosaikansicht"
    }
  },
  "artworkSpecs": {
    "button": {
      "add": "Hinzufügen"
    },
    "section": {
      "dimensions": "Abmessungen",
      "duration": "Dauer",
      "framed": "Abmessungen mit Rahmen",
      "paper": "Papierabmessungen"
    }
  },
  "auctions": {
    "empty": "Keine Auktionen verfügbar",
    "subtitle": "Ergebnisse und Rekorde",
    "title": "Auktionen"
  },
  "billing": {
    "alert": {
      "demoDisabled": "Diese Funktion ist auf Demo-Konten deaktiviert.\n\nUm auf das echte Abrechnungsportal zuzugreifen, erstellen Sie bitte ein echtes Kundenkonto.",
      "noSubscription": "Sie müssen zuerst einen Plan abonnieren.",
      "portalOpenFailed": "Das Abrechnungsportal konnte nicht geöffnet werden: {{error}}"
    },
    "cancelPlan": "Tarif kündigen",
    "changePlan": "Tarif ändern",
    "currentPlan": "Aktueller Tarif",
    "demo": {
      "noSub": {
        "button": "Pläne ansehen (Demo)",
        "note": "💡 Hinweis: Um zu sehen, wie ein aktives Abonnement aussieht, bitten Sie den Administrator, ein simuliertes Abonnement auf diesem Konto zu aktivieren.",
        "text": "Dieses Demo-Konto kann ohne aktives Abonnement verwendet werden. Alle Funktionen sind im Testmodus verfügbar.",
        "title": "Demo-Konto"
      },
      "status": {
        "active": "Aktiv",
        "canceled": "Gekündigt",
        "none": "Keines",
        "past_due": "Überfällig",
        "trialing": "Testphase"
      },
      "withSub": {
        "aboutLink": "Kundenkonto erstellen",
        "aboutText": "Dieses Konto befindet sich im Demo-Modus. Für echte Abrechnungs- und Zahlungsfunktionen erstellen Sie ein echtes Kundenkonto.",
        "aboutTitle": "Über den Demo-Modus",
        "button": {
          "invoices": "Meine Rechnungen",
          "portalDisabled": "Portal öffnen (deaktiviert)",
          "seeOffers": "Pläne anzeigen"
        },
        "explainer": "Auf einem echten Konto ermöglicht dieses Portal, Ihre Zahlungsmethode zu aktualisieren, Rechnungen einzusehen, den Plan zu wechseln oder Ihr Abonnement zu kündigen.",
        "nextPayment": "Nächste Zahlung",
        "nextPaymentValue": "N/A (Demo)",
        "note": "🎭 Demo-Modus: Dieses Abonnement ist simuliert. Auf diesem Konto wird keine echte Zahlung vorgenommen. Abrechnungsfunktionen sind deaktiviert.",
        "plan": "Plan",
        "price": "Monatlicher Preis",
        "priceValue": "29 € (simuliert)"
      },
      "badge": "Demo",
      "bannerText": "Einige Funktionen (Zahlung, Abrechnungsportal) sind im Demo-Modus deaktiviert.",
      "bannerTitle": "Demo-Modus",
      "pageTitle": "Abrechnung & Abonnement (Demo)"
    },
    "error": "Abrechnungsdaten konnten nicht geladen werden",
    "invoice": {
      "amount": "Betrag",
      "date": "Datum",
      "download": "Herunterladen",
      "number": "Nr.",
      "status": "Status"
    },
    "invoices": "Rechnungen",
    "real": {
      "button": {
        "changePlan": "Plan ändern",
        "invoices": "Meine Rechnungen",
        "portal": "Portal öffnen"
      },
      "explainer": "Über Ihr Abrechnungsportal können Sie jederzeit Ihre Zahlungsmethode aktualisieren, Rechnungen einsehen, den Plan wechseln oder Ihr Abonnement kündigen.",
      "help": {
        "link": "Support kontaktieren",
        "text": "Bei Fragen zu Ihrem Abonnement oder zur Abrechnung steht unser Team gerne zur Verfügung.",
        "title": "Brauchen Sie Hilfe?"
      },
      "noSub": {
        "button": "Pläne durchsuchen",
        "text": "Sie haben noch kein Abonnement. Wählen Sie einen Plan, um Ihre Kunstsammlung zu verwalten.",
        "title": "Kein aktives Abonnement"
      },
      "pageTitle": "Abrechnung & Abonnement"
    },
    "subtitle": "Zahlungen und Abonnements",
    "title": "Abrechnung",
    "portal": {
      "checking": "Zugang wird geprüft…",
      "loginButton": "Anmelden für Abrechnung",
      "requireLogin": "Sie müssen angemeldet sein, um auf das Abrechnungsportal zuzugreifen.",
      "title": "Abrechnungsportal"
    },
    "status": {
      "active": "Aktiv",
      "canceled": "Gekündigt",
      "none": "Kein Abonnement",
      "past_due": "Überfällig",
      "trialing": "Testphase"
    }
  },
  "client": {
    "proposals": {
      "operational": {
        "title": "Ausstellung, Leihgabe & Schenkung",
        "desc": "Verfolgen Sie Anfragen, die Sie für Ihre Kunstwerke an Institutionen gesendet haben."
      },
      "alert": {
        "cancellationError": "Unable to send the cancellation request.",
        "cancellationRequested": "Cancellation request sent to the expert.",
        "deleted": "Proposal deleted.",
        "deleteError": "Failed to delete the proposal."
      },
      "artwork": {
        "unknownArtist": "Unknown artist"
      },
      "button": {
        "cancel": "Cancel"
      },
      "column": {
        "action": "Action",
        "artwork": "Artwork",
        "date": "Date",
        "institution": "Institution",
        "type": "Type"
      },
      "confirm": {
        "delete": "Do you want to delete this proposal?",
        "requestCancellation": "Do you want to request the cancellation of this proposal?"
      },
      "error": {
        "fetch": "Error while loading proposals: {{error}}"
      },
      "loading": "Loading proposals...",
      "title": "Proposals overview",
      "type": {
        "auction": "Sale",
        "institution": "Institution"
      },
      "chip": {
        "blockchain": "Echtheitsnachweis",
        "proposals": "Vorschläge",
        "vision": "Vision"
      },
      "empty": {
        "desc": "Noch keine Vorschläge.",
        "title": "Keine Vorschläge"
      },
      "explainer": "Diese Vorschläge basieren auf Ihrer Sammlung und Ihren Präferenzen.",
      "help": {
        "point1": "Verwalten Sie Ihre Sammlung in Artkiv.",
        "point2": "Teilen Sie sie mit einem Experten oder Berater.",
        "point3": "Erhalten Sie personalisierte Vorschläge.",
        "title": "Wie funktioniert es?"
      },
      "learnMore": "Mehr erfahren",
      "value": {
        "blockchain": "Echtheitsnachweis",
        "desc": "Schutz und Aufwertung Ihrer Sammlung",
        "proposals": "Expertenvorschläge",
        "title": "Mehrwert",
        "vision": "Vision IA Analyse"
      }
    }
  },
  "collectionDetail": {
    "section": {
      "servicesCuratorial": "Curatorial services",
      "about": "Über",
      "artworks": "Kunstwerke",
      "details": "Details",
      "reports": "Berichte",
      "summary": "Zusammenfassung"
    },
    "servicesCuratorial": {
      "description": "Access the curatorial services linked to your collection: narrative reading, overall coherence, institutional loans, exhibition dossiers and bespoke advisory.",
      "open": "Open curatorial service"
    },
    "alt": {
      "image": "Sammlungsbild"
    },
    "back": "← Zurück",
    "backToCollections": "Zurück zu den Sammlungen",
    "button": {
      "delete": "Löschen",
      "edit": "Bearbeiten",
      "export": "Exportieren",
      "generateForThis": "Für diese Sammlung generieren",
      "generateReport": "Bericht generieren",
      "seeReports": "Berichte anzeigen",
      "shareAccess": "Zugang teilen"
    },
    "details": {
      "createdAt": "Erstellt am",
      "dateUnknown": "Unbekanntes Datum",
      "description": "Beschreibung",
      "owner": "Eigentümer",
      "ownerUnknown": "Unbekannter Eigentümer"
    },
    "loading": "Sammlung wird geladen…",
    "noBio": "Keine Biografie für diesen Künstler verfügbar.",
    "noDescription": "Keine Beschreibung angegeben.",
    "notFound": {
      "back": "← Zurück zu den Sammlungen",
      "id": "Sammlungs-ID nicht gefunden."
    },
    "shared": "Mit Ihnen geteilt",
    "summary": {
      "count": "{{count}} Kunstwerk(e)",
      "estimatedValue": "Geschätzter Wert",
      "purchasePrice": "Kaufpreis"
    }
  },
  "common": {
    "accept": "Annehmen",
    "comingSoon": "Demnächst",
    "refresh": "Aktualisieren",
    "reject": "Ablehnen",
    "close": "Schließen",
    "error": {
      "fallback": "Ein Fehler ist aufgetreten."
    },
    "hide": "Ausblenden",
    "loading": {
      "fallback": "Wird geladen…",
      "safe": "Sicherheitscheck…"
    },
    "okUnderstood": "OK, verstanden",
    "revoke": "Widerrufen",
    "share": "Teilen",
    "unknown": "Unbekannt",
    "untitled": "Ohne Titel",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "back": "Zurück",
    "notSpecified": "Nicht angegeben"
  },
  "comparePlans": {
    "cat": {
      "ai": "KI & Vision",
      "collection": "Sammlung",
      "integrations": "Integrationen",
      "multiClient": "Multi-Kunde",
      "reporting": "Berichte",
      "support": "Support"
    },
    "cta": {
      "details": "Plandetails anzeigen",
      "expert": "Mit einem Artkiv-Experten sprechen",
      "subtitle": "Wir helfen Ihnen, Ihre Bedürfnisse zu strukturieren — ob Privatsammler, Berater, Galerie oder Family Office.",
      "title": "Sie sind sich nicht sicher, welchen Plan Sie wählen sollen?"
    },
    "faq": {
      "a1": "Ja, Sie können jederzeit upgraden oder downgraden. Änderungen gelten ab dem nächsten Abrechnungszyklus.",
      "a2": "Ja, alle Pläne beinhalten eine 14-tägige kostenlose Testphase. Keine Kreditkarte erforderlich.",
      "a3": "Ihre Daten werden 30 Tage nach der Kündigung aufbewahrt. Sie können jederzeit alles exportieren.",
      "a4": "Ja, für Family-Office- und Unternehmenspläne. Kontaktieren Sie uns für ein individuelles Angebot.",
      "q1": "Kann ich den Plan jederzeit wechseln?",
      "q2": "Gibt es eine kostenlose Testphase?",
      "q3": "Was passiert mit meinen Daten, wenn ich kündige?",
      "q4": "Gibt es Mengenrabatte?",
      "title": "Häufig gestellte Fragen"
    },
    "features": {
      "ai": {
        "conservation": "Konservierungs-KI",
        "inheritanceMatching": "Nachlassabgleich",
        "mediaWatch": "Medienbeobachtung",
        "visualAnalysis": "Visuelle Analyse"
      },
      "collection": {
        "artistsLocations": "Künstler & Standorte",
        "artworks": "Kunstwerke",
        "photosMultiple": "Mehrere Fotos",
        "provenance": "Provenienz"
      },
      "integrations": {
        "api": "API-Zugang",
        "erp": "ERP-Integration",
        "sso": "SSO",
        "webhooks": "Webhooks"
      },
      "multiClient": {
        "clientInvites": "Kundeneinladungen",
        "coBrandedReports": "Co-Branded-Berichte",
        "collectionsCount": "Verwaltete Sammlungen",
        "multiPortfolio": "Multi-Portfolio"
      },
      "reporting": {
        "accountingExports": "Buchhaltungsexporte",
        "customDashboards": "Benutzerdefinierte Dashboards",
        "pdfExports": "PDF-Exporte",
        "taxReports": "Steuerberichte"
      },
      "support": {
        "accountManager": "Kundenmanager",
        "email": "E-Mail-Support",
        "sla": "SLA",
        "training": "Schulungen"
      }
    },
    "plan": {
      "foundation": {
        "name": "Stiftung",
        "target": "Institutionen & Kulturstiftungen",
        "price": "Auf Anfrage",
        "contact": "Kontaktieren Sie uns"
      },
      "artAdvisor": {
        "name": "Art Advisor",
        "target": "Unabhängige Berater"
      },
      "artAdvisorPremium": {
        "name": "Art Advisor Premium",
        "target": "Senior-Berater"
      },
      "familyOffice": {
        "name": "Family Office",
        "target": "Multi-Family-Strukturen"
      },
      "premium": {
        "name": "Premium",
        "target": "Ernsthafte Sammler"
      },
      "standard": {
        "name": "Standard",
        "target": "Einzelsammler"
      }
    },
    "showAll": "Alle Funktionen anzeigen",
    "subtitle": "Wählen Sie den Plan, der zu Ihrer Sammlung, Ihrer Beratungspraxis oder Ihrem Family Office passt.",
    "title": "Artkiv-Pläne vergleichen",
    "value": {
      "advanced": "Erweitert",
      "basic": "Basis",
      "custom": "Auf Anfrage",
      "france": "Frankreich",
      "france_ch": "Frankreich & Schweiz",
      "limited": "Begrenzt",
      "multiCountry": "Mehrere Länder",
      "session1": "1 Sitzung",
      "session2": "2 Sitzungen",
      "unlimited": "Unbegrenzt",
      "videos": "Videos"
    }
  },
  "contact": {
    "back": "Zurück",
    "familyOffice": {
      "next": {
        "title": "Was als Nächstes passiert"
      }
    },
    "form": {
      "clientCount": "Anzahl verwalteter Kunden / Sammlungen",
      "company": "Unternehmensname",
      "email": "Geschäftliche E-Mail",
      "employees": "Teammitglieder, die die Plattform nutzen",
      "firstname": "Vorname",
      "lastname": "Nachname",
      "location": "Standort",
      "message": "Nachricht",
      "phone": "Telefon"
    },
    "sent": {
      "back": "Zurück zur Startseite",
      "text": "Vielen Dank für Ihre Anfrage. Unser Team wird Sie innerhalb von 24 Stunden kontaktieren.",
      "title": "Nachricht gesendet!"
    },
    "submit": {
      "demo": "Demo anfragen",
      "quote": "Angebot anfragen",
      "send": "Senden",
      "sending": "Wird gesendet..."
    }
  },
  "contacts": {
    "add": {
      "advisor": {
        "browse": "Verzeichnis durchsuchen",
        "desc": "Sammlung mit einem Kunstberater teilen",
        "title": "Berater einladen"
      },
      "button": "Hinzufügen",
      "expert": {
        "browse": "Verzeichnis durchsuchen",
        "desc": "Bewertungs-, Restaurierungs- oder Authentifizierungsexperten registrieren",
        "title": "Experten hinzufügen"
      },
      "insurer": {
        "browse": "Partner anzeigen",
        "desc": "Kunstversicherungskontakte registrieren",
        "title": "Versicherer hinzufügen"
      },
      "satellite": "Als Satellit hinzufügen"
    },
    "anonymous": "Anonymous",
    "delete": {
      "confirm": "Sind Sie sicher, dass Sie diesen Kontakt löschen möchten?",
      "error": "Fehler beim Löschen",
      "invitation": "Einladung löschen",
      "success": "Kontakt gelöscht"
    },
    "edit": "Bearbeiten",
    "empty": {
      "advisors": {
        "helper": "Laden Sie einen Berater ein, um Ihre Sammlung zu strukturieren."
      },
      "experts": "Kein Experte registriert",
      "insurers": "Kein Versicherer registriert"
    },
    "list": {
      "advisors": "Kunstberater",
      "experts": "Experten",
      "insurers": "Versicherer"
    },
    "loading": "Kontakte werden geladen...",
    "sharedSince": "Geteilt seit",
    "stats": {
      "advisors": "Berater",
      "experts": "Experten",
      "insurers": "Versicherer",
      "total": "Alle Kontakte"
    },
    "subtitle": "Verwalten Sie Ihre Berater, Experten und Versicherer. Diese Kontakte bleiben streng vertraulich.",
    "table": {
      "email": "E-Mail",
      "name": "Name",
      "phone": "Telefon",
      "role": "Rolle"
    },
    "title": "Kontakte",
    "type": {
      "advisor": "Berater",
      "expert": "Experte",
      "insurer": "Versicherer"
    },
    "action": {
      "manageAccess": "Zugang verwalten",
      "remove": "Entfernen",
      "share": "Teilen"
    },
    "advisors": {
      "active": {
        "title": "Kunstberater"
      },
      "confirmed": {
        "separator": "Bestätigte Berater"
      },
      "declined": {
        "title": "Abgelehnte Berater"
      },
      "pendingInvites": {
        "title": "Ausstehende Einladungen"
      },
      "pendingShare": {
        "title": "Ausstehende Freigaben"
      }
    },
    "alert": {
      "accessRevoked": "Zugang widerrufen",
      "advisorAdded": "Berater erfolgreich hinzugefügt",
      "advisorEmailRequired": "Berater-E-Mail erforderlich",
      "deleteError": "Fehler beim Löschen",
      "expertAdded": "Experte erfolgreich hinzugefügt",
      "expertRevoked": "Experte widerrufen ✅",
      "insurerAdded": "Versicherer erfolgreich hinzugefügt",
      "insurerRevoked": "Versicherer widerrufen",
      "invitationDeleted": "Einladung gelöscht",
      "missingId": "Fehlende ID",
      "satelliteInviteSent": "Satelliten-Einladung gesendet"
    },
    "invite": {
      "declined": "Einladung abgelehnt",
      "pending": {
        "helper": "Warten auf Akzeptierung der Einladung."
      }
    },
    "pendingShare": {
      "cta": "Jetzt teilen",
      "helper": "Dieser Berater wartet auf Zugang zu Ihrer Sammlung.",
      "subtitle": "Ausstehende Freigaben",
      "title": "Ausstehende Freigaben"
    },
    "satelliteDrawer": {
      "title": "Satellit hinzufügen"
    },
    "serviceRequest": {
      "sent": "Serviceanfrage gesendet",
      "status": {
        "active": "Aktiv",
        "waiting": "Wartet auf Zugang"
      },
      "waitingAccess": "Der Experte wartet auf Zugang zu Ihren Sammlungen."
    },
    "viewAll": "Alle anzeigen"
  },
  "dashboard": {
    "actions": {
      "title": "Aktionen",
      "subtitle": "Schützen, begutachten, teilen und die nächsten Schritte für Ihre Kunstwerke vorbereiten.",
      "protect": "Schützen",
      "assess": "Begutachten",
      "certify": "Zertifizieren",
      "opportunities": "Institutionelle Möglichkeiten",
      "expertise": {
        "title": "Expertise & Bewertung",
        "desc": "Finden Sie einen Fachprofi für Expertise, Bewertung oder eine spezialisierte Einschätzung eines Kunstwerks."
      },
      "authenticity": {
        "title": "Authentizität — Dossier einreichen",
        "desc": "Reichen Sie das Kunstwerk und die Belege zur menschlichen Prüfung durch einen qualifizierten Experten ein.",
        "note": "Die Einreichung eines Dossiers stellt für sich allein kein Echtheitszertifikat dar.",
        "cta": "Dossier einreichen"
      },
      "fingerprint": {
        "title": "Digitaler Fingerabdruck",
        "desc": "Erstellen Sie einen datierten SHA-256-Fingerabdruck der Werkakte, um die Integrität der gespeicherten Daten zu prüfen.",
        "note": "Aktuelle Phase: ARTKIV-Fingerabdruck. Die öffentliche Tezos-Verankerung ist noch nicht aktiv.",
        "cta": "Digitalen Fingerabdruck ansehen"
      },
      "future": "Zukunft vorbereiten",
      "succession": {
        "title": "Übertragung & Nachfolge",
        "desc": "Bereiten Sie Begünstigte, Eigentumssituationen und private Szenarien für die Zukunft Ihrer Sammlung vor.",
        "note": "ARTKIV bietet einen Rahmen für Vorbereitung und Simulation, keine Rechts- oder Steuerberatung.",
        "cta": "Übertragung vorbereiten"
      }
    },
    "addArtwork": "Kunstwerk hinzufügen",
    "buy": "Kauf",
    "confidenceIndex": {
      "high": "Hoch",
      "label": "Vertrauensindex",
      "low": "Niedrig",
      "medium": "Mittel",
      "tooltip": "Index basierend auf den hinterlegten Informationen: Künstler, Jahr, Medium, Kaufpreis und Bildmaterial."
    },
    "contacts": {
      "sub": "Adressbuch"
    },
    "cta": {
      "addFirst": "Mein erstes Kunstwerk hinzufügen"
    },
    "details": "Details ansehen",
    "empty": {
      "subtitle": "Fügen Sie Ihr erstes Kunstwerk hinzu, um Ihre Sammlung zu strukturieren.",
      "title": "Noch keine Kunstwerke"
    },
    "error": {
      "reload": "Seite neu laden",
      "title": "Ladefehler"
    },
    "estimate": {
      "sub": "Bewerten lassen",
      "value": "Schätzung"
    },
    "forSale": "Zum Verkauf",
    "galleries": "Galerien",
    "insurance": {
      "sub": "Schützen",
      "summary": {
        "answered": "Antwort erhalten",
        "ctaFollow": "Verfolgen",
        "ctaNew": "Kunstwerk versichern",
        "desc": "Schützen Sie Ihre Kunstwerke und verfolgen Sie laufende Angebote langfristig.",
        "latestStatus": "Letzter Status",
        "pending": "Läuft",
        "seen": "Gesehen",
        "title": "Versicherung",
        "total": "Gesamt"
      }
    },
    "loading": {
      "auth": "Authentifizierung wird geprüft…",
      "collection": "Sammlung wird geladen…"
    },
    "manageCollections": "Meine Sammlungen verwalten",
    "marketplace": {
      "empty": "Keine Kunstwerke zum Verkauf.",
      "loading": "Kunstwerke werden geladen…"
    },
    "news": {
      "subtitle": "Verfolgen Sie die Neuigkeiten der Künstler Ihrer Sammlung",
      "tabs": {
        "alerts": "Meine Alerts",
        "fairs": "Kunstmessen",
        "sales": "Verkäufe & Rekorde",
        "artists": "Künstler & Messen",
        "galleries": "Galerien"
      },
      "grouped": {
        "title": "Meine Neuigkeiten",
        "subtitle": "Verfolgen Sie Künstler Ihrer Sammlung, Kunstmessen und Ihre bevorzugten Galerien"
      },
      "switchToGalleries": "Galerien anzeigen",
      "switchToArtists": "Künstler anzeigen",
      "stats": {
        "artists": "Beobachtete Künstler",
        "galleries": "Galerien",
        "fairs": "Kommende Messen",
        "alerts": "Aktive Benachrichtigungen"
      }
    },
    "notAvailable": "Nicht verfügbar",
    "plusValue": "Wertzuwachs",
    "proposals": {
      "title": "Ihre Schritte",
      "subtitle": "Behalten Sie alles rund um Ihre Kunstwerke im Blick – klar für heute und für die spätere Weitergabe."
    },
    "propose": {
      "sub": "Museum / Verkauf"
    },
    "putForSale": "Zum Verkauf anbieten",
    "share": {
      "sub": "Berater einladen"
    },
    "shareAccess": "Zugriff teilen",
    "shared": {
      "title": "Mit mir geteilte Sammlungen"
    },
    "sharedCollections": "Geteilte Sammlungen",
    "sincePurchase": "seit dem Kauf",
    "stats": {
      "sub": "Analysieren"
    },
    "subtitle": "Verwalten und bewerten Sie Ihr künstlerisches Vermögen",
    "title": "Ihr Portfolio",
    "totalEstimate": "Aktueller Schätzwert",
    "totalPurchase": "Gesamter Kaufwert",
    "ungrouped": "Nicht zugeordnete Kunstwerke",
    "works": "Ihre Kunstwerke",
    "access": {
      "ctaOpen": "Zugangsbereich öffnen",
      "desc": "Teilen Sie Ihre Sammlung mit einem Experten, Berater oder einer Vertrauensperson.",
      "drawerTitle": "Zugang verwalten",
      "hint": "Jede Person sieht nur, was Sie freigeben.",
      "mobileSummary": "Zugang",
      "tap": "Tippen zum Verwalten",
      "title": "Zugang & Teilen",
      "ctaFindExpert": "Experten finden",
      "ctaShareAccess": "Zugriff teilen",
      "ctaManage": "Verwalten",
      "freeConnection": {
        "title": "✓ Kostenlose Vermittlung (inbegriffen)",
        "description": "Die Vermittlung an einen persönlichen Artkiv-Berater ist vollständig kostenlos.",
        "paidLabel": "Kostenpflichtige Aufträge:",
        "paidText": "angezeigter Preis, ohne Zusatzgebühr (z. B. Bewertung für 149 € → Sie zahlen 149 € zzgl. MwSt.)."
      }
    },
    "emptyShared": {
      "cta": "Sammlung einladen",
      "ctaPrimary": "Sammlung einladen",
      "ctaSecondary": "Mehr erfahren",
      "desc": "Noch keine Sammlung mit Ihnen geteilt.",
      "hint": "Bitten Sie einen Eigentümer, Ihnen Zugang zu gewähren.",
      "title": "Keine geteilten Sammlungen"
    },
    "emptyWorks": {
      "cta": "Erstes Kunstwerk hinzufügen",
      "ctaPrimary": "Erstes Kunstwerk hinzufügen",
      "ctaSecondary": "Demo ansehen",
      "desc": "Beginnen Sie mit der Dokumentation Ihrer Sammlung.",
      "hint": "Fügen Sie Ihr erstes Kunstwerk hinzu.",
      "title": "Keine Kunstwerke"
    },
    "noSharedCollections": "Keine geteilten Sammlungen",
    "noWorks": "Keine Kunstwerke",
    "purchase": "Kaufpreis",
    "purchaseMissingCta": "Kaufpreis hinzufügen",
    "purchaseMissingReadonly": "Kaufpreis nicht angegeben",
    "sharedByMe": {
      "access": {
        "edit": "Bearbeiten",
        "view": "Ansehen"
      },
      "accessLabel": "Zugriffsebene",
      "collectionsCount": "{{count}} Sammlung(en)",
      "cta": {
        "editAccess": "Zugang bearbeiten",
        "manage": "Verwalten",
        "refresh": "Aktualisieren"
      },
      "empty": {
        "cta": "Berater einladen",
        "desc": "Sie haben Ihre Sammlung noch mit niemandem geteilt.",
        "title": "Noch kein Teilen"
      },
      "hint": "Geteilte Personen sehen nur, was Sie freigeben.",
      "loading": "Laden…",
      "stats": {
        "people": "{{count}} Person(en)",
        "shares": "{{count}} Freigabe(n)"
      },
      "subtitle": "Verwalten Sie, wer Zugang zu Ihren Sammlungen hat.",
      "title": "Teilen",
      "withYou": "Mit Ihnen geteilt"
    },
    "viewDetails": "Details anzeigen",
    "errors": {
      "module": "In diesem Modul ist ein Fehler aufgetreten.",
      "delegatedMissing": "Der delegierte Zugriff wurde nicht gefunden oder ist abgelaufen.",
      "delegatedForbidden": "Sie haben keine Berechtigung mehr, diese Inhalte anzusehen.",
      "collectionsLoad": "Die Sammlungen konnten nicht geladen werden.",
      "sharedCollectionsLoad": "Die geteilten Sammlungen konnten nicht geladen werden."
    },
    "navigation": {
      "overview": "Übersicht",
      "overviewHint": "Wie steht meine Sammlung da?",
      "contactsAccess": "Kontakte & Zugriffe",
      "contactsAccessHint": "Mit wem arbeite ich und wer darf was sehen?",
      "collection": "Meine Werke",
      "collectionHint": "Was besitze ich?",
      "sharing": "Freigaben",
      "marketNews": "Markt & Aktuelles",
      "marketNewsHint": "Was passiert rund um meine Künstler und den Markt?",
      "proposals": "Vorschläge",
      "actions": "Aktionen",
      "actionsHint": "Was möchte ich mit meinen Kunstwerken tun?"
    },
    "market": {
      "title": "Markt & Aktuelles",
      "subtitle": "Die Verkäufe, Ausstellungen und Informationen, die die Künstler Ihrer Sammlung wirklich betreffen.",
      "preferences": "Meine Beobachtungen verwalten",
      "viewAll": "Alle ansehen",
      "estimate": "Schätzung",
      "details": "Detail ansehen",
      "why": "Warum Sie das sehen",
      "read": "Aktuelles lesen",
      "reason": { "collection": "Künstler in Ihrer Sammlung", "priority": "Künstler mit Priorität beobachtet" },
      "type": { "exhibition": "Ausstellung" },
      "stats": {
        "watched": "Beobachtete Künstler", "watchedDetail": "Sammlung + Beobachtungen",
        "auctions": "Passende Verkäufe", "auctionsDetail": "Bevorstehend",
        "unread": "Ungelesene Neuigkeiten", "unreadDetail": "Zu entdecken",
        "events": "Bevorstehendes Ereignis", "eventsDetail": "Messen & Ausstellungen"
      },
      "tabs": { "auctions": "Bevorstehende Verkäufe", "news": "Aktuelles", "followed": "Meine Beobachtungen" },
      "auctions": { "title": "Bevorstehende Verkäufe für Ihre Sammlung", "subtitle": "Ausgewählt anhand Ihrer beobachteten Künstler.", "empty": "Noch kein Verkauf zu Ihren Künstlern gefunden. ARTKIV beobachtet den Markt weiter." },
      "news": { "title": "Aktuelles Ihrer Künstler", "subtitle": "Partnergalerien, Ausstellungen, Messen und Markt.", "empty": "Noch keine Neuigkeiten zu Ihren Künstlern. ARTKIV beobachtet Galerien, Messen und Ausstellungen weiter." },
      "followed": {
        "title": "Beobachtete Künstler",
        "subtitle": "Künstler Ihrer Sammlung werden automatisch beobachtet. Fügen Sie eine Priorität hinzu, um die Beobachtung zu verstärken.",
        "add": "Künstler folgen",
        "addPrompt": "Name des zu folgenden Künstlers:",
        "inCollection": "In meiner Sammlung",
        "priority": "Mit Priorität beobachtet",
        "prioritize": "Mit Priorität folgen",
        "unprioritize": "Priorität entfernen",
        "note": "Kein Künstler wird doppelt gezählt: Die Summe vereint Ihre Sammlung und Ihre manuellen Beobachtungen.",
        "empty": "Noch kein beobachteter Künstler. Fügen Sie Werke hinzu oder folgen Sie einem Künstler."
      }
    },
    "collectionSummary": {
      "summary": "Übersicht Ihrer Sammlung",
      "artworks": "Werke",
      "collections": "Sammlungen",
      "note": "Damit das Dashboard übersichtlich bleibt, finden Sie die vollständige Ansicht im Menü unter „Sammlungen“.",
      "ctaAdd": "Werk hinzufügen"
    },
    "breakdown": {
      "title": "Positionierung der Sammlung",
      "subtitle": "Aufteilung nach Medium, Art, Zeitraum und Standort",
      "hide": "Ausblenden",
      "show": "Meine Sammlung analysieren"
    },
    "losses": {
      "title": "Verlust & Diebstahl",
      "description": "Melden Sie ein verschwundenes, gestohlenes oder zerstörtes Werk für Ihre steuerliche und versicherungsbezogene Dokumentation.",
      "cta": "Register anzeigen"
    }
  },
  "authenticityRequest": {
    "eyebrow": "Authentizität",
    "title": "Authentizitätsdossier einreichen",
    "intro": "Stellen Sie Informationen und Dokumente zusammen, die für die Prüfung des Kunstwerks hilfreich sind. Das Dossier kann anschließend an einen qualifizierten Experten weitergeleitet werden.",
    "notice": "ARTKIV strukturiert und übermittelt das Dossier. Die Einreichung ist kein Zertifikat: Nur ein qualifizierter Experte kann eine Stellungnahme oder ein Authentizitätsdokument ausstellen.",
    "artwork": {
      "label": "Betroffenes Kunstwerk",
      "placeholder": "Kunstwerk auswählen…",
      "empty": "Fügen Sie das Kunstwerk zuerst Ihrer Sammlung hinzu.",
      "add": "Kunstwerk hinzufügen",
      "existingCertificate": "Für dieses Werk ist bereits ein Zertifikat vermerkt."
    },
    "provenance": {
      "label": "Kontext & Provenienz",
      "help": "Geben Sie an, was Sie wissen: Erwerbsquelle, Galerie, Auktionshaus, Künstler, Familiengeschichte, Ausstellung, Publikation oder bekannte Besitzgeschichte.",
      "placeholder": "Z. B. erworben bei Galerie…, Rechnung vom…, Familienprovenienz seit…"
    },
    "documents": {
      "label": "Unterlagen",
      "help": "Fügen Sie verfügbare Belege hinzu: Rechnung, vorhandenes Zertifikat, Vorder-/Rückseitenfotos, Signatur, Etiketten, Provenienzunterlagen, Publikation oder früheres Gutachten.",
      "cta": "Dokumente hinzufügen"
    },
    "notes": {
      "label": "Ihre Anfrage",
      "placeholder": "Beschreiben Sie Ihre Frage, besondere Zweifel oder den Kontext der Anfrage."
    },
    "declaration": "Ich bestätige, dass die Angaben nach bestem Wissen richtig sind und ich berechtigt bin, diese Dokumente zur Prüfung einzureichen.",
    "submit": "Dossier einreichen",
    "submitting": "Dossier wird gesendet…",
    "errors": {
      "artworks": "Ihre Kunstwerke konnten nicht geladen werden.",
      "artworkRequired": "Wählen Sie das betroffene Kunstwerk.",
      "declarationRequired": "Bestätigen Sie vor dem Absenden die Erklärung.",
      "fileType": "Nicht unterstütztes Format. Verwenden Sie PDF, JPG, PNG oder WebP.",
      "fileSize": "Eine Datei überschreitet das Limit von 15 MB.",
      "submit": "Das Dossier konnte nicht gesendet werden. Prüfen Sie die Supabase-Konfiguration und versuchen Sie es erneut."
    },
    "success": {
      "title": "Dossier übermittelt",
      "text": "Ihr Dossier wurde gespeichert. Der Status wechselt zu „in Prüfung“, sobald es übernommen wurde.",
      "dashboard": "Zurück zu Aktionen",
      "collection": "Meine Sammlung ansehen"
    }
  },
  "demo": {
    "advisor": {
      "badge": "ART ADVISOR PLAN",
      "cta": {
        "demo": "Request a live demo",
        "start": "Start now"
      },
      "final": {
        "cta": {
          "start": "Start for free",
          "team": "Talk to our team"
        },
        "note": "No commitment • Cancel anytime",
        "subtitle": "Join the art advisors who manage their client collections with Artkiv",
        "title": "Ready to transform your practice?"
      },
      "hero": {
        "subtitle": "The essential tools for art advisors managing up to 5 collectors at once",
        "title": "Manage multiple client collections like a pro"
      },
      "price": "€99",
      "section": {
        "compare": {
          "title": "Need more? Switch to Art Advisor Premium"
        },
        "features": {
          "subtitle": "Features designed for your art advisory practice",
          "title": "Everything you need"
        },
        "screenshots": {
          "subtitle": "See how Artkiv simplifies your daily work",
          "title": "The interface in pictures"
        }
      },
      "testimonials": {
        "title": "They trust us"
      }
    },
    "advisorPremium": {
      "api": {
        "badge": "IN DEVELOPMENT"
      },
      "badge": "ART ADVISOR PREMIUM PLAN",
      "cta": {
        "compare": "Compare plans",
        "demo": "Request a personalised demo"
      },
      "features": {
        "subtitle": "Everything in the Art Advisor plan, and more",
        "title": "Premium features"
      },
      "final": {
        "cta": {
          "demo": "Book a personalised demo",
          "plans": "View all plans"
        },
        "note": "Wir klären gemeinsam Ihren Bedarf, bevor Sie sich verpflichten.",
        "subtitle": "Sprechen wir über Ihr Kundenportfolio und Ihre Berichte.",
        "title": "Ready to scale up?"
      },
      "hero": {
        "subtitle": "Unbegrenzte Kunden, Vision-Analysen für jeden, Berichte unter Ihrem Namen.",
        "title": "The complete solution for professionals"
      },
      "price": "€199",
      "roi": {
        "title": "Calculate your ROI"
      },
      "testimonial": {
        "title": "They trust us"
      },
      "usecases": {
        "subtitle": "Different profiles, one shared solution",
        "title": "Who uses Art Advisor Premium?"
      },
      "why": {
        "subtitle": "The benefits that make all the difference",
        "title": "Why go Premium?"
      }
    },
    "fo": {
      "badge": "ENTERPRISE SOLUTION",
      "features": {
        "title": "Enterprise features"
      },
      "final": {
        "title": "Let’s discuss your needs"
      },
      "hero": {
        "cta": {
          "demo": "Schedule a presentation",
          "quote": "Request a tailored quote"
        },
        "subtitle": "The art wealth management platform for demanding family offices, private banks and institutions.",
        "title": "Artkiv Family Office"
      },
      "industries": {
        "title": "Our institutional clients"
      },
      "onboarding": {
        "title": "Enterprise onboarding process"
      },
      "pricing": {
        "title": "Pricing options"
      },
      "security": {
        "title": "Bank-grade security & compliance"
      },
      "why": {
        "title": "Why Artkiv for your Family Office?"
      }
    }
  },
  "donations": {
    "add": "Schenkung erfassen",
    "empty": "Noch keine Schenkungen erfasst",
    "subtitle": "Schenkungen und Übertragungen",
    "table": {
      "actions": "Aktionen",
      "artwork": "Kunstwerk",
      "beneficiary": "Begünstigter",
      "date": "Datum"
    },
    "title": "Schenkungen"
  },
  "estimates": {
    "confidence": {
      "high": "Hoch",
      "low": "Niedrig",
      "medium": "Mittel"
    },
    "disclaimer": "Die angegebenen Werte dienen ausschließlich Informationszwecken.",
    "empty": "Für diese Sammlung liegen noch keine Schätzungen vor.",
    "lastUpdate": "Letzte Aktualisierung",
    "loading": "Schätzungen werden geladen…",
    "method": {
      "ai": {
        "desc": "Algorithmische Analyse historischer Daten"
      },
      "expert": {
        "desc": "Bewertung durch zertifizierte Kunstexperten"
      },
      "market": {
        "desc": "Vergleich mit aktuellen Marktdaten"
      }
    },
    "premiumBadge": "Erweiterte Schätzungen nur für Premium-Konten",
    "refresh": "Schätzung aktualisieren",
    "run": "Schätzung starten",
    "subtitle": "Bewertung Ihrer Kunstwerke nach anerkannten Methoden",
    "title": "Schätzungen",
    "value": "Wert"
  },
  "estimation": {
    "artwork": {
      "badge": {
        "estimated": "✓ Geschätzt"
      },
      "lastEstimate": "Letzte Schätzung: {{value}} €",
      "noEstimate": "Noch nicht geschätzt",
      "untitled": "Ohne Titel"
    },
    "guide": {
      "assurance": {
        "text": "Nutzen Sie die Punktemethode oder Vergleichswerke und ergänzen Sie das Versicherungsschätzungsmodul, um Ihre Belege zusammenzustellen.",
        "title": "Für Ihre Versicherung"
      },
      "highValue": {
        "text": "Die CNES-Expertise ist in Frankreich für die Versicherung obligatorisch und wird bei größeren Transaktionen dringend empfohlen. Kontaktieren Sie unsere zugelassenen Experten.",
        "title": "Für hochwertige Werke (> 80.000 €)"
      },
      "note": "💡 Sie können mehrere Methoden für dasselbe Kunstwerk verwenden. Jede Schätzung wird in der Werkhistorie archiviert, um den Wertverlauf langfristig zu verfolgen.",
      "sale": {
        "text": "Bevorzugen Sie Vergleichswerke, um den aktuellen Marktpreis zu ermitteln. Wenn Ihr Künstler wenig Marktdaten hat, bietet die Punktemethode eine solide Grundlage.",
        "title": "Zum Verkauf Ihres Werks"
      },
      "succession": {
        "text": "Nutzen Sie das Nachlassbewertungsmodul, das automatisch die Steuerregeln Ihrer Jurisdiktion anwendet (Frankreich, Belgien, Schweiz).",
        "title": "Für eine Erbschaft"
      },
      "title": "💡 Hilfe bei der Auswahl?"
    },
    "methods": {
      "assurance": {
        "cost": "Kostenlos (Gutachten optional)",
        "description": "Erstellen Sie ein vollständiges Belegpaket für Ihren Versicherer: deklarierter Wert, Kaufnachweise, Vergleichswerte, Gutachten falls erforderlich.",
        "duration": "15–20 Min.",
        "feature1": "Vollständiges Belegdossier",
        "feature2": "Berechneter Wiederbeschaffungswert",
        "feature3": "CNES-Empfehlungen (Frankreich) bei > 80.000 €",
        "feature4": "Bereit für Ihren Versicherer",
        "title": "Versicherungsschätzung",
        "whenToUse": "Zum Abschluss oder zur Verlängerung Ihrer Kunstversicherung. Berechnet den Wiederbeschaffungswert (Aufschlag 20–30% auf Marktwert)."
      },
      "button": {
        "quote": "Angebot anfragen",
        "start": "Diese Methode starten"
      },
      "comparables": {
        "cost": "Kostenlos",
        "description": "Marktanalyse auf Basis ähnlicher Verkäufe: gleicher Künstler, Medium, Abmessungen, Periode...",
        "duration": "10–15 Min.",
        "feature1": "Reale Marktdaten",
        "feature2": "Ausreißer-Filterung",
        "feature3": "Aktuelle Nachfrage abgebildet",
        "feature4": "Mehrere Quellen (Artprice, Artnet, Galerien)",
        "title": "Vergleichswerke",
        "whenToUse": "Ideal zur Verkaufsvorbereitung oder für Künstler mit aktivem Markt. Sie müssen die vergleichbaren Verkäufe (Auktionen, Galerien) selbst eintragen — außer ein Art-Advisor-Experte übernimmt das für Sie."
      },
      "points": {
        "cost": "Kostenlos",
        "description": "Bewertung auf Basis objektiver Kriterien: Technik, Abmessungen, Periode, Zustand, Signatur, Seltenheit...",
        "duration": "5 Min.",
        "feature1": "Automatisch berechneter Score",
        "feature2": "Präzise Schätzungsspanne",
        "feature3": "Von Versicherern anerkannt",
        "feature4": "Transparente Methodik",
        "title": "Punktemethode",
        "whenToUse": "Ideal für Versicherungen oder eine erste Schätzung ohne aktuelle Vergleichsverkäufe. Besonders geeignet für klassische Werke oder wenig gehandelte Künstler."
      },
      "recommended": {
        "badge": "Empfohlen"
      },
      "subtitle": "Jede Methode verfolgt ein spezifisches Ziel. Wählen Sie die Methode, die Ihren Anforderungen entspricht.",
      "succession": {
        "cost": "Kostenlos",
        "description": "Werkzeug zur Nachlassplanung und Steuererklärung je nach Jurisdiktion: Frankreich (Pauschale 5%), Belgien (Dation 120%), Schweiz (26 Kantone).",
        "duration": "20–30 Min.",
        "feature1": "Steuerskalen nach Land",
        "feature2": "Simulationen der Erbschaftssteuer",
        "feature3": "Dationsempfehlungen (> 150.000 €)",
        "feature4": "Bericht für den Notar",
        "title": "Nachlassbewertung",
        "whenToUse": "Um Erbschaftssteuer zu antizipieren, eine Schenkung vorzubereiten oder mit Ihrem Notar/Family Office zusammenzuarbeiten. Steuerberechnungen nach geltendem Recht."
      },
      "title": "Schätzungsmethode wählen",
      "whenToUseLabel": "Wann verwenden?"
    },
    "page": {
      "subtitle": "Wählen Sie die Methode, die Ihrem Ziel entspricht",
      "title": "Ein Kunstwerk schätzen"
    },
    "pro": {
      "expertise": {
        "button": "Angebot anfragen",
        "desc": "Physische Expertise durch einen CNES-zugelassenen Experten (in Frankreich ab 80.000 € obligatorisch). Vor-Ort-Besuch, eingehende Untersuchung, zertifizierter Bericht.",
        "point1": "Physische Begutachtung des Werks",
        "point2": "Garantierter anerkannter Wert",
        "point3": "Ab 300 € (Artkiv-Provision enthalten)",
        "title": "Vollständige CNES-Expertise – Frankreich"
      },
      "footer": "💡 Artkiv erhält eine Provision auf Expertenleistungen, um die Plattformqualität zu erhalten und neue Werkzeuge zu entwickeln",
      "subtitle": "Für Werke, die eine Expertenvalidierung oder ein offizielles Gutachten erfordern",
      "title": "Artkiv-Profiservices",
      "validation": {
        "button": "Validierung anfragen",
        "desc": "Ein Artkiv-Experte prüft Ihre Schätzung (Punkte oder Vergleichswerte) und bestätigt die Marktkonformität. Ideal zur Stärkung Ihres Versicherungsdossiers.",
        "point1": "Validierung innerhalb von 48 Stunden",
        "point2": "Unterzeichnete Bestätigung inklusive",
        "point3": "150 € (Artkiv-Provision enthalten)",
        "title": "Validierung durch Artkiv-Experten"
      }
    },
    "selected": {
      "changeArtwork": "Kunstwerk wechseln"
    },
    "step1": {
      "addArtwork": "Kunstwerk hinzufügen",
      "empty": "Sie haben noch kein Kunstwerk in Ihrer Sammlung.",
      "title": "Zu schätzendes Kunstwerk auswählen"
    },
    "steps": {
      "chooseArtwork": "Kunstwerk auswählen",
      "chooseMethod": "Methode auswählen"
    },
    "ui": {
      "filtrerLaSelection": "Auswahl filtern",
      "retrouvezRapidementUneUvreParTitreArtisteTechniqueOu": "Finden Sie ein Werk schnell nach Titel, Künstler, Technik oder Untersammlung.",
      "reinitialiser": "Zurücksetzen",
      "rechercherTitreArtiste": "Nach Titel oder Künstler suchen…",
      "tousLesArtistes": "Alle Künstler",
      "toutesLesTechniques": "Alle Techniken",
      "toutesLesSousCollections": "Alle Untersammlungen",
      "uvreSAfficheeSSur": "angezeigte(s) Werk(e) von",
      "aucuneUvreNeCorrespondAuxFiltres": "Keine Werke entsprechen diesen Filtern.",
      "voirToutesLesUvres": "Alle Werke anzeigen",
      "filterResults": "{{shown}} von {{total}} Kunstwerk(en) angezeigt"
    }
  },
  "expert": {
    "add": {
      "title": "Experten hinzufügen"
    },
    "alert": {
      "error": "Fehler beim Hinzufügen des Experten: {{error}}",
      "mustBeLoggedIn": "Sie müssen angemeldet sein, um einen Experten hinzuzufügen.",
      "success": "Experte erfolgreich hinzugefügt."
    },
    "billing": {
      "cancel": "Abonnement kündigen",
      "error": "Abrechnungsinformationen konnten nicht geladen werden",
      "invoice": {
        "amount": "Betrag",
        "date": "Datum",
        "download": "Herunterladen",
        "number": "Nr.",
        "status": "Status"
      },
      "invoices": "Rechnungen",
      "manage": "Abonnement verwalten",
      "plan": {
        "basic": "Art Advisor",
        "premium": "Art Advisor Premium"
      },
      "status": {
        "active": "Aktiv",
        "canceled": "Gekündigt",
        "pastDue": "Überfällig",
        "trial": "Testphase"
      },
      "subtitle": "Ihre Abonnements und Rechnungen",
      "title": "Abrechnung",
      "upgrade": "Upgrade durchführen"
    },
    "button": {
      "submit": "Speichern"
    },
    "clients": {
      "action": {
        "notes": "Notizen",
        "open": "Öffnen",
        "permissions": "Berechtigungen"
      },
      "empty": "Noch keine Kunden zugeordnet",
      "search": "Kunde suchen",
      "subtitle": "Zugriff auf freigegebene Sammlungen",
      "table": {
        "access": "Zugriff",
        "actions": "Aktionen",
        "artworks": "Kunstwerke",
        "client": "Kunde",
        "collections": "Sammlungen"
      },
      "title": "Meine Kunden",
      "cockpitDescription": "Übersicht über Ihre betreuten Kunden und deren Sammlungen."
    },
    "dashboard": {
      "action": {
        "billing": "Abrechnung",
        "invite": "Kunden einladen",
        "newAnalysis": "Analyse starten",
        "reports": "Berichte"
      },
      "error": "Dashboard konnte nicht geladen werden",
      "loading": "Dashboard wird geladen…",
      "quickActions": "Schnellaktionen",
      "stats": {
        "analyses": "Analysen",
        "artworks": "Kunstwerke",
        "clients": "Kunden",
        "pending": "Ausstehend"
      },
      "subtitle": "Verwalten Sie Ihre Mandate und Analysen",
      "title": "Experten-Dashboard"
    },
    "Dashboard": {
      "complete": {
        "common": {
          "expert": "Experte/Expert",
          "userNotLoggedIn": "Benutzer ist nicht angemeldet",
          "errorWithMessage": "Fehler: {{message}}",
          "loading": "Wird geladen…",
          "cancel": "Abbrechen",
          "send": "Senden",
          "sending": "Wird gesendet…"
        },
        "errors": {
          "sharedDashboardLoad": "Das Modul für geteilte Sammlungen konnte nicht geladen werden."
        },
        "profile": {
          "updated": "Profil aktualisiert.",
          "saveError": "Beim Speichern des Profils ist ein Fehler aufgetreten.",
          "visibilityError": "Beim Ändern der Sichtbarkeit ist ein Fehler aufgetreten.",
          "photoUpdated": "Foto aktualisiert.",
          "photoUploadError": "Beim Hochladen des Fotos ist ein Fehler aufgetreten.",
          "cvUploaded": "Lebenslauf hochgeladen.",
          "cvUploadError": "Beim Hochladen des Lebenslaufs ist ein Fehler aufgetreten."
        },
        "invites": {
          "emailPlaceholder": "E-Mail-Adresse des Kunden",
          "notePlaceholder": "Kurze Nachricht (optional)"
        },
        "sidebar": {
          "plan": "Tarif {{plan}}",
          "features": {
            "unlimitedClients": "Unbegrenzte Kundenzahl",
            "fullAi": "Vollständige KI-Analysen",
            "customReports": "Individuelle Berichte",
          },
          "manageSubscription": "Abonnement verwalten"
        },
        "services": {
          "pageTitle": "Serviceanfragen",
          "pageSubtitle": "Verwalten Sie Anfragen Ihrer Kunden zu Expertisen, Bewertungen und spezialisierten Leistungen.",
          "types": {
            "custom": "Anfrage",
            "validation": "Bewertung / Validierung",
            "authentication": "Authentifizierung",
            "placementInstitution": "Museumsvorschlag",
            "placementAuction": "Auktionsverkauf",
            "service": "Service"
          },
          "collector": "Sammler",
          "collectorWithId": "Sammler ({{id}}…)",
          "invitation": "Einladung",
          "newMessages": "Neue Nachrichten",
          "openArtwork": "Werk öffnen",
          "start": "Starten",
          "markReflection": "Zur Prüfung einreichen",
          "submittedForReview": "Die Anfrage wurde dem Kunden vorgelegt. Sie können die Kommunikation über die Nachrichtenfunktion fortsetzen.",
          "awaitingClientFeedback": "Warten auf Rückmeldung des Kunden",
          "accept": "Annehmen",
          "reject": "Ablehnen",
          "chatWithClient": "Mit dem Kunden schreiben",
          "completedOn": "Service abgeschlossen am {{date}}",
          "acceptLoading": "Wird angenommen…",
          "acceptedClosed": "Kunde angenommen. Die Anfrage wurde geschlossen.",
          "rejectConfirm": "Möchten Sie diesen Kunden wirklich ablehnen?",
          "rejectLoading": "Wird abgelehnt…",
          "rejected": "Anfrage abgelehnt.",
          "conversationOpening": "Unterhaltung wird geöffnet…",
          "conversationOpened": "Unterhaltung geöffnet",
          "conversationOpenError": "Die Unterhaltung konnte nicht geöffnet werden.",
          "columns": {
            "new": "Neu",
            "inProgress": "In Bearbeitung",
            "awaitingFeedback": "Rückmeldung ausstehend",
            "completed": "Abgeschlossen",
            "cancelled": "Storniert"
          },
          "empty": {
            "new": "Keine neuen Anfragen",
            "inProgress": "Keine Anfragen in Bearbeitung",
            "awaitingFeedback": "Keine Rückmeldungen ausstehend",
            "completed": "Noch keine abgeschlossenen Services",
            "cancelled": "Keine stornierten Anfragen"
          },
          "status": {
            "pending": "Neu",
            "in_progress": "In Bearbeitung",
            "awaiting_feedback": "Rückmeldung ausstehend",
            "completed": "Abgeschlossen",
            "cancelled": "Storniert"
          }
        },
        "overview": {
          "noRecentActivity": "Keine aktuellen Aktivitäten",
          "quickActions": {
            "requests": "Anfragen anzeigen",
            "clientCollections": "Kundensammlungen",
            "inventoryReport": "Inventarbericht als PDF",
            "valuationReport": "Bewertungsbericht",
            "inflationReport": "Inflationsbericht (VPI)",
            "artistQuotes": "Künstlerbewertungen",
            "warehouseVisit": "Lagerbesichtigung",
            "inviteClient": "Kunden einladen",
            "profile": "Mein Artkiv-Profil"
          },
          "completionRate": "Abschlussquote",
          "averageTime": "Durchschnittliche Dauer",
          "averageTimeValue": "2,5 Tage",
          "visionQuote": "Analysieren Sie Zustand, Stil und Auffälligkeiten jedes Werks direkt aus den Sammlungen Ihrer Kunden.",
          "visionTool": "Artkiv KI-Visionstool",
          "openVision": "KI-Vision öffnen"
        },
        "collections": {
          "title": "Erfasste Sammlungen",
          "description": "Erfasste Sammlungen sind die Kunstinventare, die Ihre Kunden mit Ihnen geteilt haben. Sie können Werkdetails, Provenienz, Zustand und zugehörige Dokumente einsehen. Dieser Zugang unterstützt Sie dabei, individuelle Empfehlungen zu geben, passende Leistungen vorzuschlagen und die Entwicklung der Kundensammlungen zu verfolgen."
        },
        "portfolio": {
          "clientFallback": "Kunde",
          "clientWithId": "Kunde {{id}}…",
          "collectionFallback": "Sammlung",
          "untitled": "Ohne Titel",
          "noAccessibleCollection": "Derzeit ist keine Kundensammlung zugänglich",
          "inviteFromClientsTab": " Laden Sie im Reiter Kunden einen Kunden ein, um zu beginnen.",
          "analysisTitles": {
            "ai": "KI-gestützte Analyse • Compliance-Prüfung erforderlich",
            "rules": "Regelbasierte Analyse und aggregierte Berechnungen"
          },
          "readyDescription": "Der Umfang ist ausreichend, um das Portfolio belastbar zu beurteilen: Konzentration, Diversifikation und Allokationsentscheidungen werden aussagekräftig.",
          "structuringDescription": "Die Sammlung befindet sich noch im Aufbau. Im Mittelpunkt stehen die Werke, ihre Dokumentation und die zunehmende Dichte, bevor eine vermögensbezogene Allokation bewertet wird.",
          "metrics": {
            "trackedValue": "Erfasster Wert (Schätzung)",
            "valuationCoverageNote": "Für {{coverage}} % der Werke liegt eine Bewertungsgrundlage vor",
            "artworks": "Werke",
            "artistsCategoriesNote": "{{artists}} Künstler • {{categories}} Kategorien",
            "artistConcentration": "Künstlerkonzentration",
            "topThreeShare": "Anteil der drei führenden Künstler am Gesamtwert",
            "dominantArtistsShare": "Anteil der führenden Künstler",
            "technicalDiversity": "Technische Vielfalt",
            "techniquesCount": "{{count}} Techniken",
            "techniquesRecorded": "Erfasste Techniken",
            "documentationCoverage": "Dokumentationsgrad",
            "documentationNote": "Zertifikate, Zustandsberichte und weitere Dokumente vorhanden"
          },
          "volumeWarning": "Volumen",
          "artworkCount": "{{count}} Werk(e)",
          "artworkCount_one": "{{count}} Werk",
          "artworkCount_other": "{{count}} Werke",
          "artistsEmpty": "Ergänzen Sie Bewertungen, damit die Gewichtung der Künstler sichtbar wird.",
          "categoryChartAria": "Verteilung der Werke nach Kategorie",
          "dominantCategoryNote": "Führende Kategorie nach Anzahl der Werke. {{count}} Kategorien identifiziert.",
          "categoryDistributionEmpty": "Die Verteilung wird angezeigt, sobald Werke geteilt wurden.",
          "categoryAllocationEmpty": "Ergänzen Sie Werte, um die wirtschaftliche Gewichtung nach Kategorie zu beurteilen.",
          "valueVsArtworks": "{{valueShare}} % Wert • {{artworkShare}} % Werke",
          "artworksShareTitle": "Anteil der Werke",
          "valueShareTitle": "Wertanteil",
          "valueVolumeEmpty": "Abweichungen zwischen Wert und Volumen werden nach der Bewertung angezeigt.",
          "techniquesEmpty": "Techniken werden angezeigt, sobald die geteilten Werke entsprechend erfasst wurden."
        },
        "tools": {
          "title": "Professionelle Werkzeuge",
          "subtitle": "Werkzeuge für Berichte, Kunstbewertungen und Vor-Ort-Termine.",
          "organizedSubtitle": "Bereiten Sie Ihre Daten vor, erstellen Sie Ihre Analyse und erzeugen Sie anschließend die Unterlagen für Ihre Kunden.",
          "sections": {
            "prepare": {
              "title": "Dossier vorbereiten",
              "description": "Importieren Sie Referenzen, organisieren Sie Ihre Bewertungen und erfassen Sie Informationen vor Ort."
            },
            "analyze": {
              "title": "Analysieren und bewerten",
              "description": "Verknüpfen Sie die verfügbaren Daten zu einer fundierten professionellen Analyse."
            },
            "deliver": {
              "title": "Kundenunterlage erstellen",
              "description": "Überführen Sie Ihre Arbeit in ein klares, anpassbares und mit dem Kunden teilbares Dokument."
            }
          },
          "categories": {
            "prepare": "Vorbereitung",
            "analysis": "Analyse",
            "report": "Bericht"
          },
          "badges": {
            "vision": "ARTKIV Vision",
            "advisorPremium": "Art Advisor Premium"
          },
          "inventory": {
            "title": "Inventarbericht",
            "kicker": "Individuelles PDF",
            "description": "Erstellen Sie einen PDF-Bericht zur Sammlung eines Kunden mit Ihrem eigenen Branding. Wählen Sie die enthaltenen Felder aus und exportieren Sie das Dokument mit einem Klick.",
            "cta": "Berichtsgenerator öffnen"
          },
          "valuation": {
            "title": "Bewertungsbericht",
            "description": "Erstellen Sie einen strukturierten Bewertungsbericht für Versicherung, Nachlassplanung, Verkauf oder Besicherung mit Wertspanne, Quellen und Begründung. Export als PDF und bearbeitbare Word-Datei.",
            "cta": "Bericht erstellen"
          },
          "inflation": {
            "title": "Inflationsbereinigter Wert",
            "description": "Passen Sie den Kaufpreis an die Entwicklung der Lebenshaltungskosten an. Verfügbar, sobald Kaufpreis und Erwerbsdatum eingetragen sind, ohne dass eine Vergleichswertanalyse erforderlich ist. Export als PDF und Word.",
            "cta": "Bericht erstellen",
            "calculateCta": "Aktualisierten Wert berechnen"
          },
          "artistQuotes": {
            "title": "Künstlerbewertungen",
            "kicker": "Private Expertenbibliothek",
            "description": "Nutzen Sie Ihre A/B/C-Künstlerprofile und persönlichen Wertspannen nach Medium und Format erneut. Die Bewertungen bleiben Ihrem Expertenkonto zugeordnet und können künftige Berichte vorbefüllen.",
            "cta": "Meine Bewertungen öffnen"
          },
          "warehouse": {
            "title": "Lagerbesichtigung",
            "kicker": "Vor-Ort-Prüfung",
            "description": "Nutzen Sie die mobile Oberfläche bei Lagerbesichtigungen. Prüfen Sie Werke nach Standort, dokumentieren Sie Zustand und Risiko und ergänzen Sie Ihre Beobachtungen vor Ort.",
            "cta": "Besichtigung starten"
          },
          "artprice": {
            "title": "Artprice-Import",
            "kicker": "Marktdaten",
            "description": "Importieren Sie Auktionsergebnisse aus Artprice, um Werkdatensätze mit Marktbelegen anzureichern.",
            "cta": "Daten importieren"
          },
          "curatorial": {
            "title": "KI-kuratorische Notiz",
            "description": "Erstellen Sie anhand der Sammlungsdaten eine strukturierte kuratorische Notiz nach thematischen Schwerpunkten. Export als PDF und bearbeitbare Word-Datei.",
            "cta": "KI-Vision öffnen"
          },
          "conservation": {
            "title": "Erhaltungszustand",
            "kicker": "Vollständiger Bericht",
            "description": "Öffnen Sie den nach Erhaltungszustand gefilterten Inventarbericht, um Werke mit besonderem Handlungsbedarf zu identifizieren.",
            "cta": "Zustandsbericht"
          },
          "comparables": {
            "title": "Bewertung anhand von Vergleichswerten",
            "kicker": "Expertenbewertung",
            "description": "Bewerten Sie ein Werk anhand interner und externer Vergleichswerte. Die Verfeinerung mit KI Vision ist Experten vorbehalten.",
            "cta": "Bewertung starten"
          }
        },
        "acceptContact": {
          "title": "Anfrage abschließen",
          "body": "Sie bestätigen den Abschluss dieser Anfrage. <free>Beim Abschluss fallen keine Gebühren an</free>: Eine eventuelle Vermittlungsgebühr wird bei der Annahme des Sammlers bezahlt.",
          "confirm": "Abschluss bestätigen"
        }
      },
      "clientInvites": {
        "introFee": {
          "feeBadge": "Vermittlungsgebühr: 49 € netto, einmalig für diesen Sammler",
          "includedBadge": "Vermittlung in Ihrem Abonnement enthalten",
          "modalTitle": "Diesen Sammler annehmen",
          "modalBody": "Dieser Sammler hat Sie über die Plattform kontaktiert. Um ihn anzunehmen und zu antworten, zahlen Sie einmalig eine Vermittlungsgebühr von <price>49 € netto (58,80 € brutto)</price> per Karte. Danach gehört die Beziehung Ihnen: keine weiteren Gebühren für diesen Sammler.",
          "modalSubscribe": "Mit einem Art-Advisor-Abonnement sind Vermittlungen inklusive und unbegrenzt.",
          "seePlans": "Abonnements ansehen",
          "pay": "49 € netto per Karte zahlen",
          "paying": "Weiterleitung zur Zahlung…",
          "paidAccepted": "Zahlung erhalten: Der Sammler wurde angenommen.",
          "notPaidYet": "Zahlung noch nicht bestätigt. Bitte gleich erneut versuchen.",
          "confirmError": "Zahlung konnte nicht bestätigt werden. Kontaktieren Sie den Support, falls Sie belastet wurden.",
          "canceled": "Zahlung abgebrochen. Der Sammler bleibt ausstehend.",
          "error": "Zahlung konnte nicht gestartet werden. Bitte erneut versuchen."
        },
        "accepted": "Dossier-Prüfung akzeptiert.",
        "acceptError": "Fehler beim Akzeptieren.",
        "declined": "Einladung abgelehnt.",
        "declineError": "Fehler beim Ablehnen.",
        "empty": "Keine ausstehenden Einladungen.",
        "expires": "Läuft ab am",
        "loadError": "Einladungen konnten nicht geladen werden.",
        "messageLabel": "Nachricht",
        "subtitle": "Akzeptieren oder lehnen Sie den Zugang zu einer geteilten Sammlung ab.",
        "title": "Sammlungseinladungen",
        "unknownClient": "Sammler",
        "invitedAt": "Erhalten am"
      },
      "actions": {
        "addNote": "Notiz hinzufügen",
        "inviteExpert": "Experten einladen",
        "removeAccess": "Zugang entfernen",
        "overview": "Dashboard",
        "clients": "Kunden",
        "collections": "Sammlungen",
        "invitations": "Einladungen",
        "activity": "Aktivität",
        "aiAnalyses": "KI-Analysen",
        "reports": "Berichte",
        "new": "NEU",
        "services": "Anfragen",
        "outils": "Werkzeuge",
        "billing": "Abrechnung",
        "profile": "Berufsprofil",
        "manageSubscription": "Abonnement verwalten",
        "collaborateurs": "Mitarbeiter",
        "missions": "Missionen"
      },
      "alerts": {
        "none": "Keine Benachrichtigungen.",
        "title": "Benachrichtigungen"
      },
      "clients": {
        "empty": "Noch keine Kunden.",
        "loading": "Kunden werden geladen…",
        "none": "Keine Kunden vorhanden.",
        "search": "Kunden suchen…",
        "subtitle": "Verwalten Sie Ihre Kunden, Familien und betreute Sammlungen.",
        "title": "Kundenverwaltung",
        "viewAnalyses": "KI-Analysen anzeigen",
        "viewCollection": "Sammlung anzeigen",
        "viewDocuments": "Geteilte Dokumente anzeigen"
      },
      "invitations": {
        "accept": "Akzeptieren",
        "decline": "Ablehnen",
        "none": "Keine Einladungen.",
        "title": "Erhaltene Einladungen"
      },
      "invites": {
        "emailInvalid": "Ungültige E-Mail.",
        "emailLabel": "Kunden-E-Mail",
        "error": "Einladung fehlgeschlagen. Bitte erneut versuchen.",
        "list": {
          "empty": "Noch keine Einladungen gesendet.",
          "title": "Gesendete Einladungen"
        },
        "noteLabel": "Persönliche Nachricht (optional)",
        "send": "Einladung senden",
        "sending": "Wird gesendet…",
        "subtitle": "Laden Sie Ihre Kunden ein, ein Artkiv-Konto zu erstellen und ihre Sammlungen zu teilen.",
        "success": "Einladung erfolgreich gesendet.",
        "title": "Kunden einladen"
      },
      "kanban": {
        "new": "Neu",
        "inProgress": "In Bearbeitung",
        "awaitingFeedback": "Warte auf Rückmeldung",
        "completed": "Abgeschlossen",
        "cancelled": "Storniert",
        "emptyNew": "Nichts Neues hier",
        "emptyInProgress": "Keine laufenden Anfragen",
        "emptyAwaiting": "Keine ausstehende Rückmeldung",
        "emptyCompleted": "Noch keine abgeschlossenen Leistungen",
        "emptyCancelled": "Nichts zu melden (gute Nachricht)"
      },
      "modal": {
        "confirmDecline": {
          "cancel": "Abbrechen",
          "confirm": "Ablehnen",
          "text": "Möchten Sie diese Einladung wirklich ablehnen?",
          "title": "Einladung ablehnen"
        },
        "removeAccess": {
          "cancel": "Abbrechen",
          "confirm": "Entfernen",
          "text": "Möchten Sie den Zugang dieses Kunden entfernen?",
          "title": "Zugang entfernen"
        }
      },
      "notes": {
        "add": "Notiz hinzufügen",
        "none": "Keine Notizen gespeichert.",
        "placeholder": "Notiz schreiben…",
        "title": "Interne Notizen"
      },
      "outils": {
        "title": "Professionelle Werkzeuge",
        "subtitle": "Ihre Expertenwerkzeuge für Berichte, Bewertungen und Vor-Ort-Besuche."
      },
      "overview": {
        "activeCollections": "Aktive Sammlungen",
        "currentRequests": "Laufende Anfragen",
        "activeClients": "Aktive Kunden",
        "completedServices": "Abgeschlossene Leistungen",
        "recentActivity": "Letzte Aktivitäten",
        "portfolioAnalysisTitle": "Analyse des Kundenportfolios",
        "portfolioAnalysisHint": "Wert, Künstler, Dokumentation und Konservierung — im Detail.",
        "quickActions": "Schnellaktionen",
        "performance": "Leistung",
        "completionRate": "Abschlussquote",
        "avgTime": "Durchschnittliche Zeit",
        "noRecentActivity": "Keine aktuellen Aktivitäten",
        "trendThisMonthPlus2": "+2 diesen Monat",
        "trendThisMonthPlus5": "+5 diesen Monat"
      },
      "permissions": {
        "expired": "Zugang abgelaufen",
        "expires": "Läuft ab am {{date}}",
        "fullAccess": "Vollzugriff",
        "readOnly": "Nur lesen",
        "renew": "Zugang erneuern",
        "title": "Zugang & Berechtigungen"
      },
      "plan": {
        "feature1": "Unbegrenzte Kunden",
        "feature2": "Vollständige KI-Analysen",
        "feature3": "Personalisierte Berichte",
      },
      "portfolio": {
        "kpiValueTracked": "Erfasster Wert (Schätzung)",
        "kpiValueNote": "der Kunstwerke mit Bewertungsgrundlage",
        "kpiArtworks": "Kunstwerke",
        "artists": "Künstler",
        "mediums": "Medien",
        "kpiArtistConcentration": "Künstlerkonzentration",
        "kpiArtistNote": "Anteil der 3 dominanten Künstler am Gesamtwert",
        "kpiArtistNoteAlt": "Anteil der dominanten Künstler",
        "kpiMediumDiversity": "Medienvielfalt",
        "kpiMediumOk": "Ausgewogene Verteilung",
        "kpiMediumWeak": "Diversifizierung erforderlich",
        "kpiDocCoverage": "Dokumentationsabdeckung",
        "kpiDocNote": "Zertifikate, Zustandsberichte und Dokumente vorhanden",
        "liquidityPotential": "Potenzieller Liquiditätswert",
        "liquidityNote": "Score berechnet aus Wert, Künstler, Dokumenten, Vergleichen, Medium, Fotos, Zertifikat und Zustandsbericht",
        "titleLabel": "Expertenportfolio-Analyse",
        "title": "Expertenblick auf ausgewählten und Hauptkunden",
        "subtitle": "Standardmäßig fokussiert das Dashboard auf den Hauptkunden — denjenigen mit der reichhaltigsten Vermögensanalyse. Sie können die Analyse dann nach Sammlung verfeinern.",
        "focus": "Fokus",
        "autoMajorClient": "Automatischer Hauptkunde",
        "noSharedCollection": "Keine geteilte Sammlung",
        "noAccessibleCollection": "Keine zugängliche Sammlung",
        "updating": "Wird aktualisiert…",
        "artworksAnalyzedTotal": "{{count}} analysierte Kunstwerke insgesamt",
        "collection": "Sammlung",
        "allCollections": "Alle Sammlungen",
        "noClientCollectionTitle": "Noch keine Kundensammlung zugänglich",
        "noClientCollectionText": "Sammlungen erscheinen hier, sobald ein Kunde seine Sammlung mit Ihnen geteilt hat.",
        "inviteClient": "Kunden einladen",
        "aiEnhancedTitle": "KI-gestützte Analyse • Konformitätsprüfung erforderlich",
        "ruleBasedTitle": "Analyse basierend auf Code, Regeln und Aggregationen",
        "aiEnhancedText": "Diese Ansicht nutzt KI-Signale aus den Kunstwerkdaten. Sie bleibt eine Unterstützung zur Portfolio-Analyse: Jede Empfehlung muss vom Experten vor der Weitergabe an den Kunden überprüft werden.",
        "ruleBasedText": "Diese Ansicht basiert auf internen Berechnungen und Aggregationen. Sie kann ohne KI-Analyse-Anspruch angezeigt werden.",
        "majorClient": "Hauptkunde",
        "selectedClient": "Ausgewählter Kunde",
        "portfolioReadyRules": "Portfolio-Ready-Regeln",
        "patrimonialLevel": "Vermögensniveau",
        "dominantArtists": "Dominante Künstler (nach Wert)",
        "dominantArtistsByCount": "Dominante Künstler (nach Anzahl der Kunstwerke)",
        "showByArtworkCount": "Nach Anzahl der Kunstwerke",
        "showByValue": "Nach Wert",
        "mediumBreakdown": "Medienaufschlüsselung",
        "signals": "Zu bearbeitende Signale",
        "showTopArtists": "Top {{count}} anzeigen ›",
        "reduce": "Weniger anzeigen",
        "collectionUntitled": "Ohne Titel",
        "readablePortfolioText": "Der Umfang ist dicht genug für eine glaubwürdige Portfolio-Analyse: Konzentration, Diversifizierung und Arbitrage werden erkennbar.",
        "structuringPortfolioText": "Die Sammlung befindet sich noch in der Strukturierungsphase. Wir verfolgen Substanz, Dokumentation und Dichtewachstum.",
        "ruleValue": "Erfasster Wert ≥ 150.000 €",
        "ruleArtworks": "Anzahl der Kunstwerke ≥ 12",
        "ruleArtists": "Mindestens 3 verschiedene Künstler",
        "ruleMediums": "Mindestens 2 verschiedene Medien",
        "ruleValuationCoverage": "Bewertungsabdeckung ≥ 60%",
        "strongPatrimonyReached": "Starkes Vermögensniveau erreicht.",
        "closeToStrongPatrimony": "Nahe am starken Vermögensniveau",
        "collectionStructuring": "Sammlung in Strukturierungsphase",
        "recommendedObjective": "Empfohlenes Ziel:",
        "objectiveValue": "≥ 500.000 € erfasster Wert",
        "objectiveArtworks": "und ≥ 25 Kunstwerke",
        "topArtists": {
          "showMore": "Top {{count}} anzeigen ›",
          "showLess": "Weniger anzeigen",
          "notEnough": "Weniger als 6 bewertete Künstler: die vollständige Liste wird bereits angezeigt."
        },
        "ruleCategories": "Mindestens 2 unterschiedliche Kategorien",
        "categoryBreakdown": "Verteilung nach Kategorie",
        "categoryValueAllocation": "Kategorien: Werke vs. Wert",
        "techniqueBreakdown": "Wichtigste Techniken"
      },
      "quickActions": {
        "requests": "Anfragen anzeigen",
        "collections": "Kundensammlungen",
        "inventory": "Inventarbericht PDF",
        "valuation": "Bewertungsbericht",
        "warehouse": "Lagerbesuch",
        "invite": "Kunden einladen",
        "profile": "Mein Artkiv-Profil"
      },
      "services": {
        "badge": {
          "assignedToMe": "Mir zugewiesen",
          "done": "Abgeschlossen",
          "in_progress": "In Bearbeitung",
          "new": "Neu"
        },
        "done": {
          "success": "Anfrage als abgeschlossen markiert."
        },
        "empty": "Noch keine Leistungen bei Ihren Kunden über Artkiv.",
        "filter": {
          "all": "Alle",
          "done": "Abgeschlossen",
          "in_progress": "In Bearbeitung",
          "new": "Neu"
        },
        "filters": {
          "all": "Alle Leistungen",
          "done": "Abgeschlossen",
          "inProgress": "In Bearbeitung",
          "new": "Neu"
        },
        "heading": "Serviceanfragen",
        "intro": "Diese Anfragen stammen von Artkiv-Kunden, die Ihre Expertise suchen.",
        "intro1": "Hier finden Sie alle an Sie gerichteten Anfragen.",
        "intro2": "Filtern Sie nach Status, um Ihre Arbeit zu organisieren.",
        "loading": "Anfragen werden geladen…",
        "none": "Derzeit keine Serviceanfragen.",
        "request": {
          "markDone": "Als abgeschlossen markieren",
          "take": "Übernehmen",
          "title": "Serviceanfrage"
        },
        "take": {
          "success": "Anfrage übernommen."
        },
        "title": "Leistungen rund um die Sammlungen Ihrer Kunden",
        "errorMessage": "Serviceanfragen konnten nicht geladen werden.",
        "errorToast": "Beim Laden der Anfragen ist ein Fehler aufgetreten.",
        "toasts": {
          "taken": "Anfrage gestartet."
        }
      },
      "shared": {
        "description": "Die registrierten Sammlungen umfassen Kunstwerke, die Ihre Kunden mit Ihnen geteilt haben.",
        "empty": "Noch keine geteilten Sammlungen.",
        "error": "Das Modul für geteilte Sammlungen konnte nicht geladen werden.",
        "heading": "Registrierte Sammlungen",
        "loading": "Geteilte Sammlungen werden geladen…",
        "loadingCollections": "Geteilte Sammlungen werden geladen…"
      },
      "status": {
        "accepted": "Akzeptiert",
        "declined": "Abgelehnt",
        "pending": "Ausstehend"
      },
      "subtitle": "Verfolgen Sie geteilte Sammlungen, Serviceanfragen und Kundeneinladungen.",
      "tab": {
        "clients": "Kunden",
        "invitations": "Einladungen",
        "services": "Serviceanfragen",
        "shared": "Geteilte Sammlungen"
      },
      "title": "Experten-Dashboard",
      "collaborateurs": {
        "title": "Mein Team & Zugang",
        "subtitle": "Laden Sie Assistenten oder gelegentliche Experten ein, auf Ihre Sammlungen zuzugreifen. Jeder Zugang ist nachverfolgbar und jederzeit widerrufbar.",
        "quotaLabel": "Ihr Plan",
        "quotaUnlimited": "unbegrenzte Mitarbeiter",
        "quotaMax": "bis zu {{count}} Mitarbeiter"
      },
      "news": {
        "loading": "Neuigkeiten werden geladen…"
      }
    },
    "form": {
      "company": {
        "placeholder": "Unternehmen"
      },
      "email": {
        "placeholder": "E-Mail"
      },
      "name": {
        "placeholder": "Name des Experten"
      },
      "phone": {
        "placeholder": "Telefonnummer"
      },
      "speciality": {
        "placeholder": "Spezialgebiet (z. B. moderne Kunst, Fotografie…)"
      },
      "specialty": {
        "placeholder": "Spezialgebiet, z. B. moderne Kunst oder Fotografie"
      },
      "years": {
        "placeholder": "Jahre Berufserfahrung"
      },
      "certified": {
        "label": "Zertifizierter Experte"
      }
    },
    "invites": {
      "email": {
        "label": "E-Mail-Adresse",
        "placeholder": "kunde@email.de"
      },
      "error": "Einladung konnte nicht gesendet werden",
      "message": {
        "label": "Nachricht",
        "placeholder": "Optionale persönliche Nachricht"
      },
      "role": {
        "client": "Kunde",
        "familyOffice": "Family Office",
        "label": "Rolle"
      },
      "send": "Einladung senden",
      "sent": "Einladung gesendet",
      "status": {
        "accepted": "Angenommen",
        "declined": "Abgelehnt",
        "pending": "Ausstehend"
      },
      "submit": "Einladen",
      "subtitle": "Verwalten Sie Ihre Einladungen",
      "table": {
        "email": "E-Mail",
        "role": "Rolle",
        "sentAt": "Gesendet am",
        "status": "Status"
      },
      "title": "Einladungen"
    },
    "notes": {
      "add": "Notiz hinzufügen",
      "error": "Fehler beim Speichern",
      "placeholder": "Interne Notiz für dieses Kunstwerk oder diesen Kunden…",
      "save": "Speichern",
      "saved": "Notiz gespeichert",
      "subtitle": "Nur für Experten sichtbar",
      "title": "Interne Notizen"
    },
    "permissions": {
      "analyse": "Analysieren",
      "error": "Fehler beim Aktualisieren der Berechtigungen",
      "export": "Exportieren",
      "read": "Lesen",
      "subtitle": "Definieren Sie Ihre Zugriffsrechte",
      "title": "Berechtigungen",
      "update": "Aktualisieren",
      "updated": "Berechtigungen aktualisiert",
      "write": "Bearbeiten"
    },
    "portfolio": {
      "topArtists": {
        "showMore": "Top {{count}} anzeigen ›",
        "showLess": "Reduzieren",
        "notEnough": "Weniger als 6 bewertete Künstler: Die vollständige Liste wird bereits angezeigt."
      }
    },
    "services": {
      "authentication": {
        "desc": "Prüfung von Echtheit und Provenienz"
      },
      "conservation": {
        "desc": "Zustandsanalyse und Empfehlungen"
      },
      "insurance": {
        "desc": "Versicherungslösungen für Kunstwerke"
      },
      "subtitle": "Ihre verfügbaren Leistungen",
      "title": "Experten-Services",
      "transport": {
        "desc": "Logistik und sichere Beförderung"
      },
      "valuation": {
        "desc": "Marktbasierte Bewertung mit Dokumentation"
      }
    }
  },
  "expertBilling": {
    "bicLabel": "BIC",
    "bicPlaceholder": "AGRIFRPP…",
    "ibanLabel": "IBAN",
    "ibanPlaceholder": "FR76…",
    "noPayouts": "Noch keine Auszahlungen.",
    "payouts": {
      "title": "Auszahlungen (erhalten / geplant)"
    },
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "status": {
      "generic": "Status: {{status}}",
      "paidOn": "Bezahlt am {{date}}",
      "scheduledFor": "Geplant für {{date}}",
      "paid": "Bezahlt",
      "pending": "Ausstehend",
      "unknown": "Unbekannter Status",
      "values": {
        "paid": "Bezahlt",
        "scheduled": "Geplant",
        "pending": "Ausstehend",
        "failed": "Fehlgeschlagen",
        "cancelled": "Storniert",
        "canceled": "Storniert"
      }
    },
    "ticketLabel": "Ticket {{ticketId}}",
    "title": "Expertenabrechnung",
    "stats": {
      "totalEarned": "Gesamteinnahmen",
      "pending": "Ausstehend",
      "nextPayout": "Nächste Auszahlung",
      "none": "Keine"
    },
    "bank": {
      "title": "Bankverbindung",
      "save": "Speichern",
      "saving": "Wird gespeichert…"
    },
    "security": {
      "title": "Zahlungssicherheit",
      "description": "Ihre Bankdaten werden sicher gespeichert und ausschließlich für die Auszahlung Ihrer Honorare verwendet. Auszahlungen erfolgen automatisch 7 Tage nach Abschluss einer Dienstleistung."
    },
    "history": {
      "title": "Auszahlungsverlauf",
      "ticket": "Ticket Nr. {{id}}",
      "emptyTitle": "Noch keine Auszahlungen",
      "emptyDescription": "Ihre Auszahlungen erscheinen hier, sobald Ihre ersten Dienstleistungen abgeschlossen sind."
    },
    "fullBilling": {
      "title": "Vollständige Abrechnungsverwaltung",
      "description": "Öffnen Sie Ihr vollständiges Dashboard, um Ihre Tarife zu verwalten, detaillierte Statistiken einzusehen und den Verlauf all Ihrer Dienstleistungen abzurufen.",
      "open": "Vollständige Abrechnung öffnen"
    }
  },
  "exports": {
    "download": "Herunterladen",
    "error": "Export konnte nicht generiert werden",
    "format": {
      "csv": "CSV",
      "pdf": "PDF",
      "xlsx": "Excel"
    },
    "generate": "Export erstellen",
    "include": {
      "documents": "Dokumente einbeziehen",
      "images": "Bilder einbeziehen",
      "valuations": "Schätzungen einbeziehen"
    },
    "subtitle": "Dokumente und Berichte erstellen",
    "title": "Exporte"
  },
  "fairs": {
    "empty": "Keine Messen geplant",
    "subtitle": "Bevorstehende Veranstaltungen",
    "title": "Kunstmessen"
  },
  "familyOffice": {
    "alerts": {
      "empty": "Derzeit keine Warnungen",
      "subtitle": "Prioritäre Hinweise und Aufgaben",
      "title": "Warnungen",
      "type": {
        "conservation": "Konservierung erforderlich",
        "documents": "Dokumente fehlen",
        "insurance": "Versicherung überprüfen",
        "valuation": "Bewertung aktualisieren"
      }
    },
    "dashboard": {
      "action": {
        "addArtwork": "Kunstwerk hinzufügen",
        "addFamily": "Familie hinzufügen",
        "exports": "Exporte",
        "reports": "Berichte"
      },
      "error": "Dashboard konnte nicht geladen werden",
      "loading": "Dashboard wird geladen…",
      "quickActions": "Schnellaktionen",
      "stats": {
        "alerts": "Warnungen",
        "artworks": "Kunstwerke",
        "families": "Familien",
        "totalValue": "Gesamtwert",
        "totalArtworks": "Kunstwerke gesamt",
        "totalFamilies": "Familien gesamt"
      },
      "subtitle": "Zentrale Verwaltung mehrerer Familien und Sammlungen",
      "title": "Family-Office-Dashboard",
      "actions": {
        "viewCollection": "Sammlung ansehen",
        "viewFamily": "Familie ansehen"
      },
      "buildSuccess": "Dashboard erfolgreich erstellt",
      "empty": "Keine Familien registriert.",
      "filters": {
        "plan": "Plan",
        "status": "Status"
      },
      "ok": "Family-Office-Dashboard funktioniert!",
      "plan": {
        "premium": "Premium",
        "standard": "Standard"
      },
      "status": {
        "active": "Aktiv",
        "inactive": "Inaktiv"
      },
      "table": {
        "actions": "Aktionen",
        "artworks": "Kunstwerke",
        "family": "Familie",
        "lastActivity": "Letzte Aktivität",
        "plan": "Plan",
        "valuation": "Bewertung"
      }
    },
    "exports": {
      "download": "Herunterladen",
      "error": "Export konnte nicht erstellt werden",
      "format": {
        "csv": "CSV",
        "pdf": "PDF",
        "xlsx": "Excel"
      },
      "subtitle": "Datenexport für externe Systeme",
      "title": "Exporte"
    },
    "families": {
      "action": {
        "manage": "Verwalten",
        "open": "Öffnen"
      },
      "empty": "Noch keine Familien angelegt",
      "search": "Familie suchen",
      "subtitle": "Verwaltete Familien und Mandate",
      "table": {
        "actions": "Aktionen",
        "artworks": "Kunstwerke",
        "family": "Familie",
        "lastActivity": "Letzte Aktivität",
        "plan": "Tarif",
        "value": "Wert"
      },
      "title": "Familien"
    },
    "family": {
      "subtitle": "Sammlungen, Mitglieder und Dokumente",
      "tabs": {
        "activity": "Aktivität",
        "collections": "Sammlungen",
        "documents": "Dokumente",
        "members": "Mitglieder",
        "overview": "Übersicht",
        "reports": "Berichte"
      },
      "title": "Familienprofil"
    },
    "members": {
      "action": {
        "edit": "Bearbeiten",
        "remove": "Entfernen"
      },
      "add": "Mitglied hinzufügen",
      "role": {
        "admin": "Administrator",
        "client": "Kunde",
        "manager": "Manager",
        "team": "Team"
      },
      "subtitle": "Rollen und Zugriffsrechte",
      "table": {
        "access": "Zugriff",
        "actions": "Aktionen",
        "name": "Name",
        "role": "Rolle"
      },
      "title": "Familienmitglieder"
    },
    "reports": {
      "generate": "Bericht erstellen",
      "subtitle": "Institutionelle Auswertungen",
      "title": "Berichte",
      "type": {
        "annual": "Jahresbericht",
        "monthly": "Monatsbericht",
        "quarterly": "Quartalsbericht",
        "succession": "Nachlassbericht"
      }
    },
    "roles": {
      "admin": "Family Office Admin",
      "client": "Familienkunde",
      "manager": "Family Office Manager",
      "team": "Familienteam"
    }
  },
  "fiscal": {
    "error": {
      "emailNotFound": "E-Mail nicht gefunden",
      "loadClients": "Fehler beim Laden der Kunden",
      "save": "Fehler beim Speichern"
    },
    "regime": {
      "DE_PRIVATE_1Y_RULE": "Deutschland – 1-Jahres-Regel (Privatvermögen)",
      "FR_FORFAIT_6_5": "Frankreich – Pauschalsteuer 6,5 %",
      "FR_PLUS_VALUE": "Frankreich – Kapitalertragssteuer",
      "label": "Steuerregime",
      "UK_CGT_SIMPLE_20": "Vereinigtes Königreich – CGT 20 %",
      "none": "Kein Regime"
    },
    "save": "Speichern",
    "saved": "Steuerpräferenzen gespeichert",
    "subtitle": "Anpassung an Ihre steuerliche Situation",
    "title": "Steuerliche Präferenzen",
    "client": {
      "add": "Hinzufügen",
      "adding": "Wird hinzugefügt…",
      "emptyList": "Keine Kunden",
      "label": "Kunde",
      "loading": "Laden…",
      "placeholder": "Kunde suchen…",
      "select": "Kunden auswählen"
    },
    "description": "Steuerliche Einstellungen für Ihre Kunstverkäufe und -schenkungen",
    "hint": "Diese Einstellungen werden für die Berechnung der Steuerberichte verwendet.",
    "loading": {
      "pref": "Einstellungen werden geladen…",
      "save": "Wird gespeichert…"
    },
    "notes": {
      "clientLabel": "Kunde",
      "label": "Steuernotizen",
      "placeholder": "Notizen eingeben…"
    },
    "role": {
      "expert": "Experte",
      "fo": "Family Office"
    }
  },
  "footer": {
    "copyright": "Alle Rechte vorbehalten",
    "info": {
      "cookies": "Cookies",
      "legal": "Impressum",
      "privacy": "Datenschutz",
      "title": "Informationen"
    },
    "newsletter": {
      "error": {
        "empty": "Bitte geben Sie Ihre E-Mail-Adresse ein",
        "generic": "Ein Fehler ist aufgetreten"
      },
      "placeholder": "ihre@email.de",
      "subtitle": "Erhalten Sie Marktnews und Artkiv-Neuigkeiten",
      "success": "Vielen Dank! Sie sind für den Newsletter angemeldet.",
      "title": "Bleiben Sie informiert"
    },
    "platform": {
      "insurance": "Versicherung",
      "pricing": "Preise",
      "resources": "Ressourcen",
      "title": "Plattform"
    }
  },
  "galleries": {
    "confirmUnfollow": "Möchten Sie dieser Galerie wirklich nicht mehr folgen?",
    "empty": "Keine Galerien gefunden",
    "followed": {
      "empty": {
        "subtitle": "Nutzen Sie die Suche oben oder durchsuchen Sie unsere Vorschläge.",
        "title": "Sie folgen noch keiner Galerie."
      }
    },
    "links": {
      "instagram": "Instagram →",
      "newsletter": "Newsletter →",
      "website": "Website →"
    },
    "news": {
      "empty": "Noch keine Neuigkeiten.",
      "more": "Mehr anzeigen"
    },
    "newsletter": {
      "markAsSubscribed": "Als angemeldet markieren",
      "subscribed": "✓ Newsletter abonniert"
    },
    "open": "Öffnen",
    "search": {
      "follow": "Dieser Galerie folgen",
      "placeholder": "Galeriename…",
      "submit": "Suchen",
      "title": "Galerie suchen"
    },
    "stats": {
      "currentExhibitions": "Aktuelle Ausstellungen",
      "followed": "Verfolgte Galerien",
      "news": "Neuigkeiten",
      "suggestions": "Vorschläge"
    },
    "subtitle": "Partnergalerien und Netzwerke",
    "suggestions": {
      "button": {
        "follow": "Folgen"
      },
      "commonArtists": "Gemeinsame Künstler: {{artists}}",
      "empty": {
        "subtitle": "Fügen Sie Kunstwerke zu Ihrer Sammlung hinzu, um Vorschläge zu erhalten.",
        "title": "Keine Vorschläge verfügbar."
      },
      "hint": "💡 Diese Galerien vertreten Künstler aus Ihrer Sammlung",
      "matchBadge": "{{score}} Übereinstimmung(en)"
    },
    "tabs": {
      "followed": "Meine Galerien",
      "news": "Neuigkeiten",
      "search": "Ergebnisse",
      "suggestions": "Vorschläge"
    },
    "title": "Galerien",
    "unfollow": "Nicht mehr folgen",
    "modal": {
      "cancel": "Abbrechen",
      "confirm": "Bestätigen",
      "text": "Möchten Sie dieser Galerie folgen und ihre Neuigkeiten erhalten?",
      "title": "Folgen bestätigen"
    }
  },
  "ocr": {
    "enrich": {
      "button": "Dokument analysieren",
      "loading": "Analyse läuft…",
      "success": "Dokument erfolgreich analysiert",
      "error": "Fehler bei der Analyse",
      "noFile": "Keine Datei ausgewählt",
      "unsupported": "Nicht unterstütztes Format"
    },
    "fields": {
      "title": "Titel",
      "artist": "Künstler",
      "year": "Jahr",
      "medium": "Technik",
      "dimensions": "Maße",
      "price": "Preis",
      "currency": "Währung",
      "source": "Quelle",
      "auctionHouse": "Auktionshaus",
      "saleDate": "Verkaufsdatum"
    },
    "invoice": {
      "label": "Rechnung",
      "detected": "Rechnung erkannt",
      "number": "Rechnungsnummer",
      "total": "Gesamtbetrag",
      "buyer": "Käufer",
      "seller": "Verkäufer"
    }
  },
  "header": {
    "admin": "Admin",
    "login": "Anmelden",
    "logout": "Abmelden",
    "nav": {
      "collection": "Meine Sammlung",
      "dashboard": "Dashboard",
      "estimates": "Schätzungen",
      "services": "Werkzeuge",
      "analysesIA": "KI-Analysen",
      "myAdvisor": "Mein Advisor",
      "importDoc": "Dokument importieren",
      "start": "Loslegen"
    },
    "profile": "Mein Profil",
    "services": {
      "deposits": {
        "desc": "Anvertraute Sammlungen & verliehene Kunstwerke",
        "title": "Deposita & Leihgaben"
      },
      "estate": {
        "desc": "Vermögensübertragung",
        "title": "Nachlassplanung"
      },
      "losses": "Verluste & Diebstähle",
      "lossesDesc": "Verlorenes, gestohlenes oder zerstörtes Werk",
      "insurance": {
        "desc": "Schutz Ihrer Kunstwerke",
        "title": "Versicherung"
      },
      "locations": {
        "desc": "Präzise Lokalisierung",
        "title": "Standorte"
      },
      "sales": {
        "desc": "Transaktionsmanagement",
        "title": "Verkäufe & Schenkungen"
      }
    }
  },
  "insurance": {
    "addArtwork": "Kunstwerk hinzufügen",
    "addInsurer": "Neuen Versicherer hinzufügen",
    "back": "Zurück",
    "error": "Fehler",
    "form": {
      "insurer": "-- Versicherer auswählen --",
      "policyPlaceholder": "Versicherungsscheinnummer",
      "type": "-- Deckungsart --",
      "value": "Versicherungssumme (€)"
    },
    "insuredWorks": "Erfasste Deckungen",
    "insurer": "Versicherer",
    "loading": "Wird geladen...",
    "noArtworks": "Sie haben noch keine Kunstwerke in Ihrer Sammlung.",
    "noneYet": {
      "text": "Wenn eines Ihrer Kunstwerke bereits versichert ist, erfassen Sie hier die Vertragsdaten, damit Versicherer, Versicherungssumme und Policenangaben mit dem Werk verknüpft bleiben.",
      "title": "Noch keine Versicherungsdeckung erfasst"
    },
    "notProvided": "Nicht angegeben",
    "notSpecified": "Nicht angegeben",
    "policyNumber": "Policennummer",
    "section": {
      "new": "Bestehende Deckung hinzufügen"
    },
    "selectArtwork": "-- Kunstwerk auswählen --",
    "simulate": "Deckung simulieren",
    "status": {
      "answered": "Antwort erhalten",
      "pending": "In Bearbeitung",
      "seen": "Gesehen"
    },
    "submit": "Deckung speichern",
    "successAdded": "Deckung erfolgreich erfasst!",
    "title": "Versicherung & Deckungsnachweise",
    "type": "Art",
    "unknownArtwork": "Unbekanntes Kunstwerk",
    "validUntil": "Police gültig bis",
    "value": "Versicherungssumme",
    "recordIntro": {
      "title": "Bereits versichert?",
      "body": "Auf dieser Seite erfassen Sie eine bereits bestehende Versicherungsdeckung und verknüpfen sie mit dem Kunstwerk: Versicherer, Versicherungssumme, Deckungsart, Policennummer und Ablaufdatum.",
      "newInsurance": "Sie benötigen eine neue Versicherung? Nutzen Sie Aktionen → Versicherung, um eine Anfrage an einen Partner vorzubereiten und zu senden."
    },
    "coverage": {
      "title": "Deckung vs. Schätzwert",
      "totalEstimated": "Gesamter Schätzwert",
      "totalInsured": "Gesamte Versicherungssumme",
      "gap": "Deckungslücke",
      "underinsured": "{{count}} unterversichertes Kunstwerk",
      "underinsured_plural": "{{count}} unterversicherte Kunstwerke",
      "wellCovered": "{{count}} angemessen versichertes Kunstwerk",
      "wellCovered_plural": "{{count}} angemessen versicherte Kunstwerke",
      "insuredLabel": "Versichert",
      "estimatedLabel": "Geschätzt",
      "gapLabel": "Differenz",
      "covered": "{{pct}} % gedeckt",
      "update": "Aktualisieren →",
      "expired": "ABGELAUFEN",
      "expireSoon": "LÄUFT BALD AB",
      "cloaAClou": "Nagel zu Nagel",
      "percentCovered": "{{percent}} % gedeckt"
    },
    "authRequired": "Bitte melden Sie sich an, um diese Seite aufzurufen.",
    "notConnected": "Nicht verbunden",
    "types": {
      "theft": "Diebstahl",
      "fire": "Feuer",
      "waterDamage": "Wasserschaden",
      "transport": "Transport",
      "allRisks": "Allgefahren",
      "nailToNail": "Nagel zu Nagel"
    },
    "addError": "Fehler beim Hinzufügen der Deckung.",
    "currency": "EUR"
  },
  "insurer": {
    "add": {
      "title": "Versicherer hinzufügen"
    },
    "alert": {
      "error": "Fehler beim Hinzufügen des Versicherers: {{error}}",
      "mustBeLoggedIn": "Sie müssen angemeldet sein, um einen Versicherer hinzuzufügen.",
      "success": "Versicherer erfolgreich hinzugefügt."
    },
    "button": {
      "submit": "Speichern"
    },
    "form": {
      "company": {
        "placeholder": "Unternehmen"
      },
      "email": {
        "placeholder": "Kontakt-E-Mail"
      },
      "name": {
        "placeholder": "Kontaktname"
      },
      "phone": {
        "placeholder": "Kontakttelefon"
      },
      "reputation": {
        "placeholder": "Reputationswert (0–10)"
      }
    }
  },
  "bienvenue": {
    "meta": {
      "title": "Willkommen — Ihr Transmission Studio | Artkiv"
    },
    "connecting": "Anmeldung läuft…",
    "expired": {
      "title": "Dieser Link ist nicht mehr gültig",
      "body": "Ihr Anmeldelink ist abgelaufen oder wurde bereits verwendet. Melden Sie sich erneut an, um Ihren Bereich zu erreichen.",
      "cta": "Anmelden"
    },
    "eyebrow": "Ihr Transmission Studio ist bereit",
    "hello": "Willkommen, {{name}}.",
    "helloNoName": "Willkommen.",
    "yourProfile": "Ihr Profil",
    "archetype": {
      "batisseur": "Der Erbauer",
      "passionne": "Der Liebhaber",
      "connecteur": "Der Verbinder",
      "gardien": "Der Bewahrer",
      "mecene": "Der Förderer"
    },
    "trial": {
      "title": "Ihre 14 kostenlosen Tage beginnen jetzt.",
      "until": "Voller Zugang bis {{date}}.",
      "generic": "Voller Zugang für 14 Tage.",
      "noCard": "Keine Kreditkarte erforderlich."
    },
    "mission": {
      "label": "Ihr erster Schritt",
      "text": "Fügen Sie das erste Werk hinzu, das Ihre Erben niemals falsch verstehen sollen.",
      "cta": "Werk hinzufügen"
    },
    "skip": "Zuerst meinen Bereich erkunden"
  },
  "landing": {
    "gestures": {
      "label": "Was Sie tun werden",
      "title": "Eine einfache Geste bei jedem Schritt",
      "intro": "Kein Fachjargon. Sie fotografieren, ARTKIV versteht und schlägt vor — Sie behalten die Kontrolle.",
      "flow": {
        "gather": "Sammeln",
        "document": "Dokumentieren",
        "understand": "Verstehen",
        "protect": "Schützen",
        "value": "Bewerten",
        "transmit": "Übergeben"
      },
      "cards": {
        "addArtwork": {
          "title": "Werk hinzufügen",
          "text": "Fotografieren Sie ein Werk: ARTKIV erstellt und ergänzt seinen Datensatz."
        },
        "scanDocs": {
          "title": "Dokumente scannen",
          "text": "Fotografieren Sie eine Rechnung oder ein Zertifikat. ARTKIV extrahiert die Informationen und schlägt vor, den Datensatz zu vervollständigen."
        },
        "documentState": {
          "title": "Zustand dokumentieren",
          "text": "Fotografieren Sie Details und Schäden: Bilder und Analyse bleiben dem Werk zugeordnet."
        },
        "trackValue": {
          "title": "Wert verfolgen",
          "text": "Werk und Vergleichswerte zusammen: eine Wertspanne, über die Zeit verfolgt."
        },
        "prepareFuture": {
          "title": "Zukunft vorbereiten",
          "text": "Sammlung und Übergabe strukturiert, bereit für Ihren Notar."
        },
        "advisor": {
          "title": "Mit Ihrem Art Advisor arbeiten",
          "text": "Sichere Freigabe: Jeder sieht, was seine Berechtigungen erlauben."
        },
        "phone": {
          "title": "Auf dem Telefon fortfahren",
          "text": "Scannen Sie einen QR-Code von Ihrem Computer: Ihr Telefon öffnet direkt die richtige Aufgabe."
        }
      }
    },
    "archetypes": {
      "label": "Die fünf Profile",
      "title": "Fünf Arten zu sammeln. Fünf blinde Flecken.",
      "intro": "Wie man sammelt, bestimmt, wie eine Sammlung dokumentiert, bewertet und weitergegeben werden muss. Jedes Profil hat seine Stärken — und seinen blinden Fleck.",
      "riskLabel": "Blinder Fleck",
      "batisseur": {
        "name": "Der Erbauer",
        "text": "Er verfolgt Notierungen, Karrieren, Markttrends. Die Sammlung wird wie ein Portfolio geführt.",
        "risk": "Eine Dokumentation, die auf den Wiederverkaufswert fixiert ist und Provenienz und Zustand vernachlässigt — alles, was den Preis eines Tages rechtfertigt."
      },
      "passionne": {
        "name": "Der Liebhaber",
        "text": "Er kauft aus dem Bauch heraus, ohne Kalkül. Die Sammlung erzählt eine persönliche Geschichte.",
        "risk": "Kaum Nachvollziehbarkeit, verstreute Erwerbungen. Wenn der Tag kommt, erben die Angehörigen eine Sammlung ohne Gebrauchsanweisung."
      },
      "connecteur": {
        "name": "Der Verbinder",
        "text": "Er sammelt entlang seiner Begegnungen: Künstler, Kuratoren, Händler. Die Sammlung spiegelt sein Netzwerk.",
        "risk": "Eine Dokumentation, die in seinem Gedächtnis und seinen Beziehungen lebt statt auf dem Papier."
      },
      "gardien": {
        "name": "Der Bewahrer",
        "text": "Er denkt bereits an Vermächtnis, Institution, Stiftung. Instinktiv das Profil, das den Anforderungen eines Nachlasses am nächsten kommt.",
        "risk": "Eine starke Absicht, die selten zu einem tatsächlich bestehenden rechtlichen und steuerlichen Dossier wird."
      },
      "mecene": {
        "name": "Der Förderer",
        "text": "Er sammelt, um zu unterstützen: Künstler, Institutionen, Anliegen.",
        "risk": "Eine über Schenkungen und Leihgaben verstreute Sammlung, deren Gesamtwert unlesbar wird."
      },
      "punchline": "Keines dieser Profile — nicht einmal das methodischste — hat von sich aus eine Sammlung, die bereit ist, weitergegeben zu werden.",
      "punchlineSub": "Genau diesen blinden Fleck adressiert Artkiv, ohne dass Sie Ihre Art zu sammeln ändern müssen.",
      "cta": "Mein Profil entdecken"
    },
    "badge": "14 Tage Standard-Testversion kostenlos",
    "meta": {
      "title": "ARTKIV — Die Sammlung nach Ihnen",
      "description": "Dokumentieren, bewerten und weitergeben: Ihre Sammlung. Entdecken Sie Ihr Sammlerprofil in 2 Minuten."
    },
    "nav": {
      "explore": "Die Plattform",
      "how": "So funktioniert es",
      "login": "Anmelden"
    },
    "quiz": {
      "label": "Karte der Weitergabe",
      "title": "Welcher Sammlertyp sind Sie?",
      "text": "Vierzehn Fragen, drei Minuten. Ihr Sammler-Archetyp erscheint sofort. Ihre fünf Achsen, Ihr blinder Fleck und der Bereitschaftsindex Ihrer Sammlung werden Ihnen per E-Mail zugesandt.",
      "cta": "Sammlertest starten",
      "note": "Kostenlos, ohne Konto.",
      "archetype": {
        "builder": {
          "name": "Der Erbauer",
          "text": "Sie bauen ein stimmiges Ganzes, das Bestand haben soll."
        },
        "aficionado": {
          "name": "Der Leidenschaftliche",
          "text": "Sie kaufen aus dem Bauch heraus, und jedes Werk hat seine Geschichte."
        },
        "connector": {
          "name": "Der Verbinder",
          "text": "Ihre Sammlung lebt durch Künstler und Begegnungen."
        },
        "keeper": {
          "name": "Der Bewahrer",
          "text": "Sie bewahren, dokumentieren und schützen, was Ihnen anvertraut wurde."
        },
        "benefactor": {
          "name": "Der Mäzen",
          "text": "Sie fördern, leihen und geben: Die Sammlung wirkt über Sie hinaus."
        }
      }
    },
    "cta": {
      "button": {
        "createAccount": "Konto erstellen",
        "quiz": "Sammlertest starten",
        "note": "14 Tage Standard-Testversion kostenlos. Ohne Kreditkarte.",
        "privacy": "Datenschutzrichtlinie"
      },
      "text": "Ihre Werke bleiben privat, Ihre Nachweise werden belastbar. Sammlung, Zertifikate, Schätzungen, sicheres Teilen: an einem Ort — für Sie heute und für Ihre Familie danach.",
      "title": "Die Sammlung nach Ihnen"
    },
    "footer": {
      "cookies": "Cookies",
      "copyright": "© {{year}} Artkiv — Alle Rechte vorbehalten",
      "legal": "Impressum",
      "privacy": "Datenschutz"
    },
    "hero": {
      "button": {
        "demo": "Demo anfragen",
        "start": "Mit Artkiv starten"
      },
      "eyebrow": "The Collection After You",
      "explore": "Plattform ansehen",
      "login": "Anmelden",
      "quiz": "Sammlertest starten",
      "quizNote": "3 Minuten. Ihr Archetyp erscheint sofort; Ihre vollständige Karte erhalten Sie per E-Mail.",
      "subtitle": "Jedes Werk trägt eine Geschichte, die nur Sie kennen: Herkunft, Preis, der Grund des Kaufs. Artkiv bündelt diese Nachweise in einem klaren Dossier — für Sie heute, für Ihre Familie danach.",
      "title": "Sie wissen, warum Sie sammeln. Wissen Sie, was danach geschieht?",
      "trial": "14 Tage Standard-Testversion kostenlos.",
      "trust": "Entwickelt mit Experten für Kunst, Versicherung und Vermögensnachfolge."
    },
    "section": {
      "how": {
        "ctaPrimary": "Plattform entdecken",
        "ctaSecondary": "Konto erstellen",
        "step1": {
          "text": "Lernen Sie die Benutzeroberfläche und Module kennen (Sammlung, Dokumente, KI, Zertifikate…).",
          "title": "Entdecken"
        },
        "step2": {
          "text": "Sehen Sie, wie ein Kunstwerk zu einem klaren und teilbaren Dossier wird.",
          "title": "Beispiel testen"
        },
        "step3": {
          "text": "Erstellen Sie Ihr Konto und beginnen Sie, Ihre echte Sammlung zu strukturieren.",
          "title": "Privat starten"
        },
        "stepLabel": "Schritt {{n}}",
        "text": "Drei Schritte, um Ihre Sammlung mit Artkiv zu strukturieren.",
        "title": "So funktioniert es"
      },
      "who1": {
        "text": "Lebenslauf Ihrer Kunstwerke, Provenienz und Dokumente, verständliche Schätzungen, vereinfachte familiäre Weitergabe.",
        "title": "Sammlerinnen & Sammler"
      },
      "who2": {
        "text": "Sie erben Kunst? Wir helfen Ihnen zu verstehen, was Sie besitzen, welchen Wert es hat und welche Optionen bestehen — ohne Stress.",
        "title": "Familie / Erben"
      },
      "who3": {
        "text": "Ein sauberes, nachvollziehbares und teilbares Dossier. Weniger Unsicherheit, schnellere Prozesse, bessere Risikovorsorge.",
        "title": "Versicherer & Family Offices"
      },
      "why": {
        "point1": "Finden Sie eine Rechnung oder ein Zertifikat in wenigen Sekunden.",
        "point2": "Teilen Sie ein sicheres Dossier mit einem Experten, Versicherer oder Ihrer Familie.",
        "point3": "Verfolgen Sie den Wert und wichtige Ereignisse (Verkäufe, Bewertungen, Restaurierungen).",
        "point4": "Fügen Sie der Werkhistorie optional einen datierten, fälschungssicheren Echtheitsnachweis hinzu.",
        "text": "Dokumente gehen verloren, Nachweise verblassen, Schäden warten nicht. Artkiv verwandelt Dringlichkeit in ein belastbares Dossier.",
        "title": "Warum jetzt?"
      }
    },
    "title": "ARTKIV — Ihre Sammlung verwalten, bewerten und sichern"
  },
  "lang": {
    "selector": {
      "currency": "Währung",
      "eur": "€ EUR",
      "france": "FR – Frankreich",
      "language": "Sprache",
      "location": "Standort"
    }
  },
  "location": {
    "add": {
      "title": "Ort hinzufügen"
    },
    "alert": {
      "error": "Fehler beim Hinzufügen des Orts: {{error}}",
      "mustBeLoggedIn": "Sie müssen angemeldet sein, um einen Ort hinzuzufügen.",
      "success": "Ort erfolgreich hinzugefügt."
    },
    "button": {
      "create": "Erstellen",
      "submit": "Speichern"
    },
    "error": {
      "auth": "Authentifizierungsfehler: {{error}}",
      "create": "Fehler beim Erstellen des Standorts: {{error}}"
    },
    "form": {
      "address": {
        "placeholder": "Adresse"
      },
      "city": {
        "placeholder": "Stadt"
      },
      "country": {
        "placeholder": "Land"
      },
      "name": {
        "placeholder": "Ortsname (z. B. Wohnzimmer, Lagerraum, Galerie…)"
      },
      "notes": {
        "placeholder": "Notizen (optional)"
      },
      "type": "Typ",
      "types": {
        "exhibition": "Ausstellung",
        "loan": "Leihgabe",
        "main": "Hauptwohnsitz",
        "office": "Büro",
        "other": "Sonstiges",
        "secondary": "Zweitwohnsitz",
        "storage": "Lager"
      }
    }
  },
  "login": {
    "create": "Konto erstellen",
    "email": {
      "label": "E-Mail",
      "placeholder": "ihre@email.de",
      "hint": "Bitte überprüfen Sie das E-Mail-Format."
    },
    "error": {
      "default": "E-Mail oder Passwort ungültig",
      "loadProfile": "Ihr Profil konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
      "noProfile": "Benutzerprofil nicht gefunden."
    },
    "forgot": "Passwort vergessen?",
    "hero": {
      "alt": "Kunstgalerie",
      "copy": "Die Plattform zur Verwaltung, Sicherung und Bewertung Ihrer Kunstsammlung.",
      "exploreCta": "Sehen, wie es funktioniert",
      "pricingCta": "Pläne vergleichen",
      "proHint": "Family Office, Experte, Partner: Sie melden sich hier ebenfalls an."
    },
    "loading": "Anmeldung läuft...",
    "mobile": {
      "subtitle": "Melden Sie sich an, um auf Ihre Sammlung zuzugreifen",
      "explore": "Sehen, wie es funktioniert",
      "compare": "Pläne vergleichen"
    },
    "noAccount": "Noch kein Konto?",
    "password": {
      "label": "Passwort",
      "placeholder": "Ihr Passwort",
      "show": "Anzeigen",
      "hide": "Verbergen"
    },
    "submit": "Anmelden",
    "subtitle": "Zugriff auf Ihren persönlichen Bereich",
    "title": "Anmelden",
    "security": {
      "hint": "Sichere Anmeldung. Ihre Daten bleiben privat."
    },
    "altCta": "Ich möchte die Plattform zuerst erkunden",
    "softNote": "Sie können ohne Registrierung erkunden. Die Testphase startet, wenn Sie bereit sind."
  },
  "marketplace": {
    "empty": "Derzeit keine verfügbaren Kunstwerke.",
    "loading": "Marktplatz wird geladen..."
  },
  "nav": {
    "dashboard": "Dashboard",
    "logout": "Abmelden",
    "profile": "Mein Profil"
  },
  "news": {
    "alerts": {
      "collection": {
        "empty": "Noch kein Künstler in Ihrer Sammlung",
        "follow": "Folgen",
        "followed": "Gefolgt",
        "title": "Künstler in meiner Sammlung"
      },
      "follow": {
        "button": "Folgen",
        "placeholder": "Künstlername...",
        "title": "Einem Künstler folgen"
      },
      "followed": {
        "empty": "Sie folgen noch keinem Künstler. Nutzen Sie das Formular oben, um anzufangen.",
        "title": "Verfolgte Künstler",
        "unfollow": "Nicht mehr folgen"
      },
      "stats": {
        "collection": "In meiner Sammlung",
        "followed": "Gefolgter Künstler"
      }
    },
    "auctions": {
      "subtab": {
        "myArtists": "Meine Künstler",
        "topTen": "Globale Top 10"
      },
      "upcoming": {
        "dateUnknown": "Datum noch nicht bekannt",
        "empty": "Keine bevorstehenden Verkäufe Ihrer verfolgten Künstler.",
        "fallbackTitle": "Verkauf",
        "title": "Bevorstehende Verkäufe"
      }
    },
    "empty": "Keine Neuigkeiten verfügbar",
    "exhibitions": {
      "dateArrow": "→",
      "dateRangeBoth": "Termine noch nicht bekannt",
      "dateRangeStart": "—",
      "empty": "Keine bevorstehende Ausstellung gefunden.",
      "rpcHint": "Die get_client_exhibitions-RPC-Funktion muss in Supabase erstellt werden",
      "sourceLink": "Ausstellung ansehen",
      "title": "Ausstellungen"
    },
    "fairs": {
      "empty": "Derzeit keine bevorstehende Messe.",
      "link": "Website besuchen",
      "title": "Bevorstehende Kunstmessen"
    },
    "loading": "Neuigkeiten werden geladen...",
    "records": {
      "empty": "Keine aktuellen Rekorde.",
      "estimatePrefix": "Schätz.",
      "noPrice": " Preis nicht mitgeteilt",
      "saleFallback": "Verkauf",
      "sourceLink": "Quelle anzeigen",
      "title": "Verkaufsrekorde",
      "unknownCity": "—",
      "unknownCountry": "—",
      "unknownDate": "Unbekanntes Datum"
    },
    "subtitle": "Markt, Künstler und Ereignisse",
    "tabs": {
      "alerts": "Alerts",
      "auctions": "Auktionen",
      "fairs": "Kunstmessen"
    },
    "title": "Neuigkeiten"
  },
  "payment": {
    "success": {
      "button": {
        "invoices": "My invoices",
        "profile": "My profile"
      },
      "institution": {
        "label": "Empfänger"
      },
      "invoice": {
        "amount": "Betrag",
        "downloadPdf": "Rechnung herunterladen (PDF)",
        "label": "Rechnung",
        "none": "Keine Rechnung gefunden.",
        "viewOnline": "Online anzeigen"
      },
      "invoiceError": "Rechnungsfehler: {{error}}",
      "loadingInvoice": "Ihre Rechnung wird vorbereitet…",
      "subtitle": "Vielen Dank! Ihr Auftrag wurde erfasst. Unser Experte übernimmt jetzt.",
      "title": "Zahlung bestätigt",
      "work": {
        "fallback": "Kunstwerk",
        "label": "Kunstwerk"
      }
    }
  },
  "pricing": {
    "alert": {
      "confirm": {
        "change": "Möchten Sie Ihr Abonnement auf {{plan}} wechseln?\n\nDie anteilige Berechnung erfolgt automatisch und wird sofort angewendet."
      },
      "demo": {
        "change": "Ihren Demo-Plan auf {{plan}} wechseln?",
        "success": "Demo-Plan erfolgreich aktualisiert!"
      },
      "error": {
        "change": "Fehler beim Planwechsel: {{error}}",
        "generic": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        "subscription": "Fehler: {{error}}"
      },
      "success": {
        "change": "Ihr Plan wurde erfolgreich aktualisiert!"
      }
    },
    "compare": {
      "button": {
        "compare": "Pläne vergleichen",
        "expert": "Mit einem Experten sprechen"
      },
      "subtitle": "Vergleichen Sie die Pläne oder sprechen Sie mit unserem Team",
      "title": "Hilfe bei der Auswahl?"
    },
    "cta": {
      "contact": "Kontakt aufnehmen",
      "subscribe": "Abonnieren"
    },
    "currentPlan": {
      "bannerTitle": "Sie haben ein aktives Abonnement",
      "text": "Ihr aktueller Plan: {{plan}}. Sie können Ihren Plan jederzeit wechseln. Die anteilige Berechnung erfolgt automatisch."
    },
    "faq": {
      "a1": "Ja, Sie können Ihren Plan jederzeit upgraden oder downgraden. Die anteilige Berechnung erfolgt automatisch.",
      "a2": "Art Advisor erlaubt die Verwaltung von bis zu 5 Kundensammlungen, während Premium unbegrenzte Kunden mit vollem KI-Funktionsumfang bietet.",
      "a3": "Ja, jedes Family-Office-Abonnement umfasst ein individuelles Onboarding und einen dedizierten Account Manager.",
      "q1": "Kann ich den Plan jederzeit wechseln?",
      "q2": "Was ist der Unterschied zwischen Art Advisor und Art Advisor Premium?",
      "q3": "Beinhaltet der Family-Office-Plan eine Schulung?",
      "title": "Häufig gestellte Fragen"
    },
    "hero": {
      "subtitle": "Von privaten Sammlungen bis hin zu institutionellen Portfolios – wählen Sie den passenden Plan",
      "title": "Eine Lösung für jeden Bedarf"
    },
    "period": {
      "month": "/Monat"
    },
    "plan": {
      "artAdvisor": {
        "badge": "PRO",
        "cta": "Entdecken",
        "feature1": "5 Kundensammlungen verwalten",
        "feature2": "Multi-Portfolio-Oberfläche",
        "feature3": "Individuelle Kundenberichte",
        "feature4": "Präsentationswerkzeuge",
        "tagline": "Multi-Kunden & professionelle Werkzeuge"
      },
      "artAdvisorPremium": {
        "badge": "PRO+",
        "cta": "Entdecken",
        "feature1": "Unbegrenzte Kundensammlungen",
        "feature2": "KI & Analysen für alle Kunden",
        "feature3": "White-Label-Berichte",
        "feature4": "Aggregiertes Dashboard",
        "tagline": "Unbegrenzte Kunden & volle KI"
      },
      "badge": {
        "current": "AKTUELLER PLAN"
      },
      "button": {
        "current": "Aktueller Plan",
        "downgrade": "Wechseln zu {{title}}",
        "upgrade": "Upgrade auf {{title}}"
      },
      "currentNote": "Sie nutzen derzeit diesen Plan",
      "familyOffice": {
        "badge": "ENTERPRISE",
        "cta": "Abonnieren",
        "feature1": "Unbegrenzte Portfolios",
        "feature2": "Erweitertes individuelles Reporting",
        "feature3": "ERP/PMS-Integration",
        "feature4": "Regulatorische Konformität",
        "feature5": "Dedizierter Account Manager",
        "feature6": "Garantiertes SLA",
        "tagline": "Maßgeschneiderte institutionelle Lösung"
      },
      "fondation": {
        "badge": "INSTITUTION",
        "cta": "Abonnieren",
        "feature1": "Unbegrenztes institutionelles Inventar",
        "feature2": "Leihgaben, Depositen und Ausstellungsmanagement",
        "feature3": "Mehrbenutzerzugang & kuratorische Teams",
        "feature4": "Institutionelle und öffentliche Berichte",
        "feature5": "Vision KI für die gesamte Sammlung",
        "feature6": "Patrimonialer und regulatorischer Compliance",
        "tagline": "Patrimonierverwaltung für Kulturinstitutionen"
      },
      "premium": {
        "cta": "Upgrade auf Premium",
        "feature1": "Erweiterte KI-Bildanalyse",
        "feature2": "Konservierungsempfehlungen",
        "feature3": "Erbschafts-Matching",
        "feature4": "Medienbeobachtung & Marktbenachrichtigungen",
        "feature5": "Detaillierte Berichte",
        "tagline": "Künstliche Intelligenz & Einblicke"
      },
      "standard": {
        "cta": "Loslegen",
        "feature1": "Unbegrenztes Kunstwerkinventar",
        "feature2": "Künstler- & Standortverwaltung",
        "feature3": "Grundlegende Steuer- & Konservierungswerkzeuge",
        "feature4": "Exporte und PDF-Berichte",
        "tagline": "Essentielles Inventar & Verwaltung"
      },
      "trialBadge": "14 Tage kostenlos"
    },
    "section": {
      "collectors": {
        "subtitle": "Verwalten Sie Ihre Privatsammlung einfach und effizient",
        "title": "Für Sammler"
      },
      "pro": {
        "subtitle": "Erweiterte Tools für Art Advisors, Family Offices und Institutionen",
        "title": "Für Profis"
      }
    },
    "subtitle": "Wählen Sie den passenden Tarif",
    "title": "Preise",
    "trial": {
      "text": "Genießen Sie eine 14-tägige kostenlose Testphase des Standard-Plans bei jeder Anmeldung vor dem 15. Februar 2026. Entdecken Sie alle Funktionen ohne Verpflichtung.",
      "title": "Exklusives Einführungsangebot"
    }
  },
  "profile": {
    "firstname": "Vorname",
    "subscription": {
      "beta": {
        "confirm": {
          "cta": "Confirm my subscription"
        },
        "discount": {
          "hint": "Discount",
          "lifetime": "for life after confirmation",
          "text": "Your beta discount is active on your subscriptions.",
          "title": "Beta: -30% for life"
        },
        "ended": {
          "text": "Your free access ended. Confirm to keep -30% for life.",
          "title": "Beta period ended"
        },
        "free": {
          "text": "Your account is part of the beta program.",
          "title": "Beta: 6 months free"
        },
        "title": "Beta program"
      },
      "billingButton": "Abrechnung",
      "currentPlan": {
        "none": "Kein aktives Abonnement"
      },
      "currentPlanLabel": "Aktueller Plan",
      "demo": {
        "actionsDisabled": "Im Demo-Modus deaktiviert",
        "info": {
          "text": "Dieses Konto befindet sich im Demo-Modus. Abonnementfunktionen sind simuliert.",
          "title": "Demo-Modus"
        },
        "mode": "Demo-Modus",
        "note": "Kein echtes Abonnement auf diesem Konto.",
        "planLabel": "Demo-Plan",
        "portalButton": "Portal öffnen (Demo)",
        "portalDisabledTooltip": "Im Demo-Modus deaktiviert",
        "status": {
          "active": "Aktiv (simuliert)",
          "canceled": "Gekündigt (simuliert)",
          "none": "Kein Abonnement",
          "past_due": "Überfällig (simuliert)",
          "trialing": "Testphase (simuliert)"
        }
      },
      "demoNoSub": {
        "badge": "Demo",
        "help": "Kontaktieren Sie uns für ein echtes Konto.",
        "text": "Dieses Demo-Konto hat kein aktives Abonnement.",
        "title": "Demo-Konto ohne Abonnement"
      },
      "demoWithSub": {
        "title": "Demo-Konto mit Abonnement"
      },
      "error": {
        "payment": "Zahlungsfehler: {{message}}",
        "portal": "Fehler im Abrechnungsportal: {{message}}",
        "portalUnavailable": "Das Stripe-Abrechnungsportal ist nicht verfügbar.",
        "missingPrice": "Für diesen Tarif fehlt die Stripe-Preis-ID.",
        "stripeUnavailable": "Stripe wurde nicht initialisiert.",
        "checkoutUnavailable": "Die Stripe-Checkout-Sitzung konnte nicht erstellt werden."
      },
      "freeAccess": {
        "noBilling": "Keine Abrechnung für dieses Konto",
        "note": "Kostenloser Zugang aktiv",
        "until": "Kostenlos bis {{date}}"
      },
      "loading": "Wird geladen…",
      "manageButton": "Abonnement verwalten",
      "satellite": {
        "text": "Ihr Zugang wird von einem anderen Konto verwaltet.",
        "title": "Satelliten-Zugang",
        "textNamed": "Ihr Zugriff ist im Abonnement von {{name}} enthalten. Sie müssen keine Zahlung leisten.",
        "caption": "Mitarbeiterkonto · kein eigenes Abonnement erforderlich"
      },
      "sectionTitle": "Mein Abonnement",
      "status": {
        "active": "Aktiv",
        "demo": "Demo",
        "freeAccess": "Kostenloser Zugang",
        "inactive": "Inaktiv",
        "trialing": "Testphase"
      },
      "sectionSubtitle": "Tarife, Stripe-Abrechnung und Zugriff auf die Artkiv-Module.",
      "currentPlanButton": "Aktueller Tarif",
      "processing": "Weiterleitung…",
      "choosePlan": "Diesen Tarif wählen",
      "compareButton": "Tarife vergleichen",
      "portalProcessing": "Wird geöffnet…",
      "billingPortalButton": "Stripe-Portal"
    },
    "title": "Ihre Profildetails",
    "update": {
      "help": "Halten Sie Ihre Profilangaben aktuell, um das Beste aus Ihrem Konto herauszuholen."
    },
    "demo": {
      "ribbon": {
        "label": "Demo",
        "text": "Demo-Konto"
      }
    },
    "edit": {
      "birthYear": "Geburtsjahr",
      "company": "Unternehmen",
      "confirmPassword": "Passwort bestätigen",
      "error": {
        "birthYear": "Ungültiges Geburtsjahr",
        "generic": "Fehler beim Speichern",
        "passwordMatch": "Passwörter stimmen nicht überein",
        "required": "Pflichtfeld"
      },
      "firstName": "Vorname",
      "lastName": "Nachname",
      "password": "Neues Passwort",
      "save": "Speichern",
      "success": "Profil aktualisiert",
      "title": "Profil bearbeiten"
    },
    "fiscal": {
      "description": "Steuerregelung für Ihre Kunsttransaktionen",
      "error": {
        "save": "Fehler beim Speichern"
      },
      "saving": "Wird gespeichert…",
      "select": {
        "DE_PRIVATE_1Y_RULE": "Deutschland — Privateigentum > 1 Jahr steuerfrei",
        "FR_FORFAIT_6_5": "Frankreich — Pauschalsteuer 6,5%",
        "FR_PLUS_VALUE": "Frankreich — Kapitalgewinne",
        "none": "Keine Regelung",
        "UK_CGT_SIMPLE_20": "Vereinigtes Königreich — CGT 20%"
      },
      "title": "Steuerregelung"
    },
    "info": {
      "birthYear": "Geburtsjahr",
      "company": "Unternehmen",
      "email": "E-Mail",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "loading": "Wird geladen…",
      "title": "Meine Informationen"
    },
    "page": {
      "title": "Mein Profil",
      "eyebrow": "Persönlicher Bereich",
      "subtitle": "Verwalten Sie Ihre Angaben, Ihr Abonnement und Ihre Datenschutzeinstellungen."
    },
    "sections": {
      "identity": {
        "eyebrow": "Profil",
        "title": "Meine Identität",
        "desc": "Ihre persönlichen Angaben und Kontaktdaten."
      },
      "billing": {
        "eyebrow": "Einstellungen",
        "title": "Präferenzen & Abrechnung",
        "desc": "Ihr Abonnement, Ihre steuerlichen Präferenzen und Ihre Rechnungsdaten."
      },
      "privacy": {
        "eyebrow": "Daten",
        "title": "Datenschutz & KI",
        "desc": "Ihre Einwilligungen für die Funktionen der künstlichen Intelligenz."
      }
    },
    "plans": {
      "standard": {
        "label": "Standard",
        "description": "Inventar, Standortverwaltung, Exporte und grundlegende Sammlungsverwaltung."
      },
      "premium": {
        "label": "Premium",
        "description": "KI Vision, Mitarbeitende, Experten, Versicherung und Nachlassplanung."
      },
      "artAdvisor": {
        "label": "Art Advisor",
        "description": "Verwaltung mehrerer Kunden mit bis zu 20 Sammlungen und eingeschränktem KI-Zugang."
      },
      "artAdvisorPremium": {
        "label": "Art Advisor Premium",
        "description": "Unbegrenzte Kundenzahl, vollständiger KI-Zugang, kuratorische Analyse und erweiterte Berichte."
      },
      "familyOffice": {
        "label": "Family Office",
        "description": "Mehrfamilienübersicht, Vermögensreporting, Governance und Prüfpfad."
      }
    },
    "ia": {
      "error": {
        "save": "Die KI-Einstellung konnte nicht gespeichert werden."
      },
      "title": "KI-Funktionen & Einwilligung",
      "description": "Entscheiden Sie, ob Sie die Artkiv-KI-Module aktivieren möchten, und prüfen Sie vor Ihrer Einwilligung genau, was sie tun.",
      "descriptionUnavailable": "Ihr aktueller Tarif umfasst die Artkiv-KI-Module nicht. Sie können Ihre Sammlung weiterhin ohne KI verwalten.",
      "status": {
        "active": "KI aktiviert",
        "unavailable": "KI nicht enthalten",
        "inactive": "KI deaktiviert"
      },
      "saving": "Ihre Auswahl wird gespeichert…"
    },
    "loading": "Profil wird geladen…",
    "error": {
      "missing": {
        "title": "Profil nicht verfügbar",
        "text": "Das Profil konnte nicht geladen werden. Prüfen Sie, ob für den Benutzer ein Eintrag in profiles vorhanden ist und die RLS-Richtlinie den Lesezugriff erlaubt."
      }
    }
  },
  "reports": {
    "download": "Herunterladen",
    "empty": "Noch keine Berichte erstellt",
    "generate": {
      "button": "Bericht generieren",
      "loading": "Wird generiert…"
    },
    "subtitle": "Analysen und Zusammenfassungen",
    "title": "Berichte",
    "type": {
      "collection": "Sammlungsbericht",
      "insurance": "Versicherungsbericht",
      "succession": "Nachlassbericht",
      "valuation": "Bewertungsbericht",
      "acquisition": "Erwerb",
      "artist": "Künstler",
      "condition": "Zustand",
      "exhibition": "Ausstellung",
      "inventory": "Inventar",
      "label": "Berichtstyp",
      "location": "Standort"
    },
    "data": {
      "includeArtist": "Künstler einbeziehen",
      "includeLocation": "Standort einbeziehen",
      "includeMedium": "Medium einbeziehen",
      "includePrice": "Preis einbeziehen",
      "includeSize": "Größe einbeziehen",
      "title": "Daten"
    },
    "error": "Fehler beim Generieren des Berichts",
    "layout": {
      "groupBy": {
        "artist": "Nach Künstler",
        "location": "Nach Standort",
        "medium": "Nach Medium",
        "none": "Keine Gruppierung",
        "year": "Nach Jahr"
      },
      "sortBy": {
        "acquisitionDate": "Erwerbsdatum",
        "artist": "Künstler",
        "creationYear": "Entstehungsjahr",
        "name": "Name",
        "value": "Wert"
      },
      "title": "Layout"
    },
    "name": {
      "label": "Berichtsname"
    },
    "options": {
      "includeDate": "Datum einbeziehen",
      "includePurchaseValue": "Kaufwert einbeziehen",
      "includeThumbnails": "Vorschaubilder einbeziehen",
      "includeValueTotal": "Gesamtwert einbeziehen",
      "title": "Optionen"
    },
    "viewExisting": "Vorhandene Berichte anzeigen",
    "whiteLabel": {
      "companyName": {
        "current": "Aktueller Name",
        "label": "Unternehmensname",
        "notSet": "Nicht festgelegt"
      },
      "editProfile": "Profil bearbeiten",
      "enable": "White-Label aktivieren",
      "info": "Ihr Logo und Firmenname erscheinen auf allen generierten Berichten.",
      "logo": {
        "add": "Logo hinzufügen",
        "change": "Logo ändern",
        "label": "Logo",
        "notSet": "Nicht festgelegt"
      },
      "subtitle": "Personalisieren Sie Ihre Berichte mit Ihrem Branding.",
      "title": "White-Label"
    }
  },
  "sale": {
    "conditionNotes": {
      "title": "Zustandsnotizen"
    },
    "description": {
      "title": "Beschreibung"
    },
    "details": {
      "condition": "Zustand",
      "dimensions": "Abmessungen",
      "signature": "Signatur",
      "subject": "Thema",
      "technique": "Technik",
      "title": "Details",
      "type": "Kunsttyp",
      "year": "Jahr"
    },
    "dimensions": "Abmessungen: {{value}}",
    "loading": "Laden...",
    "none": "Kein Kunstwerk gefunden.",
    "notAvailable": "Dieses Kunstwerk ist nicht zum Verkauf verfügbar.",
    "notFound": "Kunstwerk nicht gefunden.",
    "options": "Optionen: Versand / Transport auf Anfrage.",
    "price": {
      "label": "Verkaufspreis",
      "note": "(zzgl. Steuern, Transport- und Zollgebühren)",
      "undefined": "Nicht definiert"
    },
    "request": {
      "button": "Informationen anfordern (Zustand, Provenienz usw.)",
      "checkbox": "Ich verstehe, dass diese Informationen vertraulich sind und privat bleiben.",
      "errorCheckbox": "Bitte bestätigen Sie die Vertraulichkeitsklausel.",
      "success": "Ihre Anfrage wurde gesendet. Ein Berater meldet sich in Kürze.",
      "title": "Weitere Informationen anfordern"
    },
    "tags": {
      "title": "Tags"
    },
    "yearMedium": "{{year}} — {{medium}}",
    "imageAlt": "Kunstwerk"
  },
  "sales": {
    "add": "Verkauf erfassen",
    "empty": "Noch keine Verkäufe erfasst",
    "subtitle": "Historie und Erfassung von Verkäufen",
    "table": {
      "actions": "Aktionen",
      "artwork": "Kunstwerk",
      "buyer": "Käufer",
      "date": "Datum",
      "price": "Verkaufspreis"
    },
    "title": "Verkäufe"
  },
  "sharedAccess": {
    "collection": {
      "all": "Alle Sammlungen",
      "sharedOn": "Geteilt am {date}",
      "unnamed": "Unbenannte Sammlung"
    },
    "empty": "Derzeit keine geteilten Zugriffe",
    "error": "Geteilte Zugriffe konnten nicht geladen werden",
    "expert": {
      "certified": "Zertifiziert",
      "collections": "Geteilte Sammlungen ({count})"
    },
    "loading": "Wird geladen...",
    "permission": {
      "edit": "Bearbeiten",
      "read": "Lesen"
    },
    "role": {
      "expert": "Experte",
      "familyOffice": "Family Office",
      "team": "Team",
      "user": "Nutzer"
    },
    "section": {
      "experts": "Experten ({count})",
      "users": "Weitere Nutzer ({count})"
    },
    "subtitle": "{experts} Experte(n) • {users} Nutzer",
    "title": "Geteilte Zugriffe"
  },
  "subscriptionGuard": {
    "currentStatus": "Aktueller Status",
    "explanation": "Ihr Abonnement ist inaktiv. Bitte erneuern Sie es, um auf die Plattform zuzugreifen.",
    "invoices": "Meine Rechnungen",
    "openPortal": "Abrechnungsportal öffnen",
    "payNow": "Jetzt bezahlen",
    "plan": "Plan",
    "title": "Abonnement erforderlich",
    "processing": "Verarbeitung…",
    "freeUntil": "Kostenloser Zugang bis {{date}}.",
    "demo": {
      "noStripe": "Demokonto: keine Stripe-Zahlung.",
      "noPaymentRequired": "Demomodus: keine Zahlung erforderlich."
    },
    "errors": {
      "checkout": "Der Bezahlvorgang konnte nicht gestartet werden. Bitte versuchen Sie es später erneut.",
      "portal": "Das Abrechnungsportal konnte nicht geöffnet werden.",
      "stripeUnavailable": "Stripe ist derzeit nicht verfügbar."
    },
    "status": {
      "demo": "Demo",
      "free": "kostenlos",
      "active": "aktiv",
      "trialing": "Testphase",
      "past_due": "überfällig",
      "canceled": "gekündigt",
      "cancelled": "gekündigt",
      "unpaid": "unbezahlt",
      "none": "inaktiv"
    },
    "plans": {
      "standard": "Standard",
      "premium": "Premium",
      "demo": "Demo",
      "internal_demo": "Interne Demo",
      "beta_demo": "Beta-Demo"
    }
  },
  "estimationSemblables": {
    "methodology": {
      "toDefine": {
        "badge": "Zu katalogisieren",
        "socle": "Es ist noch kein persönliches Künstler-Angebot mit diesem Kunstwerk verknüpft.",
        "signal": "Fügen Sie Vergleichswerte hinzu oder importieren Sie diese, und katalogisieren Sie den Künstler, um die Methode festzulegen.",
        "adjustment": "Der Motor kann noch nicht zwischen einer direkten CUP, einer Analogie-CUP oder einer Punktemethode unterscheiden.",
        "conclusion": "Die Schätzung bleibt vorbereitend, solange die methodische Grundlage nicht definiert ist."
      },
      "pointMethod": {
        "badge": "Punktemethode",
        "socle": "Gruppe C — kein ausreichend etablierter Sekundärmarkt.",
        "signal": "Die Bewertung basiert auf dem Expertengitter: Medium, Abmessungen, Erhaltungszustand und eventuelle Dokumentationsboni.",
        "adjustment": "Galeriepreise oder externe Signale dienen als Kontext, ersetzen aber nicht die Punktemethode.",
        "conclusion": "Der angezeigte Wert ist ein indikativer fairer Wert, basierend auf einem geregelten Primärmarkt und nicht auf Auktionsliquidität."
      },
      "quasiDirectCup": {
        "badge": "Quasi direkte CUP",
        "socle": "Gruppe B — Analogie-CUP im anfänglichen Angebot.",
        "adjustment": "Aktuelle Verkäufe sind zahlreich und konsistent genug, um den anfänglichen Vorsichtsabschlag zu reduzieren.",
        "conclusion": "Die Schätzung bleibt in Gruppe B, aber die Motorlektüre nähert sich einer partiellen direkten CUP."
      },
      "hybridReinforced": {
        "badge": "Verstärkter Hybrid",
        "socle": "Gruppe B — Analogie-CUP: historisch begrenzter oder inkonsistenter Sekundärmarkt.",
        "adjustment": "Diese frischen Verkäufe stärken teilweise die Zuverlässigkeit der Bewertung und korrigieren die anfängliche vorsichtige Lesart.",
        "conclusion": "Der Motor kombiniert Expertenangebot, aktuelle eigene Ergebnisse, Frische, technische Nähe und gewichteten Median."
      },
      "analogyPrudent": {
        "badge": "Vorsichtige Analogie",
        "socle": "Gruppe B — Analogie-CUP: aktuelle eigene Ergebnisse bleiben unzureichend.",
        "signalOne": "Es ist nur ein aktueller Vergleichswert vorhanden: Er dient als Signal, nicht als autonome Grundlage.",
        "signalNone": "Es wurden noch keine ausreichenden aktuellen Signale in den vollständigen Vergleichswerten erkannt.",
        "adjustment": "Der Vorsichtsabschlag bleibt weitgehend aktiv, bis der aktuelle Markt besser dokumentiert ist.",
        "conclusion": "Die Schätzung sollte als analogische Bewertung gelesen werden, mit Vorsicht bei der Liquidität."
      },
      "directCupActive": {
        "badge": "Direkte CUP aktiv",
        "socle": "Gruppe A — direkte CUP: dokumentierter Sekundärmarkt.",
        "adjustment": "Aktuelle Verkäufe werden nach Abmessungen, Technik, Künstlernähe und Frische gewichtet.",
        "conclusion": "Der gewichtete Median behält die zuverlässigsten Vergleichswerte bei, ohne die beobachteten Preise direkt zu ändern."
      },
      "directCupIncomplete": {
        "badge": "Direkte CUP zu vervollständigen"
      },
      "dynamic": {
        "badge": "Dynamische Lektüre",
        "adjustment": "Der Motor gewichtet Ergebnisse nach Frische, technischer Nähe und dimensionaler Konsistenz.",
        "conclusion": "Die endgültige Bewertung bleibt ein Entscheidungshilfsmittel und muss vom Experten validiert werden."
      },
      "groupB": {
        "b1label": "Verstärkter Hybrid",
        "b1desc": "Aktuelle eigene Ergebnisse existieren, sind aber für eine direkte CUP unzureichend. Der Motor gewichtet eigene Ergebnisse und Analogien mit reduziertem Vorsicht (-8%).",
        "b2label": "Vorsichtige Analogie",
        "b2desc": "Keine ausreichenden aktuellen eigenen Ergebnisse. Die Bewertung basiert auf analogen Künstlern ähnlichen Profils. Standard-Vorsichtsabschlag von -15% gemäß CUP-Methodik.",
        "b3label": "Quasi direkte CUP",
        "b3desc": "Aktuelle eigene Ergebnisse sind ausreichend und konsistent für eine Lesart nahe einer partiellen direkten CUP. Der Vorsichtsabschlag wird aufgehoben."
      }
    },
    "memory": {
      "addFromCup": "Klicken Sie auf Zur Schätzung hinzufügen im CUP-Assistenten oder Ratio-Tool. Die Auswahl erscheint auch beim nächsten Öffnen hier.",
      "extrapolation": "Extrapolation",
      "retainedSale": "Berücksichtigter Verkauf",
      "untitledExtrapolation": "Extrapolation ohne Titel",
      "untitledComparable": "Vergleichswert ohne Titel",
      "artistMissing": "Künstler nicht angegeben",
      "sourceMissing": "Quelle nicht angegeben",
      "weight": "Gewicht {{value}}",
      "remove": "Entfernen",
      "low": "Untergrenze",
      "high": "Obergrenze"
    },
    "save": {
      "missingId": "Speichern nicht möglich: estimation_id oder Benutzer fehlt.",
      "valuationError": "Fehler beim Speichern der Schätzung.",
      "resolveFailed": "Die Schätzung konnte nicht aufgelöst werden.",
      "irreparableAlert": "Dieses Kunstwerk ist als Irreparabel eingestuft — vollständige Abschreibung. Es kann kein Wert gespeichert werden. Dokumentieren Sie die Entscheidung in den Kunstwerknotizen.",
      "missingQuote": "Das Künstlerangebot existiert, aber eine Spanne oder verwendbare Vergleichswerte fehlen.",
      "catalogFirst": "Bitte katalogisieren Sie diesen Künstler zuerst in Ihren persönlichen Angeboten."
    },
    "ui": {
      "donationDirecteDeLArtisteEquivCertificat": "Direkte Schenkung durch den Künstler, einem Zertifikat gleichgestellt",
      "certificatDAuthenticite": "Echtheitszertifikat",
      "provenanceArtiste1erMarche": "Provenienz vom Künstler / Primärmarkt",
      "suiviDocumentaireComplet": "Vollständige Dokumentationskette",
      "irreparableWriteOff": "Irreparabel, vollständige Abschreibung",
      "partiellementRestaurable65": "Teilweise restaurierbar −65 %",
      "tresAbimeRestaurable50": "Stark beschädigt, restaurierbar −50 %",
      "tresMoyen30": "Sehr schlechter Zustand −30 %",
      "etatMoyen20": "Mittlerer Zustand −20 %",
      "etatDeConservation": "Erhaltungszustand",
      "decotePrudentielle": "Vorsichtsabschlag",
      "abattementLiquidite": "Liquiditätsabschlag",
      "bonificationsDocumentaires": "Dokumentationsboni",
      "decotePrudentielleGroupeB": "Vorsichtsabschlag Gruppe B",
      "abattementDeLiquiditeGroupeC": "Liquiditätsabschlag Gruppe C",
      "aucunAjustementMethodologiqueApplicable": "Keine methodische Anpassung anwendbar",
      "ajustementsAppliques": "Anpassungen angewandt",
      "aucunAjustement": "Keine Anpassung",
      "groupeB": "Gruppe B ·",
      "baseBruteAvantDecotes": "Bruttobasis vor Abschlägen",
      "valeurApresAjustements": "Wert nach Anpassungen",
      "valeurRetenue": "Angesetzter Wert",
      "ordreAppliqueEtatDeConservationDecotePrudentielleLiquiditeBonus": "Anwendungsreihenfolge: Erhaltungszustand → Vorsichts-/Liquiditätsabschlag → Dokumentationsboni.",
      "methodologieADefinir": "Methodik noch festzulegen",
      "lectureMethodologiqueArtkiv": "ARTKIV-Methodikanalyse",
      "socleMethodologique": "Methodische Grundlage",
      "signalMarcheRecent": "Aktuelles Marktsignal",
      "ajustementDynamique": "Dynamische Anpassung",
      "conclusionMoteur": "Ergebnis der Bewertungslogik",
      "comparablesComplets": "Vollständige Vergleichswerte:",
      "recents": "· aktuell:",
      "confiance": "· Konfidenz:",
      "irreparableValeurNulleDepreciationTotale": "Irreparabel, Wert null, vollständige Wertminderung",
      "lectureJustificationMarche": "Marktbegründung lesen",
      "sauvegardeJustificationMarche": "Marktbegründung speichern",
      "lectureExpertDuMarche": "Experteneinschätzung des Markts",
      "ventesDirectes": "Direkte Verkäufe:",
      "extrapolations": "· Extrapolationen:",
      "analogies": "· Analogien:",
      "enregistrement": "Speichern…",
      "enregistrerLaJustification": "Begründung speichern",
      "lesExtrapolationsEtAnalogiesConstituentDesOutilsDAide": "Extrapolationen und Analogien dienen der fachlichen Entscheidungsunterstützung und garantieren keinen erzielbaren Verkaufspreis.",
      "enregistreLe": "gespeichert am",
      "memoireExpertDeCetteEstimation": "Expertenprotokoll dieser Schätzung",
      "aucunChoixExpertEnregistre": "Keine Expertenauswahl gespeichert",
      "ceBlocRecapituleLesVentesEtExtrapolationsReellementRetenues": "Dieser Abschnitt fasst die vom Experten tatsächlich berücksichtigten Verkäufe und Extrapolationen zur Begründung des Gutachtens zusammen.",
      "mediane": "Median",
      "extrapolationse5783c": "Extrapolationen:",
      "fourchetteMemoire": "Gespeicherte Spanne:",
      "sauvegardeValuationArtwork": "Kunstwerkbewertung speichern",
      "creationComparablesManuelsNeutres": "neutrale manuelle Vergleichswerte erstellen",
      "sauvegardeComparablesRetenus": "berücksichtigte Vergleichswerte speichern",
      "cetteFonctionnaliteEstReserveeAuxComptesArtAdvisorPremium": "Diese Funktion ist Art-Advisor-Premium-Konten vorbehalten.",
      "ajoutezAuMoins3ComparablesCompletsAvantDeLancer": "Fügen Sie mindestens drei vollständige Vergleichswerte hinzu, bevor Sie Vision starten.",
      "impossibleDeLancerLAnalyseVisionPourLeMoment": "Die Vision-Analyse kann derzeit nicht gestartet werden.",
      "veuillezDAbordSelectionnerUneUvreDepuisLa": "Wählen Sie zunächst ein Kunstwerk auf der",
      "pageDEstimation": "Schätzungsseite",
      "retourAuxEstimations": "Zurück zu den Schätzungen",
      "estimationParUvresComparables": "Schätzung anhand vergleichbarer Kunstwerke",
      "comparezVotreUvreAvecDesVentesRecentesSimilaires": "Vergleichen Sie Ihr Kunstwerk mit ähnlichen aktuellen Verkäufen",
      "commentCaMarche": "💡 Wie funktioniert es?",
      "recherchezDes": "Suchen Sie",
      "uvresSimilaires": "ähnliche Kunstwerke",
      "venduesRecemmentMemeArtisteStylePeriodeDimensions": "die kürzlich verkauft wurden und denselben Künstler, Stil, Zeitraum sowie ähnliche Abmessungen aufweisen",
      "auMoins3Comparables": "mindestens drei Vergleichswerte",
      "avecLeurPrixDeVente": "mit ihren Verkaufspreisen",
      "indiquezVos": "Geben Sie Ihre",
      "artpriceChristieSSothebySGaleries": "Artprice, Christie's, Sotheby's, Galerien…",
      "lEquipeArtkiv": "Das Artkiv-Team",
      "valideEtAffine": "prüft und präzisiert",
      "votreEstimationSous4872h": "Ihre Schätzung innerhalb von 48–72 Stunden",
      "votreUvre": "Ihr Kunstwerk",
      "uvre": "Kunstwerk",
      "sansTitre": "Ohne Titel",
      "artiste": "Künstler:",
      "technique": "Technik:",
      "dimensions": "Abmessungen:",
      "cetteUvreFaitPartie": "Dieses Kunstwerk ist Teil",
      "dUnLot": "eines Lots",
      "pasBesoinDEstimerChaqueExemplaireSeparementALa": "Sie müssen nicht jedes Exemplar einzeln schätzen. Am Ende dieses Vorgangs können Sie",
      "appliquerCetteEstimationAToutLeLotEnUn": "diese Schätzung mit einem Klick auf das gesamte Lot anwenden",
      "laDecoteSelonLEtatDeConservationSeraAppliquee": ". Der Zustandsabschlag wird für jedes einzelne Werk separat angewandt, beispielsweise mittlerer Zustand −20 % oder sehr schlechter Zustand −30 %.",
      "allerAuBoutonDApplicationAuLot": "Zum Button „Auf Lot anwenden“ ↓",
      "chargementDesAutresExemplaires": "Weitere Exemplare werden geladen…",
      "aucunAutreExemplaireDetectePourCeLotVerifiezLes": "Für dieses Lot wurde kein weiteres Exemplar erkannt. Prüfen Sie die Berechtigungen oder die lot_id-Verknüpfung.",
      "trouverDesUvresComparables": "Vergleichbare Kunstwerke finden",
      "recherchezSurArtpriceMaisonsDeVentesGaleries": "Suchen Sie auf Artprice, bei Auktionshäusern und Galerien…",
      "forfaitUvreTemporelle": "Pauschale, zeitbasiertes Kunstwerk",
      "groupeCMethodeAPoints": "Gruppe C, Punktemethode",
      "ouChercher": "🔍 Wo suchen?",
      "artpriceBaseDeDonneesMondiale": "→ Artprice, weltweite Datenbank",
      "christieSVentesAuxEncheres": "→ Christie's, Auktionsergebnisse",
      "sothebySVentesAuxEncheres": "→ Sotheby's, Auktionsergebnisse",
      "artsyGaleries": "→ Artsy, Galerien",
      "verificationDeVotreCotationPersonnelleArtiste": "Ihre persönliche Künstlerbewertung wird geprüft…",
      "artisteNonEncoreCatalogueDansVosCotationsPersonnelles": "Dieser Künstler ist in Ihren persönlichen Bewertungen noch nicht erfasst.",
      "classezDAbordLArtisteDansVosCotationsExpert": "Ordnen Sie den Künstler zunächst in Ihren Expertenbewertungen der Gruppe A, B oder C zu und kehren Sie anschließend hierher zurück, um die passende Schätzung zu starten.",
      "cataloguerCetArtiste": "Diesen Künstler erfassen",
      "cotationPersonnelleDetectee": "Persönliche Bewertung erkannt:",
      "mediumNonRenseigne": "Technik nicht angegeben",
      "segmentSpecifiqueDetecte": "Spezifisches Segment erkannt:",
      "choisirUneCotationSegmentExpert": "Expertenbewertung / Segment auswählen",
      "a": "bis",
      "ajustementsAppliquesALaCotationPersonnelle": "Auf die persönliche Bewertung angewandte Anpassungen:",
      "base": "· Basis",
      "final": "→ final",
      "bonusDocumentairesDetectes": "Erkannte Dokumentationsboni:",
      "total": "→ gesamt",
      "integreALaMethodologieFinale": "in die endgültige Methodik einbezogen.",
      "irreparableDepreciationTotaleValeurNulle": "Irreparabel, vollständige Wertminderung, Wert null",
      "uvreTemporelleVideoInstallationFormulePointsInapplicable": "Zeitbasiertes Werk, Video oder Installation: Punktemethode nicht anwendbar.",
      "forfait": "Pauschale:",
      "forfaitCotationHorsFormulePoints": "Bewertungspauschale außerhalb der Punktemethode:",
      "retenu": "· angesetzt",
      "formule": "Formel: (",
      "cm": ") cm",
      "text": "×",
      "pt": "€/Punkt",
      "forfaitExpert": "Expertenpauschale:",
      "dimensionsAbsentesFormuleNonApplicable": "Abmessungen fehlen, Formel nicht anwendbar",
      "overrideExpertActifPriceLowPriceHighExclusDu": "Experten-Override aktiv; price_low und price_high sind von der Berechnung ausgeschlossen.",
      "decoteConservation": "Zustandsabschlag:",
      "apresDecote": "→ nach Abschlag",
      "bonusDocumentairesAppliques": "Angewandte Dokumentationsboni:",
      "integreDansLaValeurFinale": "% im Endwert berücksichtigt",
      "methodologieFinaleGroupeC": "Endgültige Methodik Gruppe C",
      "prixGalerieActuelArtsyArtsperGalerieBorneHauteIndicative": "Aktueller Galeriepreis, Artsy, Artsper oder Galerie, indikativer oberer Richtwert",
      "jamaisIntegreDansLaMoyennePondereeSertDePlafond": "Wird niemals in den gewichteten Durchschnitt einbezogen. Dient als obere Orientierungsgrenze und bleibt zur Nachvollziehbarkeit in der Akte gespeichert.",
      "ex23000": "Z. B. 23.000",
      "borneGalerie": "Galerie-Richtwert (",
      "inferieureALaFourchetteHauteCalculee": ") liegt unter der berechneten Obergrenze (",
      "coherenceAVerifier": ") — Plausibilität prüfen",
      "borneGalerie0f2755": "Galerie-Richtwert",
      "auDessusDeLaFourchetteCalculee": "— oberhalb der berechneten Spanne ✓",
      "modeActuel": "Aktueller Modus:",
      "fourchetteCalculee": "berechnete Spanne",
      "viaComparablesEncheres": "aus Auktionsvergleichswerten",
      "cotationPersonnelle": "persönliche Bewertung",
      "expert": "Experte (",
      "ajustements": "· Anpassungen:",
      "partirSurLaCotationPersonnelle": "Persönliche Bewertung verwenden →",
      "revenirAuxComparablesCalcules": "← Zurück zu den berechneten Vergleichswerten",
      "b3": "· B3",
      "b1HybrideRenforce": "· B1 verstärktes Hybridmodell",
      "b2AnalogiePrudente": "· B2 vorsichtige Analogie",
      "methodologieFinaleCotationPersonnelleGroupeA": "Endgültige Methodik der persönlichen Bewertung, Gruppe A",
      "estimationIdComparableId": "estimation_id,comparable_id",
      "sauvegardeComparablesRetenusAutocup": "berücksichtigte AutoCUP-Vergleichswerte speichern",
      "sauvegardeComparablesRetenusb4562d": "Berücksichtigte Vergleichswerte gespeichert:",
      "sauvegardeComparablesRetenusNonBloquanteRequeteAnnulee": "Nicht blockierendes Speichern der Vergleichswerte: Anfrage abgebrochen.",
      "sauvegardeComparablesRetenusNonBloquante": "Nicht blockierendes Speichern der Vergleichswerte:",
      "b3QuasiCupDirecte": "· B3 nahezu direkte CUP",
      "methodologieFinaleGroupeA": "Endgültige Methodik Gruppe A",
      "artistesAnaloguesRetenusSaisissezLeursResultatsAuxEncheresCi": "Ausgewählte Vergleichskünstler: Tragen Sie deren Auktionsergebnisse unten ein",
      "cliquezSurUnNomPourPreRemplirLeChamp": "Klicken Sie auf einen Namen, um das Künstlerfeld vorab auszufüllen. Suchen Sie Ergebnisse auf Artprice, Artnet oder Christie's.",
      "comparable": "Vergleichswert Nr.",
      "decesRecent": "Kürzlich verstorben",
      "titreDeLUvre": "Titel des Kunstwerks",
      "exSansTitreSerieAbstraite": "Z. B. Ohne Titel, abstrakte Serie",
      "nomDeLArtiste": "Name des Künstlers",
      "prixDeVente": "Verkaufspreis (€)",
      "ex15000": "Z. B. 15000",
      "dateDeVente": "Verkaufsdatum",
      "exArtpriceChristieS": "Z. B. Artprice, Christie's…",
      "lienOptionnel": "Link, optional",
      "ajouterUneUvreComparable": "+ Vergleichbares Kunstwerk hinzufügen (",
      "validationParLEquipeArtkiv": "📋 Validierung durch das Artkiv-Team",
      "votreAbonnement": "Ihr Abonnement",
      "inclutUneValidationHumaineUneFoisVosComparablesAjoutes": "beinhaltet eine menschliche Validierung. Sobald Sie Ihre Vergleichswerte hinzugefügt haben, analysiert unser Team diese und sendet Ihnen innerhalb von",
      "validationPrioritairePremium": "✅ Bevorzugte Premium-Validierung",
      "vousDonneAccesAUneValidation": "gewährt Ihnen Zugang zu einer Validierung",
      "sous24h": "innerhalb von 24 Stunden",
      "parNotreEquipeDExperts": "durch unser Expertenteam.",
      "affinageVision": "Vision-Präzisierung",
      "outilExpertPourAffinerLesComparablesEtEnrichirL": "Expertentool zur Präzisierung der Vergleichswerte und Vertiefung der Analyse.",
      "accesVisionCompletRequis": "Vollständiger Vision-Zugang erforderlich",
      "votreCompteExpertEstReconnuMaisLAnalyseVision": "Ihr Expertenkonto wurde erkannt, die vollständige Vision-Analyse ist jedoch folgenden Konten vorbehalten:",
      "artAdvisorPremium": "Art Advisor Premium",
      "lAnalyseVisionSeraDisponibleDesQueVousAurez": "Die Vision-Analyse ist verfügbar, sobald Sie mindestens",
      "3ComparablesComplets": "3 vollständige Vergleichswerte",
      "importezDesFichesArtpriceOuAjoutezManuellementDesComparables": "Importieren Sie Artprice-Datensätze oder fügen Sie manuell Vergleichswerte mit Titel, Künstler und Preis hinzu, um die automatische Präzisierung zu aktivieren.",
      "lancezUneAnalyseVisionPourAffinerLaCoherenceDes": "Starten Sie eine Vision-Analyse, um die Konsistenz Ihrer Vergleichswerte zu prüfen, Abweichungen bei Technik, Zeitraum, Format oder Marktnähe zu erkennen und Ihre Experteneinschätzung vor der Validierung zu stärken.",
      "analyseVisionEnCours": "Vision-Analyse läuft…",
      "analyserAvecVision": "Mit Vision analysieren",
      "resultatVision": "Vision-Ergebnis",
      "fourchetteSuggeree": "Vorgeschlagene Spanne:",
      "recapitulatifFinalGroupeC": "Abschließende Zusammenfassung Gruppe C",
      "recapitulatifFinalCotationPersonnelle": "Abschließende Zusammenfassung der persönlichen Bewertung",
      "recapitulatifFinalGroupeA": "Abschließende Zusammenfassung Gruppe A",
      "etatDeConservationNonReconnu": "⚠ Unbekannter Erhaltungszustand:",
      "laValeurStockeeEnBaseEst": "der in der Datenbank gespeicherte Wert lautet",
      "laquoNbsp": "„",
      "nbspRaquo": "“",
      "aucuneDecoteNEstAppliqueeValeursAttendues": "Es wird kein Abschlag angewandt. Erwartete Werte:",
      "writeOff": "vollständige Abschreibung",
      "corrigerLaFicheUvrePourAppliquerLaDecoteCorrectement": "Korrigieren Sie den Kunstwerkdatensatz, damit der richtige Abschlag angewandt wird.",
      "noteDeLExpertJustificationDeLEstimation": "Expertennotiz: Begründung der Schätzung",
      "cetteNoteApparaitDansLeRapportDExpertiseElle": "Diese Notiz erscheint im Gutachten und ergänzt die technischen Anpassungen. Sie wird aus der zuletzt gespeicherten Notiz vorausgefüllt und kann bearbeitet werden.",
      "exUvreEstimeeParAnalogieAvecLesSerigraphiesDu": "Z. B. Bewertung durch Analogie mit Siebdrucken desselben Formats. Wegen des fehlenden Echtheitszertifikats wurde ein Abschlag von 15 % angewandt. Der Sekundärmarkt dieses Künstlers war 2024–2025 aktiv.",
      "classementIrreparableValeurNulle": "Einstufung als irreparabel, Wert null",
      "cetteActionEnregistre": "Diese Aktion speichert",
      "commeValeurRetenueEtAppliqueLaMethode": "als angesetzten Wert und wendet die Methode an",
      "surLaFicheOeuvreDocumentezObligatoirementLaDecisionCi": "auf den Kunstwerkdatensatz an. Dokumentieren Sie die Entscheidung zwingend unten.",
      "noteDeJustification": "Begründungsnotiz",
      "exEtatIrreparableConstateLorsDeLaVisiteDu": "Z. B. Irreparabler Zustand bei der Besichtigung am 01.06.2025 festgestellt. Leinwand auf 60 % der Fläche zerrissen, Keilrahmen gebrochen. Nach den Feststellungen ist keine Restaurierung möglich.",
      "confirmerValeur0": "Bestätigen, Wert 0 €",
      "documenterLeWriteOffValeur0": "Abschreibung dokumentieren, Wert 0 €",
      "enregistrerLEstimation": "Schätzung speichern",
      "continuerVersLaValidation": "Zur Validierung fortfahren",
      "appliquerCetteEstimationAToutesLesUvresDuLot": "Diese Schätzung auf alle Kunstwerke des Lots anwenden, mit individuellem Zustandsabschlag für jedes Werk",
      "enregistrerAppliquerAuLot": "Speichern und auf Lot anwenden (",
      "serviceDeValidation": "💳 Validierungsservice",
      "10ValidationsGratuitesMoisPuis150ParValidation": ": 10 kostenlose Validierungen/Monat, danach 150 € je Validierung",
      "50ValidationsGratuitesMoisPuis150ParValidation": ": 50 kostenlose Validierungen/Monat, danach 150 € je Validierung",
      "nosExpertsVerifierontVosComparablesSous4872hOuvres": "Unsere Experten prüfen Ihre Vergleichswerte innerhalb von 48–72 Arbeitsstunden",
      "questionsFrequentes": "Häufig gestellte Fragen",
      "combienDeComparablesDoisJeAjouter": "Wie viele Vergleichswerte sollte ich hinzufügen?",
      "groupeAMinimum3ComparablesGroupeBIdealement5": "Gruppe A: mindestens 3 Vergleichswerte. Gruppe B: idealerweise 5 abgeglichene Referenzen. Gruppe C: Die Punktemethode kann direkt aus der Künstlerbewertung angewandt werden.",
      "quelsCriteresPourChoisirUneUvreComparable": "Nach welchen Kriterien sollte ich ein vergleichbares Kunstwerk auswählen?",
      "privilegiezMemeArtisteMemePeriodeStyleDimensionsSimilairesTechni": "Priorisieren Sie: gleicher Künstler > gleiche Periode bzw. gleicher Stil > ähnliche Abmessungen > identische Technik > aktuelle Verkäufe unter zwei Jahren.",
      "combienDeTempsPourRecevoirLEstimationValidee": "Wie lange dauert es, bis ich die validierte Schätzung erhalte?",
      "standard4872hPremiumSous24hJoursOuvres": "Standard: 48–72 Std. | Premium: innerhalb von 24 Std., an Arbeitstagen",
      "applicationAuLot": "Auf Lot anwenden",
      "appliquerLEstimationA": "— Schätzung anwenden auf",
      "uvres": "Kunstwerke",
      "lEstimationDeReferenceEstDupliqueeSurToutesLes": "Die Referenzschätzung wird auf alle Kunstwerke des Lots übertragen. Der Zustandsabschlag wird für jedes Kunstwerk individuell angewandt.",
      "estimationDeReferenceAvantDecoteEtat": "Referenzschätzung vor Zustandsabschlag",
      "repartitionParEtatDeConservation": "Aufteilung nach Erhaltungszustand",
      "etat": "Zustand",
      "nbUvres": "Anzahl Kunstwerke",
      "valeurRetenueUnite": "Angesetzter Wert / Einheit",
      "1d9e75": "#1D9E75",
      "ef9f27": "#EF9F27",
      "d85a30": "#D85A30",
      "1a1a1a": "#1A1A1A",
      "a32d2d": "#A32D2D",
      "totalLot": "Gesamtwert des Lots",
      "fourchetteTotaleLot": "Gesamtspanne des Lots:",
      "voirLeDetailUvreParUvre": "Details nach Kunstwerk anzeigen (",
      "nInv": "Inv.-Nr.",
      "uvreSource": "Ausgangswerk",
      "estimationAppliqueeA": "Schätzung angewandt auf",
      "chaqueUvreAEteMiseAJourAvecSa": "Jedes Kunstwerk wurde mit seinem eigenen Zustandsabschlag aktualisiert.",
      "appliquees": "angewandt,",
      "enErreur": "fehlerhaft",
      "echecSauvegardeUvreSourceLotNonModifie": "Das Ausgangswerk konnte nicht gespeichert werden. Das Lot wurde nicht verändert.",
      "applicationEnCours": "Wird angewandt…"
    },
    "segment": {
      "primary": "Primärer Vergleichswert",
      "secondary": "Sekundärer Vergleichswert",
      "analogTrend": "Trendanalogie",
      "analogContext": "Kontextanalogie"
    },
    "dynamic": {
      "groupCLiquidityNote": "Bei Künstlern der Gruppe C liefert die Punktemethode einen eingegrenzten Primärmarktwert. Dieser Wert wird anschließend durch einen Liquiditätsabschlag angepasst, um das Fehlen eines etablierten Sekundärmarkts und die Abhängigkeit von der Galeriestrategie abzubilden. Der Standardabschlag beträgt 45 % und kann je nach institutioneller Anerkennung, Dokumentation und angenommener Liquidität zwischen 30 % und 55 % variieren.",
      "writeOffNote": "Das Kunstwerk ist als irreparabel gekennzeichnet. Gemäß dem Wertanpassungsraster führt ein irreparabler Zustand zu einer vollständigen Wertminderung: angesetzter aktueller Wert 0 EUR.",
      "conditionDiscount": "Zustandsabschlag: {{label}}",
      "prudenceDiscount": "Vorsichtsabschlag Gruppe B: −{{pct}} %",
      "liquidityDiscount": "Liquiditätsabschlag: −{{pct}} %",
      "documentaryBonuses": "Dokumentationsboni: {{bonuses}}",
      "recentArtistDeath": "Kürzlicher Tod des Künstlers ({{year}}): zu beobachtendes Marktsignal.",
      "ownRecentResults": "Unter den vollständigen Vergleichswerten wurden {{count}} aktuelle eigene Marktergebnisse erkannt.",
      "recentImported": "{{count}} aktuelle Vergleichswerte aus den letzten drei Jahren importiert.",
      "recentDetectedThreeYears": "{{count}} aktuelle Vergleichswerte aus den letzten drei Jahren erkannt.",
      "recentDetected": "{{count}} aktuelle Vergleichswerte erkannt.",
      "pointFlatRateSummary": "Gruppe C — Pauschale: {{low}} – {{high}}",
      "pointFormulaSummary": "Gruppe C — ({{height}} + {{width}}) × {{lowRate}}–{{highRate}} €/Punkt{{condition}}",
      "pointExpertFlatRateSummary": "Gruppe C — Expertenpauschale: {{low}} – {{high}}",
      "savedChoices": "{{count}} Auswahl(en) bereits gespeichert",
      "lotOf": "eines Lots mit {{count}} Exemplaren",
      "minimum": "mindestens {{count}}",
      "quoteDate": " · Datum: {{date}}",
      "segment": " · Segment {{segment}}",
      "theoreticalBase": " (theoretische Basis vor Abschlag: {{low}} – {{high}})",
      "finalPersonalGroupB": "Endgültige Methodik der persönlichen Bewertung, Gruppe B{{suffix}}",
      "finalGroupB": "Endgültige Methodik Gruppe B{{suffix}}",
      "finalSummaryGroupB": "Abschließende Zusammenfassung Gruppe B{{suffix}}",
      "confirmApplyLot": "Bestätigen — auf {{count}} Kunstwerke anwenden",
      "appliedLot": "Schätzung auf {{count}} Kunstwerke des Lots angewandt.",
      "loading": "Wird geladen…",
      "example": "z. B.",
      "maximumComparables": "Maximal {{count}} vergleichbare Kunstwerke",
      "goodVeryGood": "Gut / Sehr gut",
      "defaultWriteOffNote": "Irreparabler Zustand — vollständige Wertminderung. Abschreibung dokumentiert.",
      "writeOffSaved": "Kunstwerk als irreparabel eingestuft — Wert 0 gespeichert.",
      "estimationSaved": "Schätzung im Kunstwerkdatensatz gespeichert.",
      "lot": "Lot"
    },
    "adjustmentType": {
      "bonus": "Bonus",
      "discount": "Abschlag",
      "neutral": "Neutral"
    },
    "medium": {
      "painting": "Malerei",
      "sculpture": "Skulptur",
      "photography": "Fotografie",
      "drawing": "Zeichnung",
      "print": "Druckgrafik",
      "mixed_media": "Mischtechnik",
      "installation": "Installation",
      "video": "Video",
      "textile": "Textil",
      "ceramic": "Keramik",
      "nft": "NFT / Digitale Kunst",
      "other": "Sonstiges",
      "oil_on_canvas": "Öl auf Leinwand",
      "acrylic_on_canvas": "Acryl auf Leinwand",
      "ink_on_paper": "Tusche auf Papier",
      "watercolor_on_paper": "Aquarell auf Papier",
      "pencil_on_paper": "Bleistift auf Papier",
      "charcoal_on_paper": "Kohle auf Papier",
      "mixed_media_on_paper": "Mischtechnik auf Papier"
    },
    "methodGroup": {
      "point_method": "Gruppe C — Punktemethode",
      "analogy_cup": "Gruppe B — CUP nach Analogie",
      "direct_cup": "Gruppe A — Direkte CUP",
      "direct_cup_prudent": "Vorsichtige direkte CUP",
      "analogy_cup_ratio": "Analoge CUP nach Verhältnis",
      "hybrid_points_cup": "Hybrid aus Punkten + Vergleichswerten",
      "personal_quote_analogy_cup": "Expertenbewertung nach Marktanalogie",
      "personal_quote_direct_segment": "Identifiziertes Markt-Mikrosegment",
      "group_b_analogy": "Gruppe B — CUP nach Analogie",
      "group_b_hybrid": "Gruppe B — Gemischte CUP",
      "unknown": "Methode nicht angegeben"
    },
    "humanMethod": {
      "direct_cup": "Direkte CUP",
      "analogy_cup": "CUP nach Analogie",
      "point_method": "Punktemethode",
      "points": "Punktemethode",
      "forfait": "Expertenpauschale"
    },
    "snapshot": {
      "manualDirect": "Eigenes Marktergebnis manuell erfasst",
      "manualAnalogy": "Analogie manuell erfasst",
      "autoAnalogy": "AutoCUP-Analogie",
      "autoDirect": "Eigenes AutoCUP-Marktergebnis",
      "summaryA": "Der Sekundärmarkt ist ausreichend dokumentiert: {{direct}} homogene Auktionsergebnisse wurden berücksichtigt. Die Spanne basiert überwiegend auf beobachteten Ergebnissen.",
      "summaryB": "Der Sekundärmarkt ist begrenzt: {{direct}} eigene Marktergebnisse und {{analogies}} Analogien wurden berücksichtigt und bei Bedarf durch {{extrapolations}} Expertenextrapolationen ergänzt.",
      "summaryC": "Der Sekundärmarkt ist selten oder nicht ausreichend homogen: Die Bewertung stützt sich hauptsächlich auf qualitative Analyse, Marktanalogien und fachliche Vorsicht.",
      "sourceMethod": "Ausgangsmethode: {{method}}.",
      "extrapolations": "{{count}} Extrapolationen wurden als Entscheidungshilfe, nicht als Preisnachweis, beibehalten.",
      "depthWarning": "Die Markttiefe erlaubt keine rein statistische Auswertung; der Experte setzt eine begründbare Spanne statt einer schematischen Genauigkeit an."
    },
    "marketStrength": {
      "strong": "Solider Markt",
      "limited": "Begrenzter Markt",
      "scarce": "Seltener Markt / überwiegend Extrapolation"
    },
    "marketLabel": {
      "analogTrend": "Trendanalogie · höherer Markt mit Abschlag",
      "comparable": "Vergleichswert"
    }
  },
  "succession": {
    "actions": {
      "assign": "Zuweisen",
      "copyLink": "Link kopieren",
      "edit": "Bearbeiten",
      "end": "Fertigstellen",
      "missingEmail": "E-Mail fehlt",
      "removeAssignment": "Dieses Kunstwerk entfernen",
      "sendQuestionnaire": "Fragebogen senden"
    },
    "activate": "Nachlassplanung aktivieren",
    "addBeneficiary": "Begünstigten hinzufügen",
    "delegate": {
      "banner": "Sie sehen und vervollständigen die Akte von {{name}} als Bevollmächtigte(r)."
    },
    "alert": {
      "linkCopied": "Link kopiert. Sie können ihn in Ihre E-Mail einfügen.",
      "questionnaireAlreadyDone": "Fragebogen bereits ausgefüllt ✅",
      "questionnaireSent": "Fragebogen erneut gesendet an {{name}} ({{email}})",
      "updateLimited": "Begünstigter aktualisiert, aber mit eingeschränkten Informationen.",
      "updateOk": "Kontaktdaten aktualisiert ✅"
    },
    "artwork": {
      "allAssigned": "Alle Ihre Kunstwerke sind bereits zugewiesen",
      "artistUnknown": "Unbekannter Künstler",
      "untitled": "Ohne Titel"
    },
    "assign": {
      "allAssigned": "Alle Ihre Kunstwerke sind bereits zugewiesen. Sie können die Verteilung über jeden Begünstigten anpassen.",
      "back": "Zurück",
      "close": "Fenster schließen",
      "end": "Fertigstellen",
      "noneLeft": "Keine Kunstwerke mehr zuzuweisen",
      "purchase": "Kaufpreis",
      "subtitle": "Wählen Sie die Kunstwerke aus, die Sie zuweisen möchten",
      "title": "Kunstwerke für {{name}} zuweisen",
      "value": "Aktueller Schätzwert"
    },
    "assignButton": "Zuweisen",
    "beneficiaries": {
      "title": "Meine Begünstigten und Zuweisungen"
    },
    "card": {
      "valueLabel": "Wert: ",
      "worksLabel": "Werke: "
    },
    "deactivate": "Nachlassplanung deaktivieren",
    "edit": {
      "error": "Der Begünstigte konnte derzeit nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
      "sessionExpired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um diesen Begünstigten zu bearbeiten.",
      "updated": "Begünstigter erfolgreich aktualisiert.",
      "updatedLimited": "Begünstigter aktualisiert, aber einige Informationen waren serverseitig nicht verfügbar."
    },
    "error": {
      "add": "Begünstigter konnte nicht hinzugefügt werden. Bitte überprüfen Sie die Angaben und versuchen Sie es erneut.",
      "addBeneficiary": "Begünstigter konnte nicht hinzugefügt werden.",
      "assign": "Dieses Kunstwerk konnte nicht zugewiesen werden. Bitte versuchen Sie es in Kürze erneut.",
      "assignArtwork": "Kunstwerk konnte nicht zugewiesen werden.",
      "beneficiaryNotFound": "Begünstigter nicht gefunden.",
      "copyLink": "Link konnte nicht kopiert werden.",
      "edit": "Beim Aktualisieren des Begünstigten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "load": "Fehler beim Laden der Daten. Bitte versuchen Sie es erneut oder wenden Sie sich an das Artkiv-Team.",
      "loading": "Fehler beim Laden der Daten",
      "noEmail": "Für diesen Begünstigten ist keine E-Mail-Adresse hinterlegt.",
      "remove": "Die Zuweisung dieses Kunstwerks konnte nicht entfernt werden. Bitte versuchen Sie es in Kürze erneut.",
      "removeArtwork": "Kunstwerk konnte nicht entfernt werden.",
      "selectionNotAllowed": "Auswahl nicht gefunden oder nicht erlaubt.",
      "send": "Beim Versand des Fragebogens ist ein Problem aufgetreten. Überprüfen Sie die E-Mail-Adresse oder kontaktieren Sie das Artkiv-Team.",
      "sendQuestionnaire": "Fehler beim Senden des Fragebogens.",
      "sendQuestionnairePrefix": "Fehler beim Senden: {{message}}",
      "sessionExpired": "Ihre Sitzung ist abgelaufen.",
      "updateFailed": "Aktualisierung fehlgeschlagen: {{message}}"
    },
    "heirs": {
      "add": "Erben hinzufügen",
      "edit": "Bearbeiten",
      "relation": {
        "child": "Kind",
        "foundation": "Stiftung",
        "other": "Andere",
        "spouse": "Ehepartner"
      },
      "remove": "Entfernen",
      "subtitle": "Verwaltung der Begünstigten",
      "table": {
        "actions": "Aktionen",
        "name": "Name",
        "relation": "Beziehung",
        "share": "Anteil"
      },
      "title": "Erben"
    },
    "heirStatus": {
      "completed": "Fragebogen abgeschlossen",
      "inProgress": "Fragebogen in Bearbeitung",
      "pending": "Fragebogen noch nicht gesendet"
    },
    "quiz": {
      "title": "Sammlung & Weitergabe: Ihr Profil",
      "body": "Entdecken Sie in 6 Fragen Ihren Sammler-Archetyp — und was er konkret für Ihre Nachlassplanung bedeutet.",
      "cta": "Test starten",
      "duration": "≈ 2 Minuten"
    },
    "hint": {
      "emailRequiredAdd": "Für den Versand des Fragebogens erforderlich",
      "emailRequiredEdit": "Die E-Mail-Adresse wird benötigt, um den Fragebogen zu versenden."
    },
    "loading": "Ihre Nachlassplanung wird geladen...",
    "matching": {
      "confidence": {
        "high": "Hohe Übereinstimmung",
        "low": "Geringe Übereinstimmung",
        "medium": "Mittlere Übereinstimmung"
      },
      "empty": "Noch kein Matching berechnet",
      "justification": "Begründung",
      "recommendation": "Empfohlene Zuordnung",
      "refresh": "Neu berechnen",
      "run": "Matching berechnen",
      "subtitle": "Empfohlene Zuordnung der Kunstwerke",
      "title": "KI-Matching"
    },
    "menu": {
      "assignments": "Kunstwerkzuweisungen",
      "backToDashboard": "Zurück zum Dashboard",
      "beneficiaries": "Begünstigte",
      "resources": "Ressourcen"
    },
    "modal": {
      "add": "Hinzufügen",
      "addTitle": "Neuer Begünstigter",
      "cancel": "Abbrechen",
      "editTitle": "Begünstigten bearbeiten",
      "email": "E-Mail (optional)",
      "emailHelp": "Die E-Mail-Adresse ermöglicht das automatische Versenden des intergenerationellen Matching-Fragebogens.",
      "name": "Vollständiger Name",
      "phone": "Telefon (optional)",
      "relation": "Beziehung",
      "relationDaughter": "Tochter",
      "relationFamily": "Familie (allgemein)",
      "relationFriend": "Freund/in",
      "relationInstitution": "Institution / Stiftung",
      "relationOther": "Sonstiges",
      "relationPlaceholder": "z. B. Tochter, Sohn, Ehepartner, Freund, Stiftung…",
      "relationSon": "Sohn",
      "relationSpouse": "Ehepartner/in",
      "save": "Speichern"
    },
    "noAssigned": "Keine Kunstwerke zugewiesen",
    "noBeneficiaries": {
      "text": "Fügen Sie Ihre Erben hinzu, um mit der Nachlassplanung zu beginnen.",
      "title": "Noch keine Begünstigten"
    },
    "premium": {
      "badge": "Nur für Premium-Konten verfügbar",
      "button": "Zum KI-Matching",
      "completed": "{{count}} Fragebogen/bögen abgeschlossen.",
      "cta": "Premium aktivieren",
      "features": {
        "blockchain": "Echtheitsnachweise",
        "experts": "Koordination externer Experten",
        "matching": "KI-basiertes Erben-Matching",
        "simulation": "Szenario-Simulationen",
        "tax": "Steuerliche Optimierung"
      },
      "subtitle": "Erweiterte Nachlassplanung mit KI-Unterstützung",
      "text": "Sie haben Zugriff auf das intergenerationelle KI-Matching auf vision.artkiv.com.",
      "title": "KI-Matching aktiviert"
    },
    "questionnaire": {
      "completed": "Abgeschlossen",
      "inProgress": "In Bearbeitung",
      "save": "Speichern",
      "section": {
        "intent": "Absicht (Behalten / Verkaufen)",
        "knowledge": "Kenntnisse im Kunstmarkt",
        "profile": "Profil",
        "taste": "Künstlerischer Geschmack"
      },
      "start": "Fragebogen starten",
      "submit": "Absenden",
      "subtitle": "Präferenzen und Affinitäten erfassen",
      "title": "Erben-Fragebogen"
    },
    "removeAssignment": "Dieses Kunstwerk entfernen",
    "resources": {
      "checklists": "Checklisten",
      "contacts": "Expertenkontakte",
      "dation": {
        "desc": "Verstehen Sie, wie Kunstwerke zur Bezahlung eines Teils Ihrer Erbschaftssteuer genutzt werden können.",
        "title": "Zahlung an Zahlungs statt (dation en paiement)"
      },
      "description": "Hier finden Sie wesentliche Ressourcen für die Vorbereitung Ihrer Vermögensweitergabe.",
      "download": "Herunterladen",
      "estimate": {
        "desc": "Erstellen Sie eine strukturierte Bewertungsakte für Ihren Notar oder Rechtsberater.",
        "title": "Erbschaftsbewertung"
      },
      "guides": "Leitfäden",
      "subtitle": "Dokumente und Hilfen",
      "title": "Ressourcen"
    },
    "simulation": {
      "compare": "Szenarien vergleichen",
      "direct": "Direkte Übertragung",
      "donation": "Schenkung",
      "estimate": "Geschätzte Steuerlast",
      "foundation": "Stiftung",
      "subtitle": "Vergleich verschiedener Übertragungsoptionen",
      "title": "Szenarien",
      "trust": "Trust"
    },
    "standard": {
      "cta": "Standard-Nachlass konfigurieren",
      "features": {
        "documents": "Zentralisierte Dokumente",
        "exports": "PDF- & Excel-Exporte",
        "heirs": "Erbenliste",
        "inventory": "Vollständiges Inventar der Kunstwerke"
      },
      "premiumTeaser": {
        "button": "Auf Premium upgraden",
        "paragraph": "Mit Artkiv Premium erhalten Sie Zugang zu vision.artkiv.com und unserem revolutionären KI-Matching-System, das die psychologischen Profile Ihrer Erben analysiert, um jedem Kunstwerk intelligent zuzuordnen.",
        "point1": "Ausgefeilte psychologische Fragebögen für jeden Erben",
        "point2": "Matching-Algorithmus basierend auf künstlerischen und emotionalen Präferenzen",
        "point3": "Art Market 2025-Daten für eine präzise Vermögensbewertung",
        "point4": "Detaillierte Berichte mit Kompatibilitätswerten",
        "sectionTitle": "Das erhalten Sie:",
        "stat1": {
          "label": "Genauigkeit des psychologischen Matchings"
        },
        "stat2": {
          "label": "Integrierte Marktdaten"
        },
        "stat3": {
          "label": "Analysekriterien pro Erben"
        },
        "subtitle": "Zugang zu vision.artkiv.com",
        "title": "Upgrade auf Premium für KI-Matching"
      },
      "subtitle": "Grundlegende Vorbereitung der Übertragung",
      "text": "In der Standard-Version können Sie Begünstigte hinzufügen und Kunstwerke manuell zuweisen. Die Zuweisung basiert auf dem Kaufwert Ihrer Werke.",
      "title": "Standard-Nachlass"
    },
    "stats": {
      "assignedWorks": "Zugewiesene Werke",
      "beneficiaries": "Begünstigte",
      "completed": "Abgeschlossene Fragebögen"
    },
    "status": {
      "active": "Aktiv",
      "inactive": "Nicht aktiv"
    },
    "subtitle": "Organisieren Sie die Weitergabe Ihrer Kunstsammlung durchdacht und optimal.",
    "subtitleDelegate": "Sehen und vervollständigen Sie die Übertragung der Sammlung von {{name}}.",
    "titleDelegate": "Nachlassakte — {{name}}",
    "summary": {
      "artworks": "Kunstwerke",
      "heirs": "Erben",
      "lastUpdate": "Letzte Aktualisierung",
      "totalValue": "Gesamtwert"
    },
    "tax": {
      "note": "Diese Informationen ersetzen keine individuelle Rechts- oder Steuerberatung.",
      "subtitle": "Hinweise nach geltendem Recht",
      "title": "Steuerliche Aspekte"
    },
    "title": "Nachlassplanung",
    "why": {
      "p1": "Laut UBS Global Family Office 2025 haben nur 53 % der Family Offices einen Nachlassplan erstellt. Fast die Hälfte riskiert eine ungeordnete Vermögensübertragung.",
      "p2": "Kunstwerke sind sowohl finanzielles als auch emotionales Erbe. Eine gut orchestrierte Weitergabe stellt sicher, dass Ihre Werke zu Erben gelangen, die sie bewahren und Ihre Vision fortführen.",
      "p2Delegate": "Kunstwerke sind sowohl finanzielles als auch emotionales Erbe. Eine gut orchestrierte Weitergabe stellt sicher, dass die Werke von {{name}} zu Erben gelangen, die sie bewahren und ihren Geist fortführen.",
      "title": "Warum Nachlassplanung unverzichtbar ist"
    },
    "balance": {
      "title": "Gleichgewicht der Übertragung",
      "subtitle": "Übersicht: was zugewiesen ist, an wen und in welchem Verhältnis.",
      "collectionValue": "Wert der Sammlung",
      "assigned": "Zugewiesen",
      "unassigned": "Nicht zugewiesen",
      "coverage": "{{pct}} % der Sammlung zugewiesen",
      "heirShare": "Anteil pro Erbe",
      "ofEstate": "des Gesamtvermögens",
      "ofCollection": "der Sammlung",
      "reserveOk": "Ausgewogene Verteilung im Verhältnis zum Richtwert.",
      "reserveWarn": "Ein Erbe vereint {{pct}} % der Basis: im Hinblick auf den Pflichtteil zu prüfen.",
      "reserveNote": "Indikator, keine Rechtsberatung: Der Pflichtteil bemisst sich am Gesamtvermögen (Wertpapiere, Immobilien, Liquidität…) und nach Ihrer familiären Situation. Mit Ihrem Notar zu klären.",
      "baseCollectionOnly": "Berechnungsbasis = ausschließlich Wert der Sammlung.",
      "baseGlobal": "Berechnungsbasis = Gesamtvermögen (Quelle: {{source}}).",
      "connectFO": "Verbinden Sie Ihr Family Office, um die Anteile am Gesamtvermögen zu berechnen.",
      "empty": "Fügen Sie Begünstigte hinzu und weisen Sie Werke zu, um die Verteilung anzuzeigen.",
      "valuationDated": "Aktuellste Werte zum {{date}}; die Erbschaft berücksichtigt den Verkehrswert am Todestag.",
      "valuationNone": "Kein Werk hat eine datierte Schätzung; die Erbschaft berücksichtigt den Verkehrswert am Todestag.",
      "undatedCount": "{{count}} Werk(e) ohne datierte Schätzung.",
      "estimateCta": "Diese Werke schätzen →"
    },
    "valuation": {
      "asOf": "zum {{date}}",
      "undated": "nicht datiert",
      "source": {
        "estimation": "Schätzung",
        "declared": "Deklarierter Wert",
        "purchase": "Kaufpreis",
        "none": "Nicht geschätzt"
      }
    },
    "dossier": {
      "cta": "Übertragungsdossier exportieren (PDF)",
      "generating": "Dossier wird erstellt…",
      "ctaXls": "Als Excel exportieren (.xlsx)",
      "generatingXls": "Excel wird erstellt…",
      "error": "Dossier konnte nicht erstellt werden. Bitte versuchen Sie es in Kürze erneut.",
      "title": "Übertragungsdossier",
      "client": "Sammler",
      "date": "Erstellt am",
      "synthesisTitle": "1. Vermögensübersicht",
      "heirsTitle": "2. Verteilung & Besteuerung pro Erbe",
      "heirsTitleNoTax": "2. Verteilung pro Erbe",
      "xls": {
        "sheetSummary": "Übersicht",
        "sheetHeirs": "Verteilung",
        "sheetInventory": "Inventar",
        "sheetToEstimate": "Zu schätzen",
        "coverage": "Abdeckung (%)",
        "colNum": "#",
        "colTitle": "Titel",
        "colArtist": "Künstler",
        "colDate": "Datierte Schätzung",
        "colToEstimate": "Zu schätzen",
        "colHeir": "Erbe",
        "colShareValue": "Anteil (€)",
        "colSharePct": "Anteil (%)",
        "colRegime": "Regime",
        "colDuties": "Geschätzte Abgaben (€)",
        "yes": "Ja"
      },
      "inventoryTitle": "3. Werkinventar",
      "toEstimateTitle": "4. Zu schätzende Werke",
      "toEstimateIntro": "{{count}} Werk(e) ohne datierte Schätzung — Liste zur Übergabe an Ihren Experten für eine Bewertung zum Todestag.",
      "legalTitle": "Hinweise",
      "value": "Wert",
      "heirs": "Erbe(n)",
      "provenance": "Provenienz",
      "location": "Standort",
      "toEstimate": "zu schätzen",
      "none": "—",
      "confidential": "Von Artkiv erstelltes Dokument — Richtwert und vertraulich, mit Ihrem Notar zu prüfen.",
      "page": "Seite {{n}} / {{total}}"
    }
  },
  "actusVentes": {
    "dateUnavailable": "Datum nicht verfügbar",
    "errorMessage": "Fehler: {{message}}",
    "noUpcoming": "Keine bevorstehenden Auktionen für dieses Auktionshaus",
    "seeAll": "Alle Auktionen anzeigen",
    "source": "Quelle: {{house}}"
  },
  "advisor": {
    "accessGranted": "Zugang gewährt",
    "expert": "Experte",
    "findOne": "Berater finden",
    "loading": "Laden…",
    "none": "Derzeit kein Berater",
    "pricing": {
      "desc": "Die Vermittlung ist zu 100% kostenlos (im Abonnement enthalten). Kostenpflichtige Leistungen (Schätzungen, Gutachten) werden separat zum angezeigten Preis berechnet, ohne Zusatzgebühr für Sie.",
      "title": "Preisgestaltung"
    },
    "revokeAccess": "Zugang widerrufen",
    "shareCollections": "Sammlungen teilen",
    "sharedSince": "Geteilt seit",
    "sharing": "Teilen",
    "status": {
      "accepted": "Akzeptiert",
      "pending": "Ausstehend",
      "rejected": "Abgelehnt"
    },
    "subtitle": "Ihr persönlicher Experte für die Verwaltung Ihrer Sammlung",
    "title": "Mein Berater"
  },
  "beneficiaries": {
    "add": {
      "emailPlaceholder": "E-Mail des Begünstigten",
      "namePlaceholder": "Name des Begünstigten",
      "relationPlaceholder": "Verwandtschaftsverhältnis",
      "submit": "Hinzufügen",
      "title": "Begünstigten hinzufügen"
    },
    "empty": "Keine Begünstigten eingetragen.",
    "remove": "Entfernen",
    "title": "Begünstigte"
  },
  "beneficiary": {
    "permissions": {
      "full": "Vollzugriff",
      "read": "Nur lesen",
      "title": "Zugriffsrechte",
      "valuation": "Bewertung"
    }
  },
  "cta": {
    "back": {
      "dashboard": "Zurück zum Dashboard"
    },
    "invite": {
      "expert": "Experten einladen"
    },
    "share": {
      "collection": "Sammlung teilen"
    }
  },
  "consentIA": {
    "checkboxLabel": "Ich entscheide mich dafür, die oben beschriebenen KI-Funktionen von Artkiv zu aktivieren, und willige in die dafür erforderliche Verarbeitung der Daten meiner Kunstwerke ein.",
    "description": "Die KI-Funktionen von Artkiv sind Assistenzwerkzeuge. Sie können von Ihnen bereitgestellte Informationen analysieren und Ergänzungen, Beobachtungen oder Wertindikationen vorschlagen. Die endgültige Entscheidung bleibt bei Ihnen.",
    "error": {
      "load": "Der Status Ihrer KI-Einwilligung konnte nicht geladen werden.",
      "save": "Ihre KI-Einstellung konnte nicht auf dem Server gespeichert werden."
    },
    "loading": "KI-Einstellung wird geladen…",
    "saving": "Ihre Auswahl wird gespeichert…",
    "success": {
      "enabled": "KI-Funktionen aktiviert.",
      "disabled": "KI-Funktionen deaktiviert."
    },
    "signedAt": "Aktivierung erfasst am {{date}}.",
    "previousConsent": "Letzte Einwilligung erfasst am {{date}}. Die KI ist derzeit deaktiviert.",
    "controlHint": "Sie können Ihre Einwilligung jederzeit über diese Einstellung widerrufen. Der Widerruf deaktiviert KI-Funktionen für zukünftige Verarbeitungen.",
    "detailsToggle": "Details zur Verarbeitung anzeigen",
    "withoutAI": "Ohne Aktivierung können Sie Ihre Sammlung weiterhin manuell verwalten; Funktionen, die KI benötigen, bleiben nicht verfügbar.",
    "purposes": {
      "title": "Was die KI-Module tun können",
      "visual": {
        "title": "Visuelle Analyse",
        "body": "Bilder eines Kunstwerks analysieren und Angaben zu Klassifizierung, Stil oder Beschreibung vorschlagen."
      },
      "documents": {
        "title": "Dokumente & OCR",
        "body": "Rechnungen, Zertifikate oder andere Dokumente lesen und Informationen zur Übernahme in den Werkdatensatz vorschlagen."
      },
      "conservation": {
        "title": "Konservierung",
        "body": "Beobachtungen zum Zustand eines Kunstwerks anhand der bereitgestellten Informationen erkennen und strukturieren helfen."
      },
      "valuation": {
        "title": "Bewertung",
        "body": "Wertindikationen auf Grundlage verfügbarer Daten, Vergleichswerke und von ARTKIV verwendeter Marktinformationen unterstützen."
      }
    },
    "data": {
      "title": "Daten, die verarbeitet werden können",
      "body": "Je nach verwendetem Modul: Werkbilder, Dokumente und extrahierter Text, Metadaten des Werkdatensatzes, Konservierungsinformationen, Bewertungsdaten und Vergleichswerke, die Sie ARTKIV bereitstellen."
    },
    "guardrails": {
      "title": "Was die KI nicht für Sie entscheidet",
      "suggestions": "KI-Ergebnisse sind Vorschläge oder Hinweise und stellen für sich allein keine endgültige Schlussfolgerung dar.",
      "noAuthentication": "Eine KI-Analyse ist keine Authentifizierung oder Zertifizierung eines Kunstwerks.",
      "humanValidation": "Von OCR oder KI vorgeschlagene Informationen müssen vor der Übernahme in sensible Geschäftsdaten überprüft, korrigiert, angenommen oder verworfen werden können.",
      "professional": "KI-Analysen ersetzen keinen Sachverständigen, Restaurator, Versicherer, Notar oder anderen Fachmann, wenn professionelle Beratung erforderlich ist."
    },
    "access": {
      "standard": {
        "title": "KI-Funktionen sind in Ihrem aktuellen Tarif nicht enthalten",
        "body": "Sie können Ihre Sammlung weiterhin ohne KI verwalten. Vision-Module und KI-Verarbeitung erfordern einen Tarif, der diese Funktionen umfasst; diese Einstellung allein kann sie nicht freischalten."
      },
      "waitingConsent": {
        "title": "Ihre Einwilligung ist vor jeder KI-Analyse erforderlich",
        "body": "Ihr Tarif umfasst KI-Funktionen, sie bleiben jedoch deaktiviert, bis Sie sie ausdrücklich aktivieren. Kein Kunstwerk darf von diesen Modulen ohne diese Einwilligung analysiert werden."
      },
      "enabled": {
        "title": "KI-Funktionen aktiviert",
        "body": "Ihre Einwilligung erlaubt die erforderliche Verarbeitung, wenn Sie eine KI-Funktion verwenden. Sie bedeutet nicht, dass automatisch alle Ihre Kunstwerke analysiert werden."
      },
      "viewPlans": "Tarife mit KI ansehen →",
      "upgradeRequired": "Ihr aktueller Tarif erlaubt die Aktivierung der KI-Funktionen nicht."
    },
    "scope": {
      "title": "Zwei getrennte Entscheidungen",
      "account": "Diese Einstellung betrifft die Nutzung von KI-Funktionen auf Kontoebene. Sie wird in Ihrem Profil gespeichert und kann jederzeit widerrufen werden.",
      "artworkOptIn": "Die Aufnahme eines Kunstwerks in aggregierte und anonymisierte Statistiken und Analysen von Artkiv bleibt eine separate Entscheidung auf Werkebene. Durch die Aktivierung der KI wird diese Option niemals automatisch aktiviert."
    },
    "moreInfo": {
      "text": "Detaillierte Zwecke, Funktionsweise, Daten, Dienstleister und Ihre Rechte:",
      "link": "Vollständige KI-Information lesen"
    },
    "title": "KI-Funktionen & Einwilligung"
  },
  "edition": {
    "detailsHelp": "Zusätzliche Informationen zur Ausgabe",
    "detailsLabel": "Ausgabendetails",
    "detailsPlaceholder": "Detailtext eingeben…",
    "isEditionLabel": "Ist eine Ausgabe",
    "loading": "Laden…",
    "readOnlyDetailsTitle": "Details (nur lesen)",
    "readOnlyEditionTitle": "Ausgabe (nur lesen)",
    "readOnlyIsEdition": "Ausgabe",
    "readOnlyNo": "Nein",
    "readOnlyYes": "Ja"
  },
  "family": {
    "dashboard": {
      "subtitle": "Family-Office-Portfolio Übersicht",
      "title": "Family-Office-Dashboard"
    }
  },
  "signature": {
    "title": "Signatur & Authentifizierung",
    "authLabel": "Authentifizierung",
    "authPlaceholder": "Authentifizierungsreferenz",
    "description": "Signatur und Authentifizierungsdetails des Kunstwerks",
    "notesLabel": "Notizen",
    "notesPlaceholder": "Zusätzliche Notizen…",
    "signatureLabel": "Signatur",
    "signatureBooleanLabel": "Signiertes Werk",
    "signaturePlaceholder": "Signaturbeschreibung",
    "certificateLabel": "Echtheitszertifikat",
    "certificatePresent": "Zertifikat vorhanden",
    "certificateInDocuments": "In den Dokumenten verfügbar:",
    "certificateFallbackName": "Echtheitszertifikat",
    "noCertificate": "Kein Zertifikat angegeben",
    "lotHelp": "Dieses Werk gehört zu einem Los. Sie können diese Signatur auf alle Werke des Loses anwenden.",
    "applyToLot": "Auf das ganze Los anwenden",
    "applyToLotLoading": "Wird angewendet…",
    "applyToLotConfirm": "Diese Signatur auf alle Werke des Loses anwenden?",
    "applyToLotError": "Anwendung auf das Los fehlgeschlagen.",
    "applyToLotSuccess": "Signatur auf {{count}} Werk(e) des Loses angewendet."
  },
  "questionnaire": {
    "comments": {
      "label": "Kommentare",
      "placeholder": "Ihre Kommentare…"
    },
    "interest": {
      "high": "Hoch",
      "label": "Interesse",
      "low": "Niedrig",
      "medium": "Mittel"
    },
    "preferred": {
      "label": "Präferenz",
      "placeholder": "Ihre Präferenz"
    },
    "select": "Auswählen",
    "submit": "Senden",
    "title": "Fragebogen"
  },
  "mesDemandes": {
    "error": "Ihre Anfragen konnten derzeit nicht geladen werden.",
    "empty": "Keine Anfragen.",
    "institutionFallback": "Institution",
    "loading": "Laden…",
    "seeAll": "Alle anzeigen",
    "sendMethod": {
      "email": "Per E-Mail",
      "self": "Eigenständiger Versand",
      "unknown": "Versandart nicht angegeben",
      "service": "Per Plattform"
    },
    "stats": {
      "draft": "Entwurf",
      "pending_one": "Ausstehend: {{count}}",
      "pending_other": "Ausstehend: {{count}}",
      "sent_one": "Gesendet: {{count}}",
      "sent_other": "Gesendet: {{count}}",
      "paid_one": "Bezahlt: {{count}}",
      "paid_other": "Bezahlt: {{count}}",
      "draft_one": "Entwurf: {{count}}",
      "draft_other": "Entwürfe: {{count}}",
      "paid": "Bezahlt",
      "pending": "Ausstehend",
      "sent": "Gesendet"
    },
    "status": {
      "awaiting_payment": "Zahlung ausstehend",
      "canceled": "Storniert",
      "completed": "Abgeschlossen",
      "in_progress": "In Bearbeitung",
      "cancelled": "Storniert",
      "draft": "Entwurf",
      "paid": "Bezahlt",
      "pending": "Ausstehend",
      "rejected": "Abgelehnt",
      "sent": "Gesendet",
      "unknown": "Unbekannt"
    },
    "title": "Meine Anfragen",
    "subtitle": "Ihre Vorschläge an Museen, Institutionen oder Auktionshäuser (Schenkung, Leihgabe, Auktion) zu Ihren Werken.",
    "backDashboard": "← Zurück zum Dashboard",
    "listTitle": "Alle meine Vorschläge",
    "listSubtitle": "Vorschläge an Museen, Institutionen oder Auktionshäuser (Schenkung, Leihgabe, Auktion) zu Ihren Werken.",
    "filters": {
      "all": "Alle"
    },
    "type": {
      "auction": "Auktion",
      "auction_sale": "Auktion",
      "institution_gift": "Schenkung an eine Institution",
      "institution_loan": "Leihgabe an eine Institution",
      "institution": "Institution",
      "unknown": "Anderer Vorschlag",
      "museum": "Museum"
    },
    "view": {
      "label": "Ansicht",
      "title": "Anfragen anzeigen"
    }
  },
  "collectionsListSidebar": {
    "title": "Aktionen",
    "createCollection": { "desc": "Eine neue Sammlung zu Ihrem Bestand hinzufügen." },
    "importZip": { "desc": "Mehrere Werke gleichzeitig aus einem ZIP-Ordner importieren (Fotos, Rechnungen)." },
    "createReport": { "desc": "Einen Bericht erstellen (Inventar, Bewertung, Versicherung, Erhaltungszustand…) — jeder Typ deckt einen anderen Aspekt ab; kombinieren Sie sie für ein vollständiges Bild. In Gruppen von weniger als 50 Werken für ein zuverlässiges PDF." },
    "reports": { "desc": "Bereits erstellte Berichte einsehen." },
    "exportAll": { "desc": "Nur Daten (CSV), keine Fotos. Für Bilder nutzen Sie „Bericht erstellen“." }
  },
  "collectionsList": {
    "artworkCount": "{{count}} Kunstwerk(e)",
    "createCollection": "Sammlung erstellen",
    "createFirst": "Erste Sammlung erstellen",
    "createReport": "Bericht erstellen",
    "defaultTitle": "Meine Sammlung",
    "deleteCollection": "Sammlung löschen",
    "exportAll": "Alle exportieren",
    "filter": "Filtern",
    "noneSubtitle": "Erstellen Sie Ihre erste Sammlung, um zu beginnen.",
    "noneTitle": "Keine Sammlungen",
    "reports": "Berichte",
    "title": "Meine Sammlungen",
    "viewCollection": "Sammlung anzeigen",
    "importZip": "ZIP-Ordner importieren",
    "editCollection": "Bearbeiten",
    "downloadReport": "↓ PDF-Bericht",
    "sharedBadge": "Geteilt",
    "accessEdit": "Bearbeitung",
    "accessView": "Ansicht",
    "noTypeTitle": "Keine Sammlung dieses Typs",
    "noTypeSubtitle": "Sie haben noch keine Sammlung mit diesem Status. Gehen Sie zu „Alle“ zurück, um alle Ihre Sammlungen zu sehen.",
    "showAll": "Alle Sammlungen anzeigen",
    "collectionCount_one": "{{count}} Sammlung",
    "collectionCount_other": "{{count}} Sammlungen",
    "stats": {
      "patrimonialValue": "Kunsthermögen",
      "foundationValue": "Stiftungseigener Wert",
      "excludeDeposits": "ohne Deposita",
      "excludeLoans": "ohne Leihgaben und Deposita",
      "totalArtworks": "Kunstwerke gesamt",
      "inalienable": "Unveräußerlich",
      "foundationOwned": "Stiftungseigentum",
      "inalienableSubtitle": "geschütztes Regime",
      "foundationOwnedSubtitle": "durch die Stiftung erworben",
      "deposit": "Depositum",
      "foundationLoans": "Leihgaben und Deposita",
      "nonPatrimonial": "nicht patrimonial"
    },
    "tabs": {
      "all": "Alle",
      "private": "Privat",
      "inalienable": "Unveräußerlich",
      "deposit": "Depositum",
      "foundationOwned": "Stiftungseigentum",
      "foundationFounder": "Gründerdarlehen",
      "foundationDonation": "Schenkungen / Vermächtnisse",
      "foundationDeposit": "Institutionelle Deposita"
    }
  },
  "collectionEdit": {
    "action": {
      "addArtwork": "Kunstwerk hinzufügen",
      "create": "Erstellen",
      "delete": "Löschen",
      "save": "Speichern"
    },
    "alt": {
      "preview": "Vorschau"
    },
    "artwork": {
      "dimensions": "Abmessungen",
      "label": "Kunstwerk",
      "manage": "Verwalten",
      "medium": "Medium",
      "new": "Neues Kunstwerk",
      "saveFirst": "Zuerst speichern",
      "title": "Titel",
      "year": "Jahr"
    },
    "cancel": "Abbrechen",
    "empty": {
      "artworks": "Noch keine Kunstwerke."
    },
    "error": {
      "auth": "Authentifizierungsfehler",
      "deleteArtwork": "Fehler beim Löschen des Kunstwerks",
      "load": "Fehler beim Laden",
      "save": "Fehler beim Speichern",
      "upload": "Fehler beim Hochladen"
    },
    "field": {
      "addImage": "Bild hinzufügen",
      "changeImage": "Bild ändern",
      "comments": "Kommentare",
      "curator": "Kurator",
      "description": "Beschreibung",
      "image": "Bild",
      "title": "Titel"
    },
    "page": {
      "create": "Sammlung erstellen",
      "edit": "Sammlung bearbeiten"
    },
    "saving": "Wird gespeichert…",
    "section": {
      "artworks": "Kunstwerke",
      "general": "Allgemein"
    }
  },
  "salesDonations": {
    "addModal": {
      "addDocuments": "Dokumente hinzufügen",
      "documentsHelper": "Fügen Sie relevante Dokumente hinzu (Rechnung, Vertrag…)",
      "field": {
        "amount": "Betrag",
        "artist": "Künstler",
        "artwork": "Kunstwerk",
        "buyer": "Käufer",
        "date": "Datum",
        "details": "Details",
        "documents": "Dokumente",
        "recipient": "Empfänger",
        "taxYear": "Steuerjahr",
        "type": "Typ",
        "valuation": "Bewertung"
      },
      "title": "Transaktion hinzufügen",
      "type": {
        "donation": "Schenkung",
        "sale": "Verkauf"
      }
    },
    "details": {
      "field": {
        "amount": "Betrag",
        "artist": "Künstler",
        "artwork": "Kunstwerk",
        "buyer": "Käufer",
        "date": "Datum",
        "details": "Details",
        "documents": "Dokumente",
        "estimatedValue": "Geschätzter Wert",
        "recipient": "Empfänger",
        "taxYear": "Steuerjahr",
        "type": "Typ"
      },
      "title": "Transaktionsdetails",
      "viewDocument": "Dokument anzeigen"
    },
    "export": {
      "button": "Exportieren",
      "yearAll": "Alle Jahre",
      "yearToGenerate": "Jahr zum Generieren"
    },
    "filters": {
      "taxYear": {
        "all": "Alle Jahre",
        "label": "Steuerjahr"
      },
      "transactionType": {
        "all": "Alle Typen",
        "donation": "Schenkung",
        "donations": "Schenkungen",
        "lossVol": "Verlust/Diebstahl",
        "sale": "Verkauf",
        "sales": "Verkäufe",
        "label": "Transaktionstyp"
      },
      "taxYearOptions": {
        "all": "Alle"
      },
      "transactionTypeOptions": {
        "all": "Alle",
        "donation": "Schenkungen",
        "sale": "Verkäufe"
      }
    },
    "history": {
      "addTransaction": "Transaktion hinzufügen",
      "col": {
        "actions": "Aktionen",
        "amount": "Betrag",
        "artist": "Künstler",
        "artwork": "Kunstwerk",
        "counterparty": "Gegenpartei",
        "date": "Datum",
        "police": "Polizei",
        "taxYear": "Steuerjahr",
        "type": "Typ"
      },
      "noEvent": "Keine Transaktionen.",
      "title": "Transaktionshistorie",
      "viewDetails": "Details anzeigen",
      "noTransaction": "Keine Transaktion entspricht diesem Filter."
    },
    "losses": {
      "badge": {
        "noPolice": "Keine Polizeimeldung",
        "policeNo": "Keine Polizei",
        "policeYes": "Polizei gemeldet",
        "recovered": "Wiedererlangt",
        "withPolice": "Mit Polizei"
      },
      "events": "{{count}} Ereignis",
      "events_plural": "{{count}} Ereignisse",
      "modal": {
        "ctaRecover": "Als wiedererlangt markieren",
        "fiscalNoteNoPolice": "Keine Polizeimeldung — steuerliche Absetzbarkeit eingeschränkt.",
        "fiscalNoteWithPolice": "✓ Polizei gemeldet — dieser Verlust kann steuerlich absetzbar sein.",
        "insuranceNo": "Keine Versicherung",
        "insuranceYes": "Versichert",
        "notRecovered": "Nicht wiedererlangt",
        "policeNo": "Keine Polizeimeldung",
        "policeYes": "Polizei gemeldet",
        "recovered": "Wiedererlangt",
        "recovering": "Wird aktualisiert…",
        "title": "Verlust-/Diebstahldetails",
        "reference": "Ref. {{reference}}",
        "fields": {
          "type": "Typ",
          "artwork": "Kunstwerk",
          "artist": "Künstler",
          "date": "Datum",
          "declaredValue": "Deklarierter Wert",
          "indemnity": "Versicherungsleistung",
          "taxYear": "Steuerjahr",
          "location": "Ort",
          "policeReport": "Polizeianzeige",
          "insuranceClaim": "Versicherungsfall",
          "status": "Status",
          "notes": "Notizen"
        }
      },
      "recovered": "{{count}} wiedererlangt",
      "recovered_plural": "{{count}} wiedererlangt",
      "deductionPrefix": "−",
      "taxYear": "Steuerjahr {{year}}",
      "events_one": "{{count}} Ereignis",
      "events_other": "{{count}} Ereignisse",
      "recovered_one": "{{count}} wiedergefunden",
      "recovered_other": "{{count}} wiedergefunden",
      "types": {
        "theft": "Diebstahl",
        "loss": "Verlust",
        "destruction": "Zerstörung",
        "disappearance": "Verschwinden",
        "generic": "Verlust / Diebstahl"
      }
    },
    "pdf": {
      "column": {
        "amount": "Betrag",
        "count": "Anzahl",
        "section": "Abschnitt"
      },
      "disclaimer": {
        "body": "Dieses Dokument dient nur zu Informationszwecken.",
        "title": "Hinweis"
      },
      "donationsDetails": {
        "artist": "Künstler",
        "artwork": "Kunstwerk",
        "date": "Datum",
        "estimatedValue": "Geschätzter Wert",
        "none": "Keine Schenkungen.",
        "recipient": "Empfänger",
        "title": "Schenkungsdetails"
      },
      "error": "Fehler beim Generieren des PDF",
      "generatedFromArtkiv": "Generiert von Artkiv",
      "notes": {
        "de": "Deutschland: Kunstwerke, die mehr als 1 Jahr gehalten wurden, sind steuerfrei.",
        "frForfait": "Frankreich: Pauschalsteuer 6,5% auf den Verkaufspreis.",
        "frPlusValue": "Frankreich: Kapitalgewinne — Differenz Kauf/Verkauf.",
        "none": "Keine Steuerregelung ausgewählt.",
        "uk": "Vereinigtes Königreich: CGT 20% auf Kapitalgewinne."
      },
      "row": {
        "donations": "Schenkungen",
        "estimatedTax": "Geschätzte Steuer",
        "regime": "Steuerregelung",
        "sales": "Verkäufe",
        "totalOperations": "Operationen gesamt"
      },
      "salesDetails": {
        "artist": "Künstler",
        "artwork": "Kunstwerk",
        "buyer": "Käufer",
        "date": "Datum",
        "none": "Keine Verkäufe.",
        "price": "Verkaufspreis",
        "purchaseDate": "Kaufdatum",
        "purchasePrice": "Kaufpreis",
        "title": "Verkaufsdetails"
      },
      "titleAllYears": "Alle Jahre — Steuerübersicht",
      "titleYear": "Steuerübersicht {{year}}",
      "yearTitle": "Jahr {{year}}"
    },
    "regime": {
      "de": "Deutschland (> 1 Jahr steuerfrei)",
      "frForfait": "Frankreich — Pauschal 6,5%",
      "frPlusValue": "Frankreich — Kapitalgewinne",
      "none": "Keine Regelung",
      "uk": "Vereinigtes Königreich — CGT 20%"
    },
    "summary": {
      "col": {
        "actions": "Aktionen",
        "donations": "Schenkungen",
        "losses": "Verluste",
        "lossesTooltip": "Verluste und Diebstähle",
        "sales": "Verkäufe",
        "total": "Gesamt",
        "year": "Jahr"
      },
      "estimatedTax": "Geschätzte Steuer",
      "exportYear": "Jahr exportieren",
      "noRegime": "Keine Steuerregelung ausgewählt",
      "regimeLabel": {
        "frForfait": "Pauschal 6,5%",
        "frPlusValue": "Kapitalgewinne"
      },
      "title": "Zusammenfassung"
    },
    "title": "Verkäufe & Schenkungen",
    "eyebrow": "Vermögen · Transaktionen",
    "errors": {
      "updateLoss": "Der Eintrag konnte nicht aktualisiert werden: {{message}}"
    }
  },
  "perteVol": {
    "title": "Verluste & Diebstähle",
    "subtitle": "Erfassen Sie verlorene, gestohlene oder zerstörte Kunstwerke für Steuererklärungen und Versicherungsverfahren.",
    "eyebrow": "Vermögen · Ereignisse",
    "declare": "+ Ereignis melden",
    "allClientLosses": "Alle Verluste / Diebstähle des Kunden",
    "clientLosses": "Verluste / Diebstähle des Kunden",
    "artworkLosses": "Verlust-/Diebstahlhistorie dieses Kunstwerks",
    "viewAllClientLosses": "Alle Verluste / Diebstähle des Kunden anzeigen",
    "backToArtwork": "Zurück zum Kunstwerk",
    "noLosses": "Kein Verlust oder Diebstahl erfasst",
    "noClientLosses": "Kein Verlust oder Diebstahl für diesen Kunden gefunden",
    "lossType": "Typ",
    "lossDate": "Datum",
    "taxYear": "Steuerjahr",
    "declaredValue": "Deklarierter Wert",
    "inventoryNumber": "Inventarreferenz",
    "artist": "Künstler",
    "artworkTitle": "Kunstwerk",
    "lossTypes": {
      "vol": "Diebstahl",
      "perte": "Verlust",
      "destruction": "Zerstörung",
      "incendie": "Brand",
      "inondation": "Überschwemmung",
      "autre": "Sonstiges",
      "disparition": "Verschwinden"
    },
    "purchasePrice": "Anschaffungspreis",
    "indemnity": "Versicherungsleistung",
    "netLoss": "Nettoverlust",
    "markRecovered": "Als wiedergefunden markieren",
    "recovered": "Wiedergefunden",
    "recoveredOn": "Wiedergefunden am {{date}}",
    "recoveredBy": "Wiedergefunden durch",
    "recoveredNotes": "Anmerkungen zur Wiederbeschaffung",
    "recoverConfirm": "Bestätigen Sie, dass dieses Kunstwerk wiedergefunden wurde?",
    "recoverError": "Das Kunstwerk konnte nicht aktualisiert werden",
    "recoveredHistory": "Verlauf wiedergefundener Kunstwerke",
    "exportPdf": "PDF exportieren",
    "stats": {
      "events": "Ereignisse",
      "active": "Aktiv",
      "recovered": "Wiedergefunden",
      "declaredValue": "Deklarierter Wert",
      "purchasePrice": "Anschaffungspreis",
      "indemnities": "Versicherungsleistungen",
      "netLoss": "Nettoverlust"
    },
    "filters": {
      "allTypes": "Alle Typen",
      "allYears": "Alle Jahre"
    },
    "table": {
      "type": "Typ",
      "date": "Datum",
      "artwork": "Kunstwerk",
      "artist": "Künstler",
      "purchasePrice": "Kaufpreis",
      "declaredValue": "Deklarierter Wert",
      "indemnity": "Versicherungsleistung",
      "status": "Status",
      "taxYear": "Steuerjahr"
    },
    "status": {
      "active": "Aktiv",
      "recovered": "Wiedergefunden"
    },
    "empty": {
      "all": "Es wurde noch kein Ereignis erfasst.",
      "filtered": "Kein Ereignis entspricht diesen Filtern."
    },
    "common": {
      "loading": "Wird geladen…",
      "details": "Details",
      "detailsArrow": "Details →",
      "untitled": "Ohne Titel",
      "uploading": "Upload läuft…",
      "updating": "Aktualisierung…",
      "delete": "Löschen"
    },
    "mobile": {
      "purchasePrice": "Kaufpreis",
      "declared": "Deklariert",
      "indemnity": "Leistung"
    },
    "actor": {
      "user": "Benutzer {{id}}…",
      "unknown": "Nicht angegeben"
    },
    "messages": {
      "saveError": "Das Ereignis konnte nicht gespeichert werden: {{message}}",
      "deleteConfirm": "Dieses Ereignis löschen?",
      "recoverConfirm": "Bestätigen Sie, dass dieses Kunstwerk wiedergefunden wurde und in die aktive Sammlung zurückkehren soll?",
      "recoveryNotePrompt": "Anmerkung zur Wiederbeschaffung (optional)",
      "recoverError": "Dieses Kunstwerk konnte nicht als wiedergefunden markiert werden."
    },
    "fiscalNote": {
      "title": "Steuerlicher Hinweis",
      "body": "In Frankreich können Verluste und Diebstähle von Kunstwerken unter bestimmten Voraussetzungen steuerlich abzugsfähig sein. Für einen Steuerabzug oder eine Versicherungsleistung ist in der Regel eine polizeiliche Anzeige erforderlich. Wenden Sie sich hinsichtlich der für Ihre Situation geltenden Schritte an Ihren Notar oder Steuerberater."
    },
    "addModal": {
      "title": "Ereignis melden",
      "artwork": "Kunstwerk",
      "selectArtwork": "— Kunstwerk auswählen —",
      "artworkTitle": "Titel des Kunstwerks",
      "inventoryNumber": "Inventarreferenz",
      "eventDate": "Ereignisdatum",
      "declaredValuePlaceholder": "Geschätzter Wert am Tag des Ereignisses",
      "initialPurchasePrice": "Ursprünglicher Kaufpreis",
      "currency": "Währung",
      "indemnityReceived": "Erhaltene Versicherungsleistung",
      "indemnityPlaceholder": "Nach Versicherung",
      "locationAtLoss": "Ort zum Zeitpunkt des Ereignisses",
      "locationPlaceholder": "Z. B. Galerie, Lager, Wohnsitz…",
      "notes": "Notizen / Umstände",
      "notesPlaceholder": "Beschreiben Sie die Umstände…"
    },
    "duplicate": {
      "title": "Für dieses Kunstwerk besteht bereits eine aktive Meldung",
      "createdBy": "Erstellt am {{date}} von {{actor}}"
    },
    "procedures": {
      "title": "Offizielle Schritte",
      "policeReport": "Polizeiliche Anzeige erstattet",
      "policeReference": "Aktenzeichen der Anzeige",
      "insuranceClaim": "Versicherungsmeldung",
      "insuranceReference": "Versicherungsreferenz"
    },
    "destructionProof": {
      "title": "Nachweis der Zerstörung",
      "selectFile": "Klicken, um eine Datei auszuwählen",
      "helper": "PDF, Bild oder Belegdokument",
      "remove": "Entfernen",
      "viewDocument": "Dokument anzeigen",
      "none": "Kein Nachweis hinterlegt"
    },
    "details": {
      "location": "Ort",
      "recoveredBy": "Wiedergefunden durch {{actor}}.",
      "activeLoss": "Aktiver Verlust / Diebstahl",
      "traceability": "Nachverfolgbarkeit",
      "createdOn": "Meldung erstellt am",
      "createdBy": "Erstellt von",
      "procedures": "Schritte",
      "circumstances": "Umstände"
    },
    "pdf": {
      "title": "Bericht Verluste & Diebstähle",
      "allYears": "Alle Jahre",
      "taxYear": "Steuerjahr {{year}}",
      "purchasePriceShort": "Kaufpreis",
      "activeRecovered": "Aktiv: {{active}} · Wiedergefunden: {{recovered}}",
      "theftAlert": "{{count}} Diebstahl — prüfen Sie, ob bei den zuständigen Behörden Anzeige erstattet wurde",
      "theftAlert_plural": "{{count}} Diebstähle — prüfen Sie, ob bei den zuständigen Behörden Anzeige erstattet wurde",
      "theftAlert_one": "{{count}} Diebstahl — prüfen Sie, ob bei den zuständigen Behörden Anzeige erstattet wurde",
      "theftAlert_other": "{{count}} Diebstähle — prüfen Sie, ob bei den zuständigen Behörden Anzeige erstattet wurde",
      "artworkArtist": "Kunstwerk / Künstler",
      "declaredShort": "Deklariert",
      "purchaseShort": "Kauf",
      "indemnityShort": "Leistung",
      "recoveredDate": "Wiedergefunden {{date}}",
      "recoveryNotesTitle": "Anmerkungen zur Wiederbeschaffung",
      "recoveryNoteLine": "{{artwork}} — wiedergefunden am {{date}}",
      "eventNotesTitle": "Notizen je Ereignis",
      "eventNoteLine": "{{artwork}} — {{artist}} ({{date}})",
      "disclaimer": "Dieses Dokument dient der Meldung. Kaufpreise, deklarierte Werte, Versicherungsleistungen und Wiederbeschaffungsstatus beruhen auf den in Artkiv erfassten Angaben. Wenden Sie sich hinsichtlich steuerlicher und erbrechtlicher Auswirkungen an Ihren Notar, Steuerberater oder Rechtsanwalt.",
      "footer": "Vertrauliches Dokument — Erstellt mit Artkiv",
      "page": "Seite {{page}} / {{total}}",
      "filename": "bericht_verluste_diebstahl_{{year}}.pdf",
      "filenameAll": "alle",
      "acquisitionPrice": "Anschaffungspreis",
      "declaredValue": "Deklarierter Wert",
      "indemnity": "Versicherungsleistung",
      "netLoss": "Nettoverlust",
      "recoveredStatus": "Wiederbeschaffungsstatus",
      "recoveredYes": "Wiedergefunden",
      "recoveredNo": "Nicht wiedergefunden"
    }
  },
  "rapportValorisationAdvisor": {
    "common": {
      "noValue": "Kein Wert",
      "unknownArtist": "Unbekannter Künstler",
      "untitled": "Ohne Titel"
    },
    "finality": {
      "assurance": {
        "badge": "Versicherung",
        "description": "Bewertung für Versicherungszwecke",
        "label": "Versicherung"
      },
      "marche": {
        "badge": "Markt",
        "description": "Aktuelle Marktwertbewertung",
        "label": "Markt"
      },
      "pret": {
        "badge": "Kredit",
        "description": "Bewertung als Sicherheit",
        "label": "Kredit/Garantie"
      },
      "succession": {
        "badge": "Nachfolge",
        "description": "Bewertung für Erbschaftszwecke",
        "label": "Nachfolge"
      }
    },
    "header": {
      "badge": "Advisor Premium",
      "subtitle": "Erstellen Sie einen strukturierten Bewertungsbericht mit Quellennachweis und Begründung.",
      "title": "Bewertungsbericht"
    },
    "methods": {
      "assurance_doc": "Versicherungsdokument",
      "physique": "Physische Begutachtung",
      "point": "Artkiv-Punkte-Methode",
      "semblables": "Vergleichsmethode",
      "succession": "Nachfolgebewertung"
    },
    "sources": {
      "artnet": "Artnet",
      "artprice": "Artprice",
      "bonhams": "Bonhams",
      "christies": "Christie's",
      "drouot": "Drouot",
      "insuranceReport": "Versicherungsbericht",
      "other": "Andere",
      "primaryGallery": "Primärgalerie",
      "privateMarket": "Privatmarkt",
      "sothebys": "Sotheby's"
    },
    "step1": {
      "advisorName": "Name des Beraters",
      "clientName": "Name des Kunden",
      "clientNamePlaceholder": "Vollständiger Name des Kunden",
      "continue": "Weiter",
      "subtitle": "Geben Sie die allgemeinen Informationen für diesen Bericht ein.",
      "title": "Allgemeine Informationen"
    },
    "step2": {
      "allCollections": "Alle Sammlungen",
      "artworksCount": "{{count}} Kunstwerk",
      "artworksCount_plural": "{{count}} Kunstwerke",
      "back": "Zurück",
      "chosenFinality": "Gewählter Zweck",
      "emptySearch": "Keine Ergebnisse",
      "emptySource": "Keine Kunstwerke in dieser Quelle",
      "next": "Weiter",
      "nextManual": "Manuell hinzufügen",
      "nextWithCount": "{{count}} Kunstwerk auswählen",
      "nextWithCount_plural": "{{count}} Kunstwerke auswählen",
      "noEstimate": "Kein Schätzwert",
      "noSourceSelected": "Keine Quelle ausgewählt",
      "offPlatformHint": "Geben Sie die Daten eines Kunstwerks ein, das nicht in Artkiv registriert ist.",
      "offPlatformPlaceholder": "Titel des Kunstwerks",
      "offPlatformTitle": "Kunstwerk außerhalb der Plattform",
      "pageSelection": "Seite {{page}} von {{total}}",
      "paginationSummary": "{{count}} Kunstwerk angezeigt",
      "paginationSummary_plural": "{{count}} Kunstwerke angezeigt",
      "previous": "Zurück",
      "searchPlaceholder": "Kunstwerk suchen…",
      "selectAll": "Alle auswählen",
      "selectedCount": "{{count}} ausgewählt",
      "sourceOffPlatform": "Außerhalb der Plattform",
      "sourceOwn": "Meine Sammlung",
      "sourceSharedClient": "Geteilte Kundensammlung",
      "sourceTitle": "Quelle",
      "title": "Kunstwerke auswählen",
      "unselectAll": "Alle abwählen"
    },
    "step3": {
      "addArtwork": "Kunstwerk hinzufügen",
      "artkivReference": "Artkiv-Referenz",
      "back": "Zurück",
      "delete": "Löschen",
      "finalValuePlaceholder": "Endwert in €",
      "highRange": "Hohe Schätzung",
      "justification": "Begründung",
      "justificationPlaceholder": "Begründung der Bewertung…",
      "lowRange": "Niedrige Schätzung",
      "manualArtistPlaceholder": "Künstlername",
      "manualEmpty": "Noch keine manuellen Kunstwerke.",
      "manualTitlePlaceholder": "Titel des Kunstwerks",
      "method": "Methode",
      "next": "Weiter",
      "notes": "Notizen",
      "notesPlaceholder": "Zusätzliche Notizen…",
      "required": "Pflichtfeld",
      "retainedValue": "Beibehaltener Wert",
      "sources": "Quellen",
      "subtitle": "Geben Sie die Bewertungsdetails für jedes Kunstwerk ein.",
      "title": "Bewertungsdetails",
      "totalDraft": "Gesamtentwurf"
    },
    "step4": {
      "disclaimer": "Dieser Bericht dient nur zu Informationszwecken und stellt kein rechtsverbindliches Gutachten dar.",
      "disclaimerItalic": "Artkiv unterstützt den Advisor, ersetzt aber nicht seine Expertise.",
      "downloadPdf": "PDF herunterladen",
      "downloadWord": "Word herunterladen",
      "editData": "Daten bearbeiten",
      "generating": "Wird generiert…",
      "newReport": "Neuer Bericht",
      "subtitle": "Ihr Bericht ist bereit.",
      "summary": {
        "artworks": "Kunstwerke",
        "date": "Datum",
        "finality": "Zweck",
        "totalValue": "Gesamtwert"
      },
      "title": "Bericht exportieren"
    },
    "stepper": {
      "artworks": "Kunstwerke",
      "data": "Daten",
      "export": "Export",
      "finality": "Zweck"
    }
  },
  "conservationPage": {
    "title": "Konservierungs- & Logistikakte",
    "tabs": {
      "storage": "Aktueller Zustand",
      "ideal": "Ideale Konservierung",
      "transport": "Transport",
      "history": "Verlauf",
      "monitoring": "Letzter Zustand",
      "idealStorage": "Ideale Konservierung"
    },
    "history": {
      "subtitle": "Verlauf der Eingriffe, Bewegungen und Ausstellungsbedingungen.",
      "addEntry": "+ Eintrag hinzufügen",
      "empty": "Noch keine Einträge. Fügen Sie oben den ersten hinzu.",
      "loading": "Wird geladen…",
      "form": {
        "title": "Neuer Eintrag",
        "type": "Typ *",
        "date": "Datum *",
        "contact": "Bearbeiter / Kontakt",
        "contactPlaceholder": "Atelier, Spediteur…",
        "cost": "Kosten (€)",
        "notes": "Notizen",
        "notesPlaceholder": "Beschreibung des Eingriffs…",
        "cancel": "Abbrechen",
        "save": "Speichern",
        "saving": "Wird gespeichert…"
      },
      "entryTypes": {
        "Acquisition": "Erwerb",
        "Inspection": "Inspektion",
        "Restauration": "Restaurierung",
        "Nettoyage": "Reinigung",
        "Encadrement": "Rahmung",
        "Transport": "Transport",
        "Accrochage": "Aufhängung",
        "Décrochage": "Abnahme",
        "Traitement préventif": "Präventive Behandlung",
        "Autre": "Sonstiges"
      },
      "intervenant": "Bearbeiter",
      "cost": "Kosten"
    },
    "generatePdf": "VOLLSTÄNDIGE PDF-AKTE ERSTELLEN",
    "generating": "Wird erstellt…",
    "storage": {
      "title": "Optimale Konservierungsbedingungen",
      "specificBadge": "Spezifische Anweisungen",
      "genericBadge": "Allgemeine Hinweise – {{type}}",
      "specificBody": "Diese Empfehlungen gelten speziell für dieses Werk und wurden vom Künstler, Restaurator oder von der Galerie bereitgestellt.",
      "genericBody": "Diese Empfehlungen werden automatisch anhand von Werktyp, Materialien und Erhaltungszustand erstellt.",
      "genericTitle": "Allgemeine Hinweise:",
      "genericNotice": "Diese Empfehlungen bilden eine Grundlage der präventiven Konservierung und sollten nur verwendet werden, wenn keine spezifischen Anweisungen des Künstlers, Restaurators oder der Galerie vorliegen.",
      "temperature": "Temperatur",
      "humidity": "Luftfeuchtigkeit",
      "light": "Licht",
      "placement": "Platzierung",
      "rotation": "Rotation",
      "additional": "Zusätzliche Empfehlungen – {{type}}",
      "specificActive": "Spezifische Anweisungen aktiv",
      "specificActiveBody": "Für dieses Werk werden derzeit spezifische Konservierungsanweisungen verwendet.",
      "modify": "Bearbeiten",
      "returnGeneric": "Zu allgemeinen Hinweisen zurückkehren",
      "specificAvailable": "Spezifische Anweisungen vorhanden?",
      "specificAvailableBody": "Falls Sie spezifische Konservierungsanweisungen vom Künstler, Restaurator oder von der Galerie erhalten haben, können Sie diese hier ergänzen und die allgemeinen Hinweise ersetzen.",
      "addSpecific": "Werkspezifische Anweisungen hinzufügen",
      "important": "Wichtig",
      "importantBody": "Diese allgemeinen Empfehlungen müssen an die spezifischen Materialien des Werks angepasst werden. Wenden Sie sich im Zweifel immer an eine qualifizierte Restauratorin oder einen qualifizierten Restaurator.",
      "removed": "Spezifische Anweisungen entfernt. Allgemeine Hinweise wiederhergestellt.",
      "removeError": "Die Anweisungen konnten nicht entfernt werden.",
      "comingSoon": "Funktion in Entwicklung.",
      "specificActiveTitle": "Werkspezifische Anweisungen aktiv",
      "edit": "Bearbeiten",
      "backGeneric": "Zur allgemeinen Anleitung zurückkehren",
      "specificAvailableTitle": "Sind werkspezifische Anweisungen verfügbar?",
      "importantTitle": "Wichtig"
    },
    "monitoring": {
      "loading": "Wird geladen…",
      "overdue": "Überfällige Punkte:",
      "visualInspection": "Sichtprüfung",
      "fullReport": "Vollständiger Bericht",
      "emptyTitle": "Kein Konservierungsbericht",
      "emptyBody": "Erstellen Sie den ersten Bericht, um die Überwachung zu beginnen.",
      "update": "Aktualisieren",
      "create": "Bericht erstellen"
    },
    "transport": {
      "title": "Transportlogistik",
      "body": "Diese Spezifikationen werden empfohlen, um das Werk während des Transports zu schützen.",
      "requestQuote": "Transportangebot anfordern",
      "missingId": "Werk-ID fehlt",
      "openForm": "Transportformular öffnen",
      "qr": "QR-Code erstellen",
      "downloadPdf": "PDF herunterladen",
      "pdfError": "PDF-Erstellung fehlgeschlagen.",
      "generating": "Wird erstellt…",
      "generatePdf": "VOLLSTÄNDIGES PDF-BLATT ERSTELLEN",
      "fields": {
        "caseType": "Kistentyp",
        "caseSize": "Kistengröße",
        "packagingMethod": "Verpackungsmethode",
        "transportMode": "Transportart",
        "carrier": "Transporteur",
        "estimatedCost": "Geschätzte Kosten",
        "insurance": "Versicherung",
        "customs": "Zoll",
        "temperatureControl": "Temperaturkontrolle"
      },
      "values": {
        "caseType": "Doppelwandige Isolierkiste mit maßgefertigtem Schaumstoff",
        "packagingMethod": "Verpackung mit säurefreiem Seidenpapier und Eckenschutz",
        "transportMode": "Spezialisierter Straßentransport für Kunstwerke",
        "insurance": "Empfohlene Deckung: 150.000 €",
        "customs": "ATA-Carnet für vorübergehende internationale Ausstellungen erforderlich",
        "temperatureControl": "Aktive Temperaturkontrolle während des Transports"
      },
      "generateQr": "QR-Code erstellen"
    },
    "qr": {
      "title": "QR-Code für Schnellzugriff",
      "alt": "QR-Code für Schnellzugriff",
      "body": "Dieser QR-Code bietet Zugriff auf das vollständige Konservierungs- und Transportblatt des Werks. Er eignet sich für Transporteure und Museumsrestauratoren.",
      "secure": "Sicher",
      "quick": "Schnellzugriff",
      "close": "Schließen",
      "download": "Herunterladen",
      "description": "Dieser QR-Code öffnet die vollständige Konservierungs- und Transportakte des Werks. Er eignet sich für Transporteure und Museumskonservatoren.",
      "quickAccess": "Schnellzugriff"
    },
    "types": {
      "photographie": "Fotografie",
      "peinture": "Malerei",
      "sculpture": "Skulptur",
      "art_interactif": "Interaktive / digitale Kunst",
      "generale": "Allgemein"
    },
    "templates": {
      "photographie": {
        "light": "Maximal 50 Lux, keine direkte UV-Strahlung",
        "placement": "Außenwände und Wärmequellen vermeiden",
        "rotation": "Rotation alle 3 Monate empfohlen",
        "recommendations": {
          "0": "Regelmäßig auf Staub oder Verfärbungen prüfen",
          "1": "Bei jeder Handhabung Baumwollhandschuhe tragen",
          "2": "In staubfreier Umgebung mit Luftfilterung aufbewahren",
          "3": "Nach einem Transport 24 Stunden Akklimatisierung vor dem Auspacken",
          "4": "Plötzliche Temperatur- und Feuchtigkeitsschwankungen vermeiden",
          "5": "In säurefreien Kartons oder Polyesterhüllen aufbewahren",
          "6": "UV-Schutz erforderlich (Filterglas oder Acrylglas)",
          "7": "Direkten Kontakt mit Klebstoffen oder sauren Materialien vermeiden"
        }
      },
      "peinture": {
        "light": "Maximal 150 Lux, keine direkte UV-Strahlung",
        "placement": "Außenwände und Wärmequellen vermeiden",
        "rotation": "Rotation alle 6 Monate empfohlen",
        "recommendations": {
          "0": "Regelmäßig auf Risse, Abblätterungen oder Verfärbungen prüfen",
          "1": "Bei jeder Handhabung Baumwollhandschuhe tragen",
          "2": "Bildträger und Keilrahmen prüfen",
          "3": "Nach einem Transport 24 Stunden vor dem Auspacken warten",
          "4": "Plötzliche Temperatur- und Feuchtigkeitsschwankungen vermeiden",
          "5": "Auf Schädlingsbefall achten",
          "6": "Sicherheitsabstand zu Wänden einhalten",
          "7": "Vibrationen und Stöße vermeiden",
          "8": "Schutzfirnis regelmäßig prüfen",
          "9": "Jede Zustandsänderung fotografisch dokumentieren"
        }
      },
      "sculpture": {
        "light": "Maximal 200 Lux, UV-Schutz empfohlen",
        "placement": "Stabile Fläche, fern von Durchgangsbereichen",
        "rotation": "Inspektion alle 6 Monate empfohlen",
        "recommendations": {
          "0": "Bedingungen an die jeweiligen Materialien anpassen",
          "1": "Stabilität von Sockel und Befestigungen prüfen",
          "2": "Materialgerechte Handschuhe verwenden",
          "3": "Auf Korrosion, Risse oder Schäden prüfen",
          "4": "Geeignete Hebe- und Transportmittel verwenden",
          "5": "Plötzliche Temperatur- und Feuchtigkeitsschwankungen vermeiden",
          "6": "Organische Materialien auf Schädlingsbefall prüfen",
          "7": "Sicherheitsbereich um das Werk einhalten",
          "8": "Oberflächenzustand und Veränderungen dokumentieren",
          "9": "Sockel an Gewicht und Form anpassen",
          "10": "Gleichgewicht und Stabilität regelmäßig prüfen"
        }
      },
      "art_interactif": {
        "light": "Gemäß den technischen Spezifikationen des Werks",
        "placement": "Elektrisch stabiler Bereich, fern von Magnetfeldern",
        "rotation": "Funktionstest alle 3 Monate empfohlen",
        "recommendations": {
          "0": "Alle technischen Komponenten dokumentieren und archivieren",
          "1": "Sicherungskopie digitaler Dateien aufbewahren",
          "2": "Kompatibilität der Dateiformate prüfen",
          "3": "Interaktive Elemente regelmäßig testen",
          "4": "Plan für Technologiemigration vorsehen",
          "5": "Originale technische Dokumentation aufbewahren",
          "6": "Backups auf mehreren Medien erstellen",
          "7": "Technologische Obsoleszenz überwachen",
          "8": "Detailliertes Komponentenverzeichnis führen",
          "9": "Kritische Ersatzteile vorhalten"
        }
      },
      "generale": {
        "light": "Maximal 150 Lux, keine direkte UV-Strahlung",
        "placement": "Außenwände und Wärmequellen vermeiden",
        "rotation": "Rotation alle 6 Monate empfohlen",
        "recommendations": {
          "0": "Regelmäßig auf Staub oder Verfärbungen prüfen",
          "1": "Bei jeder Handhabung Baumwollhandschuhe tragen",
          "2": "Nach einem Transport 24 Stunden vor dem Auspacken warten",
          "3": "Plötzliche Temperatur- und Feuchtigkeitsschwankungen vermeiden"
        }
      }
    }
  },
  "partner": {
    "emptyState": {
      "title": "Ihr Partnerbereich ist bereit.",
      "body": "Vervollständigen Sie Ihr Partnerprofil, um im ARTKIV-Verzeichnis zu erscheinen und Sammlern sowie Fachleuten Ihre Spezialisierungen auf einen Blick zu zeigen.",
      "completeProfile": "Profil vervollständigen",
      "viewDirectory": "Verzeichnis anzeigen",
      "nextTitle": "Richten Sie Ihren Bereich ein, während Sie auf die erste Anfrage warten",
      "filtered": "Für diesen Filter liegen keine Anfragen vor."
    },
    "common": {
      "loading": "Wird geladen…",
      "refresh": "Aktualisieren",
      "back": "Zurück",
      "noSession": "Keine aktive Sitzung",
      "artwork": "Kunstwerk",
      "untitled": "Ohne Titel",
      "unknownArtist": "Unbekannter Künstler",
      "client": "Kunde",
      "email": "E-Mail",
      "type": "Typ",
      "value": "Wert",
      "notes": "Notizen",
      "created": "Erstellt am {{date}}",
      "urgent": "Dringend",
      "processing": "Wird bearbeitet…",
      "sending": "Wird gesendet…",
      "saving": "Wird gespeichert…",
      "yes": "Ja",
      "no": "Nein"
    },
    "specialties": {
      "generic": "Partnerbereich",
      "insurance": "Versicherungspartner",
      "transport": "Transportpartner",
      "valuation": "Bewertungsexperte",
      "conservation": "Konservierungsexperte"
    },
    "sidebar": {
      "space": "Partnerbereich",
      "navigation": "Partnernavigation",
      "requests": "Anfragen",
      "completed": "Abgeschlossene Fälle",
      "profile": "Öffentliches Profil",
      "directory": "ARTKIV-Verzeichnis",
      "contract": "Meine Vereinbarung",
      "guide": "ARTKIV optimal nutzen",
      "support": "ARTKIV kontaktieren",
      "profileProgress": "Profil vollständig",
      "improveVisibility": "Sichtbarkeit verbessern",
      "contractStatus": "ARTKIV-Partnerschaft",
      "activeUntil": "Aktiv bis {{date}}",
      "contractAvailable": "Hier finden Sie die Angaben zu Ihrer Partnerschaft.",
      "viewContract": "Vereinbarung anzeigen"
    },
    "filters": {
      "all": "Alle",
      "pending": "Ausstehend",
      "seen": "Angesehen",
      "answered": "Beantwortet",
      "quoted": "Angebot gesendet",
      "accepted": "Angenommen",
      "rejected": "Abgelehnt",
      "done": "Geschlossen",
      "in_progress": "In Bearbeitung",
      "completed": "Abgeschlossen",
      "cancelled": "Storniert"
    },
    "status": {
      "pending": "Ausstehend",
      "seen": "Angesehen",
      "answered": "Beantwortet",
      "quoted": "Angebot gesendet",
      "accepted": "Angenommen",
      "rejected": "Abgelehnt",
      "done": "Geschlossen",
      "in_progress": "In Bearbeitung",
      "completed": "Abgeschlossen",
      "cancelled": "Storniert"
    },
    "dashboard": {
      "eyebrow": "ARTKIV-Portal für Fachpartner",
      "howItWorks": "So funktioniert es",
      "title": "Partnerbereich",
      "subtitle": "Ihre Anfragen",
      "subtitleConservation": "Begutachtung, Empfehlungen, Restaurierung und Konservierung",
      "intro": "Bündeln Sie die über ARTKIV eingehenden Anfragen, prüfen Sie ausschließlich die für den jeweiligen Auftrag freigegebenen Angaben und verfolgen Sie jeden Austausch bis zum Abschluss.",
      "steps": {
        "receive": "Qualifizierte Anfrage erhalten",
        "review": "Freigegebene Angaben prüfen",
        "respond": "Antworten und Fall verfolgen"
      },
      "partnershipTitle": "Meine ARTKIV-Partnerschaft",
      "partnershipStatus": "Status",
      "accessMode": "Zugang",
      "relationship": "Beziehung",
      "validUntil": "Gültigkeit",
      "noExpiry": "Ohne Ablaufdatum",
      "manageProfile": "Profil verwalten",
      "noPartnershipRecord": "Ihre Partnerakte ist noch nicht mit diesem Konto verknüpft. Kontaktieren Sie ARTKIV, um die Aktivierung abzuschließen.",
      "partnerStatus": {
        "draft": "Entwurf",
        "invited": "Eingeladen",
        "active": "Aktiv",
        "suspended": "Gesperrt",
        "expired": "Abgelaufen"
      },
      "accessModes": {
        "free": "Kostenfrei",
        "paid": "Kostenpflichtig",
        "custom": "Individuell",
        "none": "Keiner"
      },
      "relationships": {
        "marketplace_provider": "Marketplace-Dienstleister",
        "operational_provider": "Operativer Dienstleister",
        "institutional_free": "Institutioneller Partner",
        "directory_only": "Nur Verzeichnis",
        "strategic": "Strategischer Partner"
      },
      "metrics": {
        "total": "Alle Anfragen",
        "pending": "Zu bearbeiten",
        "active": "In Bearbeitung",
        "done": "Geschlossen"
      },
      "loadingSpace": "Ihr Partnerbereich wird geladen…",
      "configurationHint": "Prüfen Sie die Partnerakte und den Typ im Administrationsbereich.",
      "scope": "Die angezeigten Informationen sind auf die für die jeweilige Anfrage freigegebenen Daten beschränkt.",
      "open": "Anfrage öffnen",
      "markSeen": "Als angesehen markieren",
      "loadError": "Anfragen konnten nicht geladen werden.",
      "seenError": "Die Anfrage konnte nicht als angesehen markiert werden."
    },
    "requests": {
      "request": "Anfrage",
      "insuredValue": "Zu versichernder Wert",
      "insuranceExpected": "Erwartet: Angebot, Bescheinigung oder Anpassung des Versicherungsschutzes",
      "pickup": "Abholung",
      "delivery": "Lieferung",
      "transportExpected": "Erwartet: Kostenschätzung, Zeitfenster und Verpackungsanforderungen",
      "valuationExpected": "Erwartet: Wertspanne, Kommentare oder Dokumentenanfrage",
      "conservationRequest": "Konservierungsanfrage",
      "issue": "Problem",
      "conservationExpected": "Erwartet: Diagnose, Empfehlungen oder Restaurierungsangebot",
      "viewDetails": "Details anzeigen",
      "detailTodo": "Anfragedetails und Fachaktionen müssen noch angebunden werden."
    },
    "insurance": {
      "title": "Bereich für Versicherungspartner",
      "subtitle": "Anfragen zu Angeboten, Bescheinigungen und Wertaktualisierungen verwalten",
      "requestTitle": "Versicherungsanfrage",
      "treatment": "Bearbeitung durch den Partner",
      "intervention": "Leistungsumfang",
      "interventionBody": "Diese Informationen wurden vom Sammler für die Versicherungsanfrage freigegeben. Sie gewähren keinen Zugriff auf die gesamte Sammlung.",
      "context": "Kontext",
      "homePremium": "Hochwertige Hausratversicherung",
      "fineArtPolicy": "Spezielle Kunstversicherung",
      "policyType": "Deckungsart",
      "nailToNail": "Nagel zu Nagel",
      "allRisks": "Allgefahren",
      "transportRequired": "Transport erforderlich",
      "event": "Veranstaltung: {{start}} → {{end}}",
      "analysisData": "Für die Versicherungsprüfung bereitgestellte Daten.",
      "requestedValue": "Angefragter Wert",
      "clientMessage": "Nachricht des Kunden",
      "reply": "Antworten",
      "messageLabel": "Nachricht an den Sammler",
      "messagePlaceholder": "Fragen, benötigte Angaben, Deckungsbedingungen, Frist…",
      "quoteAmount": "Angebotssumme (EUR)",
      "sendMessage": "Nachricht senden",
      "sendQuote": "Angebot senden",
      "close": "Anfrage schließen",
      "locked": "Diese Anfrage hat den Status {{status}}. Der Kunde hat entschieden oder der Fall ist geschlossen; Änderungen sind nicht mehr möglich.",
      "invalidQuote": "Ungültige Angebotssumme.",
      "loadError": "Die Anfrage konnte nicht geladen werden.",
      "updateError": "Die Anfrage konnte nicht aktualisiert werden.",
      "seenSuccess": "Anfrage als angesehen markiert.",
      "answerSuccess": "Nachricht an den Sammler gesendet.",
      "quoteSuccess": "Angebot erfolgreich gesendet.",
      "closeSuccess": "Anfrage geschlossen."
    },
    "transport": {
      "title": "Bereich für Transportpartner",
      "subtitle": "Transport-, Handling- und Angebotsanfragen verwalten",
      "defaultRequest": "Kunsttransport"
    },
    "valuation": {
      "title": "Bereich für Bewertungsexperten",
      "subtitle": "Bewertungsanfragen verwalten und freigegebene Werkdaten einsehen",
      "tipTitle": "Relevante Angaben zusammentragen",
      "tipBody": "Prüfen Sie die vom Sammler freigegebenen Fotos, Maße, Datierung, Signatur, technischen Angaben, Provenienz und den Erhaltungszustand.",
      "requestTitle": "Bewertungsanfrage",
      "backToList": "Zurück zu meinen Anfragen",
      "artworkImage": "Abbildung des Werks",
      "details": "Detaillierte Angaben",
      "titleLabel": "Titel",
      "artist": "Künstler",
      "year": "Entstehungsjahr",
      "medium": "Technik",
      "dimensions": "Maße",
      "support": "Bildträger",
      "signature": "Signatur",
      "certificate": "Zertifikat",
      "provenance": "Provenienz",
      "condition": "Erhaltungszustand",
      "additionalNotes": "Zusätzliche Notizen",
      "collector": "Sammler",
      "name": "Name",
      "company": "Unternehmen",
      "quickActions": "Schnellaktionen",
      "start": "Bewertung beginnen",
      "yourValuation": "Ihre Bewertung",
      "estimatedValue": "Geschätzter Wert",
      "expertNotes": "Notizen und Begründung",
      "notesPlaceholder": "Begründung, Vergleichswerte, Marktlage…",
      "save": "Bewertung speichern",
      "invalidValue": "Bitte geben Sie einen gültigen Schätzwert ein.",
      "loadError": "Die Anfrage konnte nicht geladen werden.",
      "updateError": "Der Status konnte nicht aktualisiert werden.",
      "saveError": "Die Bewertung konnte nicht gespeichert werden.",
      "saveSuccess": "Bewertung erfolgreich gespeichert."
    },
    "contract": {
      "title": "Meine ARTKIV-Partnerschaft",
      "status": "Status",
      "active": "Aktiv",
      "startsAt": "Beginn",
      "endsAt": "Laufzeitende",
      "renewal": "Verlängerung",
      "renewalAutomatic": "Automatische Verlängerung",
      "renewalManual": "Manuelle Verlängerung",
      "document": "Vertragsdokument",
      "download": "Vereinbarung herunterladen",
      "contact": "ARTKIV zur Vereinbarung kontaktieren",
      "noDocument": "In Ihrem Bereich ist kein Vertragsdokument verfügbar."
    },
    "guide": {
      "title": "ARTKIV besser nutzen",
      "profileTitle": "Profil sichtbar machen",
      "profileBody": "Ergänzen Sie Fachgebiete, Einsatzgebiete, Sprachen, Referenzen und Kontaktdaten.",
      "responseTitle": "Schnell antworten",
      "responseBody": "Eine kurze erste Antwort schafft Vertrauen, auch wenn das vollständige Angebot später folgt.",
      "statusTitle": "Status aktuell halten",
      "statusBody": "Mit aktuellen Statusangaben können Kunde und ARTKIV den Fall ohne unnötige Rückfragen verfolgen.",
      "privacyTitle": "Freigegebenen Umfang beachten",
      "privacyBody": "Verwenden Sie ausschließlich Informationen, die für den jeweiligen Auftrag freigegeben wurden."
    },
    "insuranceDashboard": {
      "eyebrow": "Steuerung der Versicherungsanfragen",
      "intro": "Prüfen Sie über ARTKIV übermittelte Deckungsbedarfe, fordern Sie fehlende Angaben an, senden Sie Angebote oder Bescheinigungen und verfolgen Sie jeden Vorgang bis zur Entscheidung.",
      "workflowTitle": "Versicherungsablauf",
      "workflow": {
        "review": "Freigegebene Angaben zu Werk, Wert und Kontext prüfen",
        "qualify": "Risiko, Deckung und erforderliche Unterlagen klären",
        "quote": "Angebot, Bescheinigung oder Bedingungen übermitteln",
        "follow": "Annahme, Ablehnung oder Abschluss verfolgen"
      },
      "partnershipTitle": "Rahmen der Partnerschaft",
      "commercialTerms": "Die kaufmännischen Bedingungen der Versicherung richten sich nach Ihrer individuellen Vereinbarung mit ARTKIV; die 85/15-Regel der Bewertung gilt nicht automatisch.",
      "privacyBody": "Sie sehen nur die für die Versicherungsanfrage freigegebenen Daten, niemals die gesamte Sammlung.",
      "metrics": {
        "total": "Eingegangene Anfragen",
        "pending": "Zu prüfen",
        "quoted": "Antworten oder Angebote",
        "accepted": "Angenommen oder abgeschlossen"
      },
      "emptyTitle": "Keine Versicherungsanfrage zu bearbeiten",
      "emptyBody": "Neue Anfragen erscheinen hier mit den ausdrücklich freigegebenen Angaben."
    },
    "valuationDashboard": {
      "eyebrow": "Bewertungsaufträge",
      "intro": "Bearbeiten Sie über ARTKIV vergebene Bewertungsaufträge, prüfen Sie die freigegebenen Unterlagen, dokumentieren Sie Ihre Einschätzung und liefern Sie einen begründeten Wert.",
      "workflowTitle": "Bewertungsablauf",
      "workflow": {
        "review": "Werkakte und verfügbare Unterlagen prüfen",
        "analyze": "Zustand, Provenienz, Markt und Vergleichswerte analysieren",
        "document": "Wert und angewandte Methodik dokumentieren",
        "deliver": "Bewertung übermitteln und Auftrag abschließen"
      },
      "partnershipTitle": "Mandat und Bedingungen",
      "commercialTerms": "Bei geeigneten Marketplace-Aufträgen richtet sich die Vergütung nach den mit ARTKIV vereinbarten Bedingungen, einschließlich der 85/15-Aufteilung, sofern sie vertraglich vorgesehen ist.",
      "privacyBody": "Es sind nur die für den Auftrag freigegebenen Informationen zugänglich.",
      "metrics": {
        "total": "Erhaltene Aufträge",
        "pending": "Anzunehmen",
        "in_progress": "In Prüfung",
        "completed": "Ausgeliefert"
      },
      "emptyTitle": "Kein Bewertungsauftrag zu bearbeiten",
      "emptyBody": "Neu zugewiesene Aufträge erscheinen hier mit ihrer Dokumentation."
    }
  },
  "clientMissions": {
    "title": "Meine Aufträge",
    "active": "{{count}} laufender Auftrag mit Ihrem Berater — verfolgen Sie den Fortschritt.",
    "active_plural": "{{count}} laufende Aufträge mit Ihrem Berater — verfolgen Sie den Fortschritt.",
    "active_one": "{{count}} laufender Auftrag mit Ihrem Berater — verfolgen Sie den Fortschritt.",
    "active_other": "{{count}} laufende Aufträge mit Ihrem Berater — verfolgen Sie den Fortschritt.",
    "view": "Ansehen"
  },
  "advisorHelp": {
    "button": "Brauchen Sie Hilfe?",
    "menuTitle": "Hilfe für Art Advisors",
    "items": {
      "reports": "Einen professionellen Bericht erstellen",
      "understandValue": "Den Wert eines Kunstwerks verstehen",
      "valuation": "Ein Kunstwerk bewerten",
      "insurance": "Eine Versicherungsakte vorbereiten",
      "salesDonations": "Verkäufe & Schenkungen",
      "clientCollections": "Sammlungen Ihrer Kunden verwalten",
      "privacyAccess": "Vertraulichkeit & Kundenzugänge"
    },
    "allGuides": "Alle Praxisleitfäden"
  },
  "billingIdentity": {
    "title": "Rechnungsidentität",
    "businessToggle": "Ich stelle die Rechnung im Namen eines Unternehmens aus",
    "description": "Erforderlich für die verpflichtende elektronische B2B-Rechnungsstellung. Die Kennung hängt vom Land ab: <siren>SIREN</siren> in Frankreich, eine <vat>Umsatzsteuer-Identifikationsnummer</vat> in der EU. Ihre Daten bleiben privat und werden ausschließlich zur Rechnungsstellung verwendet.",
    "countries": {
      "france": "Frankreich",
      "belgium": "Belgien",
      "luxembourg": "Luxemburg",
      "germany": "Deutschland",
      "italy": "Italien",
      "spain": "Spanien",
      "netherlands": "Niederlande",
      "portugal": "Portugal",
      "austria": "Österreich",
      "ireland": "Irland",
      "greece": "Griechenland",
      "switzerlandNonEu": "Schweiz (Nicht-EU)",
      "unitedKingdomNonEu": "Vereinigtes Königreich (Nicht-EU)",
      "unitedStatesNonEu": "Vereinigte Staaten (Nicht-EU)",
      "other": "Anderes Land"
    },
    "validation": {
      "sirenLength": "Die SIREN-Nummer muss 9 Ziffern enthalten.",
      "sirenInvalid": "Ungültige SIREN-Nummer (Prüfziffer).",
      "sirenValid": "Gültige SIREN-Nummer.",
      "siretLength": "Die SIRET-Nummer muss 14 Ziffern enthalten.",
      "siretInvalid": "Ungültige SIRET-Nummer (Prüfziffer).",
      "siretValid": "Gültige SIRET-Nummer.",
      "vatFormat": "Erwartetes Format: Länderpräfix + Nummer (z. B. BE0123456789).",
      "vatPrefix": "Die Umsatzsteuer-ID sollte für dieses Land mit „{{expected}}“ beginnen.",
      "vatValid": "Gültiges USt-ID-Format (VIES-Prüfung noch erforderlich)."
    },
    "errors": {
      "companyRequired": "Der rechtliche Firmenname ist für die Unternehmensabrechnung erforderlich.",
      "sirenRequiredFrance": "In Frankreich ist eine 9-stellige SIREN-Nummer für eine ordnungsgemäße Geschäftsrechnung erforderlich.",
      "vatRequiredEu": "Innerhalb der EU ist eine Umsatzsteuer-Identifikationsnummer für die B2B-Identifikation erforderlich."
    },
    "fields": {
      "country": "Rechnungsland *",
      "companyName": "Rechtlicher Firmenname *",
      "siren": "SIREN * (9 Ziffern)",
      "siret": "SIRET (14 Ziffern, optional)",
      "vatOptional": "Umsatzsteuer-ID (optional)",
      "vatRequired": "Umsatzsteuer-ID *",
      "taxIdOptional": "Steueridentifikationsnummer (optional)",
      "address": "Rechnungsanschrift",
      "postalCode": "Postleitzahl",
      "city": "Ort",
      "billingEmail": "E-Mail für Rechnungen (optional)"
    },
    "placeholders": {
      "companyName": "z. B. Galerie Durand GmbH",
      "taxId": "Steueridentifikationsnummer, falls vorhanden",
      "address": "Beaux-Arts-Straße 12",
      "city": "Paris",
      "billingEmail": "buchhaltung@…"
    },
    "saving": "Wird gespeichert…",
    "save": "Speichern",
    "saved": "Gespeichert"
  },
  "register": {
    "title": "Ihr Artkiv-Konto erstellen",
    "titleDelegated": "Delegierten Zugang annehmen",
    "stepAccountTitle": "Konto erstellen",
    "stepPlanTitle": "Tarif wählen",
    "stepProgress": "Schritt {{current}} von {{total}}",
    "firstNameLabel": "Vorname",
    "firstNamePlaceholder": "Ihr Vorname",
    "continue": "Weiter",
    "back": "Zurück",
    "showPw": "Anzeigen",
    "hidePw": "Verbergen",
    "accountRecap": "Konto",
    "editAccount": "Ändern",
    "emailInvalid": "Ungültige E-Mail-Adresse.",
    "passwordShort": "Mindestens 6 Zeichen.",
    "heroEyebrow": "ARTKIV",
    "heroCopy": "Dokumentieren, bewerten und übergeben Sie Ihre Sammlung mit Vertrauen.",
    "heroPoint1": "Zentrales Inventar und Dokumente",
    "heroPoint2": "KI-gestützte Schätzung und Bewertung",
    "heroPoint3": "Nachfolge in Ruhe vorbereitet",
    "errors": {
      "invalidInviteLink": "Dieser Einladungslink ist ungültig oder abgelaufen.",
      "inviteRevoked": "Diese Einladung wurde widerrufen.",
      "inviteAlreadyUsed": "Diese Einladung wurde bereits verwendet.",
      "invalidInvite": "Ungültige Einladung.",
      "demoInviteIncompatible": "Eine Mitarbeitereinladung kann nicht mit einem Demokonto verwendet werden.",
      "userNotCreated": "Das Benutzerkonto wurde nicht erstellt. Prüfen Sie die Supabase-Einstellungen (ist eine E-Mail-Bestätigung erforderlich?).",
      "signup": "Bei der Registrierung ist ein Fehler aufgetreten"
    },
    "invite": {
      "subtitle": "Sie wurden eingeladen, an einer Sammlung mitzuarbeiten. Es ist kein Abonnement erforderlich.",
      "emailLabel": "Eingeladene E-Mail-Adresse:",
      "emailMismatch": "Bitte verwenden Sie die eingeladene E-Mail-Adresse."
    },
    "demo": {
      "title": "Demokonto",
      "body": "Sie verwenden ein Demokonto. Der Tarifwechsel erfolgt sofort und ohne Zahlung.",
      "planUpdated": "Demotarif erfolgreich aktualisiert!"
    },
    "launch": {
      "title": "Einführungsangebot",
      "body": "Sie erhalten eine <trial>14-tägige kostenlose Testphase</trial> für den Standard-Tarif, wenn Sie sich vor dem <date>15. Februar 2026</date> registrieren. Während der Testphase erfolgt keine Abbuchung."
    },
    "fields": {
      "email": "E-Mail-Adresse",
      "password": "Passwort"
    },
    "placeholders": {
      "email": "ihre@email.de",
      "password": "Mindestens 6 Zeichen"
    },
    "sections": {
      "collectors": "Sammler",
      "professionals": "Professionelle Nutzer"
    },
    "plans": {
      "perMonth": "/Monat",
      "standard": {
        "name": "Standard",
        "description": "Vollständige Sammlungsverwaltung",
        "trial": "14 Tage kostenlos"
      },
      "premium": {
        "name": "Premium",
        "badge": "BELIEBT",
        "description": "Erweiterte KI & Nachfolge-Matching"
      },
      "artAdvisor": {
        "name": "Art Advisor",
        "badge": "PRO",
        "description": "Bis zu 5 Kunden und 1 Assistent"
      },
      "artAdvisorPremium": {
        "name": "AA Premium",
        "badge": "PRO+",
        "description": "Unbegrenzte Kundenzahl"
      },
      "fondation": {
        "name": "Stiftung",
        "badge": "INSTITUTION",
        "description": "Stiftungen und Zustiftungen",
        "note": "Der Bereich wird von unserem Team nach einem Gespräch eingerichtet: Wir melden uns direkt nach der Registrierung."
      },
      "familyOffice": {
        "name": "Family Office",
        "badge": "UNTERNEHMEN",
        "price": "Preis auf Anfrage",
        "description": "Individuelle Lösung"
      }
    },
    "buttons": {
      "changing": "Tarif wird geändert…",
      "creating": "Konto wird erstellt…",
      "createDelegated": "Delegierten Zugang erstellen",
      "changePlan": "Tarif wechseln",
      "createAccount": "Mein Konto erstellen"
    },
    "trialFootnote": "Während der 14-tägigen kostenlosen Testphase erfolgt keine Abbuchung. Sie können jederzeit vor Ablauf der Testphase kündigen.",
    "professionalFollowup": "Nach der Kontoerstellung werden Sie weitergeleitet, um uns zu kontaktieren und eine persönliche Demonstration zu vereinbaren.",
    "legal": {
      "terms": "Allgemeinen Geschäftsbedingungen",
      "privacy": "Datenschutzerklärung",
      "sentence": "Mit Ihrer Registrierung akzeptieren Sie unsere <terms>Allgemeinen Geschäftsbedingungen</terms> und unsere <privacy>Datenschutzerklärung</privacy>."
    },
    "login": {
      "prompt": "Sie haben bereits ein Konto?",
      "link": "Anmelden"
    }
  },
  "mobileCapture": {
    "newArtwork": {
      "heading": "Werk fotografieren"
    },
    "verb": {
      "scan": "Scannen",
      "photo": "Fotografieren"
    },
    "doc": {
      "invoice": "Rechnung",
      "certificate": "Zertifikat",
      "verso": "Rückseite",
      "signature": "Signatur",
      "condition": "Zustand / Schaden",
      "detail": "Detail",
      "main": "Hauptansicht",
      "generic": "Dokument"
    },
    "auth": {
      "title": "Anmelden",
      "body": "Melden Sie dieses Telefon beim selben Artkiv-Konto an und scannen Sie den QR-Code erneut.",
      "cta": "Anmelden"
    },
    "error": {
      "title": "Link nicht verfügbar",
      "expired": "Dieser QR-Code ist abgelaufen. Erstellen Sie einen neuen an Ihrem Computer.",
      "completed": "Diese Aufnahme wurde bereits gesendet.",
      "generic": "Sitzung nicht gefunden. Erstellen Sie den QR-Code an Ihrem Computer neu."
    },
    "takePhoto": "Foto aufnehmen",
    "hint": "Die Kamera öffnet sich direkt.",
    "use": "Dieses Foto verwenden",
    "retake": "Wiederholen",
    "sending": "Senden…",
    "done": {
      "title": "Gesendet",
      "body": "Sie können zu Ihrem Computer zurückkehren: Das Dokument erscheint dort bereits."
    }
  },
  "usePhone": {
    "title": "Mein Telefon verwenden",
    "subtitle": "Scannen Sie diesen QR-Code mit der Kamera Ihres Telefons.",
    "qrAlt": "Aufnahme-QR-Code",
    "waiting": "Warten auf das Telefon…",
    "connected": "Telefon verbunden — Foto aufnehmen",
    "error": "QR-Code konnte nicht erstellt werden. Versuchen Sie es erneut.",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "chooseType": "Was möchten Sie aufnehmen?",
    "received": {
      "title": "Von Ihrem Telefon empfangen",
      "body": "Es wurde dem Werk zugeordnet."
    }
  },
  "onboarding": {
    "welcome": {
      "eyebrow": "Willkommen bei ARTKIV",
      "helloName": "Willkommen, {{name}}.",
      "helloNoName": "Willkommen.",
      "intro": "Ihre Umgebung ist bereits eingerichtet. Ein paar kurze Fragen helfen uns, Ihr Erlebnis zu personalisieren — nichts zu konfigurieren.",
      "start": "Loslegen",
      "space": {
        "collectionneurPlan": "Ihr {{plan}}-Abonnement ist aktiv.",
        "collectionneurGeneric": "Ihr Bereich ist bereit.",
        "advisor": "Ihr Art-Advisor-Zugang ist aktiv.",
        "family_office": "Ihr Family-Office-Bereich ist bereit.",
        "fondation": "Ihr Stiftungsbereich ist bereit.",
        "notaire": "Ihr Notarbereich ist bereit.",
        "assureur": "Ihr Versichererbereich ist bereit."
      }
    },
    "progress": "Frage {{current}} / {{total}}",
    "back": "Zurück",
    "skip": "Überspringen",
    "continue": "Weiter",
    "finish": "Fertigstellen",
    "saving": "Wird gespeichert…",
    "yes": "Ja",
    "no": "Nein",
    "saveError": "Speichern fehlgeschlagen. Sie können es erneut versuchen oder direkt fortfahren.",
    "done": {
      "eyebrow": "Alles bereit",
      "title": "Ihr Bereich ist personalisiert.",
      "actionLabel": "Erste Aktion",
      "importExisting": "Meinen vorhandenen Bestand übernehmen"
    },
    "dashboard": {
      "title": "Für den Start",
      "hello": "Machen wir dort weiter, wo Sie aufgehört haben.",
      "helloName": "Weiter geht's, {{name}}.",
      "dismiss": "Ausblenden",
      "shortcutsLabel": "Verknüpfungen",
      "stage": {
        "collectionneur": "Sie haben {{count}} Werk(e) in Ihrer Sammlung.",
        "advisor": "Sie betreuen {{count}} Kunde(n).",
        "family_office": "Sie verwalten {{count}} Familie(n).",
        "fondation": "Sie verwalten {{count}} Sammlung(en).",
        "notaire": "{{count}} Nachlassfall/-fälle.",
        "assureur": "{{count}} Anfrage(n) erhalten."
      },
      "advice": {
        "support": "Ein unterstützter Import kann Ihre Sammlung schnell strukturieren — laden Sie Ihre Dokumente hoch, um eine Empfehlung zu erhalten.",
        "centralize": "Beginnen Sie damit, Ihre Dokumente zu zentralisieren: Laden Sie sie hoch, und ARTKIV analysiert sie für Sie.",
        "transmission": "Bereiten Sie die Übertragung vor: Erfassen Sie Ihre Begünstigten und dokumentieren Sie Ihre wichtigsten Werke.",
        "insure": "Für eine gute Versicherung halten Sie Werte aktuell und Ihre Nachweise griffbereit.",
        "market": "Verfolgen Sie die Notierungen Ihrer Künstler, um die richtigen Momente zu nutzen.",
        "inventory": "Fügen Sie Ihre Werke einzeln hinzu oder laden Sie eine Datei hoch, um schneller voranzukommen.",
        "generic": "Laden Sie Ihren Bestand hoch: ARTKIV strukturiert ihn und schlägt die nächsten Schritte vor."
      },
      "shortcuts": {
        "succession": "Übertragung planen",
        "insure": "Meine Sammlung versichern",
        "market": "Den Markt verfolgen",
        "addWork": "Werk hinzufügen",
        "deposit": "Meine Dokumente hochladen",
        "estimate": "Werk bewerten",
        "home": "Mein Bereich",
        "importExisting": "Bestand übernehmen"
      }
    },
    "questions": {
      "collectionneur": {
        "collection_size": {
          "label": "Ungefähre Größe Ihrer Sammlung?",
          "opts": {
            "lt20": "Weniger als 20 Werke",
            "b20_100": "20 bis 100 Werke",
            "b100_500": "100 bis 500 Werke",
            "gt500": "Mehr als 500 Werke"
          }
        },
        "documents_location": {
          "label": "Wo befinden sich Ihre Dokumente heute?",
          "opts": {
            "paper": "Papier / Ordner",
            "computer": "Dateien auf dem Computer",
            "cloud": "Cloud (Drive, Dropbox…)",
            "scattered": "Überall verstreut"
          }
        },
        "main_goal": {
          "label": "Was ist Ihr Hauptziel?",
          "opts": {
            "inventory": "Meine Sammlung inventarisieren",
            "transmission": "Übertragung vorbereiten",
            "insure": "Versichern / bewerten",
            "market": "Den Markt verfolgen"
          }
        },
        "wants_support": {
          "label": "Möchten Sie beim Start begleitet werden?"
        }
      },
      "advisor": {
        "already_clients": {
          "label": "Arbeiten Sie bereits mit Sammlern?"
        },
        "clients_count": {
          "label": "Wie viele Kunden möchten Sie verwalten?",
          "opts": {
            "b1_5": "1 bis 5",
            "b6_20": "6 bis 20",
            "b21_50": "21 bis 50",
            "gt50": "Mehr als 50"
          }
        },
        "has_inventories": {
          "label": "Haben Sie bereits Inventare, PDFs oder Excel-Dateien zum Übernehmen?"
        }
      },
      "family_office": {
        "families_count": {
          "label": "Wie viele Familien betreuen Sie?",
          "opts": {
            "b1_3": "1 bis 3",
            "b4_10": "4 bis 10",
            "gt10": "Mehr als 10"
          }
        },
        "works_with_experts": {
          "label": "Arbeiten Sie bereits mit Experten?"
        },
        "create_first_family": {
          "label": "Möchten Sie jetzt Ihre erste Familie anlegen?"
        }
      },
      "fondation": {
        "foundation_name": {
          "label": "Name der Stiftung?",
          "placeholder": "z. B. Stiftung…"
        },
        "collections_count": {
          "label": "Wie viele Sammlungen verwalten Sie?",
          "opts": {
            "one": "1",
            "b2_5": "2 bis 5",
            "gt5": "Mehr als 5"
          }
        },
        "has_inventory": {
          "label": "Haben Sie bereits ein Inventar?"
        },
        "collaborators_count": {
          "label": "Wie viele Mitarbeitende werden ARTKIV nutzen?",
          "opts": {
            "solo": "Nur ich",
            "b2_5": "2 bis 5",
            "gt5": "Mehr als 5"
          }
        }
      },
      "notaire": {
        "handles_art_successions": {
          "label": "Bearbeiten Sie bereits Nachlässe mit Kunstwerken?"
        },
        "create_first_dossier": {
          "label": "Möchten Sie jetzt Ihren ersten Fall eröffnen?"
        }
      },
      "assureur": {
        "collections_count": {
          "label": "Wie viele Sammlungen verwalten Sie?",
          "opts": {
            "b1_5": "1 bis 5",
            "b6_20": "6 bis 20",
            "gt20": "Mehr als 20"
          }
        },
        "has_portfolio": {
          "label": "Haben Sie bereits ein bestehendes Portfolio zum Übernehmen?"
        }
      }
    },
    "actions": {
      "collectionneur": {
        "title": "Bereit, Ihre Sammlung zu beginnen?",
        "cta": "Loslegen"
      },
      "advisor": {
        "title": "Laden Sie Ihren ersten Kunden ein.",
        "cta": "Kunden einladen"
      },
      "family_office": {
        "title": "Legen Sie Ihre erste Familie an.",
        "cta": "Familie anlegen"
      },
      "fondation": {
        "title": "Legen Sie Ihre erste Sammlung an.",
        "cta": "Sammlung anlegen"
      },
      "notaire": {
        "title": "Eröffnen Sie Ihren ersten Nachlassfall.",
        "cta": "Fall eröffnen"
      },
      "assureur": {
        "title": "Öffnen Sie Ihren Versichererbereich.",
        "cta": "Meine Anfragen ansehen"
      }
    },
    "deposit": {
      "eyebrow": "Erste Aktion",
      "title": "Laden Sie Ihre ersten Dokumente hoch.",
      "intro": "PDFs, Fotos, Zertifikate, Rechnungen, Excel-Dateien… ARTKIV übernimmt Ihren Bestand und analysiert ihn für Sie. Zum Start muss nichts von Hand strukturiert werden.",
      "choose": "Dateien auswählen",
      "filesPicked": "{{count}} Datei(en) — {{size}} MB",
      "hint": "PDF · JPG/PNG · CSV/XLSX — bis zu {{max}} Dateien",
      "more": "+ {{count}} weitere…",
      "uploading": "Wird hochgeladen… {{done}}/{{total}}",
      "later": "Später",
      "submit": "Hochladen und analysieren",
      "submitting": "Wird hochgeladen…",
      "error": "Beim Hochladen ist ein Fehler aufgetreten.",
      "sources": {
        "upload": "Hochladen",
        "dropbox": "Dropbox",
        "drive": "Google Drive",
        "email": "E-Mail"
      },
      "comingSoon": "Die {{source}}-Verbindung kommt bald. In der Zwischenzeit können Sie Ihre Dateien direkt hochladen.",
      "chooseUpload": "Dateien hochladen",
      "byMetier": {
        "advisor": {
          "title": "Importieren Sie Ihr bestehendes Portfolio.",
          "intro": "Kundeninventare, PDFs, Excel-Dateien, Exporte… ARTKIV übernimmt Ihre Unterlagen und strukturiert sie für Sie."
        },
        "family_office": {
          "title": "Übernehmen Sie Ihre Vermögensunterlagen.",
          "intro": "Familien, Vermögen, Inventare und Dokumente… laden Sie den Bestand hoch, ARTKIV strukturiert ihn."
        },
        "fondation": {
          "title": "Importieren Sie Ihr Inventar.",
          "intro": "Inventare, Sammlungen, Governance-Dokumente, Zertifikate… ARTKIV übernimmt und strukturiert Ihren Bestand."
        },
        "notaire": {
          "title": "Laden Sie die Falldokumente hoch.",
          "intro": "Nachlassinventare, Gutachten, PDFs… ARTKIV liest und sortiert die Dokumente für Sie."
        },
        "assureur": {
          "title": "Importieren Sie Ihr versichertes Portfolio.",
          "intro": "Portfolio, Verträge, Sammlungen, Dokumente… ARTKIV übernimmt und strukturiert Ihre Unterlagen."
        }
      }
    },
    "reco": {
      "loading": "Ihre Analyse wird geladen…",
      "consentRequired": "Die KI-Analyse wurde nicht durchgeführt, da die KI-Einwilligung nicht aktiviert ist. Aktivieren Sie sie in Ihrem Profil, um die automatische Zusammenfassung zu erhalten. Ihre Dateien sind sicher gespeichert.",
      "analyzingEyebrow": "Analyse läuft",
      "analyzingTitle": "ARTKIV analysiert Ihre Dokumente…",
      "analyzingBody": "Das Lesen und Einordnen Ihrer Dateien dauert einen Moment. Sie können hier warten — die Empfehlung erscheint automatisch.",
      "analyzingProgress": "{{done}} / {{total}} Dokumente analysiert",
      "tooLong": "Die Analyse dauert länger als erwartet.",
      "continueAnyway": "Ohne Warten fortfahren",
      "resultEyebrow": "Analyse — {{metier}}",
      "resultTitle": "Das hat ARTKIV erkannt.",
      "errorBody": "Bei der Analyse gab es ein Problem, aber Ihre Dateien sind sicher gespeichert.",
      "howContinue": "Wie möchten Sie fortfahren?",
      "counts": {
        "documents": "Dokumente",
        "oeuvres": "erkannte Werke",
        "certificats": "Zertifikate",
        "factures": "Rechnungen",
        "aStructurer": "zu strukturieren"
      },
      "reason": {
        "autonome": "Wenige Dokumente ({{documents}}) und gut lesbar: Sie können sie selbst strukturieren.",
        "express": "Moderates Volumen ({{documents}} Dokumente): ein schneller unterstützter Import genügt.",
        "premium": "Großes Volumen ({{documents}} Dokumente) oder {{aStructurer}} zu strukturieren: eine vollständige menschliche Prüfung wird empfohlen."
      },
      "recommended": "Empfohlen",
      "payRedirect": "Weiterleitung zur Zahlung…",
      "offers": {
        "autonomous": {
          "title": "Allein fortfahren",
          "price": "Kostenlos",
          "desc": "Strukturieren Sie Ihre Sammlung in Ihrem eigenen Tempo."
        },
        "express": {
          "title": "Express-Import",
          "price": "99 €",
          "desc": "Für eine einfache Sammlung. Schneller unterstützter Import."
        },
        "premium": {
          "title": "Premium-Import",
          "price": "399 €",
          "desc": "Vollständiger Import, menschliche Prüfung, Dokumentenstrukturierung."
        },
        "concierge": {
          "title": "Concierge / Migration",
          "price": "auf Anfrage",
          "desc": "Sie übergeben uns Ihre Archive, ARTKIV baut Ihre Sammlung auf."
        }
      },
      "offersByMetier": {
        "collectionneur": {
          "premiumDesc": "Vollständiger Import, menschliche Prüfung, Dokumentenstrukturierung.",
          "top": {
            "title": "Sammlungs-Concierge",
            "price": "1.490 €",
            "desc": "Sie senden uns Ihre Archive, ARTKIV baut Ihre Sammlung auf."
          }
        },
        "advisor": {
          "premiumDesc": "Übernahme von Kunden, Sammlungen, Werken und Dokumenten, vollständige Strukturierung, menschliche Prüfung.",
          "top": {
            "title": "Kanzlei-Migration",
            "price": "ab 2.500 €",
            "desc": "Vollständige Migration Ihrer Kanzlei, auf Anfrage."
          }
        },
        "family_office": {
          "premiumDesc": "Übernahme von Familien, Sammlungen, Vermögensunterlagen und Erben, menschliche Prüfung.",
          "top": {
            "title": "Family-Office-Migration",
            "price": "ab 2.500 €",
            "desc": "Vollständige Migration, auf Anfrage."
          }
        },
        "fondation": {
          "premiumDesc": "Übernahme von Inventar, Sammlungen, Dokumenten und Dokumenten-Governance, menschliche Prüfung.",
          "top": {
            "title": "Stiftungs-Migration",
            "price": "ab 2.500 €",
            "desc": "Große Stiftungen, mehrere Standorte, Zehntausende Werke. Auf Anfrage."
          }
        },
        "notaire": {
          "premiumDesc": "Übernahme von Inventaren, Nachlässen, PDFs und Gutachten, menschliche Prüfung.",
          "top": {
            "title": "Dedizierte Betreuung",
            "price": "auf Anfrage",
            "desc": "Vollständige Bearbeitung Ihrer Fälle, auf Anfrage."
          }
        },
        "assureur": {
          "premiumDesc": "Übernahme von Portfolio, Verträgen, Sammlungen und Dokumenten, menschliche Prüfung.",
          "top": {
            "title": "Portfolio-Migration",
            "price": "ab 2.500 €",
            "desc": "Vollständige Migration Ihres Portfolios, auf Anfrage."
          }
        }
      },
      "payError": "Die Zahlung konnte nicht gestartet werden.",
      "metier": {
        "collectionneur": "Sammler",
        "advisor": "Art Advisor",
        "family_office": "Family Office",
        "fondation": "Stiftung",
        "notaire": "Notar",
        "assureur": "Versicherer",
        "generic": "Ihr Bereich"
      }
    }
  },
  "teamDashboard": {
    "accessDenied": {
      "title": "Zugriff nicht gewährt",
      "description": "Der Arbeitsbereich „Partner & Versicherung“ wurde Ihnen nicht zugewiesen. Bitten Sie eine Administratorin oder einen Administrator um Freischaltung.",
      "back": "Zurück zu meinem Bereich"
    },
    "actions": {
      "refresh": "Aktualisieren",
      "search": "Suche",
      "importClient": "Für einen Kunden importieren",
      "importClientTitle": "Kunstwerke für einen Kunden importieren (CSV/XLSX)",
      "manageAuctionHouses": "Auktionshäuser verwalten",
      "open": "Öffnen",
      "details": "Details",
      "viewInTool": "Im Tool anzeigen",
      "close": "Schließen",
      "cancel": "Abbrechen",
      "saving": "Wird gespeichert…"
    },
    "common": {
      "loading": "Wird geladen…",
      "none": "Keine",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "notAvailable": "k. A."
    },
    "header": {
      "mySpace": "Mein Bereich",
      "partnersTitle": "Partner & Versicherung",
      "hubTitle": "Team-Dashboard",
      "partnersSubtitle": "Verträge, abrechenbare Ereignisse, Versicherungsanfragen und kuratorische Leistungen.",
      "hubSubtitle": "Ihr Bereich: Greifen Sie auf Ihre zugewiesenen Arbeitsbereiche zu."
    },
    "hub": {
      "spacesTitle": "Ihre Arbeitsbereiche",
      "spacesSubtitle": "Die Bereiche, auf die Sie zugreifen können.",
      "manageTeamAccess": "Team und Zugriffe verwalten",
      "noSpaces": "Ihnen wurde noch kein Arbeitsbereich zugewiesen. Bitten Sie eine Administratorin oder einen Administrator um Zugriff.",
      "comingSoon": "demnächst"
    },
    "kpis": {
      "partnerRequests": "Partneranfragen",
      "insurancePending": "Offene Versicherungsanfragen",
      "pending": "Ausstehend",
      "sent": "Gesendet",
      "urgent": "Dringend"
    },
    "operations": {
      "eyebrow": "Sofortige Vorgänge",
      "title": "Bearbeitung & Prioritäten"
    },
    "activity": {
      "title": "Letzte Aktivitäten",
      "subtitle": "Partner-, Support- und Versicherungsanfragen in Echtzeit.",
      "supportTicket": "Support-Ticket",
      "clientNumber": "Kunde Nr. {{id}}",
      "clientNamed": "Kunde: {{name}}",
      "channelNamed": "Kanal: {{channel}}",
      "artworkNumber": "Kunstwerk Nr. {{id}}",
      "proposalNumber": "Vorschlag Nr. {{id}}",
      "insuranceTitle": "Versicherung — {{context}}{{policyKind}}{{insuredValue}}",
      "createdAgo_one": "{{actor}} • Vor {{count}} Tag erstellt",
      "createdAgo_other": "{{actor}} • Vor {{count}} Tagen erstellt",
      "empty": "Keine Aktivität für diesen Filter.",
      "filters": {
        "all": "Alle",
        "pending": "Ausstehend",
        "sent": "Gesendet",
        "urgent": "Dringend"
      },
      "badges": {
        "sent": "Gesendet",
        "urgent": "Dringend",
        "toProcess": "Zu bearbeiten",
        "pending": "Ausstehend",
        "new": "Neu"
      },
      "demo": {
        "basquiat": "Basquiat-Dossier – Einreichung bei einer Institution",
        "soulages": "Soulages – Vorschlag an Christie’s",
        "insuranceQuestion": "AXA-Versicherungsfrage – Bescheinigung"
      }
    },
    "insurance": {
      "title": "Versicherungsanfragen",
      "subtitle": "Prüfung, manuelle Zuweisung und anschließende Bearbeitung durch den Partner.",
      "loading": "Versicherungsanfragen werden geladen…",
      "empty": "Derzeit keine Versicherungsanfragen.",
      "unassigned": "— Nicht zugewiesen —",
      "assignmentError": "Fehler bei der Zuweisung des Partners.",
      "table": {
        "date": "Datum",
        "client": "Kunde",
        "context": "Kontext",
        "value": "Wert",
        "artwork": "Kunstwerk",
        "status": "Status",
        "partner": "Partner",
        "action": "Aktion"
      }
    },
    "workflows": {
      "eyebrow": "Fachliche Workflows",
      "title": "Partner, Inhalte & Orchestrierung"
    },
    "curatorial": {
      "title": "Kuratorische Leistungen",
      "subtitle": "Verwaltung von Anfragen zur kuratorischen Begleitung"
    },
    "valuationExpert": {
      "title": "Bewertungsanfragen an Fachpersonen",
      "subtitle": "Anfragen zur Werkbewertung, die an eine benannte Partnerexpertin/einen Partnerexperten gerichtet sind"
    },
    "partners": {
      "title": "Partner",
      "subtitle": "Aktive Verträge und abrechenbare Ereignisse.",
      "searchPlaceholder": "Partner nach E-Mail suchen…",
      "count_one": "{{count}} Partner",
      "count_other": "{{count}} Partner",
      "empty": "Es wurde kein Partner mit der Rolle „partner“ gefunden.",
      "table": {
        "email": "E-Mail",
        "specialty": "Fachgebiet",
        "activeContract": "Aktiver Vertrag",
        "pendingFiles": "Offene Vorgänge",
        "actions": "Aktionen"
      }
    },
    "resources": {
      "eyebrow": "Ressourcen",
      "title": "Persönlicher Bereich & geteilte Daten"
    },
    "personal": {
      "title": "Persönlicher Bereich",
      "profile": "Mein Profil",
      "shortcuts": "Schnellzugriffe",
      "allRequests": "Alle Anfragen",
      "help": "Hilfe",
      "systemStatus": "Systemstatus",
      "database": "Datenbank",
      "operational": "Betriebsbereit"
    },
    "shared": {
      "title": "Geteilte Sammlungen & Kunstwerke",
      "subtitle": "Dieser Bereich listet automatisch alles auf, was Artkiv-Kunden mit Ihrem Konto geteilt haben."
    },
    "drawer": {
      "partner": "Partner",
      "newContract": "Neuer Vertrag",
      "newEvent": "Neues Ereignis",
      "contracts": "Verträge",
      "noContracts": "Kein Vertrag für diesen Partner.",
      "commissionRate": "Provisionssatz: {{value}}",
      "fixedAmount": "Festbetrag: {{value}}",
      "contractDocument": "Vertragsdokument",
      "billableEvents": "Abrechenbare Ereignisse (letzte 25)",
      "noEvents": "Keine Ereignisse.",
      "occurredAt": "Ereignisdatum",
      "base": "Basis",
      "linkedContract": "Verknüpfter Vertrag"
    },
    "contractModal": {
      "title": "Neuer Partnervertrag",
      "create": "Vertrag erstellen",
      "createError": "Vertrag konnte nicht erstellt werden: {{message}}",
      "commissionPlaceholder": "z. B. 10,00",
      "amountPlaceholder": "z. B. 1.200,00"
    },
    "eventModal": {
      "title": "Neues abrechenbares Ereignis",
      "selectContract": "— Auswählen —",
      "noContract": "Für diesen Partner ist kein Vertrag verfügbar.",
      "create": "Ereignis erstellen",
      "createError": "Ereignis konnte nicht erstellt werden: {{message}}",
      "amountPlaceholder": "z. B. 2.500"
    },
    "fields": {
      "partnerId": "Partner-ID",
      "partnerType": "Partnertyp",
      "contractType": "Vertragstyp",
      "startDate": "Startdatum",
      "endDateOptional": "Enddatum (optional)",
      "currency": "Währung",
      "active": "Aktiver Vertrag",
      "commissionRate": "Provisionssatz",
      "fixedAmount": "Festbetrag",
      "contractDocumentOptional": "Vertrags-URL (optional)",
      "internalNotesOptional": "Interne Notizen (optional)",
      "contractId": "Vertrags-ID",
      "eventType": "Ereignistyp",
      "referenceAmount": "Referenzbetrag",
      "occurredAt": "Datum und Uhrzeit des Ereignisses",
      "artworkIdOptional": "Kunstwerk-ID (optional)",
      "collectionIdOptional": "Sammlungs-ID (optional)",
      "clientIdOptional": "Kunden-ID (optional)"
    },
    "validation": {
      "partnerRequired": "Die Partner-ID ist erforderlich.",
      "startDateRequired": "Das Startdatum ist erforderlich.",
      "contractRequired": "Die Vertrags-ID ist erforderlich.",
      "occurredAtRequired": "Das Ereignisdatum ist erforderlich."
    },
    "enums": {
      "statuses": {
        "pending": "Ausstehend",
        "sent": "Gesendet",
        "assigned": "Zugewiesen",
        "open": "Offen",
        "in_progress": "In Bearbeitung",
        "answered": "Beantwortet",
        "closed": "Geschlossen",
        "done": "Erledigt",
        "completed": "Abgeschlossen",
        "cancelled": "Storniert",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "paid": "Bezahlt",
        "overdue": "Überfällig",
        "invoice_sent": "Rechnung gesendet",
        "partially_paid": "Teilweise bezahlt",
        "draft": "Entwurf"
      },
      "partnerTypes": {
        "insurance": "Versicherung",
        "transport": "Transport",
        "valuation_expert": "Bewertungsexperte",
        "conservation_expert": "Konservierungsexperte"
      },
      "contractTypes": {
        "commission": "Provision",
        "reverse": "Rückvergütung",
        "forfait": "Pauschale"
      },
      "eventTypes": {
        "expertise": "Begutachtung",
        "transport": "Transport",
        "insurance_policy": "Versicherungspolice",
        "restoration": "Restaurierung"
      },
      "insuranceContexts": {
        "insurance": "Versicherung",
        "permanent_collection": "Dauersammlung",
        "exhibition": "Ausstellung",
        "transport": "Transport",
        "loan": "Leihgabe",
        "storage": "Lagerung",
        "event": "Ereignis",
        "temporary": "Temporärer Schutz"
      },
      "policyKinds": {
        "all_risks": "Allgefahrendeckung",
        "named_perils": "Benannte Gefahren",
        "wall_to_wall": "Von Wand zu Wand",
        "transit": "Transport",
        "exhibition": "Ausstellung",
        "storage": "Lagerung"
      },
      "requestTypes": {
        "general": "Allgemeine Anfrage",
        "museum": "Museum",
        "auction": "Auktion",
        "sale": "Verkauf",
        "loan": "Leihgabe",
        "exhibition": "Ausstellung",
        "insurance": "Versicherung",
        "transport": "Transport",
        "expertise": "Begutachtung"
      }
    },
    "coins": {
      "partenaires": {
        "title": "Partner & Versicherung",
        "description": "Verträge, Versicherungsanfragen und abrechenbare Ereignisse."
      },
      "support": {
        "title": "Support",
        "description": "Support-Tickets und Hilfeanfragen."
      },
      "newsletters": {
        "title": "Newsletter",
        "description": "Kommunikation vorbereiten und verfolgen."
      },
      "galeries": {
        "title": "Galerien",
        "description": "Galerien und Auktionshäuser verwalten."
      },
      "curatorial": {
        "title": "Kuratorische Leistungen",
        "description": "Kuratorische Anfragen und Begleitung."
      },
      "curatoriaux": {
        "title": "Kuratorische Leistungen",
        "description": "Kuratorische Anfragen und Begleitung."
      },
      "import": {
        "title": "Import",
        "description": "Kundensammlungen und Kunstwerke importieren."
      },
      "imports": {
        "title": "Importe",
        "description": "Kundensammlungen und Kunstwerke importieren."
      },
      "recherche": {
        "title": "Suche",
        "description": "Artkiv-Daten bereichsübergreifend durchsuchen."
      },
      "search": {
        "title": "Suche",
        "description": "Artkiv-Daten bereichsübergreifend durchsuchen."
      },
      "administration": {
        "title": "Administration",
        "description": "Werkzeuge zur Plattformverwaltung."
      },
      "collections": {
        "title": "Sammlungen",
        "description": "Geteilte Sammlungen und Kunstwerke."
      }
    }
  },
  "advisorMissions": {
    "focus": {
      "active": "Laufende Aufträge",
      "ready_to_deliver": "Zu sendende Ergebnisse",
      "to_invoice": "Zu fakturierende Aufträge",
      "follow_up": "Nachzufassende Kunden",
      "filtered": "Gefiltert",
      "clear": "Filter entfernen"
    },
    "common": {
      "client": "Kunde",
      "loading": "Wird geladen…"
    },
    "disabled": {
      "title": "Missionsmodul nicht aktiviert",
      "description": "Dieses Modul wird derzeit ausgerollt. Schauen Sie bald wieder vorbei."
    },
    "header": {
      "eyebrow": "Art Advisor",
      "title": "Missionen",
      "description": "ARTKIV organisiert die Mission. Ihre Kunden, Honorare und Buchhaltung bleiben in Ihrer Verantwortung."
    },
    "actions": {
      "close": "Schließen",
      "newMission": "+ Neue Mission",
      "creating": "Wird erstellt…",
      "create": "Mission erstellen"
    },
    "form": {
      "titleLabel": "Titel *",
      "titlePlaceholder": "z. B. Inventar der Sammlung X",
      "typeLabel": "Missionstyp",
      "clientLabel": "Kunde",
      "noClientOption": "— Kein Kunde / externer Kontakt —",
      "collectionLabel": "Sammlung",
      "noCollectionOption": "— Keine —",
      "clientEntityLabel": "Kundenakte",
      "noClientEntityOption": "— Keine Akte —",
      "dueDateLabel": "Fälligkeitsdatum",
      "priorityLabel": "Priorität",
      "billingModeLabel": "Abrechnungsart",
      "scopeLabel": "Umfang (optional)",
      "scopePlaceholder": "Beschreiben Sie Umfang, Leistungen oder Rahmenbedingungen der Mission."
    },
    "kpis": {
      "inProgress": "Laufende Missionen",
      "readyToInvoice": "Abrechnungsbereit",
      "invoiced": "In Rechnung gestellt (gemeldet)",
      "received": "Eingegangen (gemeldet)",
      "overdue": "Überfällig (gemeldet)",
      "disclaimer": "Diese Angaben dienen der Nachverfolgung. Ihre Buchhaltung und Erklärungen bleiben in Ihrer Verantwortung und der Ihres Buchhaltungstools."
    },
    "table": {
      "mission": "Mission",
      "client": "Kunde",
      "progress": "Fortschritt",
      "dueDate": "Fälligkeit",
      "billing": "Abrechnung",
      "lastActivity": "Letzte Aktivität",
      "empty": "Noch keine Mission. Erstellen Sie eine, um zu beginnen."
    },
    "errors": {
      "create": "Fehler: {{message}}"
    },
    "enums": {
      "missionTypes": {
        "inventory": "Inventar",
        "valuation": "Bewertung",
        "appraisal": "Begutachtung",
        "expertise": "Begutachtung",
        "conservation": "Konservierung",
        "condition_report": "Zustandsbericht",
        "insurance": "Versicherung",
        "transport": "Transport",
        "sale": "Verkauf",
        "acquisition": "Erwerb",
        "succession": "Nachlassplanung",
        "donation": "Schenkung",
        "loan": "Leihgabe",
        "exhibition": "Ausstellung",
        "curatorial": "Kuratorische Begleitung",
        "documentation": "Dokumentation",
        "other": "Sonstiges"
      },
      "statuses": {
        "draft": "Entwurf",
        "planned": "Geplant",
        "in_progress": "In Bearbeitung",
        "waiting_client": "Warten auf den Kunden",
        "waiting_partner": "Warten auf einen Partner",
        "ready_to_deliver": "Lieferbereit",
        "delivered": "Geliefert",
        "closed": "Geschlossen",
        "cancelled": "Storniert"
      },
      "priorities": {
        "low": "Niedrig",
        "normal": "Normal",
        "high": "Hoch",
        "urgent": "Dringend"
      },
      "billingModes": {
        "external": "Direkte Abrechnung durch den Advisor",
        "artkiv": "Abrechnung über ARTKIV",
        "artkiv_invoice": "Abrechnung über ARTKIV",
        "platform": "Abrechnung über die Plattform",
        "included": "Im Honorar enthalten",
        "free": "Kostenfrei"
      }
    }
  },
  "advisorBillingIdentity": {
    "title": "Rechnungsdaten",
    "description": {
      "before": "Ihre juristische Person und Ihre Umsatzsteuerregelung. Diese Angaben werden für Ihre Dokumente verwendet und dienen dazu, ",
      "emphasis": "die auf Ihre Aufträge anzuwendende Umsatzsteuer zu bestimmen",
      "after": ". Für die Richtigkeit bleiben Sie verantwortlich."
    },
    "validation": {
      "sirenLength": "Die SIREN muss 9 Ziffern enthalten.",
      "sirenInvalid": "Ungültige SIREN (Prüfziffer).",
      "sirenValid": "Gültige SIREN."
    },
    "fields": {
      "legalName": "Firmenname / juristische Person",
      "tradeName": "Handelsname (optional)",
      "legalForm": "Rechtsform",
      "siren": "SIREN (9 Ziffern)",
      "siret": "SIRET (14 Ziffern, optional)",
      "vatNumber": "EU-Umsatzsteuer-Identifikationsnummer",
      "vatRegime": "Umsatzsteuerregelung",
      "defaultVatRate": "Standard-Umsatzsteuersatz (%)",
      "exemptionMention": "Hinweis zur Umsatzsteuerbefreiung (erscheint auf der Rechnung)",
      "billingEmail": "E-Mail für Rechnungen",
      "address": "Anschrift des Firmensitzes",
      "postalCode": "Postleitzahl",
      "city": "Ort"
    },
    "placeholders": {
      "legalName": "z. B. Delorme Conseil GmbH",
      "legalForm": "GmbH, AG, Einzelunternehmen…"
    },
    "vatRegimes": {
      "standard": "Umsatzsteuerpflichtig (Regelsatz)",
      "franchiseBase": "Kleinunternehmerregelung (nicht umsatzsteuerpflichtig)",
      "custom": "Benutzerdefiniert"
    },
    "actions": {
      "saving": "Wird gespeichert…",
      "save": "Rechnungsdaten speichern",
      "saved": "Gespeichert"
    }
  },
  "expertIdentity": {
    "title": "Berufliche Identität",
    "subtitle": "Diese Angaben erscheinen in Ihren Kundenberichten und, wenn Sie Ihr öffentliches Profil aktivieren, im Artkiv-Verzeichnis.",
    "fields": {
      "professionalTitle": "Berufsbezeichnung"
    },
    "placeholders": {
      "professionalTitle": "z. B. Experte für moderne und zeitgenössische Kunst, Paris"
    },
    "hints": {
      "professionalTitle": "Wird unter Ihrem Namen in PDF-Berichten und im Verzeichnis angezeigt."
    },
    "pdfLogo": {
      "title": "Logo für Kundenberichte",
      "description": "Erscheint nur in Ihren privaten PDFs. Ihre Kunden sehen Ihre Marke, nicht das öffentliche Verzeichnis.",
      "name": "PDF-Logo",
      "preview": "Vorschau des PDF-Logos"
    },
    "publicLogo": {
      "title": "Logo für das öffentliche Verzeichnis",
      "description": "Nur im Artkiv-Verzeichnis sichtbar, wenn Ihr öffentliches Profil aktiviert ist.",
      "name": "Verzeichnislogo",
      "preview": "Vorschau des Verzeichnislogos"
    },
    "acceptedFormats": "Akzeptierte Formate: PNG, JPG, SVG — maximal 2 MB. Transparenter Hintergrund empfohlen (PNG oder SVG).",
    "validation": {
      "imageOnly": "Bitte wählen Sie eine Bilddatei aus (PNG, JPG, SVG).",
      "maxSize": "Das Logo darf nicht größer als 2 MB sein."
    },
    "actions": {
      "uploading": "Wird hochgeladen…",
      "changeLogo": "Logo ändern",
      "remove": "Entfernen",
      "saving": "Wird gespeichert…",
      "save": "Identität speichern"
    },
    "toasts": {
      "logoUpdated": "{{label}} wurde aktualisiert.",
      "saved": "Berufliche Identität wurde gespeichert."
    },
    "errors": {
      "urlNotGenerated": "URL wurde nicht erzeugt",
      "upload": "Fehler beim Hochladen: {{message}}",
      "save": "Fehler: {{message}}"
    }
  },
  "expertProfile": {
    "welcome": {
      "title": "Willkommen bei Artkiv!",
      "description": "Um unserem Netzwerk zertifizierter Experten beizutreten und in unserem Verzeichnis geführt zu werden, vervollständigen Sie bitte unten Ihr berufliches Profil. Nach der Freigabe können Sie Ihre Artkiv-Kunden einladen, Ihre Expertise zu bestätigen.",
      "stepsTitle": "Die 4 Schritte zur Zertifizierung:",
      "steps": {
        "completeProfileTitle": "Profil vervollständigen",
        "completeProfileDetail": "(Name, Fachgebiet, Biografie, Standort, Foto)",
        "activatePresenceTitle": "Präsenz aktivieren",
        "activatePresenceDetail": "im Artkiv-Verzeichnis",
        "inviteClientsTitle": "Mindestens 3 Artkiv-Kunden einladen",
        "inviteClientsDetail": "Ihre Expertise zu bestätigen",
        "getBadge": "Das Abzeichen „Zertifizierter Experte“ erhalten"
      }
    },
    "incomplete": {
      "title": "Unvollständiges Profil",
      "before": "Vervollständigen Sie die Pflichtfelder (",
      "fields": "Name, Fachgebiet, Biografie, Standort",
      "after": "), bevor Sie Ihre Präsenz im Verzeichnis aktivieren."
    },
    "ready": {
      "title": "Ihr Profil kann veröffentlicht werden!",
      "description": "Ihr Profil ist vollständig. Aktivieren Sie unten Ihre öffentliche Artkiv-Präsenz, um im Verzeichnis zu erscheinen und Kundenanfragen zu erhalten.",
      "hint": "Sobald Ihr Profil öffentlich ist, können Sie Kunden einladen, Ihre Expertise zu bestätigen und das Abzeichen „Zertifizierter Experte“ zu erhalten."
    },
    "directory": {
      "title": "Präsenz im Artkiv-Verzeichnis",
      "publicStatus": "Ihr Profil ist im öffentlichen Verzeichnis sichtbar",
      "privateStatus": "Ihr Profil ist derzeit privat",
      "completeFirst": "Vervollständigen Sie zuerst Ihr Profil (Name, Fachgebiet, Biografie, Standort), um diese Funktion zu aktivieren.",
      "visibleOn": "Ihr Profil ist sichtbar unter",
      "aboutTitle": "Über die Präsenz im Verzeichnis:",
      "aboutText": "Ein Artkiv-Experte kann Kunden verwalten, von anderen eingeladen werden und auf Wunsch eine berufliche Präsentationsseite aktivieren. Die Profile werden in unserem Verzeichnis standardisiert, um Transparenz und Servicequalität zu gewährleisten.",
      "criteriaTitle": "Kriterien für die Aufnahme in das Verzeichnis:",
      "criteria": {
        "experience": "Seit mindestens 5 Jahren als Kunstfachperson tätig sein",
        "education": "Eine fundierte Ausbildung und fortgeschrittene Erfahrung in Kunstgeschichte nachweisen",
        "noStock": "Keinen eigenen Bestand halten und keine Werke in Kommission annehmen",
        "clientPaid": "Ausschließlich von den eigenen Kunden vergütet werden",
        "transparency": "Transparenz über die Vergütungsstruktur gewährleisten",
        "clientInterest": "Die Interessen der Kunden an erste Stelle setzen"
      }
    },
    "photo": {
      "alt": "Experte",
      "uploading": "Wird hochgeladen…",
      "change": "Foto ändern"
    },
    "cv": {
      "analyzing": "Lebenslauf wird analysiert…",
      "upload": "Lebenslauf hochladen (PDF)"
    },
    "certified": "Zertifiziert",
    "fields": {
      "fullName": "Vollständiger Name",
      "specialty": "Fachgebiet",
      "organization": "Organisation",
      "location": "Standort",
      "contactEmail": "Kontakt-E-Mail",
      "phone": "Telefon",
      "experience": "Erfahrung",
      "languages": "Sprachen",
      "bio": "Berufliche Biografie",
      "specializations": "Spezialisierungen",
      "credentials": "Zertifizierungen und Qualifikationen"
    },
    "placeholders": {
      "fullName": "z. B. Marie Dupont",
      "specialty": "z. B. Moderne Kunst",
      "organization": "z. B. Auktionshaus XYZ",
      "location": "z. B. Paris, Frankreich",
      "contactEmail": "z. B. expert@example.com",
      "phone": "z. B. +49 17…",
      "experience": "z. B. über 25 Jahre, Experte seit 2000",
      "languages": "z. B. DE, EN, FR",
      "bio": "Zusammenfassung Ihres Werdegangs und Ihrer Expertise (400–700 Zeichen empfohlen)",
      "specializations": "z. B. Impressionismus, Art déco",
      "credentials": "z. B. ILAB, SFEP"
    },
    "actions": {
      "saving": "Wird gespeichert…",
      "save": "Profil speichern",
      "refresh": "Aktualisieren"
    },
    "certification": {
      "title": "Expertenzertifizierung",
      "subtitle": "Laden Sie Ihre Artkiv-Kunden ein, Ihre Expertise zu bestätigen und das Abzeichen „Zertifizierter Experte“ zu erhalten.",
      "howToTitle": "Wie erhalte ich Bestätigungen?",
      "steps": {
        "shareTitle": "Teilen Sie Ihr Profil",
        "shareDetail": "mit Ihren bestehenden Kunden",
        "inviteTitle": "Laden Sie sie zu Artkiv ein",
        "inviteDetail": "falls sie noch keine Mitglieder sind",
        "validateBefore": "Nach der Anmeldung können sie",
        "validateStrong": "Ihre Expertise bestätigen",
        "validateAfter": "direkt über Ihr Profil.",
        "badgeBefore": "Nach",
        "badgeStrong": "3 Bestätigungen",
        "badgeAfter": " erhalten Sie automatisch das Abzeichen „Zertifizierter Experte“."
      },
      "importantTitle": "Wichtig:",
      "importantText": "Nur Artkiv-Mitglieder können einen Experten bestätigen. Ihre Kunden müssen zunächst ein Artkiv-Konto erstellen.",
      "privateMessage": "Aktivieren Sie Ihre öffentliche Präsenz, um auf die Zertifizierung zuzugreifen."
    }
  },
  "expertBillingManager": {
    "common": {
      "loading": "Wird geladen…",
      "signInRequired": "Bitte melden Sie sich an",
      "notAvailable": "k. A."
    },
    "toasts": {
      "loadError": "Fehler beim Laden der Abrechnungsdaten.",
      "feesSaved": "Honorare wurden erfolgreich aktualisiert.",
      "feesSaveError": "Fehler beim Speichern der Honorare."
    },
    "serviceTypes": {
      "validation": "Validierung einer Schätzung",
      "expertiseCnes": "CNES-Gutachten",
      "placementInstitution": "Vermittlung an eine Institution",
      "placementAuction": "Vermittlung an eine Auktion",
      "custom": "Individuelle Leistung"
    },
    "statuses": {
      "pending": "Ausstehend",
      "inProgress": "In Bearbeitung",
      "completed": "Abgeschlossen",
      "cancelled": "Storniert"
    },
    "header": {
      "title": "Abrechnung und Honorare",
      "before": "Verfolgen Sie Ihre Einnahmen, konfigurieren Sie Ihre Honorare und verwalten Sie Auszahlungen transparent. Jede abgeschlossene Leistung erzeugt automatisch eine Auszahlung, die 7 Tage später vorgesehen ist.",
      "modelLabel": "Neues Modell 2026:",
      "after": "Sie erhalten 90 % des Preises der Leistungen, die Sie über die Plattform abrechnen (Artkiv erhält 10 %); der Kunde zahlt den angezeigten Preis ohne Zusatzgebühr. Keine Provision auf Ihre Direktverkäufe oder Honorare. Dieses Modell umfasst die 2026-konforme E-Rechnung, sichere Zahlungen und spezielle steuerliche Unterstützung."
    },
    "navigation": {
      "overview": "Übersicht",
      "services": "Leistungen",
      "fees": "Honorare",
      "payouts": "Auszahlungen"
    },
    "overview": {
      "totalGrossRevenue": "Gesamter Bruttoumsatz",
      "completedServices": "{{count}} abgeschlossene Leistung",
      "completedServices_one": "{{count}} abgeschlossene Leistung",
      "completedServices_other": "{{count}} abgeschlossene Leistungen",
      "completedServices_plural": "{{count}} abgeschlossene Leistungen",
      "netRevenue": "Nettoeinnahmen",
      "afterCommission": "Nach Artkiv-Provision",
      "pending": "Ausstehend",
      "servicesInProgress": "Laufende Leistungen",
      "averageTicket": "Durchschnittshonorar",
      "perService": "Pro Leistung",
      "revenueBreakdown": "Aufteilung der Einnahmen",
      "yourNetShare": "Ihr Nettoanteil",
      "artkivCommission": "Artkiv-Provision",
      "totalGross": "Bruttosumme",
      "latestServices": "Neueste Leistungen"
    },
    "actions": {
      "viewAll": "Alle anzeigen",
      "saving": "Wird gespeichert…",
      "saveFees": "Honorare speichern",
      "reset": "Zurücksetzen"
    },
    "empty": {
      "noServices": "Noch keine Leistungen",
      "noPayouts": "Noch keine Auszahlungen"
    },
    "services": {
      "historyTitle": "Leistungsverlauf",
      "columns": {
        "service": "Leistung",
        "artwork": "Kunstwerk",
        "date": "Datum",
        "status": "Status",
        "amountInclTax": "Betrag inkl. USt.",
        "commission": "Provision",
        "yourShare": "Ihr Anteil"
      }
    },
    "fees": {
      "title": "Honorareinstellungen",
      "subtitle": "Legen Sie Ihre Honorare für jede Leistungsart fest. Die Artkiv-Provision wird automatisch berechnet.",
      "youReceive": "Sie erhalten (90 %)",
      "commissionHint": "Artkiv: 10 % • Kunde: keine Zusatzgebühr",
      "validation": {
        "title": "Validierung einer Schätzung",
        "subtitle": "Standardleistung innerhalb von 48 Stunden",
        "priceLabel": "Preis inkl. USt. (empfohlen: 49 €)"
      },
      "cnes": {
        "restrictedInfo": "CNES-zertifizierte Gutachten sind akkreditierten Experten vorbehalten. Ihr Tarif wird automatisch auf Aufträge angewendet, die mit Ihrem Status vereinbar sind.",
        "certifiedTitle": "Zertifiziertes Gutachten (CNES)",
        "deepOpinionTitle": "Vertiefte Expertenmeinung",
        "certifiedSubtitle": "Physisches, CNES-zertifiziertes Gutachten",
        "deepOpinionSubtitle": "Nicht zertifizierte Expertenanalyse (außerhalb CNES)",
        "baseRateLabel": "Grundhonorar (empfohlen: 300 €)"
      },
      "hourly": {
        "title": "Stundensatz",
        "subtitle": "Für zusätzliche Leistungen",
        "priceLabel": "Preis zzgl. USt. pro Stunde (empfohlen: 80 €)"
      },
      "placement": {
        "title": "Vermittlung an Institutionen oder Auktionen",
        "subtitle": "Festhonorar plus variable Provision",
        "priceLabel": "Festhonorar zzgl. USt. (empfohlen: 500 €)",
        "noteTitle": "Hinweis:",
        "noteText": "variable Provision auf den endgültigen Verkaufspreis gemäß AGB (in der Regel 2–5 %)."
      }
    },
    "commissionModel": {
      "title": "Neues Provisionsmodell (2026)",
      "youReceiveLabel": "Sie erhalten:",
      "artkivTakesLabel": "Artkiv erhält:",
      "clientPaysLabel": "Der Kunde zahlt:",
      "youPayLabel": "Sie zahlen:",
      "exampleLabel": "Beispiel:",
      "fees": "Gebühr",
      "total": "insgesamt",
      "paidServices": {
        "title": "Kostenpflichtige Leistungen (Schätzungen, Gutachten usw.)",
        "youReceive": "90 % des Leistungspreises",
        "artkivTakes": "10 % (von Ihrem Anteil abgezogen)",
        "clientPays": "den Leistungspreis, ohne Zusatzgebühr",
        "exampleTitle": "Schätzung für 149 €",
        "exampleYouReceive": "Sie erhalten: 134,10 € (90 %)",
        "exampleClientPays": "Der Kunde zahlt: 149 € zzgl. USt.",
        "exampleArtkivTakes": "Artkiv erhält: 14,90 € (10 %)"
      },
      "introduction": {
        "title": "Kontaktvermittlung „Persönlicher Berater“",
        "clientPays": "0 € (kostenlos, im Abonnement enthalten)",
        "youPay": "49 € zzgl. USt. (58,80 € inkl. USt.), wenn Sie annehmen",
        "artkivTakes": "49 € (Zugang zu einem qualifizierten Kunden)"
      },
      "why": {
        "title": "Warum dieses Modell?",
        "intro": "Diese Provisionen ermöglichen Artkiv:",
        "platform": "die Plattform zu betreiben und die 2026-konforme E-Rechnung bereitzustellen",
        "payments": "sichere Zahlungen zu verwalten (Garantie innerhalb von 48 Stunden)",
        "support": "spezielle Kunden- und Steuerunterstützung anzubieten",
        "savings": "Ihnen jährlich rund 1.560 € für Software und Buchhaltung zu ersparen"
      }
    },
    "payouts": {
      "title": "Auszahlungsverlauf",
      "paidOn": "Ausgezahlt am {{date}}",
      "scheduledOn": "Vorgesehen für {{date}}",
      "statuses": {
        "paid": "Ausgezahlt",
        "scheduled": "Vorgesehen"
      }
    }
  },
  "collaborators": {
    "title": "Mitarbeitende",
    "subtitle": "Zugriff auf Sammlungen (Team, Assistenz, Experten)",
    "common": {
      "loading": "Wird geladen…"
    },
    "stats": {
      "total": "{{count}} insgesamt",
      "total_one": "{{count}} insgesamt",
      "total_other": "{{count}} insgesamt",
      "active": "{{count}} aktiv",
      "active_one": "{{count}} aktiv",
      "active_other": "{{count}} aktiv",
      "active_plural": "{{count}} aktiv",
      "pending": "{{count}} ausstehend",
      "pending_one": "{{count}} ausstehend",
      "pending_other": "{{count}} ausstehend"
    },
    "actions": {
      "invite": "Einladen",
      "assistantAccess": "Assistenzzugriff",
      "hide": "Ausblenden",
      "details": "Details",
      "cancel": "Abbrechen",
      "update": "Aktualisieren",
      "sendInvitation": "Einladung senden",
      "copy": "Kopieren",
      "close": "Schließen"
    },
    "empty": {
      "title": "Keine Mitarbeitenden",
      "text": "Laden Sie eine Assistenz oder einen Experten ein, um die Sammlung zu vervollständigen."
    },
    "roles": {
      "labels": {
        "teamReadonly": "Teammitglied (nur Lesen)",
        "teamMember": "Teammitglied",
        "expert": "Experte",
        "collectorClient": "Sammlerkunde",
        "assistant": "Assistenz",
        "familyOfficeUser": "Family-Office-Nutzer",
        "artAdvisor": "Art Advisor",
        "familyOffice": "Family Office"
      },
      "descriptions": {
        "teamReadonly": "1 Mitglied mit Lesezugriff",
        "teamMember": "Bis zu 5 Mitglieder mit Berechtigungen",
        "expert": "Bei Bedarf eingeladene Experten",
        "collectorClientLimited": "Maximal 5 Kunden",
        "collectorClientUnlimited": "Unbegrenzte Kundenzahl",
        "assistant": "Bis zu 3 Assistenzen",
        "assistantOne": "Maximal 1 Assistenz",
        "familyOfficeUser": "Unbegrenzte Nutzerzahl",
        "artAdvisor": "Kunstberatung und kuratorische Betreuung",
        "familyOffice": "Vermögensverwaltung und finanzielle Begleitung"
      }
    },
    "statuses": {
      "pending": "Ausstehend",
      "active": "Aktiv",
      "suspended": "Gesperrt",
      "revoked": "Widerrufen"
    },
    "tooltips": {
      "activate": "Manuell aktivieren (der Nutzer hat sich registriert)",
      "resend": "Einladung erneut senden",
      "copyLink": "Zugangslink kopieren",
      "edit": "Bearbeiten",
      "suspend": "Sperren",
      "reactivate": "Reaktivieren",
      "revoke": "Widerrufen"
    },
    "permissions": {
      "label": "Berechtigungen",
      "none": "keine",
      "view": "Kunstwerke ansehen",
      "edit": "Datensätze bearbeiten",
      "add": "Kunstwerke hinzufügen",
      "delete": "Kunstwerke löschen",
      "export": "Daten exportieren",
      "reports": "Berichte erstellen",
      "ai": "Auf KI-Werkzeuge zugreifen",
      "short": {
        "view": "ansehen",
        "edit": "bearbeiten",
        "add": "hinzufügen",
        "delete": "löschen",
        "export": "Export",
        "reports": "Berichte",
        "ai": "KI"
      }
    },
    "collections": {
      "label": "Sammlungen",
      "noneDefined": "keine Sammlung festgelegt"
    },
    "modal": {
      "editTitle": "Mitarbeitenden bearbeiten",
      "inviteTitle": "Mitarbeitenden einladen"
    },
    "form": {
      "role": "Rolle",
      "email": "E-Mail",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "phone": "Telefon",
      "accessibleCollections": "Zugängliche Sammlungen",
      "collectionsHint": "Die Person sieht nur die ausgewählten Sammlungen.",
      "noCollectionsLoaded": "Keine Sammlungen geladen. Der Zugriff bleibt mit der aktuellen Sammlung verknüpft, sofern eine vorhanden ist.",
      "notes": "Notizen",
      "notesPlaceholder": "Interne Notizen zu dieser Person…"
    },
    "presets": {
      "readonly": "Nur Lesen",
      "assistant": "Assistenz",
      "expert": "Experte"
    },
    "linkModal": {
      "title": "Einladungslink für Mitarbeitende",
      "description": "Senden Sie diesen Link an die eingeladene Person. Sie kann ein Konto erstellen oder sich anmelden, um die Einladung anzunehmen."
    },
    "fallbacks": {
      "unknownClient": "Unbekannter Kunde",
      "untitledCollection": "Sammlung ohne Namen",
      "collectionWithId": "Sammlung {{id}}"
    },
    "confirm": {
      "revoke": "Möchten Sie den Zugriff dieser Person wirklich widerrufen?",
      "activate": "Diesen Zugriff manuell aktivieren? Der Nutzer kann sich anschließend sofort anmelden."
    },
    "toasts": {
      "inviteReady": "Einladung ist bereit ✍️",
      "invitationResent": "Einladung erneut per E-Mail gesendet ✅",
      "linkCopied": "Einladungslink kopiert ✅",
      "activating": "Wird aktiviert…",
      "activated": "Zugriff aktiviert ✅"
    },
    "errors": {
      "load": "Fehler beim Laden der Mitarbeitenden: {{message}}",
      "unknownPlan": "Unbekannter Tarif",
      "roleLimit": "Das Limit für diese Rolle ist erreicht ({{current}}/{{limit}}). Wechseln Sie zu einem höheren Tarif oder widerrufen Sie einen Zugriff.",
      "selectCollection": "Wählen Sie mindestens eine zugängliche Sammlung aus.",
      "generic": "Fehler: {{message}}",
      "resend": "Fehler beim erneuten Senden: {{message}}",
      "unknown": "unbekannt",
      "noToken": "Kein Token verfügbar. Wählen Sie zuerst „Einladung erneut senden“.",
      "copyLink": "Der Link konnte nicht kopiert werden.",
      "copyManually": "Markieren Sie den Link und kopieren Sie ihn manuell.",
      "activateImpossible": "Diese Person konnte nicht aktiviert werden.",
      "activate": "Fehler bei der Aktivierung: {{message}}"
    },
    "audit": {
      "revokeReason": "Über das Dashboard widerrufen"
    }
  },
  "artworksForSale": {
    "loading": "Zum Verkauf stehende Werke werden geladen…",
    "empty": "Derzeit stehen keine Werke zum Verkauf.",
    "untitledArtwork": "Werk ohne Titel",
    "unknownTechnique": "Technik unbekannt",
    "undefined": "Nicht angegeben",
    "sections": {
      "mine": "Ihre Werke zum Verkauf",
      "others": "Werke anderer Sammler zum Verkauf"
    },
    "labels": {
      "estimate": "Schätzwert",
      "purchasePrice": "Kaufpreis",
      "salePrice": "Verkaufspreis",
      "proposedPrice": "Angebotspreis"
    },
    "actions": {
      "view": "Details ansehen",
      "remove": "Entfernen",
      "makeOffer": "Angebot abgeben"
    },
    "confirmRemove": "Möchten Sie dieses Werk wirklich aus dem Verkauf nehmen?",
    "errors": {
      "loadingUnknown": "Beim Laden ist ein unbekannter Fehler aufgetreten.",
      "remove": "Das Werk konnte nicht aus dem Verkauf genommen werden: {{message}}",
      "unknown": "unbekannter Fehler"
    }
  },
  "estimationPage": {
    "title": "Bewertungen der Kunstwerke",
    "form": {
      "title": "Neue Bewertung hinzufügen",
      "methodIntro": "Die Bewertungsart bestimmt die Methode, mit der der Wert des Kunstwerks ermittelt wird:"
    },
    "methods": {
      "ai": {
        "label": "KI-Bewertung",
        "description": "Wird automatisch von unseren internen Algorithmen anhand vergleichbarer Kunstwerke, Medium, Abmessungen, Künstler und Markttrends erstellt."
      },
      "physical": {
        "label": "Physische Begutachtung",
        "description": "Wird von einem Experten nach direkter Begutachtung vor Ort, etwa in einer Galerie oder einem Depot, durchgeführt."
      },
      "comparables": {
        "label": "Bewertung anhand vergleichbarer Werke",
        "description": "Basiert auf dem direkten Vergleich mit ähnlichen bereits bewerteten oder verkauften Werken aus internen Daten oder externen Quellen."
      },
      "insurance": {
        "label": "Versicherungsbewertung",
        "description": "Wird von einem Versicherer oder zugelassenen Vermittler zur Festlegung eines vertraglichen Versicherungswerts erstellt."
      },
      "succession": {
        "label": "Nachlassbewertung",
        "description": "Dient einer Vermögenserklärung oder Übertragung gemäß steuerlichen und notariellen Anforderungen."
      }
    },
    "fields": {
      "artwork": "Kunstwerk",
      "artist": "Künstler",
      "appraiser": "Gutachter",
      "date": "Datum",
      "estimatedValue": "Geschätzter Wert (€)",
      "estimatedValueShort": "Geschätzter Wert",
      "method": "Bewertungsart",
      "notes": "Notizen",
      "document": "Dokument (PDF oder Bild)",
      "documentShort": "Dokument"
    },
    "placeholders": {
      "selectArtwork": "Kunstwerk auswählen",
      "selectExpert": "Experten auswählen",
      "searchArtwork": "🔍 Kunstwerk suchen…"
    },
    "actions": {
      "newEstimation": "Neue Bewertung",
      "comparableEstimation": "Bewertung anhand vergleichbarer Werke",
      "pointsEstimation": "Punktebasierte Bewertung",
      "cancel": "Abbrechen",
      "addExpert": "Hinzufügen",
      "save": "Speichern",
      "download": "Herunterladen"
    },
    "history": {
      "title": "Bewertungsverlauf",
      "empty": "Keine Bewertung entspricht Ihrer Suche."
    },
    "fallbacks": {
      "unknownArtwork": "Unbekanntes Kunstwerk",
      "unknownArtist": "Unbekannter Künstler"
    },
    "alerts": {
      "required": "Bitte geben Sie mindestens das Kunstwerk und den geschätzten Wert an.",
      "uploadError": "Beim Hochladen des Dokuments ist ein Fehler aufgetreten.",
      "saveError": "Fehler beim Speichern: {{message}}",
      "saved": "Bewertung erfolgreich gespeichert!"
    }
  },
  "depositsPage": {
    "title": "Depots & Leihgaben",
    "subtitle": "Dritten anvertraute Sammlungen und einzeln verliehene Kunstwerke",
    "museumSidebar": {
      "title": "Einem Museum vorschlagen",
      "text": "Erstellen Sie aus Ihren Werken ein Vorschlagsdossier für eine Institution.",
      "cta": "Museumsdossier erstellen"
    },
    "tabs": {
      "deposits": "Sammlungen im Depot",
      "loans": "Verliehene Kunstwerke",
      "risks": "Zu klären"
    },
    "ownerTypes": {
      "a_clarifier": "Zu klären",
      "private_collector": "Privatsammler",
      "institution": "Institution",
      "family_succession": "Familie / Nachlass"
    },
    "contract": {
      "noEndDate": "⚠ Kein Enddatum",
      "expiredAgo": "VOR {{count}} TAG ABGELAUFEN",
      "expiredAgo_plural": "VOR {{count}} TAGEN ABGELAUFEN",
      "expiredAgo_one": "VOR {{count}} TAG ABGELAUFEN",
      "expiredAgo_other": "VOR {{count}} TAGEN ABGELAUFEN",
      "expiresIn": "⚠ Läuft in {{count}} Tag ab",
      "expiresIn_plural": "⚠ Läuft in {{count}} Tagen ab",
      "expiresIn_one": "⚠ Läuft in {{count}} Tag ab",
      "expiresIn_other": "⚠ Läuft in {{count}} Tagen ab",
      "validUntil": "Gültig bis {{date}}",
      "urgentSummary": "{{count}} Vertrag ist abgelaufen oder innerhalb von 60 Tagen zu erneuern",
      "urgentSummary_plural": "{{count}} Verträge sind abgelaufen oder innerhalb von 60 Tagen zu erneuern",
      "urgentSummary_one": "{{count}} Vertrag ist abgelaufen oder innerhalb von 60 Tagen zu erneuern",
      "urgentSummary_other": "{{count}} Verträge sind abgelaufen oder innerhalb von 60 Tagen zu erneuern"
    },
    "toast": {
      "depositSaved": "Depotakte gespeichert",
      "loanMarked": "Kunstwerk als Leihgabe markiert",
      "loanRemoved": "Leihstatus entfernt",
      "error": "Fehler: {{message}}"
    },
    "depositModal": {
      "title": "Depotakte",
      "ownerType": "Eigentümertyp",
      "ownerName": "Name des Eigentümers",
      "ownerNamePlaceholder": "Name oder Firmenbezeichnung",
      "contact": "Kontakt",
      "contactPlaceholder": "E-Mail, Telefon…",
      "contractStart": "Vertragsbeginn",
      "contractEnd": "Vertragsende",
      "insuranceRequired": "Versicherung erforderlich",
      "insuranceHolderPlaceholder": "Wer trägt die Versicherung? (Einlieferer, Verwahrer…)",
      "specialConditions": "Besondere Bedingungen",
      "specialConditionsPlaceholder": "Klauseln, Einschränkungen, Pflichten…"
    },
    "loanModal": {
      "removeTitle": "Leihgabe beenden",
      "markTitle": "Als Leihgabe markieren",
      "destination": "Ziel / Begünstigter der Leihgabe",
      "destinationPlaceholder": "z. B. Museum für Moderne Kunst, Paris",
      "confirmReturn": "Rückgabe bestätigen",
      "confirmLoan": "Leihgabe bestätigen"
    },
    "empty": {
      "depositsTitle": "Keine Sammlung im Depot",
      "depositsText": "Erstellen Sie unter „Meine Sammlung“ eine Sammlung vom Typ „Depot“, um sie hier zu verwalten.",
      "loansTitle": "Keine Kunstwerke verliehen",
      "loansText": "Markieren Sie Kunstwerke in ihren Einzelakten oder auf dieser Seite als „verliehen“.",
      "viewCollections": "Meine Sammlungen anzeigen",
      "viewCollection": "Meine Sammlung anzeigen"
    },
    "risks": {
      "allLocated": "Alle Ihre Kunstwerke sind lokalisiert",
      "loanLocatedHint": "Verliehene Kunstwerke gelten als bei der entleihenden Institution lokalisiert.",
      "unknownLocationTitle": "Standort unbekannt —",
      "unknownLocationText": "Für diese Kunstwerke ist weder ein Lagerort noch eine Leihgabe erfasst. Im Schadensfall kann ihr Standort gegenüber dem Versicherer nicht nachgewiesen werden.",
      "collectionLabel": "Sammlung: {{collection}}"
    },
    "actions": {
      "complete": "Ergänzen",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "saving": "Wird gespeichert…",
      "edit": "Bearbeiten",
      "view": "Ansehen"
    },
    "depositCard": {
      "badge": "Depot",
      "artworkCount": "{{count}} Kunstwerk",
      "artworkCount_plural": "{{count}} Kunstwerke",
      "artworkCount_one": "{{count}} Kunstwerk",
      "artworkCount_other": "{{count}} Kunstwerke",
      "insurance": "Versicherung: {{holder}}",
      "toDefine": "noch festzulegen",
      "missingRecord": "⚠ Keine Depotakte vorhanden — Vertrag, Eigentümer und Versicherung sind unbekannt"
    },
    "loanCard": {
      "estimatedValue": "Geschätzter Wert: {{value}}",
      "return": "Rückgabe",
      "record": "Akte"
    }
  },
  "locationManager": {
    "page": {
      "title": "Meine Standorte",
      "subtitle": "Ein paar Angaben genügen, um jedes Werk dort zu pflegen, wo es lebt — zu Hause wie an einem spezialisierten Ort."
    },
    "status": {
      "suitable": "Geeignet",
      "improve": "Zu verbessern",
      "monitor": "Zu beobachten"
    },
    "microcopy": {
      "headerTitle": "Pflegen Sie Ihre Werke dort, wo sie leben",
      "headerSub": "Ein paar Angaben genügen für auf jedes Werk zugeschnittene Hinweise — zu Hause wie an einem spezialisierten Ort.",
      "homeTitle": "Zu Hause aufbewahrt? Das ist oft völlig geeignet.",
      "homeText": "ARTKIV hilft Ihnen einfach, Licht, Feuchtigkeit, Wärme und die Sicherheit der Hängung zu prüfen.",
      "unknownTitle": "Nicht alle Antworten parat? Kein Problem.",
      "unknownText": "Geben Sie an, was Sie heute wissen. Sie können später ergänzen.",
      "proTitle": "Brauchen Sie eine technischere Umgebung?",
      "proText": "Für empfindliche, große oder häufig bewegte Werke kann ein spezialisiertes Lager zusätzliche Leistungen bieten.",
      "privacyTitle": "Ihre Adresse und Ihre Fotos bleiben privat.",
      "privacyText": "Sie entscheiden genau, wer die Angaben zum Ort einsehen darf."
    },
    "actions": {
      "newLocation": "Neuer Standort",
      "cancel": "Abbrechen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "transfer": "Übertragen",
      "confirm": "Bestätigen",
      "save": "Speichern"
    },
    "fields": {
      "type": "Typ",
      "address": "Adresse",
      "notes": "Notizen",
      "status": "Status"
    },
    "types": {
      "primaryResidence": "Hauptwohnsitz",
      "secondaryResidence": "Zweitwohnsitz",
      "office": "Büro / Geschäftsräume",
      "personalReserve": "Persönliches Depot",
      "selfStorage": "Selfstorage / Lagerbox",
      "artWarehouse": "Spezialisiertes Kunstlager",
      "professionalDeposit": "Galerie / Atelier / Händler",
      "museum": "Museum / Institution",
      "transit": "Transport / Transit",
      "freeport": "Zolllager / Freihafen",
      "storage": "Lager",
      "loan": "Leihgabe",
      "exhibition": "Ausstellung",
      "other": "Sonstiges"
    },
    "security": {
      "intrusionAlarm": "Einbruchmeldeanlage",
      "videoSurveillance": "Videoüberwachung",
      "restrictedAccess": "Beschränkter Zugang",
      "specificInsurance": "Spezielle Versicherung"
    },
    "risks": {
      "low": "Niedrig",
      "medium": "Mittel",
      "high": "Hoch"
    },
    "conditions": {
      "temperature": "Temperatur",
      "humidity": "Luftfeuchtigkeit",
      "light": "Licht",
      "ventilation": "Belüftung",
      "humidityRelative": "Relative Luftfeuchtigkeit",
      "lightUv": "Licht / UV",
      "packagingVentilation": "Verpackung / Belüftung",
      "temperaturePlaceholder": "Z. B. 18-20 °C, stabil, klimatisiert",
      "humidityPlaceholder": "Z. B. 50-55 % rF, kontrolliert",
      "lightPlaceholder": "Z. B. vollständige Dunkelheit, UV-Filter, Jalousien",
      "ventilationPlaceholder": "Z. B. säurefreie Rollen, Holzkisten, belüfteter Bereich"
    },
    "form": {
      "sections": {
        "general": "Allgemeine Informationen",
        "conservation": "Erhaltungsbedingungen",
        "security": "Sicherheitsmaßnahmen",
        "risk": "Gesamtrisiko",
        "observationsPhotos": "Beobachtungen & Fotos"
      },
      "name": "Name des Standorts",
      "generalObservations": "Allgemeine Beobachtungen",
      "observationsPlaceholder": "Beobachtete Risiken, geplante Arbeiten, Zugang, Bewachung…"
    },
    "photos": {
      "title": "Fotos des Raums",
      "uploadingShort": "Upload…",
      "uploading": "Upload läuft…",
      "add": "+ Hinzufügen",
      "addPhotos": "+ Fotos hinzufügen",
      "addSpacePhotos": "Fotos des Raums hinzufügen",
      "addMore": "Weitere Fotos hinzufügen"
    },
    "artworks": {
      "atLocation": "Kunstwerke an diesem Standort:"
    },
    "transfer": {
      "selectDestination": "Ziel auswählen",
      "confirmTitle": "Übertragung bestätigen",
      "destination": "Ziel"
    },
    "delete": {
      "confirmTitle": "Diesen Standort löschen?",
      "containsArtworks": "Dieser Standort enthält {{count}} Kunstwerk. Übertragen Sie es vor dem Löschen.",
      "containsArtworks_plural": "Dieser Standort enthält {{count}} Kunstwerke. Übertragen Sie sie vor dem Löschen.",
      "containsArtworks_one": "Dieser Standort enthält {{count}} Kunstwerk. Übertragen Sie es vor dem Löschen.",
      "containsArtworks_other": "Dieser Standort enthält {{count}} Kunstwerke. Übertragen Sie sie vor dem Löschen.",
      "irreversible": "Diese Aktion kann nicht rückgängig gemacht werden."
    },
    "fallback": {
      "untitled": "Ohne Titel",
      "unknownArtist": "unbekannter Künstler"
    },
    "notifications": {
      "uploadError": "Upload-Fehler: {{message}}",
      "selectTransfer": "Wählen Sie ein Ziel und die zu übertragenden Kunstwerke aus.",
      "transferSuccess": "Kunstwerke erfolgreich übertragen!",
      "transferError": "Fehler bei der Übertragung.",
      "updateSuccess": "Standort aktualisiert!",
      "updateError": "Fehler beim Aktualisieren des Standorts.",
      "createSuccess": "Neuer Standort hinzugefügt.",
      "createError": "Fehler beim Erstellen des Standorts.",
      "deleteBlocked": "Löschen nicht möglich: An diesem Standort befindet sich {{count}} Kunstwerk. Übertragen Sie es zuerst.",
      "deleteBlocked_plural": "Löschen nicht möglich: An diesem Standort befinden sich {{count}} Kunstwerke. Übertragen Sie sie zuerst.",
      "deleteBlocked_one": "Löschen nicht möglich: An diesem Standort befindet sich {{count}} Kunstwerk. Übertragen Sie es zuerst.",
      "deleteBlocked_other": "Löschen nicht möglich: An diesem Standort befinden sich {{count}} Kunstwerke. Übertragen Sie sie zuerst.",
      "deleteSuccess": "Standort gelöscht.",
      "deleteError": "Fehler beim Löschen des Standorts."
    }
  },
  "estimationValidation": {
    "cancelled": {
      "ui": {
        "paiementAnnule": "Zahlung abgebrochen",
        "vousAvezAnnuleLeProcessusDePaiementAucunMontant": "Sie haben den Zahlungsvorgang abgebrochen. Es wurde kein Betrag belastet. Ihre Validierungsanfrage wurde nicht erstellt.",
        "retourAuxEstimations": "Zurück zu den Bewertungen"
      }
    },
    "success": {
      "ui": {
        "verificationDuPaiement": "Zahlung wird geprüft...",
        "paiementConfirme": "Zahlung bestätigt!",
        "votreDemandeDeValidationAEteTransmiseANotre": "Ihre Validierungsanfrage wurde an unser Expertenteam übermittelt. Sie erhalten die validierte Bewertung per E-Mail innerhalb von",
        "4872hOuvres": "48–72 Geschäftsstunden",
        "prochainesEtapes": "Nächste Schritte",
        "vousRecevrezUnEmailDeConfirmationImmediatement": "Sie erhalten umgehend eine Bestätigungs-E-Mail",
        "notreEquipeAnalyseraVotreEstimationDansLes4872h": "Unser Team prüft Ihre Bewertung innerhalb von 48–72 Stunden",
        "vousRecevrezLeRapportDetailleParEmail": "Sie erhalten den ausführlichen Bericht per E-Mail",
        "retourAuxEstimations": "Zurück zu den Bewertungen",
        "monCompte": "Mein Konto"
      }
    },
    "request": {
      "ui": {
        "aucuneDonneeDEstimationTrouveeVeuillezDAbordEffectuer": "Es wurden keine Bewertungsdaten gefunden. Bitte führen Sie zuerst die Berechnung durch.",
        "votreDemandeDeValidationAEteEnvoyeeAL": "✅ Ihre Validierungsanfrage wurde an das Artkiv-Team gesendet. Sie erhalten innerhalb von 48–72 Stunden eine Benachrichtigung per E-Mail.",
        "calculDEstimationRequis": "Bewertungsberechnung erforderlich",
        "vousDevezDAbordEffectuerLeCalculDEstimation": "Sie müssen die Bewertung zunächst mit der Punktemethode oder anhand vergleichbarer Werke berechnen, bevor Sie eine Validierung anfordern können.",
        "retourAuxEstimations": "Zurück zu den Bewertungen",
        "demandeDeValidationDEstimation": "Anfrage zur Validierung einer Bewertung",
        "serviceExpertArtkivValidationSous4872h": "Artkiv-Expertenservice · Validierung innerhalb von 48–72 Stunden",
        "recapitulatifDeVotreEstimation": "Zusammenfassung Ihrer Bewertung",
        "sansTitre": "Ohne Titel",
        "methodeUtilisee": "Verwendete Methode",
        "methodeParPoints": "Punktemethode",
        "uvresComparables": "Vergleichbare Werke",
        "valeurEstimee": "Geschätzter Wert",
        "indiceDeConfiance": "Konfidenzwert",
        "estimationProvisoireBaseDeComparablesInsuffisantePourValidationC": "Vorläufige Bewertung · unzureichende Vergleichsdaten für eine vollständige CUP-Validierung.",
        "validationGratuiteIncluse": "Kostenlose Validierung inklusive",
        "servicePayant": "Kostenpflichtiger Service",
        "votreAbonnement": "Ihr Abonnement",
        "validationsGratuitesParMois": "kostenlose Validierungen pro Monat.",
        "validationsUtiliseesCeMois": "In diesem Monat verwendete Validierungen",
        "validationsGratuitesRestantes": "Verbleibende kostenlose Validierungen",
        "coutDeCetteValidation": "Kosten dieser Validierung",
        "passezALAbonnementPremiumPourObtenir50Validations": ": Wechseln Sie zu Premium und erhalten Sie 50 kostenlose Validierungen pro Monat",
        "commentCaMarche": "Wie funktioniert es?",
        "envoiDeVotreDemande": "Anfrage senden",
        "votreCalculDEstimationEstTransmisALEquipe": "Ihre Bewertungsberechnung wird an das Artkiv-Team übermittelt",
        "verificationExperte": "Expertenprüfung",
        "nosExpertsAnalysentVosDonneesVerifientLesSourcesEt": "Unsere Experten analysieren Ihre Daten, prüfen die Quellen und verfeinern die Bewertung",
        "receptionSous4872h": "Erhalt innerhalb von 48–72 Stunden",
        "vousRecevezLEstimationValideeParEmailAvecUn": "Sie erhalten die validierte Bewertung per E-Mail zusammen mit einem ausführlichen Bericht",
        "envoiEnCours": "Wird gesendet...",
        "envoyerPourValidation": "Zur Validierung senden",
        "gratuit": "(Kostenlos)",
        "noteImportante": "Wichtiger Hinweis:",
        "cetteValidationNEstPasUneExpertiseOfficielleCnes": "Diese Validierung ist kein offizielles CNES-Gutachten. Bei hochwertigen Werken (> 80.000 €) oder für rechtliche Zwecke wie Erbschaft oder Versicherung kann eine physische Begutachtung durch einen anerkannten Experten erforderlich sein.",
        "enSavoirPlus": "Mehr erfahren",
        "loading": "Wird geladen…",
        "submitError": "❌ Fehler beim Senden der Anfrage: {{message}}",
        "planIncludes": "Ihr {{plan}}-Abonnement umfasst {{count}} kostenlose Validierungen pro Monat.",
        "tip": "Tipp",
        "range": "Spanne"
      }
    },
    "info": {
      "ui": {
        "serviceDeValidationDEstimation": "Service zur Validierung von Schätzungen",
        "commentFaireValiderVotreEstimationParUnExpertArtkiv": "So lassen Sie Ihre Schätzung von einem Artkiv-Experten validieren",
        "leProcessusEn3Etapes": "Der Ablauf in 3 Schritten",
        "effectuezVotreEstimation": "Führen Sie Ihre Schätzung durch",
        "utilisezLUneDeNosDeuxMethodesPourCalculer": "Nutzen Sie eine unserer beiden Methoden, um den Wert Ihres Kunstwerks zu berechnen:",
        "methodeParPoints": "Punktemethode",
        "calculBaseSurLesDimensionsEtLaCoteDe": ": Berechnung auf Grundlage der Abmessungen des Kunstwerks und der Marktposition des Künstlers",
        "uvresComparables": "Vergleichbare Kunstwerke",
        "analyseDeVentesSimilairesRecentes": ": Analyse aktueller vergleichbarer Verkäufe",
        "demandezLaValidation": "Validierung anfordern",
        "uneFoisVotreCalculTermineCliquezSurDemanderUne": "Sobald Ihre Berechnung abgeschlossen ist, klicken Sie auf „Expertenvalidierung anfordern“. Sie sehen sofort, ob die Validierung im Rahmen Ihres monatlichen Kontingents kostenlos oder kostenpflichtig (150 €) ist.",
        "recevezLEstimationValidee": "Validierte Schätzung erhalten",
        "nosExpertsVerifientVosDonneesConsolidentLesSourcesEt": "Unsere Experten prüfen Ihre Daten, konsolidieren die Quellen und präzisieren die Schätzung. Sie erhalten innerhalb von",
        "4872hOuvres": "48–72 Arbeitsstunden",
        "tarificationTransparente": "Transparente Preisgestaltung",
        "lesValidationsNeSontPasAutomatiquementInclusesDansVotre": "Validierungen sind NICHT automatisch in Ihrem Abonnement enthalten",
        "abonnementStandard": "Standard-Abonnement",
        "validationsGratuites": "Kostenlose Validierungen",
        "10Mois": "10 / Monat",
        "auDelaDuQuota": "Über das Kontingent hinaus",
        "150Validation": "150 € / Validierung",
        "abonnementPremium": "Premium-Abonnement",
        "recommande": "Empfohlen",
        "50Mois": "50 / Monat",
        "ceQuiEstInclusDansLaValidation": "Was die Validierung umfasst",
        "verificationDesDonnees": "Prüfung der Daten",
        "controleDeCoherenceDesInformationsSaisies": "Plausibilitätsprüfung der eingegebenen Informationen",
        "consolidationDesSources": "Konsolidierung der Quellen",
        "verificationEtEnrichissementDesComparables": "Prüfung und Ergänzung der Vergleichswerte",
        "affinementDeLEstimation": "Präzisierung der Schätzung",
        "ajustementsBasesSurLExpertiseDuMarche": "Anpassungen auf Grundlage der Marktexpertise",
        "rapportDetaille": "Detaillierter Bericht",
        "documentPdfProfessionnelAvecMethodologie": "Professionelles PDF-Dokument mit Methodik",
        "notreEngagementTransparence": "💎 Unser Transparenzversprechen",
        "artkivNeModifieJamaisVosCalculs": "Artkiv verändert Ihre Berechnungen niemals.",
        "notreValidationEnrichitVotreAnalyseAvecDesVentesComplementaires": "Unsere Validierung ergänzt Ihre Analyse um weitere Verkäufe, die wir in professionellen Datenbanken wie Artprice, Artnet und Auktionshausarchiven identifiziert haben.",
        "chaqueAjoutEstJustifie": "Jede Ergänzung wird begründet",
        "etTraceDansLeRapportFinal": "und im Abschlussbericht nachvollziehbar dokumentiert.",
        "vousVerrezExactement": "Sie sehen genau:",
        "votreCalculInitial": "Ihre ursprüngliche Berechnung",
        "reproduitTelQuelInchange": "(unverändert und exakt wie eingereicht wiedergegeben)",
        "lesVentesAjouteesParArtkiv": "Von Artkiv ergänzte Verkäufe",
        "avecSourcesExactesMaisonDeVentesDateLotEt": "mit genauen Quellen, einschließlich Auktionshaus, Datum und Los, sowie der Begründung für die Aufnahme",
        "lesVentesEcartees": "Ausgeschlossene Verkäufe",
        "siNecessaireAvecJustificationDetaillee": "gegebenenfalls mit ausführlicher Begründung",
        "lEcartEntreVotreEstimationEtLaNotre": "Die Abweichung zwischen Ihrer Schätzung und unserer",
        "avecExplicationMethodologique": "mit methodischer Erläuterung",
        "notreSeuleMission": "Unser einziges Ziel:",
        "vousDonnerLEstimationLaPlusJustePossibleBasee": "Ihnen eine möglichst faire, am realen Markt orientierte Schätzung zu liefern. Wir erhalten keine Provision auf spätere Verkäufe oder Versicherungsverträge. Unsere Einnahmen stammen ausschließlich aus den Validierungsgebühren.",
        "importantValidationVsExpertiseCnes": "⚠️ Wichtig: Validierung vs. CNES-Gutachten",
        "laValidationDEstimationArtkiv": "Die Artkiv-Schätzungsvalidierung",
        "nEstPas": "ist kein",
        "uneExpertiseOfficielleParUnExpertAgreeCnesElle": "offizielles Gutachten eines CNES-zertifizierten Experten. Sie eignet sich für:",
        "assurancePourDesUvres80000": "• Versicherung von Kunstwerken unter 80.000 €",
        "gestionDeCollectionPersonnelle": "• Verwaltung einer privaten Sammlung",
        "premiereEvaluationAvantVente": "• Erste Bewertung vor einem Verkauf",
        "pourLesUvresDeHauteValeur80000Ou": "Für hochwertige Kunstwerke über 80.000 € oder für rechtliche Zwecke wie Erbschaft, Schenkung oder Streitverfahren wird ein",
        "expertiseCnes": "CNES-Gutachten",
        "estRecommandeeOuObligatoire": "empfohlen oder vorgeschrieben.",
        "enSavoirPlus": "Mehr erfahren",
        "questionsFrequentes": "Häufig gestellte Fragen",
        "commentPuisJeEtreSurEQuArtkivN": "💎 Wie kann ich sicher sein, dass Artkiv keine Verkäufe erfindet, um einen höheren Preis zu rechtfertigen?",
        "excellenteQuestionEtNousLaComprenonsParfaitement": "Eine sehr berechtigte Frage, die wir vollkommen verstehen.",
        "laTransparenceEstAuCUrDeNotreService": "Transparenz steht im Mittelpunkt unseres Validierungsservice. Dafür geben wir Ihnen vier Garantien:",
        "votreCalculResteIntact": "Ihre Berechnung bleibt unverändert",
        "nousReproduisonsExactementVotreEstimationInitialeDansLeRapport": "Wir geben Ihre ursprüngliche Schätzung in Abschnitt 1 des Berichts EXAKT und unverändert wieder, damit Sie beide Analysen direkt vergleichen können.",
        "sourcesVerifiables": "Überprüfbare Quellen",
        "chaqueVenteAjouteeInclutMaisonDeVentesDateExacte": "Jeder ergänzte Verkauf enthält das Auktionshaus, das genaue Datum, die Losnummer und, sofern verfügbar, einen Link zu öffentlichen Archiven. Sie können alle Angaben überprüfen.",
        "justificationSystematique": "Systematische Begründung",
        "pourChaqueVenteAjouteeNousExpliquonsPourquoiElleEst": "Für jeden ergänzten Verkauf erläutern wir, WARUM er relevant ist, etwa wegen ähnlicher Abmessungen, derselben Schaffensperiode oder eines renommierten Auktionshauses.",
        "aucunConflitDInteret": "Kein Interessenkonflikt",
        "nousNeTouchonsAucuneCommissionSurVosVentesOu": "Wir erhalten KEINE Provision auf Ihre späteren Verkäufe oder Versicherungsverträge. Unsere einzigen Einnahmen sind die Validierungsgebühr von 150 €, sofern sie nicht in Ihrem Abonnement enthalten ist.",
        "notreReputationDependDeNotreHonneteteUnClientInsatisfait": "Unser Ruf beruht auf unserer Integrität. Unzufriedene Kunden können unseren Bericht von anderen Experten prüfen lassen. Wir haben keinerlei Interesse daran, Daten zu manipulieren.",
        "quellesSourcesDeDonneesUtilisezVousPourEnrichirMon": "Welche Datenquellen nutzen Sie, um meine Schätzung zu ergänzen?",
        "notreValidationReposeSurUnAccesProfessionnelAPlusieurs": "Unsere Validierung stützt sich auf professionellen Zugang zu mehreren führenden Datenbanken des Kunstmarkts:",
        "basesDeDonneesMondiales": "📊 Internationale Datenbanken",
        "30mResultatsDeVentes": ": über 30 Mio. Auktionsergebnisse",
        "ventesInternationalesDepuis1985": ": internationale Verkäufe seit 1985",
        "theArtMarket": "The Art Market",
        "analysesSectorielles": ": Branchenanalysen",
        "archivesMaisonsDeVentes": "🏛️ Archive von Auktionshäusern",
        "christieSSothebySBonhams": "• Christie's, Sotheby's, Bonhams",
        "artcurialTajanPiasaMillon": "• Artcurial, Tajan, Piasa, Millon",
        "cataloguesSpecialisesParArtiste": "• Künstlerbezogene Spezialkataloge",
        "sourcesAcademiques": "📚 Wissenschaftliche Quellen",
        "cataloguesRaisonnesSiDisponibles": "• Werkverzeichnisse, sofern verfügbar",
        "publicationsDExpertsSpecialises": "• Publikationen spezialisierter Experten",
        "archivesGaleriesHistoriques": "• Historische Galeriearchive",
        "expertiseInterne": "👥 Interne Expertise",
        "expertsDiplomesHistoireDeLArt": "• Experten mit kunsthistorischem Hochschulabschluss",
        "specialisationsParPeriode": "• Spezialisierungen nach Epochen",
        "veilleContinueDuMarche": "• Laufende Marktbeobachtung",
        "notreValeurAjoutee": "Unser Mehrwert:",
        "nousCroisonsCesSourcesProfessionnellesSouventPayantesOuA": "Wir gleichen diese professionellen, häufig kostenpflichtigen oder zugangsbeschränkten Quellen ab, um die relevantesten Verkäufe zu finden, die Sie allein möglicherweise nicht entdeckt hätten.",
        "toutesLesVentesAjouteesDansVotreRapportInclurontLa": "Jeder in Ihrem Bericht ergänzte Verkauf enthält die genaue Quelle, damit Sie seine Echtheit überprüfen können.",
        "commentFonctionneLeQuotaMensuelDeValidationsGratuites": "Wie funktioniert das monatliche Kontingent kostenloser Validierungen?",
        "chaqueAbonnementInclutUnCertainNombreDeValidationsGratuites": "Jedes Abonnement enthält eine bestimmte Anzahl kostenloser Validierungen pro Monat:",
        "standard29Mois": "Standard (29 €/Monat):",
        "10ValidationsGratuites": "10 kostenlose Validierungen",
        "premium199Mois": "Premium (199 €/Monat):",
        "50ValidationsGratuites": "50 kostenlose Validierungen",
        "important": "📅 Wichtig:",
        "leQuotaSeRenouvelleAutomatiquementLe1erDeChaque": "Das Kontingent wird automatisch am ersten Tag jedes Monats erneuert. Nicht genutzte Validierungen werden nicht in den Folgemonat übertragen.",
        "auDelaDuQuotae1b639": "Über das Kontingent hinaus:",
        "chaqueValidationSupplementaireCoute150QuelQueSoitVotre": "Jede zusätzliche Validierung kostet unabhängig von Ihrem Abonnement 150 €.",
        "astuce": "💡 Tipp:",
        "siVousFaitesRegulierementPlusDe2ValidationsPayantes": "Wenn Sie regelmäßig mehr als zwei zusätzliche Validierungen pro Monat benötigen, lohnt sich ein Wechsel zu Premium: 199 € für 50 Validierungen entsprechen einem Abonnementwert von 3,98 € pro Validierung.",
        "puisJeAvoirUneValidationEnMoinsDe48h": "Kann ich bei Dringlichkeit eine Validierung in weniger als 48 Stunden erhalten?",
        "leDelaiStandardEstDe": "Die Standardbearbeitungszeit beträgt",
        "4872HeuresOuvrees": "48–72 Arbeitsstunden",
        "lundiVendrediHorsJoursFeries": "Montag bis Freitag, ausgenommen Feiertage.",
        "pourUne": "Für eine",
        "validationExpress24h": "Expressvalidierung innerhalb von 24 Stunden",
        "nousPouvonsEtudierVotreDemandeAuCasParCas": ", können wir Ihre Anfrage im Einzelfall prüfen:",
        "contactezNousA": "Kontaktieren Sie uns unter",
        "expertsArtkivCom": "experts@artkiv.com",
        "avantDeFaireLaDemande": "BEVOR Sie die Anfrage absenden",
        "supplementDe75Total225OuQuota75": "Aufpreis von 75 €, insgesamt 225 € oder Kontingent plus 75 €",
        "selonDisponibiliteDeNosExpertsPasGaranti": "Abhängig von der Verfügbarkeit unserer Experten und ohne Garantie",
        "attention": "⚠️ Bitte beachten:",
        "memeEnExpressNousMaintenonsLaMemeQualiteD": "Auch bei Expressanfragen halten wir denselben Qualitätsstandard ein. Wenn die Komplexität mehr Zeit erfordert, informieren wir Sie.",
        "queFaireAvecLeRapportDeValidationUneFois": "Wie kann ich den Validierungsbericht nach Erhalt verwenden?",
        "leRapportDeValidationArtkivPeutEtreUtilisePour": "Der Artkiv-Validierungsbericht kann verwendet werden für:",
        "usagesRecommandes": "✅ Empfohlene Verwendungen",
        "assuranceUvres80000": "• Versicherung von Kunstwerken unter 80.000 €",
        "gestionCollectionPersonnelle": "• Verwaltung einer privaten Sammlung",
        "partageAvecConseillerPatrimoine": "• Weitergabe an einen Vermögensberater",
        "discussionAvecGaleriste": "• Gespräch mit einer Galerie",
        "valorisationPatrimoniale": "• Vermögensbewertung",
        "necessiteExpertiseCnes": "❌ Erfordert ein CNES-Gutachten",
        "successionDeclarationFiscale": "• Erbschaft und Steuererklärung",
        "donationActeNotarie": "• Schenkung mit notarieller Urkunde",
        "contentieuxJuridique": "• Rechtsstreitigkeiten",
        "assuranceUvres800004aa7fe": "• Versicherung von Kunstwerken über 80.000 €",
        "venteMaisonInternationale": "• Verkauf über ein internationales Auktionshaus",
        "litigeAuthenticite": "• Streit über die Echtheit",
        "pourAllerPlusLoin": "💼 Nächster Schritt:",
        "siVotreSituationNecessiteUneExpertiseCnesOfficielleContactez": "Wenn Ihre Situation ein offizielles CNES-Gutachten erfordert, kontaktieren Sie uns unter experts@artkiv.com. Der Artkiv-Bericht bildet eine solide Grundlage für die physische Begutachtung.",
        "queSePasseTIlSiJeNeSuis": "Was geschieht, wenn ich mit dem Bericht nicht zufrieden bin?",
        "votreSatisfactionEstNotrePrioriteSiVousAvezDes": "Ihre Zufriedenheit hat für uns Priorität. Wenn Sie Fragen haben oder Punkte beanstanden möchten:",
        "contactezNousSous7Jours": "Kontaktieren Sie uns innerhalb von 7 Tagen",
        "emailExpertsArtkivComAvecVotreReferenceDeValidation": "Senden Sie eine E-Mail mit Ihrer Validierungsreferenz an experts@artkiv.com",
        "echangeAvecLExpertValidateur": "Austausch mit dem validierenden Experten",
        "nousOrganisonsUnAppelPourClarifierLesPointsContestes": "Wir organisieren ein Gespräch, um die beanstandeten Punkte zu klären",
        "correctionSiErreurDeNotrePart": "Korrektur bei einem Fehler unsererseits",
        "siNousAvonsFaitUneErreurFactuelleNousCorrigeons": "Wenn uns ein sachlicher Fehler unterlaufen ist, korrigieren wir ihn innerhalb von 48 Stunden kostenlos",
        "important7cb751": "⚠️ Wichtig:",
        "unSimpleDesaccordMethodologiqueNeConstituePasUneErreur": "Eine methodische Meinungsverschiedenheit stellt keinen Fehler dar. Alle unsere Schätzungen beruhen auf überprüfbaren realen Verkäufen, und wir erläutern Ihnen unsere Argumentation ausführlich.",
        "mesDonneesEtImagesDUvresSontEllesConfidentielles": "Sind meine Daten und Bilder der Kunstwerke vertraulich?",
        "laConfidentialiteEstGarantieA100": "Vertraulichkeit ist zu 100 % gewährleistet:",
        "aucunPartageAvecDesTiers": "Keine Weitergabe an Dritte",
        "vosImagesEtInformationsNeSortentJamaisDArtkiv": "- Ihre Bilder und Informationen verlassen Artkiv niemals ohne Ihre ausdrückliche Zustimmung",
        "conformiteRgpd": "DSGVO-Konformität",
        "toutesVosDonneesSontProtegeesSelonLeReglementEuropeen": "- Alle Ihre Daten werden gemäß der europäischen Datenschutz-Grundverordnung geschützt",
        "hebergementSecuriseEurope": "Sicheres Hosting in Europa",
        "serveursHetznerEnAllemagneChiffrementSauvegardesQuotidiennes": "- Hetzner-Server in Deutschland, Verschlüsselung und tägliche Sicherungen",
        "accesRestreint": "Beschränkter Zugriff",
        "seulLExpertAssigneAVotreValidationAccedeA": "- Nur der Ihrer Validierung zugewiesene Experte kann während der Bearbeitung auf Ihre Daten zugreifen",
        "suppressionALaDemande": "Löschung auf Anfrage",
        "vousPouvezDemanderLaSuppressionDeVosDonneesA": "- Sie können jederzeit die Löschung Ihrer Daten im Rahmen des Rechts auf Vergessenwerden verlangen",
        "pourPlusDInformations": "Weitere Informationen:",
        "politiqueDeConfidentialite": "Datenschutzerklärung",
        "pretAEstimerVotreUvre": "Bereit, Ihr Kunstwerk zu schätzen?",
        "commencezParChoisirVotreMethodeDEstimation": "Wählen Sie zunächst Ihre Schätzmethode",
        "commencerLEstimation": "Schätzung starten",
        "absolument": "Absolut."
      }
    }
  },
  "estimationSuccession": {
    "ui": {
      "dansQuelPaysSeSitueLaSuccession": "In welchem Land befindet sich der Nachlass?",
      "lesReglesDEvaluationDesUvresDArtVarient": "Die Bewertungsregeln für Kunstwerke unterscheiden sich je nach örtlicher Gesetzgebung.",
      "changerDePays": "Land ändern",
      "successionEnBelgique": "🇧🇪 Nachlass in Belgien",
      "valeurVenaleAuJourDuDecesPossibiliteDeDation": "Verkehrswert am Todestag. Kunstwerke können an Zahlungs statt übertragen werden; in Flandern werden sie seit 2023 mit 120 % bewertet.",
      "selectionnezLaRegionDuDefunt": "Region der verstorbenen Person auswählen",
      "lesDroitsDeSuccessionVarientSelonLaRegionDe": "Die Erbschaftsteuer hängt von der Wohnsitzregion der verstorbenen Person ab.",
      "evaluationDeLUvreDArt": "Bewertung des Kunstwerks",
      "valeurVenaleDeLUvreAuJourDuDeces": "Verkehrswert des Kunstwerks am Todestag",
      "ex50000": "Z. B. 50000",
      "estimationParCommissairePriseurOuExpertRecommandee": "Bewertung durch einen Auktionator oder Sachverständigen empfohlen",
      "valeurTotaleDeLaSuccession": "Gesamtwert des Nachlasses",
      "ex500000": "Z. B. 500000",
      "lienDeParenteAvecLeDefunt": "Verwandtschaftsverhältnis zur verstorbenen Person",
      "selectionner": "Auswählen",
      "conjointCohabitantLegal": "Ehegatte / gesetzlich zusammenlebende Person",
      "ligneDirecteEnfantsParents": "Direkte Linie (Kinder, Eltern)",
      "freresSUrsOnclesTantes": "Geschwister, Onkel und Tanten",
      "autresHeritiers": "Andere Erben",
      "optionDationEnPaiement": "💡 Option: Hingabe an Zahlungs statt",
      "vousPouvezPayerLesDroitsDeSuccessionEnCedant": "Sie können Erbschaftsteuer durch die Übertragung von Kunstwerken begleichen, die zum belgischen Kulturerbe gehören.",
      "avantageFlandreReforme2023": "🇧🇪 Vorteil in Flandern (Reform 2023)",
      "evaluationA": "• Bewertung mit",
      "120DeLaValeurVenale": "120 % des Verkehrswerts",
      "elargissementAuxBiensCulturelsBijouxManuscritsObjetsArcheologiqu": "• Ausweitung auf „Kulturgüter“ wie Schmuck, Manuskripte und archäologische Objekte",
      "remboursementDuSurplusSiValeurDroitsDus": "• Erstattung eines Überschusses, wenn der Wert die geschuldete Steuer übersteigt",
      "envisagerLaDationEnPaiement": "Hingabe an Zahlungs statt in Betracht ziehen",
      "necessiteAccordDeLEtatEtExpertiseFraisA": "Erfordert staatliche Zustimmung und ein Gutachten; Gebühren können anfallen",
      "pointsClesBelgique": "📋 Wichtige Punkte · Belgien",
      "valeurVenale": "Verkehrswert",
      "auJourDuDecesMarcheDesBiensDOccasion": "am Todestag auf Grundlage des Gebrauchtmarkts",
      "expertiseRecommandee": "Gutachten empfohlen",
      "parCommissairePriseurPourUvresImportantes": "bei bedeutenden Werken durch einen Auktionator",
      "tauxVariables": "Variable Steuersätze",
      "selonRegionDegreDeParenteEtMontant": "je nach Region, Verwandtschaftsgrad und Betrag",
      "dationPossible": "Hingabe an Zahlungs statt möglich",
      "cessionDUvresAuLieuDuPaiementEnNumeraire": ": Übertragung von Werken anstelle einer Geldzahlung",
      "controleFiscal": "Steuerliche Prüfung",
      "lAdministrationPeutDemanderUneExpertiseDeControle": ": die Verwaltung kann ein Kontrollgutachten verlangen",
      "retour": "← Zurück",
      "demanderUneExpertise": "Gutachten anfordern",
      "successionEnSuisse": "🇨🇭 Nachlass in der Schweiz",
      "26RegimesCantonauxDifferentsValeurVenaleAuJourDu": "Es gelten 26 unterschiedliche kantonale Regelungen. Maßgeblich ist der Verkehrswert am Todestag. Schwyz und Obwalden erheben keine Erbschaftsteuer. In bestimmten Kantonen, darunter Genf und Waadt, ist eine Hingabe an Zahlungs statt möglich.",
      "selectionnezLeCantonDuDernierDomicileDuDefunt": "Kanton des letzten Wohnsitzes der verstorbenen Person auswählen",
      "lImpotSurLesSuccessionsEstPreleveParLe": "Die Erbschaftsteuer wird vom Wohnsitzkanton der verstorbenen Person erhoben.",
      "cantonDe": "Kanton",
      "aucunImpotSurLesSuccessionsDansCeCanton": "✓ In diesem Kanton fällt keine Erbschaftsteuer an",
      "informationsSurLUvre": "Angaben zum Kunstwerk",
      "valeurVenaleDeLUvreChf": "Verkehrswert des Kunstwerks (CHF)",
      "evaluationALaValeurDuMarcheAuJourDu": "Bewertung zum Marktwert am Todestag",
      "lienAvecLeDefunt": "Beziehung zur verstorbenen Person",
      "conjointPartenaireEnregistre": "Ehegatte / eingetragener Partner",
      "enfantsPetitsEnfants": "Kinder / Enkelkinder",
      "freresEtSUrs": "Brüder und Schwestern",
      "dationEnPaiementDisponible": "💡 Hingabe an Zahlungs statt verfügbar",
      "leCantonDe": "Der Kanton",
      "permetDePayerLImpotSurLesSuccessionsEn": "ermöglicht die Begleichung der Erbschaftsteuer durch Übertragung eines Kunstwerks von hohem kulturellem Wert an den Staat.",
      "cantonDeVaudLdpi2005": "Kanton Waadt (LDPI 2005)",
      "serviceDesAffairesCulturellesSeracEvalueLInteret": "• Die Kulturbehörde SERAC bewertet das kulturelle Interesse",
      "enrichissementDesCollectionsDuMuseeCantonal": "• Erweiterung der Sammlungen des Kantonsmuseums",
      "procedureDAgrementRequise": "• Genehmigungsverfahren erforderlich",
      "envisagerLaDationEnPaiementPourCetteUvre": "Hingabe dieses Werks an Zahlungs statt in Betracht ziehen",
      "specificitesDuCanton": "📋 Kantonale Besonderheiten",
      "26SystemesDifferents0A50": ": 26 unterschiedliche Systeme mit Steuersätzen von 0 % bis 50 %",
      "impotCommunal": "Gemeindesteuer",
      "peutSAjouterALImpotCantonal": ": kann zusätzlich zur Kantonssteuer erhoben werden",
      "delaiDePaiement": "Zahlungsfrist",
      "generalement30JoursApresNotification": ": in der Regel 30 Tage nach Zustellung",
      "evaluationAuJourDuDecesMarcheSecondaire": ": Bewertung am Todestag auf Grundlage des Sekundärmarkts",
      "pasDImpotFederal": "Keine eidgenössische Erbschaftsteuer",
      "seulsLesCantonsPreleventLImpot": ": die Erbschaftsteuer wird ausschließlich von den Kantonen erhoben",
      "changerDeCanton": "← Kanton ändern",
      "faireEtablirUnInventaireParUnCommissairePriseurOu": "Ein Inventar durch einen Auktionator oder Sachverständigen erstellen lassen",
      "montantForfaitaireFaibleEtSimple": "Niedriger und einfach anzuwendender Pauschalbetrag",
      "utiliserLeForfaitMobilierStandard": "Die übliche Möbelpauschale verwenden",
      "comparerInventaireVsForfaitSelonValeurReelle": "Inventarwert und Pauschale anhand des tatsächlichen Werts vergleichen",
      "consulterUnNotaireOuExpertComptable": "Notar oder Steuerberater konsultieren",
      "successionEnFranceArticle764Cgi": "🇫🇷 Nachlass in Frankreich · Artikel 764 des französischen Steuergesetzbuchs",
      "hierarchieLegale1VentePublique2Ans2Inventaire": "Gesetzliche Rangfolge: 1) öffentliche Versteigerung innerhalb von 2 Jahren → 2) Inventar innerhalb von 5 Jahren → 3) Versicherungspolice unter 10 Jahren → 4) 5-%-Pauschale oder Schätzerklärung",
      "informationsSurLaSuccession": "Angaben zum Nachlass",
      "valeurTotaleDeLaSuccessionAvantDeductionDesDettes": "Gesamtwert des Nachlasses vor Abzug der Verbindlichkeiten",
      "inclutImmobilierPlacementsAutresBiensMobiliers": "Umfasst Immobilien, Anlagen und sonstige bewegliche Vermögenswerte",
      "forfaitMobilier5": "5-%-Möbelpauschale =",
      "siVousUtilisezLeForfaitLesMeublesUvresSeront": "Bei Anwendung der Pauschale werden Möbel und Kunstwerke mindestens mit diesem Betrag bewertet.",
      "concernantLUvreAEstimer": "Zum zu bewertenden Kunstwerk:",
      "ventePubliqueDansLes2Ans": "Öffentliche Versteigerung innerhalb von 2 Jahren",
      "prixDeVenteObligatoireSiVenteAuxEncheresApres": "Bei einer Versteigerung nach dem Todesfall ist der Verkaufspreis verbindlich.",
      "dateDeLaVente": "Verkaufsdatum",
      "prixDeVente": "Verkaufspreis (€)",
      "inventaireDansLes5Ans": "Inventar innerhalb von 5 Jahren",
      "parNotaireCommissairePriseurOuExpert": "Erstellt durch einen Notar, Auktionator oder Sachverständigen",
      "dateDeLInventaire": "Inventardatum",
      "valeurEstimee": "Geschätzter Wert (€)",
      "contratDAssuranceDeMoinsDe10Ans": "Versicherungspolice unter 10 Jahren",
      "volIncendieOuDommage": "Diebstahl, Brand oder Beschädigung",
      "dateDuContrat": "Vertragsdatum",
      "valeurAssuree": "Versicherungswert (€)",
      "voirLaRecommandation": "Empfehlung anzeigen",
      "recapitulatif": "Zusammenfassung",
      "valeurTotaleSuccession": "Gesamtwert des Nachlasses",
      "forfaitMobilier547ea06": "5-%-Möbelpauschale",
      "valeurInventaire": "Inventarwert",
      "recommandation": "Empfehlung:",
      "pointsDAttention": "⚠️ Zu beachtende Punkte",
      "lAdministrationFiscalePeutContesterEtDemanderUnePreuve": "Die Steuerverwaltung kann die Bewertung anfechten und Gegenbelege verlangen.",
      "distinctionEntreMeublesMeublantsTableauxDOrnementEtObjets": "Es wird zwischen Hausrat, einschließlich dekorativer Gemälde, und Kunst- oder Sammlungsobjekten in einer privaten Galerie unterschieden.",
      "delaisVentePublique2AnsInventaire5AnsAssurance": "Fristen: öffentliche Versteigerung innerhalb von 2 Jahren, Inventar innerhalb von 5 Jahren und Versicherungspolice unter 10 Jahren.",
      "conserverTousLesJustificatifsFacturesExpertisesContrats": "Bewahren Sie alle Nachweise auf, darunter Rechnungen, Gutachten und Verträge.",
      "besoinDUnAccompagnementProfessionnel": "Benötigen Sie professionelle Unterstützung?",
      "unExpertComptableSpecialiseEnFiscaliteDesSuccessionsOu": "Ein auf Erbschaftsteuer spezialisierter Steuerberater oder ein Auktionator kann die Bewertung optimieren und kostspielige Fehler vermeiden.",
      "modifierLesDonnees": "Angaben bearbeiten",
      "estimationPourSuccession": "Nachlassbewertung",
      "outilDAideALaDeclarationFiscaleSelonVotre": "Hilfsmittel für die Steuererklärung entsprechend Ihrer Rechtsordnung",
      "leModuleDEstimationSuccessionPourCePaysEst": "Das Modul zur Nachlassbewertung für dieses Land befindet sich in Entwicklung.",
      "choisirUnAutrePays": "Anderes Land auswählen",
      "ressourcesUtiles": "Nützliche Ressourcen",
      "article764DuCodeGeneralDesImpotsFrance": "→ Artikel 764 des französischen Steuergesetzbuchs",
      "bofipEvaluationDesBiensMeublesFrance": "→ BOFiP-Leitfaden zur Bewertung beweglicher Vermögensgegenstände in Frankreich",
      "fichePratiqueSuccessionArtkiv": "→ Artkiv-Praxisleitfaden zur Nachlassplanung"
    },
    "data": {
      "country": {
        "FR": {
          "name": "Frankreich",
          "regulations": "Artikel 764 des französischen Steuergesetzbuchs: 5-%-Pauschale oder Inventar"
        },
        "BE": {
          "name": "Belgien",
          "regulations": "Verkehrswert am Todestag"
        },
        "CH": {
          "name": "Schweiz",
          "regulations": "Je nach Kanton unterschiedliche Regelungen"
        },
        "US": {
          "name": "Vereinigte Staaten",
          "regulations": "Fair Market Value - IRS"
        },
        "UK": {
          "name": "Vereinigtes Königreich",
          "regulations": "Nachlassbewertung - HMRC"
        }
      },
      "region": {
        "WAL": {
          "name": "Wallonien",
          "info": "Wallonisches Erbschaftsteuerrecht"
        },
        "BXL": {
          "name": "Region Brüssel-Hauptstadt",
          "info": "Region Brüssel-Hauptstadt"
        },
        "FLA": {
          "name": "Flandern",
          "info": "Erfbelasting: Reform 2023 mit erweiterter Leistung an Erfüllungs statt"
        }
      },
      "canton": {
        "GE": {
          "name": "Genf",
          "exemption": "Direkte Linie und Ehepartner sind befreit"
        },
        "VD": {
          "name": "Waadt",
          "exemption": "Kinder: 250.000 CHF steuerfrei"
        },
        "ZH": {
          "name": "Zürich",
          "exemption": "Direkte Linie ist befreit"
        },
        "BE": {
          "name": "Bern",
          "exemption": "Direkte Linie und Ehepartner sind befreit"
        },
        "VS": {
          "name": "Wallis",
          "exemption": "Nach kantonalem Tarif"
        },
        "TI": {
          "name": "Tessin",
          "exemption": "Nach kantonalem Tarif"
        },
        "SZ": {
          "name": "Schwyz",
          "exemption": "Keine Erbschaftsteuer"
        },
        "OW": {
          "name": "Obwalden",
          "exemption": "Keine Erbschaftsteuer"
        }
      }
    },
    "recommendation": {
      "inventory": "Inventar",
      "flatRate": "5-%-Pauschale",
      "toEvaluate": "Weitere Prüfung erforderlich",
      "savings": "Geschätzte Erbschaftsteuerersparnis von {{amount}}"
    }
  },
  "estimationAssurance": {
    "ui": {
      "factureDAchat": "Kaufrechnung",
      "expertiseAgreee": "Anerkanntes Gutachten",
      "certificatDAuthenticite": "Echtheitszertifikat",
      "historiqueProvenance": "Provenienzhistorie",
      "uvresComparables": "Vergleichbare Werke",
      "etatExcellent": "Ausgezeichneter Zustand",
      "estimationPourAssurance": "Versicherungsbewertung",
      "constituezUnDossierSolidePourJustifierVotreValeurDeclaree": "Erstellen Sie eine belastbare Dokumentation zur Begründung Ihres deklarierten Werts",
      "valeurDeclareeVsValeurAgreee": "💡 Deklarierter Wert vs. vereinbarter Wert",
      "valeurDeclaree": "Deklarierter Wert",
      "vousEstimezVousMemeLaValeurAvecJustificatifsPlus": ": Sie schätzen den Wert selbst und legen Nachweise vor. Dies ist einfacher und schneller und wird bis 80.000 € empfohlen.",
      "valeurAgreee": "Vereinbarter Wert",
      "expertiseParUnProfessionnelAgreeCnesObligatoireAuDela": ": Gutachten durch einen von der CNES anerkannten Sachverständigen. Über 80.000 € erforderlich und für bedeutende Werke empfohlen.",
      "quelleMethodeDEvaluationChoisir": "Welche Bewertungsmethode sollten Sie wählen?",
      "vousEstimezVousMemeAvecDesJustificatifsFactureComparables": "Sie schätzen den Wert selbst anhand von Nachweisen wie Rechnung, Vergleichswerken, Fotos und Provenienz. Artkiv unterstützt Sie beim Aufbau der Dokumentation und zeigt fehlende Elemente an.",
      "rapideEtSimple": "✓ Schnell und unkompliziert",
      "recommandeJusquA80000": "✓ Bis 80.000 € empfohlen",
      "coutGratuitDansVotreAbonnement": "✓ Kosten: im Abonnement enthalten",
      "expertRequis": "Sachverständiger erforderlich",
      "expertiseParUnProfessionnelAgreeCnesChambreNationaleDes": "Gutachten durch einen von der CNES anerkannten Sachverständigen. Bietet dem Versicherer die höchstmögliche Sicherheit.",
      "obligatoire80000": "✓ Über 80.000 € erforderlich",
      "reconnueParTousLesAssureurs": "✓ Von allen Versicherern anerkannt",
      "cout150500SelonUvre": "✓ Kosten: 150–500 € je nach Werk",
      "votreUvreActuelle": "📊 Ihr aktuelles Werk",
      "valeurActuelleDansArtkiv": "Aktueller Wert in Artkiv",
      "expertiseRecommandee": "Gutachten empfohlen",
      "valeurDeclareeSuffisante": "Deklarierter Wert ausreichend",
      "changerDeMethode": "Methode ändern",
      "constituerVotreDossierDeJustification": "Nachweisdokumentation erstellen",
      "valeurDeclareePourLAssurance": "Deklarierter Versicherungswert (€)",
      "ex15000": "Z. B. 15000",
      "valeurDeRemplacementPrixDAchatInflationMarge10": "Wiederbeschaffungswert: Kaufpreis + Inflation + 10–20 % Zuschlag",
      "prixDAchatInitial": "Ursprünglicher Kaufpreis",
      "ex12000": "Z. B. 12000",
      "dateDAchat": "Kaufdatum",
      "suggestionBaseeSurInflationMargeRemplacement": "💡 Vorschlag auf Grundlage von Inflation und Wiederbeschaffungszuschlag",
      "utiliserCetteValeur": "Diesen Wert verwenden",
      "documentsJustificatifs": "📎 Nachweisdokumente",
      "factureDAchatRecuFortementRecommande": "Kaufrechnung / Beleg (dringend empfohlen)",
      "sourcesComparablesOptionnel": "Vergleichsquellen (optional)",
      "exArtpriceChristieSSothebyS": "Z. B. Artprice, Christie's, Sotheby's...",
      "etatDeConservation": "Erhaltungszustand",
      "tresBon": "Sehr gut",
      "necessiteRestauration": "Restaurierung erforderlich",
      "analyserLeDossier": "Dokumentation analysieren →",
      "demanderUneExpertiseAgreee": "Anerkanntes Gutachten anfordern",
      "unExpertAgreeCnesPartenaireDArtkivVaEvaluer": "Ein CNES-anerkannter Partnerexperte von Artkiv bewertet Ihr Werk anhand folgender Kriterien:",
      "authenticiteCertificatsProvenanceSignature": "Authentizität: Zertifikate, Provenienz und Signatur",
      "etatDeConservationRestaurationsAlterations": "Erhaltungszustand: Restaurierungen und Veränderungen",
      "rareteEtDemandeDuMarcheActuel": "Seltenheit und aktuelle Marktnachfrage",
      "historiqueDeLUvreEtDeLArtiste": "Geschichte des Werks und des Künstlers",
      "comparablesRecentsVentesAuxEncheresGaleries": "Aktuelle Vergleichswerke aus Auktionen und Galerien",
      "tarifsIndicatifs": "💰 Unverbindliche Preise",
      "uvre10000": "Werk unter 10.000 €",
      "uvre10k100k": "Werk von 10.000 € bis 100.000 €",
      "uvre100000": "Werk über 100.000 €",
      "surDevis": "Auf Anfrage",
      "valeurEstimeeOptionnel": "Geschätzter Wert (optional)",
      "ex150000": "Z. B. 150000",
      "pourOrienterLExpertNonContractuel": "Zur Orientierung des Sachverständigen; unverbindlich",
      "messagePourLExpert": "Nachricht an den Sachverständigen",
      "informationsComplementairesUrgencePreferences": "Zusätzliche Informationen, Dringlichkeit, Wünsche...",
      "demandeEnvoyeeAuxExpertsArtkiv": "Anfrage an die Artkiv-Experten gesendet!",
      "demanderUnDevisExpert": "Expertenangebot anfordern",
      "contacterDirectement": "Direkt kontaktieren",
      "modifierLeDossier": "Dokumentation bearbeiten",
      "analyseDeVotreDossier": "Analyse Ihrer Dokumentation",
      "forceDeJustification": "Aussagekraft der Nachweise",
      "scoreBaseSur": "Bewertung auf Grundlage von",
      "criteres": "Kriterien",
      "typeDAssuranceRecommande": "Empfohlene Versicherungsart",
      "assuranceSpecialiseeObjetDArt": "Spezialversicherung für Kunstobjekte",
      "extensionAssuranceHabitation": "Erweiterung der Hausratversicherung",
      "primeEstimee": "Geschätzte Prämie: ca.",
      "an": "pro Jahr",
      "dossierSolide": "✅ Belastbare Dokumentation",
      "dossierARenforcer": "⚠️ Dokumentation ausbaufähig",
      "dossierInsuffisant": "❌ Unzureichende Dokumentation",
      "ajoutezUneFactureDAchat": "Kaufrechnung hinzufügen",
      "cEstLeJustificatifLePlusImportant": ": sie ist der wichtigste Nachweis",
      "expertiseObligatoire": "Gutachten erforderlich",
      "votreUvreDepasse80000": ": Ihr Werk übersteigt 80.000 €",
      "ajoutezDes": "Fügen Sie",
      "sourcesDeComparables": "Vergleichsquellen",
      "artpriceMaisonsDeVentes": "von Artprice oder Auktionshäusern hinzu",
      "completezL": "Vervollständigen Sie die",
      "historiqueDeProvenance": "Provenienzhistorie",
      "dansLaFicheUvre": "im Datensatz des Werks",
      "etatMoyenEnvisagezUne": "Mittlerer Zustand: Ziehen Sie eine",
      "avantAssurance": "vor Abschluss der Versicherung in Betracht",
      "prochainesEtapes": "Nächste Schritte",
      "dossierEnregistreDansLUvre": "Dokumentation beim Werk gespeichert!",
      "enregistrerDansLUvre": "Beim Werk speichern",
      "retourALaFiche": "Zurück zum Werk",
      "contacterUnCourtierPartenaire": "Partner-Makler kontaktieren",
      "aSavoirSurLAssurance": "📋 Wissenswertes zur Versicherung",
      "renouvellementExpertise": "Erneuerung des Gutachtens",
      "tousLes10AnsArtAncienOu2Ans": ": alle 10 Jahre bei alter Kunst oder alle 2 Jahre bei zeitgenössischer Kunst",
      "couvertureClouAClou": "„Nagel-zu-Nagel“-Deckung",
      "protegeDurantTransportEtExpositionTemporaire": ": schützt das Werk während Transport und vorübergehender Ausstellung",
      "verifiezLeMontantSouvent510DeLaValeur": ": prüfen Sie die Selbstbeteiligung, häufig 5–10 % des Werts",
      "securite": "Sicherheit",
      "certainsAssureursExigentAlarmeCoffreOuSurveillance": ": manche Versicherer verlangen Alarmanlage, Safe oder Überwachung",
      "declarationModification": "Änderungen melden",
      "informezVotreAssureurDeTouteRestaurationOuChangementD": ": informieren Sie Ihren Versicherer über Restaurierungen oder Zustandsänderungen",
      "ressourcesUtiles": "Nützliche Ressourcen",
      "expertsPartenairesArtkiv": "Artkiv-Partnerexperten",
      "demanderUneMiseEnRelation": "→ Vermittlung anfordern",
      "annuaireCnesExpertsAgrees": "→ CNES-Verzeichnis anerkannter Sachverständiger",
      "courtiersSpecialises": "Spezialisierte Makler",
      "nosCourtiersPartenaires": "→ Unsere Partner-Makler",
      "guideAssuranceUvresDArt": "→ Leitfaden zur Versicherung von Kunstwerken",
      "pourLesFamilyOffices": "Für Family Offices:",
      "artkivProposeUnServiceDedieDeGestionPatrimonialeIncluant": "Artkiv bietet einen spezialisierten Vermögensverwaltungsservice mit Gutachten, Gesamtversicherung und Steueroptimierung.",
      "contactezNotreEquipe": "Unser Team kontaktieren",
      "conditionExcellent": "Ausgezeichnet",
      "conditionGood": "Gut",
      "conditionFair": "Mittel",
      "franchise": "Selbstbehalt",
      "restoration": "Restaurierung"
    }
  },
  "auth": {
    "required": {
      "title": "Anmeldung erforderlich",
      "text": "Melden Sie sich an, um auf Ihr Profil zuzugreifen."
    },
    "login": "Anmelden"
  },
  "sharedDashboard": {
    "common": {
      "untitled": "Ohne Titel",
      "client": "Kunde",
      "clientNumber": "Kunde #{{id}}",
      "ownCollection": "Meine Sammlung"
    },
    "report": {
      "defaultTitle": "Bericht — {{collection}}",
      "noArtworks": "Diese Sammlung enthält keine Kunstwerke.",
      "generateError": "Der Bericht konnte nicht erstellt werden.",
      "title": "Bericht erstellen",
      "loadingArtworks": "Kunstwerke werden geladen…",
      "artworkCount": "{{count}} Kunstwerk in dieser Sammlung",
      "artworkCount_plural": "{{count}} Kunstwerke in dieser Sammlung",
      "artworkCount_one": "{{count}} Kunstwerk in dieser Sammlung",
      "artworkCount_other": "{{count}} Kunstwerke in dieser Sammlung",
      "titleLabel": "Berichtstitel",
      "includedContent": "Enthaltene Inhalte",
      "options": {
        "title": "Werktitel",
        "artist": "Künstler",
        "medium": "Technik",
        "dimensions": "Abmessungen",
        "price": "Schätzung / Preis",
        "location": "Standort",
        "thumbnail": "Miniaturbilder",
        "date": "Berichtsdatum"
      },
      "coBrandingPrefix": "Der Bericht wird mit Ihrem Logo versehen, wenn Sie es unter folgendem Punkt hinterlegt haben:",
      "profileIdentity": "Profil → Berufliche Identität",
      "cancel": "Abbrechen",
      "generating": "Wird erstellt…",
      "downloadPdf": "PDF herunterladen"
    },
    "tabs": {
      "collections": "Sammlungen ({{count}})",
      "artworks": "Kunstwerke ({{count}})"
    },
    "searchPlaceholder": "Suchen…",
    "allClients": "Alle Kunden",
    "sort": {
      "recentlyUpdated": "Zuletzt geändert",
      "recentlyCreated": "Zuletzt erstellt",
      "name": "Name (A-Z)",
      "ascending": "Aufsteigend",
      "descending": "Absteigend"
    },
    "reload": "Neu laden",
    "errors": {
      "load": "Die geteilten Daten konnten nicht geladen werden."
    },
    "loading": "Daten werden geladen…",
    "empty": {
      "collection": "Keine geteilten Sammlungen",
      "artwork": "Keine geteilten Kunstwerke"
    },
    "badges": {
      "shared": "GETEILT",
      "edit": "BEARBEITUNG",
      "view": "NUR LESEN"
    },
    "labels": {
      "client": "Kunde:",
      "modifiedOn": "Geändert am {{date}}"
    },
    "actions": {
      "viewCollection": "Sammlung ansehen →",
      "viewArtwork": "Kunstwerk ansehen →",
      "reportPdf": "↓ PDF-Bericht",
      "present": "▶ Präsentieren"
    }
  },
  "sharedPresentation": {
    "errors": {
      "expired": "Dieser Präsentationslink ist abgelaufen.",
      "invalid": "Dieser Präsentationslink ist nicht mehr gültig.",
      "generic": "Auf diese Präsentation kann nicht zugegriffen werden."
    },
    "loading": "Präsentation wird geladen…",
    "accessDenied": "Zugriff verweigert",
    "backToArtkiv": "Zurück zu Artkiv"
  },
  "sharePresentationModal": {
    "title": "Präsentation teilen",
    "close": "Schließen",
    "description": "Erstellen Sie einen temporären Link, um diese Sammlung mit Ihrem Kunden zu teilen. Die Präsentation kann ohne Anmeldung auf jedem Gerät geöffnet werden.",
    "expiryLabel": "Gültigkeitsdauer des Links:",
    "duration": {
      "hour_one": "{{count}} Stunde",
      "hour_other": "{{count}} Stunden",
      "day_one": "{{count}} Tag",
      "day_other": "{{count}} Tage"
    },
    "generating": "Wird erstellt…",
    "generate": "Link erstellen",
    "scanMobile": "Scannen, um die Präsentation mobil zu öffnen",
    "copied": "✓ Kopiert",
    "copy": "Kopieren",
    "expiresOn": "Gültig bis:",
    "directAccess": "Dieser Link ermöglicht direkten Zugriff auf die Präsentation ohne Authentifizierung.",
    "revoke": "Link widerrufen",
    "errors": {
      "create": "Der Link konnte nicht erstellt werden.",
      "revoke": "Der Link konnte nicht widerrufen werden.",
      "empty": "Der Freigabelink konnte nicht erstellt werden."
    }
  },
  "sharingSettings": {
    "title": "Freigegebene Experten",
    "empty": "Derzeit ist kein Experte freigegeben"
  },
  "sharedAccessManager": {
    "title": "Geteilte Zugriffe",
    "stats": "{{experts}} Experte(n) • {{users}} Benutzer",
    "loading": "Wird geladen…",
    "empty": "Derzeit keine geteilten Zugriffe",
    "errors": {
      "load": "Die geteilten Zugriffe konnten nicht geladen werden.",
      "revoke": "Der Zugriff konnte nicht entfernt werden.",
      "update": "Die Lese- oder Bearbeitungsrechte konnten nicht aktualisiert werden."
    },
    "sections": {
      "experts": "Experten ({{count}})",
      "users": "Weitere Benutzer ({{count}})"
    },
    "fallback": {
      "collection": "Unbenannte Sammlung",
      "allCollections": "Alle Sammlungen",
      "user": "Benutzer",
      "expert": "Experte"
    },
    "certified": "Zertifiziert",
    "sharedCollections": "Geteilte Sammlungen ({{count}})",
    "sharedOn": "Geteilt am {{date}}",
    "permission": {
      "edit": "Bearbeiten",
      "view": "Nur lesen",
      "switchConfirm": "Berechtigungen von {{name}} für „{{collection}}“ ändern?",
      "toView": "Auf nur lesen umstellen",
      "toEdit": "Bearbeitung aktivieren"
    },
    "revoke": {
      "collectionConfirm": "Zugriff von {{name}} auf „{{collection}}“ entfernen?",
      "collectionTitle": "Diese Sammlung entfernen",
      "allConfirm": "Alle Zugriffe von {{name}} entfernen?",
      "allTitle": "Alle Zugriffe entfernen",
      "button": "Entfernen"
    },
    "roles": {
      "user": "Benutzer",
      "familyOffice": "Family Office",
      "expert": "Experte",
      "team": "Team"
    },
    "plan": "Tarif: {{plan}}"
  },
  "sharedCollectionsList": {
    "loading": "Wird geladen…",
    "empty": "Keine geteilten Sammlungen.",
    "fallbackTitle": "Sammlung",
    "view": "Sammlung ansehen"
  },
  "artistQuoteTools": {
    "common": {
      "artistPlaceholder": "Name des Künstlers"
    },
    "mediums": {
      "huile": "Öl auf Leinwand",
      "huile_sur_toile": "Öl auf Leinwand",
      "aquarelle": "Aquarell",
      "dessin": "Zeichnung",
      "sculpture": "Skulptur"
    },
    "mediumBreakdown": {
      "title": "Aufschlüsselung nach Technik",
      "averagePrice": "Durchschnittspreis: {{value}}",
      "analyzed": "{{count}} Werk analysiert",
      "analyzed_one": "{{count}} Werk analysiert",
      "analyzed_other": "{{count}} Werke analysiert"
    },
    "formatAnalysis": {
      "title": "Analyse nach Format",
      "formatLabel": "Format {{format}}",
      "formats": {
        "petit": "klein",
        "moyen": "mittel",
        "grand": "groß"
      },
      "averagePrice": "Durchschnittspreis: {{value}} ({{count}} Werk)",
      "averagePrice_one": "Durchschnittspreis: {{value}} ({{count}} Werk)",
      "averagePrice_other": "Durchschnittspreis: {{value}} ({{count}} Werke)",
      "noData": "Keine Daten verfügbar"
    },
    "trendAlerts": {
      "positive": "🚀 Starker Anstieg: +{{value}} % in den letzten 6 Monaten.",
      "negative": "📉 Starker Rückgang: −{{value}} % in den letzten 6 Monaten."
    },
    "engine": {
      "title": "Schätzung des Künstler-Marktwerts",
      "widthPlaceholder": "Breite (cm)",
      "heightPlaceholder": "Höhe (cm)",
      "mediumLabel": "Technik",
      "periodLabel": "Künstlerische Periode",
      "periods": {
        "major": "Hauptperiode",
        "minor": "Nebenperiode",
        "neutral": "Neutrale Periode"
      },
      "pricePerSqM": "Durchschnittspreis pro m² (€)",
      "estimate": "Schätzung: {{value}}"
    },
    "iaAlert": {
      "title": "KI-Warnung erstellen",
      "types": {
        "vente_recommandee": "Verkauf empfohlen",
        "hausse_cote": "Marktwertanstieg",
        "baisse_cote": "Marktwertrückgang"
      },
      "messagePlaceholder": "Warnmeldung",
      "save": "Warnung speichern",
      "saved": "Warnung gespeichert.",
      "error": "Die Warnung konnte nicht gespeichert werden: {{message}}"
    },
    "quoteForm": {
      "title": "Künstlerbewertung hinzufügen",
      "averageValue": "Durchschnittswert (€)",
      "pricePerSqM": "Durchschnittspreis pro m² (€)",
      "notesPlaceholder": "Quelle oder Kommentar (z. B. Artprice, Verkäufe 2024…)",
      "save": "Speichern",
      "success": "Künstlerbewertung erfolgreich gespeichert!",
      "error": "Fehler: {{message}}"
    },
    "chart": {
      "noData": "Für diesen Künstler und diese Technik wurden keine Daten gefunden.",
      "title": "Entwicklung des Marktwerts",
      "averageValue": "Durchschnittswert"
    },
    "dashboard": {
      "title": "Dashboard: {{artist}}"
    }
  },
  "museumProposalPayment": {
    "loading": "Zahlung wird geladen",
    "errors": {
      "createPayment": "Die Zahlung konnte nicht erstellt werden.",
      "payment": "Die Zahlung konnte nicht abgeschlossen werden."
    },
    "checkout": {
      "processing": "Verarbeitung läuft…",
      "pay": "{{amount}} zzgl. MwSt. bezahlen"
    },
    "title": {
      "auction": "Service für Auktionsplatzierung",
      "institution": "Service für institutionelle Platzierung"
    },
    "summary": {
      "title": "Zusammenfassung Ihrer Anfrage",
      "artwork": "Kunstwerk",
      "target": {
        "auction": "Ziel-Auktionshaus",
        "institution": "Zielinstitution"
      },
      "service": "Service",
      "serviceName": {
        "auction": "Platzierung in einer Auktion",
        "institution": "Platzierung bei einer Institution"
      },
      "initialAmount": "Anfangsbetrag",
      "amountExVat": "{{amount}} zzgl. MwSt."
    },
    "partner": {
      "team": "Artkiv-Team"
    },
    "service": {
      "title": "Serviceleistung",
      "partner": "Unser Partner: {{name}}",
      "partnerDescription": {
        "auction": "Ein auf Auktionen und Kunstgutachten spezialisiertes Team",
        "institution": "Eine Expertin für die Platzierung von Werken bei Kulturinstitutionen"
      },
      "includesTitle": "Der Service umfasst",
      "includes": {
        "auction": {
          "1": "Bewertung des Werks und Ermittlung seines Werts auf dem Auktionsmarkt",
          "2": "Empfehlungen zu den am besten geeigneten Spezialauktionen",
          "3": "Vermittlung an spezialisierte Auktionatoren",
          "4": "Verhandlung der Verkaufsbedingungen einschließlich Gebühren und Mindestpreis",
          "5": "Begleitung bis zum endgültigen Verkauf"
        },
        "institution": {
          "1": "Analyse des Werks und seines Potenzials für die Zielinstitution",
          "2": "Professionelle Erstellung eines individuellen Präsentationsschreibens",
          "3": "Direkter Kontakt zu Kuratoren und Erwerbsteams",
          "4": "Sechsmonatige Begleitung des Vorschlags",
          "5": "Monatlicher Fortschrittsbericht"
        }
      }
    },
    "pricing": {
      "title": "Preise",
      "fixed": "Festpreis: {{amount}} zzgl. MwSt. (jetzt zahlbar)",
      "hourly": "Zusätzliche Arbeiten: 80 € zzgl. MwSt. pro Stunde",
      "commission": {
        "auction": "Provision bei Auktionsverkauf: abhängig vom Werkwert, wie in den Geschäftsbedingungen erläutert",
        "institution": "Provision bei Verkauf: abhängig vom Werkwert, wie in den Geschäftsbedingungen erläutert"
      }
    },
    "paymentTitle": "Zahlung",
    "legal": {
      "acceptance": "Mit der Zahlung akzeptieren Sie unsere <terms>Servicebedingungen</terms>.",
      "additionalInvoices": "Zusätzliche Stunden werden Ihnen vor der Rechnungsstellung zur Genehmigung vorgelegt."
    }
  },
  "proposalCancelled": {
    "fallbackArtwork": "Ihr Kunstwerk",
    "title": "Anfrage storniert",
    "subtitle": "Die Serviceanfrage für {{artwork}} wurde storniert.",
    "noCharge": "Ihre Anfrage wurde erfolgreich storniert. Es entstehen keine Kosten.",
    "help": "Für eine spätere neue Anfrage oder bei Fragen wenden Sie sich an unser Team.",
    "back": "Zurück zu meinem Dashboard"
  },
  "upcomingAuctions": {
    "loading": "Kommende Auktionen werden geladen…",
    "error": "Fehler: {{message}}",
    "empty": {
      "title": "Keine kommenden Auktionen",
      "description": "Kommende Auktionen werden hier in Kürze angezeigt.",
      "text": "Bevorstehende Auktionen werden hier angezeigt."
    },
    "title": "Kommende Auktionen",
    "subtitle": "Internationale Auktionshäuser · Weltweite Top 10",
    "filters": {
      "allHouses": "Alle Auktionshäuser",
      "ariaLabel": "Nach Auktionshaus filtern"
    },
    "saleCount": "{{count}} Auktion(en)",
    "saleCount_one": "{{count}} Auktion",
    "saleCount_other": "{{count}} Auktionen",
    "saleCount_plural": "{{count}} Auktionen",
    "topRank": "Top {{rank}}",
    "openWebsite": "Website von {{house}} öffnen",
    "footer": "{{count}} kommende Auktion(en) · Täglich aktualisiert",
    "footer_one": "{{count}} kommende Auktion · Täglich aktualisiert",
    "footer_other": "{{count}} kommende Auktionen · Täglich aktualisiert",
    "footer_plural": "{{count}} kommende Auktionen · Täglich aktualisiert",
    "allHouses": "Alle Auktionshäuser",
    "salesCount": "{{count}} Auktionen"
  },
  "requireStaff": {
    "checkingAccess": "Ihre Zugriffsrechte werden geprüft…"
  },
  "refPricingAdmin": {
    "title": "Preisreferenzen (ref_pricing)",
    "newRule": "+ Neue Regel",
    "searchPlaceholder": "Suche (Bewegung, Medium, Künstler, Quelle)",
    "refresh": "↻ Aktualisieren",
    "loading": "Wird geladen…",
    "empty": "Keine Regeln",
    "page": "Seite {{page}}",
    "previous": "Zurück",
    "next": "Weiter",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "confirmDelete": "Diese Regel löschen?",
    "deleteError": "Die Regel konnte nicht gelöscht werden: {{message}}",
    "loadError": "Die Regeln konnten nicht geladen werden: {{message}}",
    "sort": {
      "newest": "Neueste",
      "oldest": "Älteste",
      "priceDesc": "€/m² ↓",
      "priceAsc": "€/m² ↑",
      "confidenceDesc": "Vertrauen ↓",
      "confidenceAsc": "Vertrauen ↑"
    },
    "table": {
      "movement": "Bewegung",
      "artist": "Künstler",
      "medium": "Medium",
      "minCm2": "min. cm²",
      "maxCm2": "max. cm²",
      "pricePerM2": "€/m²",
      "lowPct": "− %",
      "highPct": "+ %",
      "recency": "Aktualität",
      "confidence": "Vertrauen",
      "created": "Erstellt",
      "actions": "Aktionen"
    },
    "fields": {
      "artistOptional": "Künstler (optional)",
      "movement": "Bewegung",
      "medium": "Medium",
      "minCm2": "min. cm²",
      "maxCm2": "max. cm²",
      "pricePerM2": "€/m²",
      "lowPct": "− % (niedrig)",
      "highPct": "+ % (hoch)",
      "recencyMonths": "Aktualität (Monate)",
      "sourceNote": "Quelle / Notiz",
      "confidence": "Vertrauen (0–100)"
    },
    "editor": {
      "editTitle": "Regel bearbeiten",
      "newTitle": "Neue Regel",
      "close": "Schließen",
      "save": "Speichern",
      "saving": "Wird gespeichert…",
      "saved": "✅ Gespeichert",
      "saveError": "❌ {{message}}"
    }
  },
  "adminInvite": {
    "title": "Teammitglied einladen",
    "email": "E-Mail",
    "submit": "Einladen",
    "sending": "Wird gesendet…",
    "success": "Einladung gesendet ✅",
    "errorFallback": "Einladung fehlgeschlagen",
    "error": "Fehler: {{message}}",
    "role": {
      "label": "Rolle",
      "expert": "Experte",
      "team": "Team",
      "admin": "Administrator"
    },
    "plan": {
      "label": "Tarif",
      "standard": "Standard",
      "premium": "Premium"
    },
    "description": "Die Einladung erstellt den Benutzer anhand der E-Mail-Adresse, initialisiert das Profil mit der gewählten Rolle und dem Tarif und markiert das Profil als genehmigt."
  },
  "estimationComparableForm": {
    "title": "Vergleichsverkauf hinzufügen",
    "success": "✅ Verkauf erfolgreich in realized_sales gespeichert",
    "saving": "Wird gespeichert…",
    "cancel": "Abbrechen",
    "add": "Hinzufügen",
    "errors": {
      "missingArtwork": "Diesem Vergleichsverkauf ist kein Kunstwerk zugeordnet.",
      "insert": "Der Vergleichsverkauf konnte nicht gespeichert werden: {{message}}"
    },
    "fields": {
      "sourceType": {
        "label": "Quelle (Website, Presse usw.)",
        "placeholder": "Sotheby’s, Handelsblatt usw."
      },
      "title": "Werktitel",
      "artist": "Künstler",
      "estimatedValue": "Geschätzter Wert (€)",
      "exactSource": "Genaue Quelle (Link, Zitat …)",
      "medium": "Medium / Träger",
      "dimensions": {
        "label": "Abmessungen (cm)",
        "height": "Höhe",
        "width": "Breite",
        "depth": "Tiefe"
      },
      "comment": "Kommentar (optional)"
    }
  },
  "pendingProfiles": {
    "loading": "Ausstehende Profile werden geladen…",
    "title": "🛂 Zu genehmigende Profile",
    "empty": "Keine neuen Profile warten auf Genehmigung.",
    "approve": "✅ Genehmigen",
    "approving": "Wird genehmigt…",
    "notProvided": "Nicht angegeben",
    "contact": "📧 {{email}} | 📞 {{phone}}",
    "createdAt": "Erstellt am: {{date}}",
    "errors": {
      "load": "Profile konnten nicht geladen werden: {{message}}",
      "approve": "Dieses Profil konnte nicht genehmigt werden: {{message}}"
    }
  },
  "myValidationRequests": {
    "loading": "Ihre Anfragen werden geladen…",
    "title": "Meine Validierungsanfragen",
    "count": "{{count}} Anfrage(n)",
    "count_one": "{{count}} Anfrage",
    "count_other": "{{count}} Anfragen",
    "count_plural": "{{count}} Anfragen",
    "empty": "Sie haben noch keine Validierungsanfrage gestellt.",
    "createEstimate": "Schätzung erstellen",
    "untitledArtwork": "Werk ohne Titel",
    "requestedAt": "Angefragt am {{date}}",
    "status": {
      "pending": "Ausstehend",
      "in_progress": "In Bearbeitung",
      "completed": "Validiert",
      "rejected": "Abgelehnt"
    },
    "method": {
      "label": "Methode:",
      "points": "Punktemethode",
      "comparables": "Vergleichswerte"
    },
    "cost": {
      "label": "Kosten:",
      "free": "Kostenlos"
    },
    "expertNotes": "Notizen des Experten:",
    "rejectionReason": "Ablehnungsgrund:",
    "downloadReport": "Bericht herunterladen",
    "processingDelay": "⏱️ Ihre Anfrage wird bearbeitet. Geschätzte Dauer: 48 bis 72 Geschäftsstunden.",
    "errors": {
      "load": "Ihre Anfragen konnten nicht geladen werden: {{message}}"
    }
  },
  "icmsSubscription": {
    "title": "Bewertung anhand ähnlicher Werke — ICMS",
    "intro": "⚠️ Die Bewertung bleibt <strong>durch einen menschlichen Experten validiert</strong>. KI und ICMS-Berechnungen bilden eine nachvollziehbare und erklärbare Grundlage.",
    "common": {
      "untitled": "Ohne Titel",
      "unknownArtwork": "Unbekanntes Werk"
    },
    "errors": {
      "load": "Die Daten konnten nicht geladen werden: {{message}}"
    },
    "alerts": {
      "maxExternal": "Sie können höchstens fünf externe Vergleichswerte hinzufügen.",
      "selectArtwork": "Wählen Sie ein Kunstwerk aus.",
      "staffFallbackRequired": "Weniger als drei Vergleichswerte: Fallback-Felder ausfüllen (Abmessungen + €/m²).",
      "clientVerificationRequired": "Weniger als drei Vergleichswerte: Fordern Sie eine Artkiv-Prüfung für die formatbasierte Berechnung an.",
      "humanValidationRequired": "Eine menschliche Validierung ist erforderlich: Bestätigungsfeld markieren.",
      "notLoggedIn": "Benutzer ist nicht angemeldet.",
      "reportUploadError": "Der Bericht konnte nicht hochgeladen werden.",
      "requestError": "Die Prüfungsanfrage konnte nicht gespeichert werden: {{message}}",
      "saveError": "Die Bewertung konnte nicht gespeichert werden: {{message}}",
      "saved": "ICMS-Bewertung gespeichert und Bericht erstellt."
    },
    "artwork": {
      "label": "Zu bewertendes Kunstwerk",
      "placeholder": "Kunstwerk auswählen"
    },
    "internalComparables": {
      "title": "Interne Vergleichswerke auswählen",
      "noValue": "Kein Schätzwert",
      "valuePlaceholder": "Wert €",
      "missingValue": "Wert fehlt: Artkiv-Prüfung anfordern"
    },
    "externalComparables": {
      "title": "Externe Vergleichswerte hinzufügen (bis zu 5)",
      "add": "Externes Vergleichswerk hinzufügen",
      "remove": "Entfernen",
      "fields": {
        "title": "Titel",
        "artist": "Künstler",
        "source": "Quelle (Website, Presse)",
        "medium": "Medium",
        "dimensions": "Abmessungen",
        "value": "Geschätzter Wert (€)",
        "date": "Verkaufs- oder Veröffentlichungsdatum",
        "comment": "Kommentar"
      }
    },
    "subscription": {
      "standard": "⚠️ Ihr Tarif ist <strong>Standard</strong>: Eine Prüfung durch das Artkiv-Team kann erforderlich sein.",
      "premium": "✅ Ihr Tarif ist <strong>Premium</strong>: Eine monatliche Prüfung durch das Artkiv-Team ist enthalten.",
      "requestVerification": "Artkiv-Prüfung anfordern",
      "requesting": "Anfrage wird gesendet…",
      "requestSaved": "✅ Anfrage gespeichert",
      "lastVerification": "Letzte Prüfung: {{date}}",
      "nextDue": "— Nächster Termin: {{date}}"
    },
    "fallback": {
      "title": "Fallback „Preis nach Format“",
      "active": "Aktiv (weniger als drei Vergleichswerte)",
      "inactive": "Inaktiv",
      "staffDescription": "Nur für das Team: Geben Sie Abmessungen und den von der Galerie verwendeten Quadratmeterpreis ein. Dieser Wert wird nur für diese Berechnung verwendet und bleibt der menschlichen Validierung unterstellt.",
      "height": "Höhe (cm)",
      "width": "Breite (cm)",
      "basePrice": "Grundpreis (€/m²)",
      "surface": "Fläche: {{area}} m²",
      "autoSwitch": "Sobald drei oder mehr Vergleichswerte vorhanden sind, hat ICMS automatisch Vorrang.",
      "clientDescription": "Bei weniger als drei Vergleichswerten muss die formatbasierte Berechnung durch das Artkiv-Team bestätigt werden. Verwenden Sie oben die Schaltfläche zur Prüfungsanfrage."
    },
    "values": {
      "title": "Berechnete Werte",
      "icmsBase": "ICMS (Basis):",
      "fmv": "FMV (nach Anpassungen):",
      "retailReplacement": "Wiederbeschaffungswert (Versicherung):",
      "succession": "Nachlasswert:"
    },
    "confidence": {
      "title": "Vertrauensscore",
      "volume": "Anzahl Vergleichswerte: {{score}}/35",
      "dispersion": "Preisstreuung: {{score}}/35",
      "diversity": "Quellenvielfalt: {{score}}/10",
      "recency": "Aktualität (≤ 24 Monate): {{score}}/20"
    },
    "explain": {
      "title": "Erklärbare KI — Gewichtung der Quellen",
      "description": "Diese Prozentsätze zeigen, welche Quellen die Bewertung konkret beeinflussen, und erhöhen die Transparenz der Berechnung.",
      "factors": {
        "sameArtistNamed": "Aktuelle Verkäufe desselben Künstlers ({{artist}})",
        "sameArtist": "Aktuelle Verkäufe desselben Künstlers",
        "movementNamed": "Aktuelle Verkäufe der Richtung {{movement}}",
        "similarContemporary": "Aktuelle Verkäufe ähnlicher zeitgenössischer Künstler",
        "internalComparables": "Interne Vergleichswerte (Kundensammlung)",
        "otherExternalSales": "Weitere externe Verkäufe",
        "aiTrendAdjustment": "KI-Trendanpassung",
        "expertAdjustment": "Expertenanpassung",
        "recentExternalSales": "Aktuelle externe Verkäufe",
        "aiExpertAdjustment": "KI-/Expertenanpassung"
      }
    },
    "movements": {
      "impressionism": "Impressionismus",
      "streetArt": "Street Art",
      "contemporaryAbstraction": "zeitgenössische Abstraktion",
      "contemporaryFigurative": "zeitgenössische figurative Kunst",
      "digitalNft": "digitale Kunst / NFT",
      "other": "ähnliche Richtung"
    },
    "advanced": {
      "show": "Erweiterte Einstellungen anzeigen",
      "hide": "Erweiterte Einstellungen ausblenden",
      "title": "Gewichtungen und Anpassungen",
      "internalWeight": "Gewicht interner Vergleichswerte (%)",
      "externalWeight": "Gewicht externer Vergleichswerte (%)",
      "aiTrend": "KI-Trendanpassung (%)",
      "expertAdjustment": "Expertenanpassung (%)",
      "insuranceMarkup": "Versicherungsaufschlag (%)",
      "successionDiscount": "Nachlassabschlag (%)",
      "hint": "Halten Sie die Summe der Gewichte nahe bei 100% (intern + extern). Sie wird automatisch normalisiert, wenn eine Vergleichsgruppe leer ist."
    },
    "validation": {
      "label": "Ich bestätige, dass ich diese Bewertung als Experte oder Galerieprofi <strong>geprüft und validiert</strong> habe."
    },
    "actions": {
      "save": "Bewertung speichern und PDF erstellen",
      "cancel": "Abbrechen"
    },
    "pdf": {
      "title": "Bewertungsbericht — Methode ähnlicher Werke (ICMS)",
      "date": "Datum: {{date}}",
      "artwork": "Bewertetes Werk: {{title}}",
      "calculatedValues": "Berechnete Werte:",
      "icmsBase": "• ICMS (Basis): {{value}}",
      "fmv": "• Fair Market Value (nach Anpassungen): {{value}}",
      "retailReplacement": "• Wiederbeschaffungswert (Versicherung): {{value}}",
      "successionValue": "• Nachlasswert: {{value}}",
      "fallbackMode": "Fallback „Preis nach Format“ aktiv — {{area}} m² × {{price}} €/m²",
      "icmsDetails": "ICMS-Details:",
      "internalMean": "• Robuster interner Mittelwert: {{value}} — Gewicht {{weight}}%",
      "externalMean": "• Robuster externer Mittelwert: {{value}} — Gewicht {{weight}}%",
      "adjustments": "• KI-Trendanpassung: {{ai}}% — Expertenanpassung: {{expert}}%",
      "markups": "• Versicherungsaufschlag: +{{insurance}}% — Nachlassabschlag: −{{succession}}%",
      "confidenceBreakdown": "Vertrauensscore — Aufschlüsselung:",
      "volume": "• Anzahl Vergleichswerte: {{score}}/35",
      "dispersion": "• Preisstreuung: {{score}}/35",
      "diversity": "• Quellenvielfalt: {{score}}/10",
      "recency": "• Aktualität (≤ 24 Monate): {{score}}/20",
      "explainability": "KI-Erklärung:",
      "factorLine": "• {{weight}}% — {{label}}",
      "internalComparables": "Interne Vergleichswerte:",
      "externalComparables": "Externe Vergleichswerte:",
      "comparableLine": "• {{title}} — {{artist}} {{date}} — {{value}} — {{source}}"
    }
  },
  "artworkImages": {
    "alt": {
      "main": "Hauptbild des Kunstwerks",
      "primary": "Hauptbild",
      "thumbnail": "Miniatur {{id}}",
      "view": "Ansicht {{id}}"
    },
    "selected": "Ausgewählt",
    "primary": "Hauptbild",
    "addImage": "Bild hinzufügen",
    "deleteConfirm": "Dieses Bild löschen?",
    "deleteTitle": "Dieses Bild löschen",
    "formats": "Unterstützte Formate: JPEG, PNG, WEBP",
    "limit": "Limit: 10 Bilder (maximal 30 MB pro Bild)"
  },
  "artworkImageManager": {
    "quotaReached": "Sie haben die für Ihren Tarif zulässige Höchstzahl an Bildern erreicht.",
    "onlyRemaining": "Mit Ihrem Tarif können nur noch {{count}} zusätzliche Bild(er) hinzugefügt werden.",
    "uploadPrompt": "Bilder hier ablegen oder zum Hinzufügen klicken",
    "uploadDisabled": "Das Hinzufügen von Bildern ist deaktiviert",
    "formats": "Unterstützte Formate: JPEG, PNG, WEBP",
    "usage": "Verwendete Bilder: {{count}} / {{max}}",
    "unlimited": "unbegrenzt",
    "familyOfficeNote": "Im Family-Office-Tarif können nur Ihre Kunden Bilder hinzufügen oder bearbeiten. Sie verfügen über eine konsolidierte Ansicht.",
    "artworkAlt": "Kunstwerk",
    "primary": "Hauptbild",
    "setCover": "Als Titelbild festlegen",
    "deletePrimaryConfirm": "Das Hauptbild löschen? Ein anderes Bild wird automatisch zum Hauptbild.",
    "deleteConfirm": "Dieses Bild löschen?"
  },
  "artworkNft": {
    "title": "NFT & Blockchain",
    "subtitle": "Erfassen Sie die Blockchain-Daten eines bereits tokenisierten Werks",
    "info": {
      "title": "Blockchain bei ARTKIV",
      "body": "Dieser Tab erfasst die Daten eines bereits tokenisierten Werks (NFT oder On-Chain-Zertifikat). ARTKIV erstellt zudem einen SHA-256-Zeitstempel der Fiche; öffentliche Verankerung (z. B. Tezos) und Minting über einen Partner sind noch nicht aktiv.",
      "fingerprintCta": "ARTKIV-Fingerabdruck ansehen"
    },
    "smartstamp": {
      "title": "Blockchain-Zertifizierung",
      "body": "Dieses Kunstwerk wurde noch nicht zertifiziert. Mit unserem Partner SmartStamp können Sie eine sichere Blockchain-Zertifizierung erstellen.",
      "cta": "SmartStamp entdecken"
    },
    "certificationType": "Zertifizierungsart",
    "types": {
      "digital": {
        "label": "Digitales Kunstwerk",
        "description": "Authentifizierte digitale künstlerische Schöpfung"
      },
      "certificate": {
        "label": "Echtheitszertifikat",
        "description": "Blockchain-Zertifizierung eines physischen Kunstwerks"
      },
      "hybrid": {
        "label": "Hybrides Kunstwerk",
        "description": "Verbindung von physischer und digitaler Kunst"
      }
    },
    "blockchainOther": "Andere Blockchain",
    "contractAddress": "Vertragsadresse",
    "tokenId": "Token-ID",
    "tokenPlaceholder": "Token-Kennung",
    "provider": "Anbieter",
    "providerSelect": "Anbieter auswählen",
    "providerOther": "Andere",
    "mintDate": "Erstellungsdatum",
    "explorerLink": "Explorer-Link",
    "linkedPhysicalTitle": "Mit einem physischen Kunstwerk verknüpft",
    "linkedPhysicalDescription": "Diese Zertifizierung gehört zu einem physischen Kunstwerk",
    "certificateTitle": "Blockchain-Zertifikat"
  },
  "artworkLocationTab": {
    "lossTypes": {
      "vol": "Diebstahl",
      "perte": "Verlust",
      "destruction": "Zerstörung",
      "incendie": "Brand",
      "inondation": "Überschwemmung",
      "autre": "Sonstiges"
    },
    "locationTypes": {
      "museum": "Museum",
      "gallery": "Galerie",
      "home": "Wohnort",
      "residence": "Residenz",
      "warehouse": "Lagerhaus",
      "storage": "Lagerung",
      "loan": "Leihgabe",
      "exhibition": "Ausstellung",
      "other": "Sonstiges"
    },
    "lossModal": {
      "badge": "Meldung",
      "title": "Verlust · Diebstahl · Zerstörung",
      "untitled": "Unbenanntes Kunstwerk",
      "successTitle": "Meldung gespeichert",
      "successBody": "Den vollständigen Bericht finden Sie im Modul Verlust & Diebstahl.",
      "eventType": "Ereignisart",
      "eventDate": "Ereignisdatum",
      "declaredValue": "Deklarierter Wert (€)",
      "estimatedValue": "Geschätzter Wert",
      "location": "Ort zum Zeitpunkt des Ereignisses",
      "locationPlaceholder": "Z. B. Hauptwohnsitz, Galerie XY…",
      "policeReport": "Polizeianzeige erstattet",
      "policeRef": "Aktenzeichen der Polizei",
      "insuranceClaim": "Versicherungsschaden gemeldet",
      "insuranceRef": "Schadennummer",
      "indemnity": "Erhaltene Entschädigung (€)",
      "notes": "Zusätzliche Hinweise",
      "notesPlaceholder": "Umstände, Zeugen, beigefügte Dokumente…",
      "fiscalNote": "Steuerhinweis — In Frankreich können Verluste und Diebstähle von Kunstwerken unter bestimmten Voraussetzungen abzugsfähig sein. In der Regel ist eine polizeiliche Anzeige erforderlich. Wenden Sie sich an Ihren Notar oder Steuerberater.",
      "error": "Fehler beim Speichern.",
      "cancel": "Abbrechen",
      "saving": "Wird gespeichert…",
      "save": "Meldung speichern"
    },
    "lossStatus": {
      "incident": "Vorfall",
      "declared": "Kunstwerk gemeldet: {{type}}",
      "police": "Polizeianzeige"
    },
    "loan": {
      "outgoing": "Ausgehende Leihgabe",
      "contact": "Kontakt: {{value}}",
      "from": "Von {{date}}",
      "to": "bis {{date}}",
      "agreementRef": "Vertragsref.: {{value}}",
      "borrowerLocation": "Das Kunstwerk befindet sich derzeit bei der entleihenden Institution. Legen Sie nach Ende der Leihgabe wieder den üblichen Lagerort fest."
    },
    "currentLocation": "Aktueller Standort",
    "hiddenLocation": "Dieses Kunstwerk ist einem von Ihrem Kunden definierten Standort zugeordnet. Ihre aktuellen Berechtigungen erlauben es nicht, die Details einzusehen oder zu ändern.",
    "noLocation": "Für dieses Kunstwerk ist kein Standort definiert.",
    "defineLocation": "Standort festlegen",
    "declareLoss": "Verlust · Diebstahl · Zerstörung melden",
    "change": "Ändern",
    "fields": {
      "address": "Adresse",
      "city": "Stadt",
      "country": "Land",
      "contact": "Kontakt",
      "email": "E-Mail",
      "phone": "Telefon",
      "notes": "Notizen"
    },
    "history": "Standortverlauf",
    "available": "Weitere verfügbare Standorte",
    "viewAll": "Alle Standorte anzeigen ({{count}})",
    "manage": "Meine Standorte verwalten"
  },
  "artworkComparables": {
    "methods": {
      "cup_alleges": "Vereinfachte Vergleichsmethode (Zusammenfassung)",
      "cup_complet": "Vollständige CUP-Methode (dokumentierter Vergleich)",
      "cup_ifrs": "CUP — IFRS 13 / BOFiP"
    },
    "saveError": "Fehler beim Speichern: {{message}}",
    "unknownError": "Unbekannter Fehler",
    "title": "CUP-Bewertung",
    "subtitle": "Comparable-Uncontrolled-Price-Methode gemäß IFRS 13 / BOFiP",
    "saved": "Gespeichert",
    "save": "Bewertung speichern",
    "expertValueSection": "Marktwert nach Experteneinschätzung",
    "estimatedValue": "Geschätzter Wert (€ netto)",
    "estimatedPlaceholder": "Z. B. 4500",
    "method": "Methode",
    "select": "Auswählen…",
    "expertDate": "Bewertungsdatum",
    "range": "Spanne ±10 %:",
    "comparablesAverage": "Durchschnitt der Vergleichswerte:",
    "gapWarning": "Abweichung von mehr als 30 % zu den Vergleichswerten",
    "comparablesTitle": "Vergleichsverkäufe ({{count}}/mindestens 3)",
    "addComparable": "Vergleich hinzufügen",
    "empty": "Keine Vergleichswerte erfasst. Fügen Sie mindestens 3 Referenzverkäufe hinzu.",
    "firstComparable": "Ersten Vergleich hinzufügen",
    "comparable": "Vergleich {{number}}",
    "auctionHouse": "Auktionshaus",
    "auctionHousePlaceholder": "Z. B. Christie’s, Artcurial, Millon…",
    "saleDate": "Verkaufsdatum",
    "soldArtwork": "Titel / Beschreibung des verkauften Kunstwerks",
    "soldArtworkPlaceholder": "Z. B. signierte Lithografie, 45 × 60 cm, Auflage 20",
    "hammerPrice": "Zuschlagspreis (€)",
    "hammerPricePlaceholder": "Z. B. 3800",
    "adjustment": "Anpassung (%)",
    "adjustmentPlaceholder": "Z. B. -10 oder +5",
    "adjustedValue": "Angepasster Wert",
    "adjustmentNote": "Hinweis / Begründung der Anpassung",
    "adjustmentNotePlaceholder": "Z. B. kleineres Format, mittlerer Zustand, rückläufiger Markt",
    "expertNote": "Expertennotiz (im Bericht enthalten)",
    "expertNotePlaceholder": "Anmerkungen zu Zustand, Seltenheit, Markt und Provenienz… Diese Notiz wird in das CUP-Berichtsblatt aufgenommen.",
    "complete": "CUP-Blatt vollständig und berichtsfertig.",
    "missingValue": "Marktwert fehlt",
    "missingComparables": "{{count}} Vergleich(e) fehlen",
    "incomplete": "Unvollständiges Blatt: {{reason}}."
  },
  "artworkProvenance": {
    "title": "Provenienz",
    "add": "Eintrag hinzufügen",
    "empty": "Noch kein Provenienzeintrag vorhanden.",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "types": {
      "direct_artiste": "Direkt vom Künstler",
      "echange_production": "Tausch / Produktion",
      "galerie": "Galerie",
      "vente_privee": "Privatverkauf",
      "encheres": "Auktion",
      "succession": "Erbschaft / Nachlass",
      "don": "Schenkung",
      "collection_privee": "Privatsammlung",
      "autre": "Sonstiges"
    }
  },
  "artworkSpecifications": {
    "sections": {
      "dimensions": "Maße des Kunstwerks",
      "framed": "Gerahmte Maße",
      "paper": "Papiermaße",
      "duration": "Dauer"
    },
    "hints": {
      "dimensions": "Nur das Werk, ohne Rahmen oder Ränder (die „Ansicht“).",
      "framed": "Außenmaß inkl. Rahmen — nützlich für Hängung, Transport und Versicherung.",
      "paper": "Arbeiten auf Papier: Maße des gesamten Blattes, oft größer als das Bild."
    },
    "fields": {
      "height": "Höhe",
      "width": "Breite",
      "depth": "Tiefe",
      "unit": "Einheit",
      "framedHeight": "Gerahmte Höhe",
      "framedWidth": "Gerahmte Breite",
      "framedDepth": "Gerahmte Tiefe",
      "frameUnit": "Rahmeneinheit",
      "paperHeight": "Papierhöhe",
      "paperWidth": "Papierbreite",
      "paperUnit": "Papiereinheit"
    },
    "swapTitle": "Höhe und Breite vertauschen",
    "swap": "H/B tauschen",
    "units": {
      "inches": "Zoll"
    },
    "durationPlaceholder": "Z. B. 12 Min. 30 Sek., Videoschleife, temporäre Performance…"
  },
  "artworkDocumentsTab": {
    "view": "Ansehen",
    "loading": "Wird geladen…",
    "openError": "Dieses Dokument konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.",
    "title": "Dokumente",
    "deleteConfirm": "Dieses Dokument löschen?",
    "types": {
      "certificate": "Echtheitszertifikat",
      "invoice": "Rechnung",
      "condition_report": "Zustandsbericht",
      "exhibition": "Ausstellungsdokumente",
      "photo": "Hochauflösendes Foto",
      "other": "Sonstiges"
    },
    "loan": {
      "title": "Vertrag für ausgehende Leihgabe",
      "noReference": "Ohne Referenz",
      "institution": "Institution",
      "location": "Ort",
      "contact": "Kontakt",
      "start": "Beginn",
      "end": "Voraussichtliches Ende",
      "conditions": "Bedingungen",
      "empty": "Kunstwerk als Leihgabe. Tragen Sie Institution und Daten über den Bereich Bearbeiten ein."
    },
    "lot": {
      "title": "Dokumente des Loses — {{title}}",
      "add": "Zum Los hinzufügen",
      "referenceAlt": "Losreferenz",
      "referenceTitle": "Referenzfoto (Los)",
      "referenceSubtitle": "Gemeinsames Bild für alle Exemplare",
      "empty": "Keine gemeinsamen Dokumente für dieses Los.",
      "remove": "Aus dem Los entfernen"
    },
    "aiScore": "KI-Score:",
    "certificate": {
      "missingTitle": "Echtheitszertifikat fehlt",
      "missingBody": "Fügen Sie ein Zertifikat hinzu, um Wert und Rückverfolgbarkeit Ihres Kunstwerks zu erhöhen.",
      "classicTitle": "Klassisches Zertifikat erkannt",
      "classicBody": "Stärken Sie den Schutz mit einem datierten, fälschungssicheren Echtheitsnachweis.",
      "blockchainTitle": "Echtheitsnachweis bestätigt",
      "blockchainBody": "Ihr Kunstwerk verfügt über einen fälschungssicheren Echtheitsnachweis{{blockchain}}."
    },
    "empty": "Diesem Kunstwerk sind keine Dokumente zugeordnet",
    "addedOn": "Hinzugefügt am {{date}}",
    "reclassify": "Kategorie ändern",
    "add": "Dokument hinzufügen"
  },
  "ocrEnrich": {
    "fields": {
      "year": "Jahr",
      "dimensions": "Abmessungen",
      "medium": "Medium / Technik",
      "mediumCategory": "Kategorie",
      "acquisitionPrice": "Erwerbspreis",
      "acquisitionType": "Erwerbsart",
      "acquisitionDate": "Erwerbsdatum",
      "seller": "Schenker / Verkäufer",
      "buyer": "Begünstigter / Käufer",
      "title": "Titel",
      "artist": "Künstler",
      "signature": "Signatur",
      "authentication": "Zertifikat / Authentifizierung",
      "signatureNotes": "Hinweise zur Signatur",
      "auctionHouse": "Auktionshaus",
      "auctionSaleName": "Auktionsbezeichnung",
      "auctionSaleDate": "Auktionsdatum",
      "auctionLotNumber": "Losnummer",
      "auctionHammerPrice": "Zuschlagspreis (€)",
      "auctionFees": "Aufgeld und Gebühren"
    },
    "mediumCategory": {
      "painting": "Malerei",
      "photography": "Fotografie",
      "sculpture": "Skulptur",
      "print": "Druckgrafik",
      "drawing": "Zeichnung",
      "work_on_paper": "Arbeit auf Papier",
      "mixed_media": "Mischtechnik",
      "installation": "Installation",
      "film_video": "Film / Video",
      "digital": "Digitale Kunst",
      "ceramics": "Keramik",
      "textile": "Textil",
      "design": "Design",
      "other": "Sonstiges"
    },
    "button": {
      "title": "Metadaten aus den PDF-Dokumenten des Kunstwerks extrahieren",
      "analyzing": "Analyse läuft…",
      "enrich": "Mit OCR anreichern"
    },
    "documentTypes": {
      "invoice": "Rechnung / Zuschlagsbeleg / Schenkungs- oder Tauschurkunde",
      "certificate": "Echtheitszertifikat",
      "condition_report": "Zustandsbericht",
      "exhibition": "Ausstellungsdokument",
      "other": "Sonstiges"
    },
    "modal": {
      "title": "Durch OCR extrahierte Felder",
      "subtitle": "Wählen Sie die Felder aus, die in die Werkakte übernommen werden sollen"
    },
    "sections": {
      "documentsAnalyzed": "Analysierte Dokumente",
      "auction": "Auktion"
    },
    "documents": {
      "changeCategory": "Kategorie ändern",
      "rerun": "↺ Analyse mit den korrigierten Typen erneut starten",
      "untitled": "Dokument"
    },
    "confidence": {
      "title": "OCR-Konfidenzwert",
      "description": "Der Wert kombiniert die Qualität der Quellen, den Abgleich zwischen Rechnung und Kunstwerk sowie erkannte Unstimmigkeiten.",
      "level": {
        "veryHigh": "Sehr hoch",
        "high": "Hoch",
        "medium": "Mittel",
        "careful": "Mit Vorsicht"
      }
    },
    "dimensions": {
      "warningTitle": "Abweichung bei den Abmessungen erkannt",
      "record": "Werkakte:",
      "document": "Rechnung:",
      "differenceEachSide": "Abweichung von {{diff}} cm auf jeder Seite —",
      "recordLikelyFramed": "Die Werkakte enthält wahrscheinlich die Rahmenmaße (Außenmaß).",
      "documentLikelyFramed": "Die Rechnung enthält wahrscheinlich die Rahmenmaße.",
      "mismatch": "Die Abmessungen stimmen nicht überein. Vor der Übernahme prüfen.",
      "applyQuestion": "Die Abmessungen aus der Rechnung in die Werkakte übernehmen?",
      "yesApply": "Ja, {{dimensions}} übernehmen",
      "noKeep": "Nein, {{dimensions}} beibehalten",
      "confirmed": "Die Abmessungen aus der Rechnung werden übernommen",
      "rejected": "Abmessungen unverändert. Bitte manuell prüfen.",
      "confirmationRequired": "⚠ Bestätigung oben erforderlich",
      "onlyWarning": "Keine weiteren Felder müssen aktualisiert werden. Prüfen Sie die Abweichung oben."
    },
    "titleTechnicalWarning": "⚠ technische Beschreibung erkannt",
    "actions": {
      "saving": "Speichern…",
      "applied": "Übernommen",
      "applyCount": "{{count}} Feld{{plural}} übernehmen"
    },
    "alerts": {
      "noNewInfo": "OCR hat in diesen Dokumenten keine neuen Informationen gefunden.",
      "ocrError": "OCR-Fehler: {{message}}",
      "noFieldSelected": "Kein Feld ausgewählt.",
      "noPatch": "Nach der Normalisierung sind keine nutzbaren Daten übrig.",
      "saveError": "Fehler beim Speichern: {{message}}"
    },
    "errors": {
      "urlInaccessible": "Dokument nicht erreichbar: {{name}}",
      "readFailed": "Das Dokument konnte nicht gelesen werden ({{status}})",
      "emptyDocument": "Das Dokument ist leer oder unlesbar."
    }
  },
  "servicesCuratorialPage": {
    "back": "← Zurück",
    "title": "Kuratorische Begleitung",
    "intro": "Geben Sie Ihrer Sammlung eine <strong>kuratorische Perspektive</strong>: thematische Leitlinien, stimmige Titel, relevante <strong>Schlagwörter</strong> und einen redaktionellen Rahmen. Dadurch werden Ihre Werkdaten strukturiert und die <strong>langfristige Bewertung unterstützt</strong>.",
    "pricing": {
      "title": "Kostenpflichtige Leistung nach Angebot",
      "description": "Unsere Partnerexpertinnen und -experten erstellen je nach Umfang ein <strong>individuelles Angebot</strong>. Nach Erhalt können Sie es frei annehmen oder ablehnen."
    },
    "scope": {
      "label": "Umfang",
      "collection": "Gesamte Sammlung"
    },
    "goals": {
      "label": "Hauptziel",
      "options": {
        "structure": "Meine Sammlung strukturieren (Themen, Titel und Schlagwörter)",
        "presentation": "Eine Präsentation oder Hängung vorbereiten",
        "narrative": "Eine narrative und redaktionelle Geschichte entwickeln",
        "audit": "Vollständiges kuratorisches Audit",
        "other": "Sonstiges, unten erläutert"
      }
    },
    "details": {
      "label": "Details / Kontext",
      "placeholder": "Zum Beispiel: Schwerpunkt zeitgenössische Fotografie, Gliederung nach Jahrzehnten, thematische Indexierung…",
      "startingPoint": "Ausgangspunkt: Werk {{id}}"
    },
    "expert": {
      "label": "Auswahl der Fachperson",
      "auto": {
        "title": "Artkiv wählt für mich aus",
        "description": "Wir schlagen die für Ihre Sammlung am besten geeignete Fachperson vor."
      },
      "choose": {
        "title": "Ich wähle selbst",
        "description": "Durchsuchen Sie unser Verzeichnis zertifizierter Fachpersonen."
      },
      "loading": "Fachpersonen werden geladen…",
      "empty": "Derzeit ist keine Fachperson verfügbar.",
      "generic": "Fachperson",
      "directory": "Vollständiges Expertenverzeichnis anzeigen"
    },
    "contact": {
      "email": "Kontakt-E-Mail",
      "preference": "Bevorzugter Kontaktweg",
      "methods": {
        "email": "E-Mail",
        "phone": "Telefon",
        "video": "Videoanruf"
      }
    },
    "submit": {
      "send": "Anfrage senden",
      "sending": "Wird gesendet…"
    },
    "error": {
      "generic": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
    },
    "success": {
      "title": "Anfrage gesendet ✓",
      "artwork": "Vielen Dank. Unser <strong>kuratorisches Partnerteam</strong> prüft Ihren Bedarf und meldet sich innerhalb von <strong>48 Stunden</strong> mit einem <strong>individuellen Angebot</strong> für dieses Werk.",
      "collection": "Vielen Dank. Unser <strong>kuratorisches Partnerteam</strong> prüft Ihren Bedarf und meldet sich innerhalb von <strong>48 Stunden</strong> mit einem <strong>individuellen Angebot</strong> für Ihre gesamte Sammlung.",
      "backCollection": "Zurück zu meiner Sammlung"
    },
    "note": "Hinweis: Diese Begleitung wird von ausgewählten <strong>Partnerexpertinnen und -experten</strong> durchgeführt. Sie erhalten innerhalb von 48 Stunden ein individuelles Angebot und können es frei annehmen oder ablehnen."
  },
  "servicesValuationPage": {
    "back": "← Zurück",
    "title": "Bewertung durch eine Expertin/einen Experten anfragen",
    "intro": "Senden Sie dieses Werk an eine <strong>Partnerexpertin/einen Partnerexperten</strong> — selbst gewählt oder von Artkiv vorgeschlagen — für eine <strong>begründete Bewertung</strong>, unabhängig von unseren Selbstbewertungs-Tools.",
    "pricing": {
      "title": "Kostenpflichtige Leistung nach Angebot",
      "description": "Die Partnerexpertin/der Partnerexperte erstellt je nach Umfang des Auftrags ein <strong>individuelles Angebot</strong>. Nach Erhalt können Sie es frei annehmen oder ablehnen."
    },
    "artwork": {
      "label": "Betroffenes Werk",
      "unknown": "Ausgewähltes Werk"
    },
    "purpose": {
      "label": "Zweck der Bewertung",
      "options": {
        "sale": "Verkauf vorbereiten",
        "insurance": "Versicherung",
        "succession": "Nachlass / Übergabe",
        "donation": "Schenkung",
        "other": "Sonstiges, unten erläutert"
      }
    },
    "details": {
      "label": "Details / Kontext",
      "placeholder": "Zum Beispiel: Vorgeschichte, bekannte Provenienz, Dringlichkeit, bereits vorhandene Unterlagen…"
    },
    "expert": {
      "label": "Auswahl der Fachperson",
      "auto": {
        "title": "Artkiv wählt für mich aus",
        "description": "Wir schlagen die für dieses Werk am besten geeignete Fachperson vor."
      },
      "choose": {
        "title": "Ich wähle selbst",
        "description": "Durchsuchen Sie unser Verzeichnis von Partnerexpertinnen und -experten."
      },
      "loading": "Fachpersonen werden geladen…",
      "empty": "Derzeit ist keine Fachperson verfügbar.",
      "generic": "Fachperson",
      "noAccountHint": "Gelistete Fachperson ohne Artkiv-Konto — das Artkiv-Team nimmt manuell Kontakt auf.",
      "directory": "Vollständiges Expertenverzeichnis anzeigen"
    },
    "contact": {
      "email": "Kontakt-E-Mail",
      "preference": "Bevorzugter Kontaktweg",
      "methods": {
        "email": "E-Mail",
        "phone": "Telefon",
        "video": "Videoanruf"
      }
    },
    "submit": {
      "send": "Anfrage senden",
      "sending": "Wird gesendet…"
    },
    "error": {
      "generic": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
    },
    "success": {
      "title": "Anfrage gesendet ✓",
      "body": "Vielen Dank! Ihre Anfrage wurde an die <strong>Partnerexpertin/den Partnerexperten</strong> gesendet (oder an unser Team, falls noch kein Artkiv-Konto besteht). Sie erhalten innerhalb von 48 Stunden ein <strong>individuelles Angebot</strong>.",
      "backArtwork": "Zurück zur Werkkarte",
      "backCollection": "Zurück zu meiner Sammlung"
    },
    "note": "Hinweis: Diese Bewertung wird von einer <strong>Partnerexpertin/einem Partnerexperten</strong> durchgeführt, unabhängig vom Artkiv-Team. Sie erhalten innerhalb von 48 Stunden ein individuelles Angebot und können es frei annehmen oder ablehnen."
  },
  "teamAuctionHouses": {
    "title": "Auktionshäuser",
    "searchPlaceholder": "Nach Name, Stadt, Land oder Website suchen",
    "refresh": "Aktualisieren",
    "creating": "Wird erstellt…",
    "add": "Hinzufügen",
    "loading": "Wird geladen…",
    "saving": "Wird gespeichert…",
    "save": "Speichern",
    "empty": "Keine Ergebnisse",
    "fields": {
      "name": "Name",
      "nameRequired": "Name *",
      "city": "Stadt",
      "country": "Land",
      "website": "Website",
      "websitePlaceholder": "Website (https://…)",
      "topTen": "Top 10",
      "rank": "Rang",
      "active": "Aktiv",
      "action": "Aktion"
    }
  },
  "proposeMuseum": {
    "common": {
      "loading": "Wird geladen…",
      "untitled": "Ohne Titel"
    },
    "auth": {
      "title": "Anmeldung erforderlich",
      "description": "Bitte melden Sie sich an, um ein Werk vorzuschlagen.",
      "login": "Anmelden"
    },
    "title": "Ein Werk vorschlagen",
    "subtitle": "Reichen Sie Ihr Werk bei einer Institution oder einem Auktionshaus ein.",
    "type": {
      "title": "Was ist Ihr Ziel?",
      "auctionNote": "Ein Verkauf folgt einem eigenen Weg: Schätzung, Limit, Gebühren und Zeitplan. Museumsfelder werden nicht abgefragt.",
      "institution_gift": { "title": "Schenkung oder Vermächtnis", "description": "Aufnahme in eine ständige Sammlung vorschlagen." },
      "institution_loan": { "title": "Ausstellungsleihgabe", "description": "Auf ein temporäres kuratorisches Projekt antworten." },
      "auction_sale": { "title": "Auktionsverkauf", "description": "Begutachtung, Schätzung und Einlieferung anfragen." },
      "museum": {
        "title": "Museum / Institution",
        "description": "Temporäre oder dauerhafte Ausstellung zur Sichtbarmachung Ihres Werks."
      },
      "auction": {
        "title": "Auktionshaus",
        "description": "Auktion für eine möglichst gute Marktpositionierung."
      }
    },
    "institutionType": {
      "label": "Art der Institution",
      "options": { "museum": "Museum", "foundation": "Stiftung", "frac": "Kunstzentrum / FRAC", "university": "Universität", "public": "Krankenhaus / öffentliche Einrichtung", "other": "Andere" }
    },
    "contact": {
      "name": "Identifizierter Kontakt",
      "namePlaceholder": "Name (optional)",
      "role": "Funktion",
      "rolePlaceholder": "Kuratorium, Erwerbungen…"
    },
    "missionFit": {
      "label": "Passung zu Auftrag und Sammlungen der Institution",
      "placeholder": "Welche Lücke, welchen wissenschaftlichen Schwerpunkt oder welches kuratorische Projekt bedient dieses Werk wirklich?"
    },
    "provenance": {
      "label": "Provenienz und Eigentumsnachweis",
      "placeholder": "Eigentumsgeschichte, Rechnung, Zertifikat, noch zu prüfende Punkte…",
      "ownership": "Ich bestätige, Eigentümer:in oder beauftragt zu sein, dieses Werk vorzuschlagen."
    },
    "documents": {
      "label": "Bereits verfügbare Unterlagen",
      "items": { "images": "Hochauflösende Bilder", "invoice": "Rechnung / Eigentumsnachweis", "provenance": "Dokumentierte Provenienz", "condition": "Zustandsbericht", "authenticity": "Zertifikat / Echtheitsgutachten", "valuation": "Unabhängige Bewertung" }
    },
    "restrictions": {
      "label": "Vorgesehene Bedingungen",
      "hint": "Institutionen bevorzugen in der Regel Schenkungen ohne übermäßige Auflagen.",
      "options": { "none": "Ohne besondere Auflage", "credit_line": "Namensnennung gewünscht", "display_request": "Präsentationswunsch (nicht garantiert)", "other": "Weitere Bedingungen zu besprechen" }
    },
    "artwork": {
      "label": "Ihr Werk",
      "loading": "Werke werden geladen…",
      "empty": "Es sind keine Werke verfügbar. Fügen Sie Ihrer Sammlung zunächst Werke hinzu.",
      "select": "Werk auswählen"
    },
    "institution": {
      "auctionLabel": "Auktionshaus",
      "museumLabel": "Zielinstitution",
      "auctionPlaceholder": "Zum Beispiel: Christie’s, Sotheby’s…",
      "museumPlaceholder": "Zum Beispiel: Centre Pompidou, MoMA…"
    },
    "message": {
      "label": "Präsentationstext",
      "auctionPlaceholder": "Informationen zum Werk, zur Provenienz und zum Zustand…",
      "museumPlaceholder": "Warum sollte dieses Werk ausgestellt werden?"
    },
    "museum": {
      "artistBio": "Biografie der Künstlerin / des Künstlers",
      "artistBioPlaceholder": "Werdegang, Ausstellungen und biografische Angaben…",
      "artworkDescription": "Werkbeschreibung",
      "artworkDescriptionPlaceholder": "Technik, Maße und Entstehungskontext…",
      "relevance": "Künstlerische / kuratorische Relevanz",
      "relevancePlaceholder": "Warum passt dieses Werk in die Zielinstitution?"
    },
    "exhibitions": {
      "title": "Ausstellungshistorie",
      "close": "Schließen",
      "add": "Ausstellung hinzufügen",
      "delete": "Löschen",
      "save": "Ausstellung speichern",
      "fields": {
        "title": "Ausstellungstitel",
        "venue": "Ort / Institution",
        "location": "Stadt / Land",
        "description": "Beschreibung"
      }
    },
    "auction": {
      "estimateLabel": "Gewünschte Schätzung",
      "estimatePlaceholder": "Zum Beispiel: 12.000",
      "reserveLabel": "Limitpreis",
      "reservePlaceholder": "Zum Beispiel: 9.000",
      "reserveHint": "Mindestpreis, unter dem das Werk nicht verkauft wird (optional)."
    },
    "services": {
      "title": "Expertenleistung",
      "service": "Leistung",
      "clientRate": "Kundenpreis netto",
      "expertCost": "Expertenkosten netto",
      "expertService": "Expertenleistung",
      "selectedExpert": "Ausgewählte Fachperson",
      "defaultDescription": "Institutionelle Platzierung, Pauschale 500 € netto"
    },
    "expert": {
      "label": "Partnerexpertin / Partnerexperte",
      "select": "Fachperson auswählen…",
      "directory": "Verzeichnis anzeigen"
    },
    "sendMethod": {
      "title": "Versandart",
      "professional": {
        "title": "Professionelle Leistung, 500 € netto",
        "auctionDescription": "Unsere Fachperson verhandelt für Sie und begleitet den Vorgang sechs Monate lang.",
        "museumDescription": "Unsere Fachperson reicht Ihr Werk ein und begleitet den Vorgang sechs Monate lang."
      },
      "self": {
        "title": "Ich kümmere mich selbst darum, kostenlos",
        "description": "Sie erhalten den formatierten Vorschlag per E-Mail und verwalten die Kontakte selbst."
      },
      "emailLabel": "Ihre E-Mail",
      "emailPlaceholder": "email@beispiel.de"
    },
    "submit": {
      "toPayment": "Weiter zur Zahlung",
      "send": "Vorschlag senden"
    },
    "alerts": {
      "exhibitionRequired": "Bitte geben Sie mindestens Titel und Ort der Ausstellung an.",
      "selectArtwork": "Bitte wählen Sie ein Werk aus.",
      "selectExpert": "Wählen Sie vor dem Fortfahren eine Fachperson aus.",
      "createFailed": "Der Vorschlag konnte nicht erstellt werden.",
      "submitError": "Fehler beim Senden: {{message}}",
      "unknownError": "Unbekannter Fehler"
    },
    "payment": {
      "title": "Sichere Zahlung",
      "description": "Schließen Sie den Auftrag ab, um den institutionellen Vorschlag zu starten.",
      "amountExclTax": "Betrag netto",
      "vat": "MwSt. 20 %",
      "totalInclTax": "Gesamt brutto",
      "processing": "Verarbeitung…",
      "pay": "{{amount}} netto zahlen",
      "createError": "Die Zahlung konnte nicht erstellt werden.",
      "genericError": "Zahlungsfehler."
    },
    "history": {
      "title": "Verlauf Ihrer Vorschläge",
      "museum": "Institution",
      "auction": "Auktion",
      "type": { "institution_gift": "Schenkung / Vermächtnis", "institution_loan": "Ausstellungsleihgabe", "auction_sale": "Auktionsverkauf", "museum": "Institution", "auction": "Auktion", "other": "Vorschlag" },
      "status": {
        "pending": "Ausstehend",
        "paid": "Bezahlt",
        "awaitingPayment": "Zahlung erforderlich"
      }
    }
  },
  "supportImportCancel": {
    "title": "Zahlung abgebrochen",
    "description": "Sie können den Vorgang jederzeit auf der Seite für den unterstützten Import erneut starten.",
    "back": "Zurück zum unterstützten Import"
  },
  "supportImportSuccess": {
    "title": "Vielen Dank!",
    "description": "Ihre Zahlung wurde bestätigt. Ein Artkiv-Experte wird Sie kontaktieren.",
    "dashboard": "Zurück zum Dashboard"
  },
  "stripeSuccess": {
    "title": "Zahlung erfolgreich!",
    "description": "Ihr ARTKIV-Abonnement ist jetzt aktiv.",
    "redirect": "Weiterleitung zu Ihrem persönlichen Bereich…"
  },
  "newsletterUnsubscribe": {
    "loading": "Wird bearbeitet…",
    "successTitle": "Erfolgreich abgemeldet",
    "successDescription": "Sie wurden von unserem Newsletter abgemeldet.",
    "errorTitle": "Fehler",
    "errorDescription": "Bei der Abmeldung ist ein Fehler aufgetreten."
  },
  "pendingApproval": {
    "title": "Freigabe ausstehend",
    "thanks": "Vielen Dank für Ihre Registrierung bei Artkiv.",
    "reviewing": "Ihr Konto wird derzeit von unserem Team geprüft.",
    "delayWarning": "⚡ Falls Sie innerhalb von 48 Stunden keine Nachricht erhalten,",
    "contact": "kontaktieren Sie uns bitte unter {{email}}.",
    "emailNotice": "Sie erhalten eine E-Mail, sobald Ihr Konto aktiviert wurde."
  },
  "authCallback": {
    "verifyingEmail": "Ihre E-Mail wird überprüft…",
    "invalidSession": "Ungültige Sitzung, Weiterleitung…",
    "emailConfirmed": "E-Mail bestätigt! Abonnement wird geprüft…",
    "subscriptionFound": "Abonnement gefunden, Weiterleitung…",
    "redirectPayment": "Weiterleitung zur Zahlung…",
    "error": "Fehler: {{message}}",
    "pleaseWait": "Bitte warten…"
  },
  "updatePassword": {
    "title": "Neues Passwort",
    "newPassword": "Neues Passwort",
    "newPasswordPlaceholder": "Mindestens {{count}} Zeichen",
    "confirmPassword": "Passwort bestätigen",
    "confirmPasswordPlaceholder": "Bestätigen Sie Ihr Passwort",
    "updating": "Wird aktualisiert…",
    "submit": "Passwort aktualisieren",
    "success": "✅ Passwort erfolgreich aktualisiert!",
    "errors": {
      "mismatch": "Die Passwörter stimmen nicht überein.",
      "tooShort": "Das Passwort muss mindestens {{count}} Zeichen enthalten.",
      "generic": "Beim Aktualisieren des Passworts ist ein Fehler aufgetreten."
    }
  },
  "emailConfirmationWaiting": {
    "defaultEmail": "Ihre Adresse",
    "title": "Bestätigen Sie Ihre E-Mail-Adresse",
    "sentTo": "Wir haben einen Bestätigungslink gesendet an",
    "stepInboxTitle": "Schritt 1: Prüfen Sie Ihren Posteingang",
    "stepInboxDescription": "Öffnen Sie Ihre E-Mail und klicken Sie auf den Bestätigungslink, den wir Ihnen gesendet haben.",
    "spamTitle": "Prüfen Sie Ihren Spam-Ordner",
    "spamDescription": "Falls Sie unsere E-Mail nicht sehen, prüfen Sie bitte Ihren Spam- oder Junk-Ordner.",
    "stepPaymentTitle": "Schritt 2: Schließen Sie die Zahlung ab",
    "stepPaymentDescription": "Nach der Bestätigung Ihrer E-Mail werden Sie automatisch zu Stripe weitergeleitet, um Ihr Abonnement abzuschließen.",
    "notReceived": "E-Mail nicht erhalten?",
    "sending": "Wird gesendet…",
    "retryIn": "In {{seconds}} s erneut versuchen",
    "resend": "Bestätigungs-E-Mail erneut senden",
    "success": "✓ E-Mail erfolgreich erneut gesendet!",
    "error": "✗ Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    "importantLabel": "Wichtig:",
    "importantDescription": "Sie können erst auf Ihren persönlichen Bereich zugreifen, wenn Ihre E-Mail bestätigt und Ihr Abonnement abgeschlossen wurde.",
    "needHelp": "Brauchen Sie Hilfe?",
    "contactSupport": "Support kontaktieren",
    "backToLogin": "Zurück zur Anmeldung"
  },
  "supportTicketDetail": {
    "back": "Zurück",
    "notFound": "Ticket nicht gefunden.",
    "dashboard": "Dashboard",
    "priority": "Priorität: {{value}}",
    "channel": "Kanal: {{value}}",
    "mode": "Modus: {{value}}",
    "createdAgo": "Vor {{count}} Tag(en) erstellt",
    "createdAgo_one": "Vor {{count}} Tag erstellt",
    "createdAgo_other": "Vor {{count}} Tagen erstellt",
    "client": "Kunde: #{{id}}",
    "markResolved": "Als gelöst markieren",
    "message": "Nachricht",
    "metadata": "Metadaten",
    "status": {
      "open": "Offen",
      "pending": "Ausstehend",
      "sent": "Gesendet",
      "resolved": "Gelöst",
      "closed": "Geschlossen",
      "canceled": "Abgebrochen"
    }
  },
  "supportImportPage": {
    "title": "Import mit Expertenunterstützung",
    "introStandard": "Lassen Sie Ihre Kunstwerke aus einer Tabelle oder einem Dokument importieren. {{price}} für den Standardimport.",
    "introExtended": "Für größere Mengen: {{hourlyPrice}} pro Stunde.",
    "requesterEmail": "Ihre E-Mail (Abrechnung / Kontakt)",
    "collectorEmail": "E-Mail des Sammlers",
    "importType": "Importart",
    "scope": {
      "standard": "Standard — {{price}}",
      "extended": "Erweitert — {{hourlyPrice}}/Std."
    },
    "estimatedHours": "Geschätzte Stundenzahl",
    "fileLabel": "Datei (CSV/XLSX/DOCX/PDF) — optional",
    "fileHelp": "Bei einer großen Datei können Sie sie uns auch später senden.",
    "notesLabel": "Nützliche Angaben (Anzahl der Einträge, Besonderheiten…)",
    "estimatedAmount": "Geschätzter Betrag:",
    "amountInclTax": "{{amount}} inkl. MwSt.",
    "redirecting": "Weiterleitung…",
    "pay": "Weiter zur Zahlung",
    "details": {
      "standardTitle": "Standard ({{price}}):",
      "standardDescription": "strukturierte Datei (CSV/XLSX) oder einfache Doc/PDF-Liste in angemessenem Umfang.",
      "extendedTitle": "Erweitert ({{hourlyPrice}}/Std.):",
      "extendedDescription": "große unstrukturierte Listen, mehrere Quellen oder umfangreiche Datenbereinigung."
    },
    "afterPayment": "Nach der Zahlung übernimmt ein Artkiv-Experte Ihren Import, sendet Ihnen eine Kontrollvorschau und schließt die Integration ab.",
    "errors": {
      "emailsRequired": "Die E-Mail-Adressen des Antragstellers und des Sammlers sind erforderlich.",
      "hoursRequired": "Geben Sie mindestens eine Stunde an.",
      "checkoutNotCreated": "Die Checkout-Sitzung konnte nicht erstellt werden.",
      "generic": "Ein Fehler ist aufgetreten."
    }
  },
  "intergenerationalMatchingPage": {
    "title": "Test der generationsübergreifenden Zuordnung",
    "matchAlert": "✅ „{{artwork}}“ an {{heir}} weitergeben",
    "rejectLog": "❌ „{{artwork}}“ für {{heir}} abgelehnt",
    "heirs": {
      "sarah": {
        "preferences": {
          "landArt": "Land Art",
          "sustainableArt": "Nachhaltige Kunst"
        },
        "values": {
          "sustainability": "Nachhaltigkeit",
          "transmission": "Weitergabe"
        }
      },
      "james": {
        "preferences": {
          "classical": "Klassische Kunst",
          "renaissance": "Renaissance"
        },
        "values": {
          "investment": "Investition"
        }
      }
    },
    "artworks": {
      "suspendedForests": {
        "title": "Schwebende Wälder",
        "medium": "Acryl auf Leinwand"
      },
      "emeraldCascade": {
        "title": "Smaragdfarbener Wasserfall",
        "medium": "Fotografie"
      }
    }
  },
  "warehouseVisit": {
    "title": "Lagerbesuch",
    "common": {
      "loading": "Wird geladen…",
      "untitled": "Ohne Titel"
    },
    "conditions": {
      "excellent": "Ausgezeichnet",
      "very_good": "Sehr gut",
      "good": "Gut",
      "fair": "Mittel",
      "poor": "Schlecht",
      "partially_restorable": "Teilweise restaurierbar",
      "heavily_damaged": "Stark beschädigt",
      "irreparable": "Irreparabel"
    },
    "risks": {
      "faible": "Geringes Risiko",
      "moyen": "Mittleres Risiko",
      "eleve": "Hohes Risiko",
      "urgent": "DRINGEND"
    },
    "fields": {
      "condition": "Erhaltungszustand",
      "riskLevel": "Risikostufe",
      "visitNotes": "Besuchsnotizen",
      "notesPlaceholder": "Festgestellte Schäden, Dringlichkeit, Beobachtungen…",
      "randomNotesPlaceholder": "Beobachtungen und festgestellte Schäden…",
      "medium": "Technik",
      "dimensions": "Abmessungen",
      "estimatedValue": "Geschätzter Wert"
    },
    "actions": {
      "saved": "Gespeichert",
      "save": "Speichern",
      "record": "Werkdaten",
      "next": "Weiter",
      "inspect": "Prüfen",
      "back": "Zurück",
      "exportPdf": "Bericht als PDF exportieren",
      "finish": "Besuch beenden · Zusammenfassung anzeigen"
    },
    "client": {
      "title": "Kunden auswählen",
      "description": "Wählen Sie den zu prüfenden Sammler",
      "empty": "Kein zugänglicher Kunde"
    },
    "location": {
      "title": "Standort auswählen",
      "description": "Wählen Sie den heute zu prüfenden Standort",
      "loading": "Standorte werden geladen…",
      "empty": "Kein Standort gespeichert",
      "lastVisit": "Letzter Besuch"
    },
    "risk": {
      "zone": "Risikozone: {{risk}}",
      "zoneArtwork": "Lagerrisikozone: {{risk}} — dieses Werk kann betroffen sein",
      "unsuitable": "Die Erhaltungsbedingungen sind ungeeignet"
    },
    "random": {
      "title": "Zufälliges Werk"
    },
    "summary": {
      "completed": "Besuch abgeschlossen",
      "title": "Besuchszusammenfassung",
      "priority": "Vorrangig zu bearbeiten ({{count}})",
      "noUrgency": "Keine dringenden Probleme festgestellt",
      "allGood": "Alle geprüften Werke befinden sich in gutem Zustand"
    },
    "stats": {
      "present": "Vorhandene Werke",
      "evaluated": "Bewertet",
      "damaged": "Schlechter Zustand",
      "highRisk": "Hohes Risiko / dringend",
      "total": "Gesamt",
      "notEvaluated": "Nicht bewertet",
      "damagedShort": "Beschädigt",
      "evaluatedProgress": "{{evaluated}}/{{total}} bewertet"
    },
    "inspection": {
      "title": "Prüfung",
      "search": "Titel, Künstler, Inventarnr.…",
      "loading": "Werke werden geladen…",
      "empty": "An diesem Standort ist kein Werk gespeichert",
      "noResults": "Keine Ergebnisse",
      "resultCount": "{{count}} Werk",
      "resultCount_other": "{{count}} Werke",
      "sortedByCondition": "nach Zustand sortiert"
    },
    "filters": {
      "all": "Alle ({{count}})",
      "damaged": "Beschädigt ({{count}})",
      "random": "Zufällig"
    },
    "pdf": {
      "title": "Lagerbesuchsbericht",
      "location": "Standort",
      "visitDate": "Besuch am",
      "riskZone": "Standort mit Risikostufe {{risk}}",
      "unsuitable": "Die Erhaltungsbedingungen an diesem Standort sind für die Bewahrung der Werke ungeeignet.",
      "evaluatedVisit": "Bei diesem Besuch bewertet",
      "intervention": "Werke mit Handlungsbedarf",
      "noUrgency": "Bei diesem Besuch wurden keine dringenden Probleme festgestellt",
      "artwork": "Werk",
      "artist": "Künstler",
      "inventoryNumber": "Inventarnr.",
      "fullInventory": "Vollständiges Besuchsinventar",
      "generatedOn": "Bericht erstellt am {{date}}",
      "confidential": "Vertraulich"
    }
  },
  "collectionReports": {
    "title": "Bericht erstellen",
    "error": "Fehler",
    "types": {
      "inventory": "Inventarbericht",
      "artist": "Bericht nach Künstler",
      "location": "Bericht nach Standort",
      "valuation": "Bewertungsbericht",
      "insurance": "Versicherungsbericht",
      "exhibition": "Ausstellungskatalog",
      "acquisition": "Erwerbsverlauf",
      "condition": "Zustandsbericht der Werke",
      "completude": "Vollständigkeitsbericht — Fehlende Daten"
    },
    "actions": {
      "viewExisting": "Vorhandene Berichte anzeigen",
      "generating": "Wird erstellt…",
      "generatePdf": "PDF erstellen"
    },
    "fields": {
      "reportType": "Berichtstyp",
      "reportName": "Berichtsname"
    },
    "common": {
      "notProvided": "Nicht angegeben"
    },
    "selection": {
      "advisorTitle": "Sammler und Sammlung auswählen",
      "collectionTitle": "Sammlung auswählen",
      "collector": "Sammler",
      "allCollectors": "Alle Sammler",
      "sharedCollectors": "{{count}} Sammler mit gemeinsamem Zugriff",
      "sharedCollectors_other": "{{count}} Sammler mit gemeinsamem Zugriff",
      "collection": "Sammlung",
      "allCollections": "Alle Sammlungen",
      "untitledCollection": "Sammlung ohne Titel",
      "loadedInCollection": "{{count}} Werk in dieser Sammlung geladen",
      "loadedInCollection_other": "{{count}} Werke in dieser Sammlung geladen",
      "loadedTotal": "{{count}} Werk insgesamt geladen",
      "loadedTotal_other": "{{count}} Werke insgesamt geladen"
    },
    "largeCollection": {
      "title": "Ihre Auswahl enthält {{count}} Werke.",
      "description": "Bei großen Sammlungen empfehlen wir, den Bericht nach Sammlung oder Künstler statt für die Gesamtauswahl zu erstellen. Das Ergebnis ist übersichtlicher und schneller verfügbar.",
      "thumbnails": "Miniaturbilder werden auf die ersten 50 Werke begrenzt, um die PDF-Erstellung sicherzustellen."
    },
    "completeness": {
      "title": "Zu prüfende Felder",
      "description": "Wählen Sie die Informationen aus, bei denen Lücken erkannt werden sollen.",
      "essential": "wesentlich",
      "note": "Als „wesentlich“ markierte Felder sind für eine belastbare Schätzung oder Bewertung erforderlich."
    },
    "options": {
      "title": "Berichtsoptionen",
      "includeDate": "Heutiges Datum einfügen",
      "includeThumbnails": "Miniaturbilder einfügen",
      "valueTotals": "Gesamtwerte der Werke",
      "purchaseTotal": "Gesamter Kaufwert"
    },
    "data": {
      "title": "Einzubeziehende Daten",
      "image": "Hauptbild",
      "artist": "Künstlername",
      "dimensions": "Abmessungen",
      "medium": "Technik / Medium",
      "mediumShort": "Medium",
      "creationYear": "Entstehungsjahr",
      "estimatedValue": "Geschätzter Wert",
      "invoiceCertificate": "Rechnung oder Zertifikat",
      "inventoryRef": "Inventarreferenz",
      "description": "Beschreibung",
      "acquisitionPrice": "Kaufpreis",
      "location": "Standort",
      "priceEstimated": "Preis / geschätzter Wert",
      "valueSource": "Wertquellen angeben"
    },
    "whiteLabel": {
      "title": "Personalisierter Bericht",
      "description": "Bericht mit Ihrer professionellen Identität erstellen",
      "enable": "Aktivieren",
      "company": "Name Ihres Unternehmens oder Büros",
      "current": "Aktuell",
      "editProfile": "In meinem Profil bearbeiten",
      "logo": "Ihr Logo",
      "changeLogo": "Logo ändern",
      "noLogo": "Kein Logo hochgeladen. Fügen Sie in Ihrem Profil ein Logo hinzu, um Berichte zu personalisieren.",
      "addLogo": "Logo hinzufügen",
      "note": "Berichte werden mit Ihrer professionellen Identität statt der Artkiv-Marke erstellt — ideal für Kundentermine."
    },
    "layout": {
      "title": "Layout",
      "groupBy": "Gruppieren nach",
      "none": "Keine Gruppierung",
      "artist": "Künstler",
      "location": "Standort",
      "medium": "Medium",
      "year": "Jahr",
      "sortBy": "Sortieren nach",
      "titleSort": "Titel",
      "value": "Wert",
      "acquisitionDate": "Erwerbsdatum"
    }
  },
  "valuationPdf": {
    "reportTitle": "Bewertungsbericht",
    "preparedFor": "Dokument zur Validierung und Begleitung durch den Art Advisor",
    "purpose": "Zweck",
    "preparedBy": "Erstellt von",
    "date": "Datum",
    "client": "Kunde",
    "executiveSummary": "Zusammenfassung",
    "artworksValued": "Bewertete Werke",
    "lowRange": "Untere Spanne",
    "highRange": "Obere Spanne",
    "retainedValue": "Angesetzter Wert",
    "averageConfidence": "Durchschnittlicher Vertrauenswert",
    "confidenceNote": "Dieser Wert misst die dokumentarische Robustheit der Bewertung und garantiert nicht die Erzielung des Preises.",
    "artworkDetail": "Bewertungsdetails je Werk",
    "marketToDocument": "Markt zu dokumentieren",
    "expertValidationRequired": "Expertenvalidierung erforderlich",
    "untitled": "Ohne Titel",
    "artistMissing": "Künstler nicht angegeben",
    "confidence": "Vertrauen",
    "liquidity": "Liquidität",
    "risk": "Risiko",
    "trend": "Trend",
    "marketReading": "Markteinschätzung",
    "method": "Methode",
    "sources": "Quellen",
    "notProvidedF": "Nicht angegeben",
    "notProvidedPlural": "nicht angegeben",
    "sourcesWeighting": "Quellen / Vergleichswerte und Gewichtung",
    "recommendation": "Empfehlung des Art Advisors",
    "generalNotes": "Allgemeine Notizen des Art Advisors",
    "methodologyTitle": "Methodik",
    "methodologyDescription": "Die Bewertung wendet ARTKIV-Regeln je Gruppe an: Gruppe A nutzt direkte CUP; Gruppe B arbeitet mit Analogie und mindestens fünf Referenzen; Gruppe C verwendet die Formel (H + L) × Punktwert. Ergebnisse, die älter als fünf Jahre sind, werden ausgeschlossen, sofern keine Alternative besteht. Galeriepreise dienen nur als Obergrenze.",
    "disclaimer": "Dieser Bewertungsbericht ist eine Entscheidungshilfe, die ein Art Advisor anhand der am Ausstellungsdatum verfügbaren Informationen erstellt hat. Er ist kein gerichtliches, steuerliches oder erbrechtliches Gutachten. Die Werte sind indikativ und von einem zugelassenen Experten zu bestätigen.",
    "defaultFinality": "Marktbewertung",
    "defaultBadge": "Experten-Arbeitsdokument",
    "buttonTitle": "{{count}} Werk(e) exportieren, angesetzter Wert {{value}}",
    "noArtwork": "Kein Werk zum Exportieren",
    "generating": "PDF wird erstellt…",
    "export": "Bewertungsbericht als PDF exportieren",
    "methodology": {
      "direct_cup": "Gruppe A — Direkte CUP: aktuelle Ergebnisse desselben Künstlers werden gewichtet; Ergebnisse über fünf Jahre werden ausgeschlossen. Der Galeriepreis dient nur als Obergrenze.",
      "analogy_cup": "Gruppe B — CUP durch Analogie: aktuelle Vergleichswerte werden gewichtet; ohne direkte Ergebnisse gilt ein Vorsichtsabschlag.",
      "point_method": "Gruppe C — Punktemethode: Formel (H + L) × Punktwert."
    }
  },
  "artpriceImport": {
    "messages": {
      "loginRequired": "Sie müssen angemeldet sein, um eine PDF-Datei zu importieren.",
      "importError": "Importfehler",
      "processing": "PDF importiert. Analyse läuft ({{id}}…)",
      "processed": "PDF importiert und analysiert. {{count}} Auftrag abgeschlossen.",
      "queued": "PDF importiert. Analyse in Warteschlange.",
      "houseAdded": "Auktionshaus hinzugefügt.",
      "returnToCup": "Kehren Sie zu CUP zurück, um die Vergleichswerte zu laden."
    },
    "context": {
      "title": "Importkontext",
      "description": "Jeder importierte Vergleichswert wird seinem Eigentümer zugeordnet: Kunde, Experte oder Artkiv-Team.",
      "importedBy": "Importiert von",
      "visibility": "Berechnete Sichtbarkeit",
      "client": "Betroffener Kunde",
      "selectClient": "Kunden auswählen",
      "clientUuid": "Kunden-UUID",
      "clientWarning": "Ein Experte muss vor dem Import in einen Kundenbereich einen Kunden auswählen."
    },
    "house": {
      "optional": "Auktionshaus (optional)",
      "search": "Suchen…",
      "addTitle": "Auktionshaus hinzufügen",
      "name": "Name",
      "city": "Stadt",
      "country": "Land",
      "website": "Website",
      "aliases": "Aliase (durch Kommas getrennt)"
    },
    "actions": {
      "add": "Hinzufügen",
      "cancel": "Abbrechen",
      "saving": "Wird gespeichert…",
      "import": "Importieren",
      "importing": "Import läuft…",
      "backToCup": "Zurück zum CUP-Assistenten"
    },
    "table": {
      "artist": "Künstler",
      "title": "Titel",
      "estimate": "Schätzung",
      "hammer": "Zuschlag",
      "sale": "Verkauf",
      "owner": "Eigentümer"
    }
  },
  "valuationReport": {
    "loading": "Bewertungsmodul wird geladen…",
    "kicker": "Bericht · Art Advisor Premium",
    "title": "Bewertungsbericht",
    "description": "Wählen Sie Werke aus, ordnen Sie Künstler den Gruppen A/B/C zu, definieren Sie Spannen nach Künstler, Technik und Format, wenden Sie diese auf die Werkdaten an, passen Sie Ausnahmen an und speichern Sie.",
    "inflation": {
      "title": "Inflationsbericht (INSEE-VPI) verfügbar",
      "description": "Neubewertung des Kaufpreises ohne erforderliche CUP-Schätzung"
    },
    "steps": {
      "purpose": "Zweck",
      "artworks": "Werke",
      "artists": "Künstler A/B/C",
      "records": "Werkdaten"
    },
    "actions": {
      "open": "Öffnen",
      "chooseArtworks": "Werke auswählen",
      "back": "Zurück",
      "defineRanges": "Spannen festlegen",
      "saving": "Wird gespeichert…",
      "saveQuotes": "Meine persönlichen Künstler-/Technikbewertungen speichern",
      "applyAll": "Alle Spannen auf die Werkdaten anwenden",
      "backToArtists": "Zurück zur Künstlerklassifizierung",
      "saveArtworks": "In artworks speichern",
      "exportPdf": "PDF exportieren",
      "exportWord": "Word exportieren"
    },
    "fields": {
      "clientName": "Name des Kunden",
      "clientPlaceholder": "Kunde / Akte",
      "artist": "Künstler"
    },
    "common": {
      "untitled": "Ohne Titel",
      "date": "Datum",
      "artworkCount": "{{count}} Werk",
      "artworkCount_other": "{{count}} Werke"
    },
    "purpose": {
      "title": "Zweck des Berichts",
      "options": {
        "assurance": {
          "label": "Versicherung",
          "description": "Dokumentierter Wert für Versicherungsschutz oder Verlängerung."
        },
        "succession": {
          "label": "Nachlass / Übertragung",
          "description": "Vorsichtige, nachvollziehbare und dokumentierte Bewertung für die Vermögensaufteilung."
        },
        "marche": {
          "label": "Markt / Disposition",
          "description": "Nutzbare Marktspanne für Verkaufs-, Halte- oder Erwerbsentscheidungen."
        },
        "pret": {
          "label": "Besicherung / Darlehen",
          "description": "Vorsichtige Einschätzung unter Einbeziehung von Liquidität, Dokumentation und Risiko."
        }
      }
    },
    "selection": {
      "title": "Werke auswählen",
      "description": "Inventarreferenzen werden angezeigt, um Verwechslungen bei großen Beständen zu vermeiden.",
      "selected": "{{count}} ausgewählt",
      "selected_other": "{{count}} ausgewählt",
      "phaseTitle": "Phase 0 — persönliche Expertenbewertungen",
      "phaseDescription": "Nach der Auswahl prüft ARTKIV, ob bereits Bewertungen für die vorhandenen Künstler und Techniken gespeichert wurden. Falls ja, werden Gruppen A/B/C und Spannen vorausgefüllt. Andernfalls geben Sie sie ein und speichern sie nur bei Bedarf.",
      "allCollections": "Alle Sammlungen",
      "search": "Künstler, Titel oder Inventar suchen…",
      "toggleAll": "Alle auswählen / abwählen ({{count}})",
      "savedQuote": "Gespeicherte Bewertung",
      "noRange": "Keine Spanne",
      "loadingQuotes": "Bewertungen werden gesucht…",
      "classify": "Künstler klassifizieren ({{count}})"
    },
    "classification": {
      "title": "Künstler den Gruppen A/B/C zuordnen",
      "description": "Zuerst wird die Methode je Künstler festgelegt. Anschließend werden Spannen nach Künstler, Technik und Format erarbeitet.",
      "prefilled": "{{count}} persönliche Bewertung vorgeladen. Felder bleiben bearbeitbar.",
      "prefilled_other": "{{count}} persönliche Bewertungen vorgeladen. Felder bleiben bearbeitbar.",
      "none": "Für diese Auswahl wurde keine bestehende persönliche Bewertung gefunden. Füllen Sie die Gruppen jetzt aus und speichern Sie die Bewertungen, wenn Sie sie wiederverwenden möchten.",
      "comparableArtists": "Vergleichskünstler: Künstler A, Künstler B…",
      "analogyReason": "Gleiche Galerie, Generation, gemeinsame Ausstellung…",
      "expertNote": "Expertennotiz zu Marktwert, Liquidität, Vorsicht und Trend…",
      "otherArtworks": "{{count}} weiteres Werk",
      "otherArtworks_other": "{{count}} weitere Werke"
    },
    "confidence": {
      "low": "Niedriges Vertrauen",
      "medium": "Mittleres Vertrauen",
      "high": "Hohes Vertrauen"
    },
    "ranges": {
      "title": "Spannen nach Künstler + Technik + Format",
      "description": "Speichern Sie persönliche Expertenbewertungen nur, wenn Sie Ihre private Bibliothek ergänzen möchten. Wenden Sie anschließend die Spannen auf die Werkdaten an und passen Sie Ausnahmen einzeln an.",
      "prefilled": "Persönliche Bewertung vorausgefüllt",
      "artworkPrefilled": "Bewertung bereits in den Werkdaten erfasst — Spannen und Gewichtung vorgeladen",
      "applyToRecords": "Auf {{count}} Werkdaten anwenden",
      "pointLow": "Unterer Punktwert",
      "pointHigh": "Oberer Punktwert",
      "low": "Untere Spanne €",
      "high": "Obere Spanne €",
      "average": "Durchschnittswert €",
      "weightingTitle": "Gewichtungsmethodik",
      "weightingDescription": "Ergebnisse, die älter als fünf Jahre sind, werden ausgeschlossen. Der aktuelle Galeriepreis dient nur als Obergrenze, niemals als Durchschnitt.",
      "savedNote": "Gespeicherte Bewertungsnotiz für diesen Künstler/diese Technik/dieses Format",
      "ownRecentCount": "Eigene Ergebnisse <3 Jahre",
      "ownRecentMedian": "Median eigene Ergebnisse <3 Jahre €",
      "ownOldCount": "Eigene Ergebnisse 3–5 Jahre",
      "ownOldMedian": "Median eigene Ergebnisse 3–5 Jahre €",
      "compRecentCount": "Vergleichswerte <3 Jahre",
      "compRecentMedian": "Median Vergleichswerte <3 Jahre €",
      "compOldCount": "Vergleichswerte 3–5 Jahre",
      "compOldMedian": "Median Vergleichswerte 3–5 Jahre €",
      "galleryCap": "Aktueller Galeriepreis, nur Obergrenze €",
      "prudenceDiscount": "Vorsichtsabschlag ohne eigene Ergebnisse %",
      "sourcesDetail": "Detaillierte Quellen und Begründung der Vergleichswerte"
    },
    "adjustments": {
      "title": "Manuelle Anpassungen / Ausnahmen je Werk",
      "description": "Der Experte kann ein historisches, museales oder atypisches Werk nach der Sammelanwendung korrigieren.",
      "finalValue": "Endwert",
      "certificate": "Zertifikat +5%",
      "provenance": "Künstlerprovenienz +2%",
      "followUp": "Lückenlose Nachverfolgung +5%",
      "expertOverride": "Außergewöhnliche Expertenanpassung",
      "sources": "Konsultierte Quellen",
      "justification": "Begründung für den Kunden je Werk…",
      "low": "Unterer Wert €",
      "high": "Oberer Wert €",
      "retained": "Angesetzter Wert €",
      "forcedValue": "Erzwungener Endwert €",
      "overrideReason": "Grund: historisches Werk, bedeutende Ausstellung…"
    },
    "losses": {
      "title": "Aus dem aktiven Gesamtwert ausgeschlossene Werke",
      "description": "Irreparable Werke werden als Verluste ausgewiesen und nicht in den aktiven Gesamtwert einbezogen."
    },
    "totalAdjusted": "Angepasster aktiver Gesamtwert",
    "generalNotes": "Allgemeine Berichtsnotizen"
  },
  "artistQuotes": {
    "loading": "Künstlerbewertungen werden geladen…",
    "backToTools": "Zurück zu den Werkzeugen",
    "kicker": "Private Expertenbibliothek",
    "title": "Künstlerbewertungen",
    "description": "Speichern Sie Ihre A/B/C-Gruppen, Wertspannen, Analogien und Entscheidungsparameter. In Gruppe A werden Verkäufe desselben Künstlers zusätzlich nach Abmessungen, Technik, Formatnähe und Aktualität gewichtet. In Gruppe B erhält jeder Vergleichskünstler einen eigenen Expertenabschlag.",
    "messages": {
      "required": "Künstler und Technik sind erforderlich.",
      "saved": "Künstlerbewertung in Ihrer privaten Bibliothek gespeichert.",
      "confirmDelete": "Diese persönliche Bewertung löschen?",
      "deleted": "Bewertung gelöscht."
    },
    "methods": {
      "directCup": "Gruppe A — direkte CUP",
      "directCupPrudent": "C+ — vorsichtige direkte CUP / Serie",
      "analogyCup": "Gruppe B — CUP durch Analogie",
      "analogyCupRatio": "C+ — Analogie / Referenzverhältnis",
      "hybridPointsCup": "C+ — Punkte + partielle Vergleichswerte",
      "pointMethod": "Gruppe C — Punktemethode"
    },
    "confidence": {
      "label": "Vertrauen",
      "low": "Niedrig",
      "medium": "Mittel",
      "high": "Hoch"
    },
    "microSegment": {
      "kicker": "Expertenblick · Mikrosegment",
      "title": "Eine eigene Zeile anlegen, wenn eine Serie verlässlicher wird als das allgemeine Medium",
      "description": "Beispiel: Nicht sämtliche Fotografien von Yuki Onodera zusammenfassen, wenn der Experte mehrere konsistente Ergebnisse der Serie Transvest ermittelt hat. Die Bewertung wird dann als eigene Zeile für Künstler + Serie / Format / Technik geführt und als C+ oder vorsichtige direkte CUP eingestuft: Der Markt bleibt klein, ist aber beobachtbar.",
      "item1": "Derselbe Künstler und zugleich dieselbe identifizierbare Serie oder Werkgruppe.",
      "item2": "Ähnliche Formate, vergleichbare Technik und nachvollziehbare Editionen.",
      "item3": "Mehrere homogene Ergebnisse oder Schätzungen, auch bei geringer Liquidität.",
      "item4": "Die eigene Zeile verhindert, dass das Signal in einem zu breiten Medium verwässert wird.",
      "prefill": "Beispiel Yuki Onodera · Transvest vorausfüllen"
    },
    "form": {
      "editTitle": "Bewertung bearbeiten",
      "newTitle": "Neue Bewertung",
      "artist": "Künstler",
      "medium": "Technik / Format, z. B. Eisenskulptur · Großformat",
      "priceLow": "Untere Spanne €",
      "priceHigh": "Obere Spanne €",
      "averageValue": "Durchschnittswert €",
      "recentWeight": "Gewicht <3 Jahre %",
      "oldWeight": "Gewicht 3–5 Jahre %",
      "galleryCap": "Galerieobergrenze €",
      "minReferences": "Min. Referenzen",
      "dimension": "Abmessungen %",
      "technique": "Technik %",
      "proximity": "Nähe %",
      "freshness": "Aktualität %",
      "pointLow": "Unterer Punktwert €",
      "pointHigh": "Oberer Punktwert €",
      "comparableArtist": "Vergleichskünstler",
      "logic": "Begründung: gleiche Generation, Material…",
      "source": "Quelle",
      "careerDiscount": "Karriereabschlag %",
      "maxPriceWeight": "Max. Preisgewicht %",
      "observedLow": "Beobachteter Tiefstwert €",
      "observedHigh": "Beobachteter Höchstwert €",
      "discount": "Abschlag %",
      "weight": "Gewicht %",
      "notes": "Expertennotizen, Quellen, Vorsicht, Markt, Trend…"
    },
    "groupA": {
      "title": "Parameter Gruppe A — erweiterter Vergleich",
      "description": "Derselbe Künstler bedeutet nicht automatisch Vergleichbarkeit: ARTKIV gewichtet auch Abmessungen, Technik, Formatnähe und Aktualität der Verkäufe. Verkäufe, die älter als fünf Jahre sind, werden ausgeschlossen, sofern der Experte sie nicht manuell wieder aufnimmt."
    },
    "groupB": {
      "title": "Vergleichswerte Gruppe B",
      "description": "Geben Sie mindestens drei Vergleichskünstler an. Der Abschlag bleibt eine Expertenentscheidung; die Koeffizienten bewerten Abmessungen, Technik, Nähe und Aktualität.",
      "comparable": "Vergleich #{{number}}",
      "expertOverride": "Persönliche Expertenentscheidung: Diese Analogie trotz Marktunterschied beibehalten.",
      "adjustedResult": "Angepasstes Ergebnis:",
      "calculatedRange": "Berechnete Spanne Gruppe B:",
      "average": "Durchschnitt"
    },
    "marketRoles": {
      "trendOnly": "Trendanalogie",
      "context": "Nur Kontext",
      "priceComparable": "Preisvergleich mit geringer Gewichtung"
    },
    "marketTiers": {
      "inferior": "Niedrigerer Markt",
      "equivalent": "Gleichwertiger Markt",
      "superior": "Höherer Markt",
      "different": "Anderer Markt"
    },
    "actions": {
      "add": "Hinzufügen",
      "delete": "Löschen",
      "edit": "Bearbeiten",
      "saving": "Wird gespeichert…",
      "update": "Aktualisieren",
      "save": "Speichern",
      "cancel": "Abbrechen"
    },
    "list": {
      "title": "Meine persönlichen Bewertungen",
      "search": "Künstler oder Technik suchen…",
      "empty": "Keine Bewertungen gefunden.",
      "groupARecorded": "Gruppe A: Gewichtung nach Abmessungen / Technik / Nähe / Aktualität gespeichert.",
      "groupB": "Gruppe B:",
      "marketRules": "Individuelle Marktregeln: {{count}} Künstler",
      "average": "Durchschnitt:"
    }
  },
  "artistQuotePage": {
    "title": "🎨 Künstler-Marktwert suchen",
    "artistName": "Name des Künstlers",
    "artistPlaceholder": "Z. B. Bernar Venet",
    "medium": "Technik",
    "mediums": {
      "oil": "Öl auf Leinwand",
      "watercolor": "Aquarell",
      "drawing": "Zeichnung",
      "sculpture": "Skulptur"
    },
    "submit": "Dashboard anzeigen"
  },
  "accountPage": {
    "loading": "Ihr Abonnement wird geladen…",
    "title": "Mein Abonnement",
    "plan": "Tarif:",
    "status": "Status:",
    "trialActive": "⏳ Testphase aktiv — Sie haben noch {{count}} Tag(e) Zeit für Ihre Entscheidung.",
    "trialActive_one": "⏳ Testphase aktiv — Sie haben noch {{count}} Tag Zeit für Ihre Entscheidung.",
    "trialActive_other": "⏳ Testphase aktiv — Sie haben noch {{count}} Tage Zeit für Ihre Entscheidung.",
    "active": "✓ Abonnement aktiv",
    "pastDue": "Zahlung überfällig — aktualisieren Sie Ihre Zahlungsmethode.",
    "frozen": "🔒 Ihr Profil ist vorübergehend gesperrt. Wählen Sie einen Tarif, um alle Funktionen wieder zu nutzen.",
    "manage": "Abonnement verwalten",
    "invoices": "Meine Rechnungen",
    "noSubscription": "Kein aktives Abonnement.",
    "choosePlan": "Tarif auswählen",
    "plans": {
      "standard": "Standard",
      "premium": "Premium",
      "family_office": "Family Office",
      "art_advisor": "Art Advisor",
      "art_advisor_premium": "Art Advisor Premium",
      "expert": "Experte"
    },
    "statuses": {
      "active": "Aktiv",
      "trialing": "Testphase",
      "past_due": "Zahlung überfällig",
      "canceled": "Gekündigt",
      "unpaid": "Unbezahlt",
      "incomplete": "Unvollständig",
      "paused": "Pausiert"
    }
  },
  "conservationTrackingPage": {
    "title": "Konservierungsüberwachung",
    "values": {
      "notProvidedMasculine": "Nicht angegeben",
      "notProvidedFeminine": "Nicht angegeben",
      "assessmentPending": "Bewertung ausstehend",
      "toCalculate": "Zu berechnen",
      "toSchedule": "Zu planen",
      "sampleRecommendation": "Das Kunstwerk ist in ausgezeichnetem Zustand, einschließlich der Ecken und der Oberfläche. Die nächste Sichtprüfung sollte in 1 Jahr und ein vollständiger Zustandsbericht in 5 Jahren erfolgen. Temperatur bei 18–20 °C und relative Luftfeuchtigkeit bei 45–55 % halten. Direkte UV-Einstrahlung vermeiden."
    }
  },
  "messaging": {
    "back": "Zurück",
    "title": "Nachrichten",
    "conversations": "Unterhaltungen",
    "loading": "Wird geladen…",
    "emptyConversations": "Noch keine Unterhaltungen.",
    "conversation": "Unterhaltung",
    "selectConversation": "Unterhaltung auswählen",
    "chooseConversation": "Wählen Sie eine Unterhaltung aus der Liste.",
    "emptyMessages": "Noch keine Nachrichten. Starten Sie die Unterhaltung 🙂",
    "placeholder": "Nachricht schreiben…",
    "send": "Senden",
    "user": "Benutzer",
    "userWithId": "Benutzer ({{id}}…)",
    "errors": {
      "loadConversations": "Unterhaltungen konnten nicht geladen werden.",
      "loadMessages": "Nachrichten konnten nicht geladen werden.",
      "send": "Nachricht konnte nicht gesendet werden.",
      "introFeeRequired": "Nehmen Sie zuerst die Vermittlung an (Tab Kunden), um diesem Sammler zu antworten."
    },
    "rlsNote": "RLS-Sicherheit: Der Zugriff ist auf autorisierte Unterhaltungen und Nachrichten beschränkt."
  },
  "insuranceRequest": {
    "header": {
      "title": "Versicherungsanfrage",
      "subtitle": "Fordern Sie ein Angebot an und bestimmen Sie genau, welche Informationen mit dem Makler geteilt werden."
    },
    "dataControl": {
      "title": "Kontrolle der freigegebenen Daten",
      "description": "Sie entscheiden genau, welche Angaben aus dem Kunstwerkdatensatz an den Makler übermittelt werden. Standardmäßig werden die erforderlichen technischen Daten geteilt, während sensible Informationen wie detaillierte Provenienz, Kaufpreis und genauer Standort geschützt bleiben.",
      "sharedCountSuffix": "/{{total}} Felder geteilt",
      "hide": "Ausblenden",
      "customize": "Anpassen",
      "controlLabel": "Datenkontrolle",
      "shareAll": "✓ Alles teilen",
      "minimum": "🔐 Notwendiges Minimum"
    },
    "sections": {
      "identity": "🎨 Identität des Kunstwerks",
      "technical": "🔬 Technische Merkmale",
      "condition": "⚙️ Zustand und Konservierung",
      "authenticity": "✅ Authentizität",
      "values": "💰 Werte",
      "acquisitionWarning": "Erwerbsinformationen, Freigabe nicht empfohlen",
      "other": "Weitere Daten"
    },
    "labels": {
      "recommended": "(empfohlen)",
      "premiumImpact": "(wirkt sich auf die Prämie aus)",
      "sensitive": "(sensibel)",
      "verySensitive": "(sehr sensibel)"
    },
    "fields": {
      "title": "Titel",
      "artist": "Künstler",
      "year": "Jahr",
      "typeOfArt": "Kunstgattung",
      "medium": "Medium / Technik",
      "dimensions": "Maße",
      "condition": "Zustand",
      "conditionNotes": "Zustandsnotizen",
      "provenance": "Provenienz",
      "certificate_auth": "Echtheitszertifikat",
      "signature": "Signatur",
      "signature_desc": "Beschreibung der Signatur",
      "editionInfo": "Editionsangaben",
      "acquisition_date": "Erwerbsdatum",
      "acquisition_source": "Erwerbsquelle",
      "acquisition_price": "Kaufpreis",
      "acquisition_type": "Erwerbsart",
      "estimated_value": "Geschätzter Wert",
      "valuation_estimated_value": "Bewertungswert",
      "last_estimation_date": "Datum der letzten Bewertung",
      "location_id": "Genauer Standort",
      "image_url": "Bild",
      "description": "Beschreibung",
      "documents": "Dokumente",
      "specifications": "Spezifikationen",
      "subjectMatter": "Motiv / Thema",
      "styles": "Stile"
    },
    "anonymization": {
      "active": "Aktive Anonymisierung:"
    },
    "anonymized": {
      "workByArtist": "Werk von {{artist}}",
      "longProvenance": "Über mehrere Jahrzehnte dokumentierte Historie",
      "establishedProvenance": "Gesicherte und dokumentierte Provenienz",
      "specializedGallery": "Spezialisierte europäische Galerie",
      "publicAuction": "Öffentliche Auktion",
      "professionalSource": "Etablierte professionelle Quelle",
      "secureLocation": "Sicherer Standort, Kennung verborgen"
    },
    "artwork": {
      "fallbackTitle": "Kunstwerk",
      "year": "Jahr",
      "medium": "Medium",
      "dimensions": "Maße",
      "condition": "Zustand",
      "certificate": "Echtheitszertifikat",
      "currentEstimate": "Aktuelle Schätzung",
      "sharedSummary": "{{shared}} von {{total}} Feldern werden an den Makler übermittelt.",
      "tipTitle": "Hinweis:",
      "tipBody": "Starten Sie die Anfrage aus dem Kunstwerkdatensatz, damit der Makler die erforderlichen Informationen automatisch und ohne unnötige Rückfragen erhält."
    },
    "coverage": {
      "question": "Wie ist Ihre Situation?",
      "homePremium": {
        "title": "Hochwertige Hausratversicherung",
        "body": "Deckung meiner Kunstwerke prüfen, Lücken erkennen und zusätzlichen Schutz anfragen."
      },
      "fineArt": {
        "title": "Spezielle Kunstversicherung",
        "body": "Eine eigene Police mit maßgeschneidertem Schutz entsprechend dem tatsächlichen Wert der Werke."
      }
    },
    "policy": {
      "label": "Gewünschte Versicherungsart",
      "select": "— Auswählen —",
      "nailToNail": "🧷 Von Nagel zu Nagel, Veranstaltung, Transport oder Ausstellung",
      "allRisks": "🛡️ Allgefahren, umfassender Schutz",
      "transportRequired": "Transport erforderlich"
    },
    "event": {
      "start": "Beginn der Veranstaltung, optional",
      "end": "Ende der Veranstaltung, optional"
    },
    "form": {
      "storageLocation": "Aufbewahrungsort",
      "storagePlaceholder": "Wohnung, Lager, Galerie, Freeport…",
      "insuredValue": "Zu versichernder Wert (EUR)",
      "prefilled": "(aus dem Kunstwerkdatensatz vorausgefüllt)",
      "valuePlaceholder": "Z. B. 12000",
      "context": "Zusätzlicher Kontext oder Nachricht, optional",
      "contextPlaceholder": "Angaben zu Erwartungen, Fristen oder besonderen Bedingungen…",
      "name": "Ihr Name, optional",
      "email": "Ihre E-Mail-Adresse, optional"
    },
    "consent": {
      "title": "Rahmen des Versicherungsvermittlungsdienstes",
      "description": "Mit dem Absenden bestätigen Sie, dass Artkiv ausschließlich als Vermittlungsplattform handelt und keine Versicherungsprodukte verkauft. Partnermakler arbeiten unabhängig. Über Artkiv wird kein Versicherungsvertrag abgeschlossen.",
      "checkbox": "Ich habe den Rahmen des Dienstes gelesen und möchte diese Anfrage übermitteln.",
      "link": "Vollständige Bedingungen lesen"
    },
    "actions": {
      "sending": "Wird gesendet…",
      "submit": "✨ Anfrage senden",
      "cancel": "Abbrechen"
    },
    "errors": {
      "acceptTerms": "Bitte akzeptieren Sie den Rahmen des Dienstes, bevor Sie die Anfrage senden.",
      "noSession": "Keine aktive Sitzung.",
      "invalidInsuredValue": "Der Versicherungswert ist ungültig.",
      "selectPolicy": "Bitte wählen Sie eine Versicherungsart: von Nagel zu Nagel oder Allgefahren.",
      "submit": "Beim Senden der Anfrage ist ein Fehler aufgetreten."
    },
    "footer": {
      "title": "Warum all diese Informationen teilen?",
      "body": "Ein spezialisierter Makler bewertet das Risiko anhand von Technik, Zustand, Provenienz und aktuellem Wert. Ein vollständiges Dossier ermöglicht bereits beim ersten Austausch eine passende Empfehlung.",
      "note": "⚡ Schnellere Bearbeitung und klarere Kommunikation"
    }
  },
  "insuranceRequestDetail": {
    "loading": "Ihre Anfrage wird geladen…",
    "notFound": "Anfrage nicht gefunden.",
    "artworkFallback": "Kunstwerk",
    "errors": {
      "load": "Anfrage konnte nicht geladen werden.",
      "updateStatus": "Status konnte nicht aktualisiert werden."
    },
    "header": {
      "title": "Anfragedetails",
      "subtitle": "Status Ihrer Versicherungsanfrage",
      "createdAt": "Erstellt am {{date}}"
    },
    "actions": {
      "back": "← Zurück",
      "backToRequests": "← Zurück zu meinen Anfragen",
      "refresh": "🔄 Aktualisieren",
      "accept": "✓ Angebot annehmen",
      "reject": "✗ Ablehnen"
    },
    "status": {
      "pending": "Ausstehend",
      "seen": "Angesehen",
      "answered": "Antwort erhalten",
      "quoted": "Angebot erhalten",
      "accepted": "Angenommen",
      "rejected": "Abgelehnt",
      "done": "Abgeschlossen",
      "unknown": "Unbekannter Status"
    },
    "statusExplanation": {
      "pending": "Der Partnermakler hat die Anfrage erhalten und wird sie innerhalb von 48 Stunden prüfen.",
      "seen": "Der Makler hat die Anfrage geöffnet und bereitet eine Empfehlung vor.",
      "answered": "Sie haben eine Antwort erhalten. Prüfen Sie sie in Ruhe, bevor Sie entscheiden.",
      "quoted": "Sie haben ein Angebot erhalten. Prüfen Sie es in Ruhe, bevor Sie entscheiden.",
      "accepted": "Sie haben das Angebot angenommen. Der Makler wird Sie zur Finalisierung kontaktieren.",
      "rejected": "Sie haben das Angebot abgelehnt. Bei Bedarf können Sie eine neue Anfrage stellen.",
      "done": "Diese Anfrage ist abgeschlossen.",
      "unknown": "Der Status dieser Anfrage wird aktualisiert."
    },
    "analysis": {
      "title": "Wie bewertet der Makler Ihre Anfrage?",
      "body": "Anhand der Angaben im Kunstwerkdatensatz, insbesondere Provenienz, Zertifikate und Zustand, kann der Makler Risiken präzise bewerten und geeigneten Schutz empfehlen, ohne zahlreiche Dokumente per E-Mail anzufordern.",
      "note": "⚡ Schnellere Bearbeitung und eine präzisere Empfehlung für Ihre Sammlung."
    },
    "details": {
      "requestType": "Anfragetyp",
      "insuredValue": "Versicherungswert",
      "context": "Kontext"
    },
    "requestType": {
      "insurance_quote": "Anfrage für ein Versicherungsangebot"
    },
    "coverage": {
      "home_premium": "Hochwertige Hausratversicherung",
      "fine_art_policy": "Spezielle Kunstversicherung"
    },
    "policy": {
      "nail_to_nail": "Von Nagel zu Nagel",
      "all_risks": "Allgefahren"
    },
    "coverageDetails": {
      "title": "📋 Gewünschter Versicherungsschutz",
      "policyType": "Versicherungsart",
      "storageLocation": "Aufbewahrungsort",
      "transportRequired": "Transport für dieses Kunstwerk erforderlich",
      "eventPeriod": "Veranstaltungszeitraum"
    },
    "sharedInfo": {
      "title": "📄 Mit dem Makler geteilte Informationen",
      "description": "Diese Angaben wurden für diese Anfrage bewusst geteilt. Sie helfen dem Makler, Ihren Bedarf ohne wiederholte Rückfragen zu verstehen."
    },
    "partner": {
      "title": "Empfehlung des Partnermaklers",
      "noticeTitle": "Wichtige Hinweise",
      "noticeBody": "Das folgende Angebot ist unverbindlich. Prüfen Sie es sorgfältig, stellen Sie Fragen und entscheiden Sie frei.",
      "message": "Nachricht des Maklers",
      "quoteAmount": "Vorgeschlagene Prämie",
      "percentage": "Etwa {{percentage}} % des Versicherungswerts, ein angemessener Preis zum Schutz Ihres Vermögens.",
      "importantTitle": "Wichtig:",
      "importantBody": "Bei Annahme wird der Vertrag direkt mit dem Partnermakler außerhalb der Artkiv-Plattform geschlossen. Sie werden innerhalb von 48 Stunden kontaktiert, um die Bedingungen zu finalisieren."
    },
    "pending": {
      "title": "Prüfung läuft",
      "body": "Der Partnermakler hat die Anfrage erhalten und prüft die Angaben. Im Durchschnitt erhalten Sie innerhalb von 48 Stunden eine Empfehlung.",
      "note": "Eine sorgfältige Prüfung hilft, die passendste Lösung zu finden."
    },
    "footer": {
      "title": "Warum ist Kunstversicherung vergleichsweise günstig?",
      "body": "Prämien für Kunstversicherungen liegen typischerweise bei 0,1 % bis 0,3 % des Werts pro Jahr. Für ein Werk im Wert von 20.000 € entspricht dies etwa 20–60 € pro Monat. Im Vergleich zu den finanziellen und emotionalen Folgen eines Totalverlusts ist dies eine schützende Investition.",
      "note": "✨ Einige Policen umfassen Bewertungen, Notfallrestaurierung und Rechtsberatung."
    }
  },
  "insuranceRequests": {
    "hero": {
      "title": "Meine Versicherungsanfragen",
      "subtitle": "Verfolgen Sie Anfragen für Angebote, Bescheinigungen und Wertaktualisierungen."
    },
    "actions": {
      "newRequest": "✨ Neue Anfrage",
      "refresh": "🔄 Aktualisieren",
      "viewDetails": "Details ansehen"
    },
    "errors": {
      "noSession": "Keine aktive Sitzung.",
      "load": "Versicherungsanfragen konnten nicht geladen werden."
    },
    "loading": "Ihre Anfragen werden geladen…",
    "artworkFallback": "Kunstwerk",
    "education": {
      "whyInsure": {
        "title": "Warum eine Kunstsammlung versichern?",
        "protection": "Schützen Sie, was zählt. Auch an einem sicheren Ort bestehen Risiken wie Wasserschäden, Brand, Diebstahl oder Unfallschäden beim Transport.",
        "affordable": "Eine erschwingliche Prämie. Die Versicherung eines Kunstwerks kostet meist 0,1 % bis 0,3 % seines Werts pro Jahr. Bei einem Werk im Wert von 10.000 € sind das etwa 10–30 € pro Monat.",
        "note": "💬 Unsere Partnermakler prüfen den Kunstwerkdatensatz und empfehlen maßgeschneiderten Schutz."
      },
      "sharing": {
        "title": "Warum Informationen aus dem Kunstwerkdatensatz teilen?",
        "body": "Jede Anfrage gibt dem Partnermakler nur Zugriff auf die von Ihnen ausgewählten Angaben, etwa Provenienz, Zertifikate, Zustandsberichte oder die letzte Bewertung.",
        "result": "Ergebnis: schnellere Prüfung, präzisere Empfehlung und weniger E-Mail-Rückfragen.",
        "note": "🔒 Der Partner kann nur diese Anfrage sehen, niemals den Rest Ihrer Sammlung."
      }
    },
    "privacy": {
      "title": "Kontrolle und Vertraulichkeit",
      "body": "Artkiv verkauft keine Versicherungsprodukte. Die Plattform vermittelt einen auf Kunst spezialisierten Makler, der aufgrund seiner Expertise ausgewählt wurde.",
      "scope": "Die übermittelten Informationen sind strikt auf den für die Prüfung erforderlichen Umfang begrenzt. Der Makler sieht nichts anderes."
    },
    "empty": {
      "title": "Noch keine Anfragen.",
      "body": "Stellen Sie Ihre erste Anfrage, um eine auf Ihre Sammlung zugeschnittene Versicherungsempfehlung zu erhalten. Der Vorgang ist schnell, vertraulich und unverbindlich.",
      "cta": "Erste Anfrage erstellen"
    },
    "coverage": {
      "home_premium": "Hochwertige Hausratversicherung",
      "fine_art_policy": "Kunstversicherung"
    },
    "policy": {
      "nail_to_nail": "Von Nagel zu Nagel",
      "all_risks": "Allgefahren"
    },
    "labels": {
      "transport": "Transport",
      "type": "Typ",
      "insuredValue": "Versicherungswert"
    },
    "requestType": {
      "insurance_quote": "Anfrage für ein Versicherungsangebot"
    },
    "status": {
      "pending": "Ausstehend",
      "seen": "Angesehen",
      "answered": "Antwort erhalten",
      "quoted": "Angebot erhalten",
      "accepted": "Angenommen",
      "rejected": "Abgelehnt",
      "done": "Abgeschlossen"
    },
    "footer": {
      "title": "Mehr als eine gewöhnliche Versicherung",
      "body": "Jede Anfrage verbindet Sie mit einem Spezialisten, der den finanziellen und emotionalen Wert Ihrer Sammlung versteht. Sie erhalten eine maßgeschneiderte Prüfung statt eines Standardformulars oder ungeeigneten Schutzes.",
      "note": "💬 Fragen zu Ihrem aktuellen Schutz? Unsere Partnermakler antworten in der Regel innerhalb von 48 Stunden."
    }
  },
  "partners": {
    "back": "Zurück",
    "loading": "Wird geladen…",
    "close": "Schließen",
    "title": "Unsere Servicepartner",
    "subtitle": "Qualifizierte und vertrauenswürdige Fachleute für die Verwaltung Ihrer Sammlung.",
    "search": "Suchen…",
    "service": "Dienstleistung",
    "categories": {
      "labels": {
        "all": "Alle",
        "insurance": "Versicherungsmakler",
        "transport": "Kunsttransporteure",
        "conservation": "Restauratoren",
        "other": "Weitere Dienste"
      },
      "descriptions": {
        "all": "Alle Partner",
        "insurance": "Schutz für Ihre Kunstwerke",
        "transport": "Spezialisierter Kunsttransport",
        "conservation": "Konservierung und Restaurierung",
        "other": "Ergänzende Dienstleistungen"
      }
    },
    "contact": "Kontaktieren",
    "addToContacts": "Zu meinen Kontakten hinzufügen",
    "alert": {
      "loginRequired": "Bitte melden Sie sich an, um diesen Partner zu Ihren Kontakten hinzuzufügen.",
      "addedToContacts": "Partner wurde zu Ihren Kontakten hinzugefügt.",
      "comingSoon": "Diese Funktion wird für diesen Partnertyp bald verfügbar sein.",
      "error": "Partner konnte nicht hinzugefügt werden."
    },
    "errors": {
      "load": "Partner konnten nicht geladen werden."
    },
    "modal": {
      "title": "Partner kontaktieren",
      "desc": "Verwenden Sie die folgenden Kontaktdaten:",
      "company": "Unternehmen",
      "email": "E-Mail",
      "phone": "Telefon",
      "address": "Adresse"
    },
    "empty": {
      "title": "Keine Partner gefunden",
      "search": "Versuchen Sie eine andere Suche",
      "filter": "Wählen Sie eine andere Kategorie"
    }
  },
  "eventLanding": {
    "ribbon": {
      "onSite": "Vor Ort:",
      "followStories": "Unsere Stories ansehen →"
    },
    "events": {
      "when": {
        "thisWeek": "diese Woche",
        "nextWeek": "nächste Woche",
        "december": "im Dezember"
      }
    },
    "hero": {
      "title": "Treffen wir uns auf der Messe.",
      "subtitle": "Artkiv verbindet KI, Blockchain und menschliche Expertise, um Kunstwerke zu dokumentieren, zu bewerten und zu schützen. Kunst wird nicht nur gesammelt, sondern weitergegeben.",
      "freeTrial": "🎁 14 Tage kostenlos testen",
      "requestMeeting": "📅 Termin auf der Messe anfragen"
    },
    "audiences": {
      "collectors": {
        "title": "Sammlerinnen und Sammler",
        "body": "Lebenslauf der Kunstwerke, Provenienz und Dokumente, verständliche Bewertungen und vereinfachte familiäre Weitergabe."
      },
      "families": {
        "title": "Familien und Erben",
        "body": "Kunst geerbt? Wir klären, was Sie besitzen, welchen Wert es hat und wie rechtliche oder steuerliche Fehler vermieden werden."
      },
      "professionals": {
        "title": "Family Offices und Versicherer",
        "body": "Nutzbare Kulturgutdossiers, Rückverfolgbarkeit und Nachweise zur Risikoreduzierung und einfacheren Absicherung."
      }
    },
    "meeting": {
      "title": "Sprechen wir 15 Minuten vor Ort?",
      "body": "Bringen Sie ein konkretes Kunstwerk, ein Foto, eine Rechnung oder ein Zertifikat mit oder einfach eine Frage zu Nachlass oder Versicherung. Wir reservieren während der Messe einen diskreten Termin.",
      "emailSubject": "Termin auf der Kunstmesse",
      "emailCta": "✉️ Anfrage senden",
      "instagramCta": "Instagram-DM an @artkiv_official"
    },
    "footer": {
      "tagline": "Ein vertrauenswürdiges Werkzeug für Privatsammlungen: Wert, Rückverfolgbarkeit und Schutz."
    }
  },
  "sharedPage": {
    "title": "Mit mir geteilte Sammlungen"
  },
  "artworkCharts": {
    "title": "Sammlungsstatistiken",
    "collection": "Sammlung",
    "allCollections": "Alle",
    "noCollection": "Ohne Sammlung",
    "untitled": "Ohne Titel",
    "unknown": "Unbekannt",
    "notProvided": "Nicht angegeben",
    "notLocated": "Nicht verortet",
    "loadError": "Werke konnten nicht geladen werden.",
    "charts": {
      "valueByLocation": "Gesamtwert nach Standort",
      "artworksByArtist": "Anzahl der Werke nach Künstler",
      "byMedium": "Verteilung nach Medium",
      "byType": "Verteilung nach Kunsttyp",
      "byPeriod": "Verteilung nach Zeitraum",
      "byTotalValue": "Verteilung nach Gesamtwert"
    },
    "datasets": {
      "totalValue": "Gesamtwert",
      "artworks": "Werke"
    },
    "periodHelp": "Werke ohne Jahresangabe werden der Kategorie „Unbekannt“ zugeordnet.",
    "noValueData": "Keine Wertdaten verfügbar",
    "tooltipCount": "{{value}} ({{percent}} %)"
  },
  "artworkCosts": {
    "title": "Kostenverfolgung – {{artwork}}",
    "artworkFallback": "Werk Nr. {{id}}",
    "back": "Zurück zum Werk",
    "addTitle": "Kosten hinzufügen",
    "selectType": "Typ auswählen",
    "amountPlaceholder": "Betrag (€)",
    "description": "Beschreibung",
    "provider": "Dienstleister",
    "automaticCategory": "Automatische Kategorie:",
    "saving": "Wird gespeichert…",
    "add": "Hinzufügen",
    "history": "Kostenhistorie",
    "columns": {
      "date": "Datum",
      "type": "Typ",
      "amount": "Betrag",
      "lot": "Los",
      "description": "Beschreibung",
      "provider": "Dienstleister"
    },
    "total": "Gesamt",
    "saveError": "Die Kosten konnten nicht gespeichert werden.",
    "loadError": "Die Kosten konnten nicht geladen werden.",
    "empty": "Keine Kosten erfasst.",
    "lots": {
      "lot1": "Los 1",
      "lot2": "Los 2"
    },
    "types": {
      "fabrication": "Herstellung",
      "framing": "Rahmung",
      "otherTechnical": "Sonstiges (technisch)",
      "exhibition": "Ausstellung",
      "documentation": "Dokumentation",
      "legalFees": "Rechtskosten",
      "otherEnhancement": "Sonstiges (Aufwertung)"
    }
  },
  "smartDashboardRedirect": {
    "loadingDashboard": "Dashboard wird geladen…",
    "loadingPartner": "Partnerbereich wird geladen…"
  },
  "marketInsights": {
    "loading": "Art-Basel-Daten 2025 werden geladen…",
    "loadError": "Art-Basel-Daten konnten nicht geladen werden",
    "title": "Art Basel 2025 Insights",
    "subtitle": "Daten und Analysen zum Markt für zeitgenössische Kunst",
    "nav": {
      "overview": "Übersicht",
      "sectors": "Sektoren",
      "prices": "Preise",
      "recommendations": "Empfehlungen"
    },
    "overview": {
      "title": "Marktübersicht 2025",
      "globalSales": "Weltweite Verkäufe",
      "billionUsd": "Milliarden USD",
      "onlineShare": "E-Commerce-Anteil",
      "vs2024": "+2 % gegenüber 2024",
      "volumeGrowth": "Volumenwachstum",
      "transactions": "Transaktionen",
      "averageValue": "Durchschnittswert",
      "perTransaction": "Je Transaktion",
      "topMarkets": "Wichtigste Märkte"
    },
    "sectors": {
      "title": "Performance nach Sektor",
      "performance": "Performance:",
      "volume": "Volumen:"
    },
    "prices": {
      "title": "Preissegmente",
      "volumeShare": "Volumenanteil:",
      "valueShare": "Wertanteil:",
      "growth": "Wachstum:"
    },
    "recommendations": {
      "title": "KI-Empfehlungen",
      "collectorInsights": "Sammler-Insights",
      "artAllocation": "Durchschnittliche Kunstallokation",
      "onlinePreference": "Bevorzugen Online-Käufe",
      "millennials": "Beteiligung der Millennials"
    },
    "footer": {
      "source": "Quellen: Art Basel & UBS Report 2025 • Algorithmusversion {{version}}",
      "updated": "Letzte Aktualisierung: {{date}}"
    },
    "countries": {
      "United States": "Vereinigte Staaten",
      "United Kingdom": "Vereinigtes Königreich",
      "China": "China",
      "France": "Frankreich",
      "Switzerland": "Schweiz",
      "Hong Kong": "Hongkong"
    },
    "sectorNames": {
      "Contemporary Art": "Zeitgenössische Kunst",
      "Modern Art": "Moderne Kunst",
      "Post-War Art": "Nachkriegskunst",
      "Impressionist and Post-Impressionist": "Impressionismus und Postimpressionismus",
      "Old Masters": "Alte Meister"
    }
  },
  "expertsDirectory": {
    "badge": "Artkiv-Experte",
    "requestLabel": "Anfrage",
    "defaultIntro": "Guten Tag, ich möchte Sie als persönlichen Art Advisor hinzufügen.",
    "conversationError": "Konversation konnte nicht erstellt werden",
    "loginRequired": "Bitte melden Sie sich an.",
    "artkivOnly": "Nur für Artkiv-Experten verfügbar.",
    "notAuthenticated": "Benutzer nicht authentifiziert",
    "alreadyRequested": "Eine Anfrage ist bereits offen oder angenommen.",
    "requestDescription": "Anfrage für persönlichen Berater",
    "success": "Einladung gesendet. Die Antwort des Experten steht noch aus.",
    "sendError": "Die Anfrage konnte nicht gesendet werden.",
    "title": "Artkiv-Experten",
    "search": "Experten suchen…",
    "allSpecialties": "Alle Fachgebiete",
    "becomeAdvisor": "Als persönlichen Berater auswählen",
    "messagePlaceholder": "Nachricht an den Experten (optional)",
    "sending": "Wird gesendet…",
    "send": "Anfrage senden"
  },
  "addArtwork": {
    "title": "Werk hinzufügen",
    "tabs": {
      "details": "Details",
      "specifications": "Spezifikationen",
      "provenance": "Provenienz",
      "documents": "Dokumente",
      "location": "Standort",
      "nft": "NFT"
    },
    "collection": {
      "label": "Sammlung auswählen",
      "auto": "Sammlung automatisch erstellen (Standard)",
      "unnamed": "Unbenannte Sammlung ({{id}})",
      "create": "+ Neue Sammlung erstellen",
      "prompt": "Name der neuen Sammlung:",
      "created": "Sammlung erstellt.",
      "createError": "Die Sammlung konnte nicht erstellt werden."
    },
    "uploadError": "Das Bild konnte nicht hochgeladen werden.",
    "success": "Werk erfolgreich hinzugefügt.",
    "saveError": "Fehler: {{message}}",
    "saving": "Wird hinzugefügt…",
    "submit": "Werk hinzufügen"
  },
  "acceptCollectionTransfer": {
    "errors": {
      "invalid": "Ungültiger Link.",
      "notFound": "Link nicht gefunden oder abgelaufen.",
      "expired": "Dieser Link ist abgelaufen (7 Tage gültig).",
      "cancelled": "Diese Übertragung wurde vom Art Advisor storniert.",
      "network": "Netzwerkfehler. Bitte erneut versuchen.",
      "generic": "Fehler"
    },
    "loading": "Link wird geprüft…",
    "invalidTitle": "Ungültiger Link",
    "home": "Zur Startseite",
    "wrongUserTitle": "Falsches Konto",
    "wrongUserBody": "Dieser Link ist für {{expected}} bestimmt. Sie sind als {{current}} angemeldet.",
    "wrongUserHelp": "Melden Sie sich ab und anschließend mit dem richtigen Konto wieder an.",
    "switchAccount": "Abmelden und Konto wechseln",
    "doneTitle": "Sammlungen übertragen",
    "doneBody": "Die Sammlungen befinden sich jetzt in Ihrem Artkiv-Bereich.",
    "viewCollections": "Meine Sammlungen ansehen",
    "accepting": "Übertragung läuft…",
    "eyebrow": "ÜBERTRAGUNGSEINLADUNG",
    "title": "Ihr Art Advisor überträgt Sammlungen an Sie",
    "included": "Enthaltene Sammlungen",
    "notice": "Mit der Annahme erscheinen diese Sammlungen in Ihrem Bereich. Ihr Art Advisor behält einen eingeschränkten Zugang, um Sie zu unterstützen.",
    "accept": "Übertragung annehmen",
    "loginHelp": "Melden Sie sich mit {{email}} an oder erstellen Sie ein Konto, um anzunehmen.",
    "login": "Anmelden",
    "register": "Konto erstellen"
  },
  "transportPreforum": {
    "documentTitle": "Kunsttransport – Angebotsanfrage | ARTKIV",
    "authRequired": "Sie müssen angemeldet sein, um eine Transportanfrage zu senden.",
    "sendError": "Die Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
    "title": "Kunsttransport – Angebotsanfrage",
    "subtitle": "Erfassung der Angaben für ein Angebot eines Transportpartners.",
    "steps": {
      "one": "Schritt 1 – Orte und Werke",
      "two": "Schritt 2 – Optionen und Versicherung",
      "three": "Schritt 3 – Zusammenfassung und Versand"
    },
    "prefill": "Adresse wird vorbefüllt…",
    "fields": {
      "carrier": "Transporteur",
      "salutation": "Anrede",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "phone": "Telefon",
      "pickupAddress": "Abholadresse",
      "deliveryAddress": "Lieferadresse",
      "city": "Stadt",
      "country": "Land",
      "desiredDate": "Wunschdatum",
      "distance": "Geschätzte Entfernung (km)",
      "floor": "Etage (falls kein Aufzug)",
      "pieces": "Anzahl der Stücke",
      "category": "Kategorie",
      "length": "L (cm)",
      "width": "B (cm)",
      "height": "H (cm)",
      "weight": "Gewicht (kg)",
      "packing": "Verpackung",
      "crate": "Schutzkiste",
      "volume": "Volumen",
      "handling": "Handhabung",
      "international": "Internationaler Transport",
      "temperature": "Temperaturkontrolle",
      "declaredValue": "Deklarierter Wert (€) für Versicherung",
      "customs": "Zollformalitäten",
      "attachments": "Fotos oder Dokumente hinzufügen"
    },
    "hintApprox": "ca.",
    "pickupPlaceholder": "Beispiel: 55 Storage Road, Boston, MA 02215, USA",
    "salutations": {
      "mrs": "Frau",
      "mr": "Herr",
      "other": "Andere"
    },
    "categories": {
      "painting": "Malerei",
      "sculpture": "Skulptur",
      "paper": "Zeichnung / Papier",
      "photography": "Fotografie",
      "object": "Möbel / Objekt"
    },
    "packing": {
      "bubble": "Luftpolsterfolie / Schaumstoff",
      "foam": "Hochdichter Schaumstoff",
      "crate": "Eigene Kiste"
    },
    "crate": {
      "none": "Keine",
      "cardboard": "Verstärkter Karton",
      "museum": "Holz (Museumsqualität)"
    },
    "volume": {
      "small": "Klein",
      "medium": "Mittel",
      "large": "Groß"
    },
    "handling": {
      "simple": "Einfach",
      "medium": "Mittel",
      "complex": "Komplex (Hängung / Rigging)"
    },
    "yes": "Ja",
    "no": "Nein",
    "toPlan": "Einzuplanen",
    "import": "Importieren",
    "filesAdded": "{{count}} Datei hinzugefügt",
    "filesAdded_plural": "{{count}} Dateien hinzugefügt",
    "quickEstimate": "Schnellschätzung",
    "quote": {
      "subtotal": "Logistik-Zwischensumme",
      "insurance": "Versicherung (Schätzung)",
      "vat": "MwSt. 20 %",
      "estimatedTotal": "Geschätzter Gesamtbetrag inkl. MwSt.",
      "partnerEstimate": "ARTKIV-Partnerschätzung (unverbindlich)"
    },
    "cancel": "Abbrechen",
    "back": "Zurück",
    "continue": "Weiter",
    "indicative": "unverbindliche Schätzung",
    "readyTitle": "Bereit zur Übermittlung an den Logistikpartner",
    "readyBody": "Wir erfassen Ihre Anfrage. Ein aktiver Transportpartner meldet sich, um Termin, Zugang, Team und Angebot zu bestätigen.",
    "summaryRequest": "Zusammenfassung der Anfrage",
    "copy": "Kopieren",
    "sending": "Wird gesendet…",
    "send": "Senden",
    "submittedTitle": "Anfrage erfasst",
    "submittedBody": "Ihre Transportanfrage wurde erfasst{{reference}}. Ein Transportpartner wird Sie per E-Mail oder Telefon kontaktieren.",
    "reference": " (Referenz {{id}})",
    "backArtwork": "Zurück zum Werk",
    "summary": "Zusammenfassung",
    "partner": "Partner:",
    "route": "Strecke",
    "floorLabel": "Etage:",
    "artworks": "Werk(e)",
    "selectedOptions": "Gewählte Optionen",
    "packingLabel": "Verpackung:",
    "crateLabel": "Kiste:",
    "volumeLabel": "Volumen:",
    "handlingLabel": "Handhabung:",
    "temperatureLabel": "Temperatur:",
    "internationalLabel": "International:",
    "customsLabel": "Zoll: Ja – Incoterm {{incoterm}}",
    "activeControl": "Aktive Kontrolle",
    "other": "Andere",
    "artkiv": "ARTKIV"
  },
  "delegatedAccess": {
    "roles": {
      "team_member": "Teammitglied",
      "team_readonly": "Nur-Lese-Zugriff",
      "expert": "Eingeladener Experte",
      "assistant": "Assistent",
      "client": "Kunde",
      "collaborator": "Mitarbeiter"
    },
    "tabs": {
      "collections": "Sammlungen",
      "artworks": "Werke",
      "locations": "Standorte",
      "reports": "Berichte",
      "vision": "Vision KI"
    },
    "edit": "Bearbeiten",
    "untitled": "Ohne Titel",
    "untitledCollection": "Unbenannte Sammlung",
    "noSharedCollections": "Keine freigegebenen Sammlungen",
    "artworkCount": "{{count}} Werk",
    "artworkCount_plural": "{{count}} Werke",
    "editable": "BEARBEITBAR",
    "search": "Titel, Künstler…",
    "loading": "Wird geladen…",
    "noArtwork": "Keine Werke.",
    "page": "Seite {{current}} / {{total}}",
    "allArtworksLoading": "Alle Werke werden geladen…",
    "allArtists": "Alle Künstler",
    "allMediums": "Alle Medien",
    "clear": "Löschen",
    "results": "{{count}} Ergebnis",
    "results_plural": "{{count}} Ergebnisse",
    "previous": "Zurück",
    "next": "Weiter",
    "unknownLocation": "Standort nicht angegeben",
    "reportsPermissionTitle": "Berechtigung nicht erteilt",
    "reportsPermissionBody": "Die Berichtserstellung ist in Ihrem Mitarbeiterzugang nicht enthalten.",
    "reportsIntro": "Greifen Sie auf Inventar- und Bewertungsberichte der freigegebenen Sammlungen zu.",
    "reportInventory": "PDF-Inventarbericht",
    "reportInventoryDesc": "Vollständiges Sammlungsinventar erstellen",
    "reportValuation": "Bewertungsbericht",
    "reportValuationDesc": "Schätzungs- und Bewertungsbericht",
    "visionPermissionBody": "Der Zugriff auf Vision-KI-Werkzeuge ist in Ihrem Mitarbeiterzugang nicht enthalten.",
    "visionIntro": "Nutzen Sie visuelle Analyse und die Anreicherung von Werkdaten.",
    "openVision": "Artkiv Vision öffnen",
    "noAccess": "Kein aktiver Mitarbeiterzugang.",
    "genericError": "Fehler.",
    "ownerFallback": "Ihr Experte",
    "loadingPage": "Wird geladen…",
    "accessUnavailable": "Zugriff nicht verfügbar",
    "logout": "Abmelden",
    "logoutShort": "Abmelden",
    "access": "Zugriff:",
    "permissions": {
      "view": "Ansehen",
      "edit": "Bearbeiten",
      "add": "Hinzufügen",
      "delete": "Löschen",
      "export": "Exportieren",
      "reports": "Berichte",
      "ai": "KI"
    },
    "footer": "Ihr Zugriff wird von {{owner}} verwaltet und kann jederzeit geändert oder widerrufen werden. Alle Ihre Aktionen werden protokolliert. Für diesen Bereich ist kein Abonnement erforderlich."
  },
  "inflationReport": {
    "back": "Zurück",
    "title": "Inflationsbereinigter Anschaffungswert",
    "subtitle": "Anpassung des Kaufpreises – INSEE-VPI Basis 100 (2015)",
    "ipc": {
      "live": "Live-VPI – {{date}}",
      "embedded": "Eingebetteter VPI – {{date}}",
      "loading": "VPI wird geladen…",
      "unavailable": "VPI nicht verfügbar"
    },
    "collection": "Sammlung",
    "select": "Auswählen…",
    "clientName": "Name des Kunden (für den Bericht)",
    "clientPlaceholder": "Beispiel: Galerie RX",
    "loadingArtworks": "Werke werden geladen…",
    "stats": {
      "total": "Werke gesamt",
      "withPrice": "Mit Kaufpreis",
      "computable": "Berechenbar",
      "missing": "Fehlende Daten"
    },
    "financial": {
      "purchaseTotal": "Gesamter Kaufwert",
      "updatedTotal": "Gesamter bereinigter Wert",
      "globalVariation": "Gesamtveränderung"
    },
    "missing": {
      "summary": "Bei {{count}} Werk fehlen Kaufpreis oder Erwerbsdatum; es wird von der Berechnung ausgeschlossen.",
      "summary_plural": "Bei {{count}} Werken fehlen Kaufpreis oder Erwerbsdatum; sie werden von der Berechnung ausgeschlossen.",
      "excelNotice": "Der Excel-Export enthält ein Blatt „Fehlende Daten“.",
      "hide": "In der Vorschau ausblenden",
      "show": "In der Vorschau anzeigen",
      "hidden": "({{count}} Zeilen mit fehlenden Daten ausgeblendet)",
      "noPrice": "Kaufpreis fehlt",
      "noDate": "Erwerbsdatum fehlt",
      "ipc": "VPI für diesen Zeitraum nicht verfügbar",
      "ipcBefore": "VPI für einen Erwerb vor 2010 nicht verfügbar"
    },
    "preview": "Berechnungsvorschau",
    "columns": {
      "inventory": "Inventar-Nr.",
      "artwork": "Werk",
      "date": "Erwerbsdatum",
      "purchasePrice": "Kaufpreis",
      "coefficient": "Koeff.",
      "updatedValue": "Bereinigter Wert",
      "variation": "+/−"
    },
    "untitled": "Ohne Titel",
    "formatTitle": "Berichtsformat",
    "formats": {
      "pdf": "Professionelles Layout",
      "word": "Bearbeitbare .docx-Datei",
      "excel": "3 Blätter: Berechnungen, fehlende Daten und Zusammenfassung"
    },
    "alerts": {
      "chooseFormat": "Wählen Sie mindestens ein Format.",
      "noIpc": "VPI-Daten sind nicht verfügbar.",
      "generation": "Fehler bei der Erstellung: {{message}}"
    },
    "generating": "Wird erstellt…",
    "downloadMultiple": "{{formats}} herunterladen",
    "downloadOne": "{{format}} herunterladen",
    "selectFormat": "Format auswählen",
    "noComputable": "Kein Werk verfügt über Kaufpreis und Erwerbsdatum.",
    "legal": "Dieser Bericht passt den Kaufpreis an die Entwicklung der Lebenshaltungskosten an (INSEE-VPI). Er bildet weder das Marktniveau des Künstlers noch den Verkehrswert des Werks ab. Er kann als Mindestwert für Erbschaft oder Versicherung dienen.",
    "referenceIndex": "Referenzindex: {{value}} – {{date}}.",
    "empty": "Keine Werke in dieser Sammlung.",
    "export": {
      "untitled": "Ohne Titel",
      "sheetRevaluation": "Anpassung",
      "sheetMissing": "Fehlende Daten",
      "sheetSummary": "Zusammenfassung",
      "headers": {
        "inventory": "Inventar-Nr.",
        "title": "Titel",
        "artist": "Künstler",
        "acquisitionDate": "Erwerbsdatum",
        "purchasePrice": "Kaufpreis (EUR)",
        "acquisitionIpc": "VPI beim Erwerb",
        "referenceIpc": "Referenz-VPI",
        "coefficient": "Koeffizient",
        "updatedValue": "Bereinigter Wert (EUR)",
        "variation": "Veränderung (%)",
        "missing": "Fehlende Angabe",
        "parameter": "Parameter",
        "value": "Wert"
      },
      "summary": {
        "collection": "Sammlung",
        "client": "Kunde",
        "reportDate": "Berichtsdatum",
        "referenceIpc": "Referenz-VPI",
        "totalArtworks": "Werke gesamt",
        "computedArtworks": "Berechnete Werke",
        "missingData": "Fehlende Daten",
        "totalPurchase": "Gesamter Kaufpreis (EUR)",
        "totalUpdated": "Gesamter bereinigter Wert (EUR)",
        "globalVariation": "Gesamtveränderung (%)",
        "indexSource": "Indexquelle",
        "legalReference": "Rechtsgrundlage",
        "indexSourceValue": "INSEE-Verbraucherpreisindex Frankreich ohne Tabak, Basis 100 (2015)",
        "legalValue": "Art. 761 französisches Steuergesetz – Erbschaft / Versicherung"
      },
      "coverTitle": "INFLATIONSBEREINIGTER ANSCHAFFUNGSWERT",
      "coverSubtitle": "Anpassung an die Lebenshaltungskosten – INSEE-VPI Basis 100 (2015)",
      "coverMethod": "Methode gemäß Art. 761 des französischen Steuergesetzes – Mindestwert für Erbschaft und Versicherung",
      "collection": "Sammlung: {{name}}",
      "client": "Kunde: {{name}}",
      "reportDate": "Berichtsdatum: {{date}}",
      "referenceIpc": "Referenz-VPI: {{value}} ({{date}})",
      "worksWithPrice": "WERKE MIT KAUFPREIS",
      "totalUpdated": "GESAMTER BEREINIGTER WERT",
      "averageCoefficient": "DURCHSCHNITTLICHER KOEFFIZIENT",
      "tableTitle": "ANPASSUNGSTABELLE",
      "computedCount": "{{count}} Werk berechnet – VPI {{date}}",
      "computedCount_plural": "{{count}} Werke berechnet – VPI {{date}}",
      "tableHeaders": {
        "inventory": "Inventar-Nr.",
        "titleArtist": "Titel / Künstler",
        "acquisition": "Erwerb",
        "purchase": "Kaufpreis",
        "coefficient": "Koeff.",
        "updated": "Bereinigter Wert",
        "variation": "+/−"
      },
      "total": "GESAMT",
      "missingTitle": "FEHLENDE DATEN FÜR DIE INFLATIONSBERECHNUNG",
      "missingIntro": "Diese Werke werden mangels Kaufpreis oder Erwerbsdatum nicht in die Berechnung einbezogen.",
      "exclusionReason": "Ausschlussgrund",
      "methodologyTitle": "METHODISCHER HINWEIS",
      "methodology": {
        "objectTitle": "GEGENSTAND DES BERICHTS",
        "object1": "Dieser Bericht stellt den Anschaffungswert jedes Werks dar, angepasst an die Entwicklung der Lebenshaltungskosten in Frankreich.",
        "object2": "Er ist weder eine Schätzung des Marktwerts noch ein Gutachten.",
        "indexTitle": "VERWENDETER INDEX",
        "index1": "Verbraucherpreisindex (VPI) – Frankreich ohne Tabak, Basis 100 im Jahr 2015.",
        "index2": "Quelle: INSEE, Reihe 001641683. Saisonbereinigte Daten. Zeitraum: 2000 bis heute.",
        "formulaTitle": "FORMEL",
        "formula1": "Bereinigter Wert = Kaufpreis × (VPI am Berichtsdatum / VPI im Erwerbsmonat)",
        "formula2": "Der Koeffizient wird mit 3 Dezimalstellen berechnet. Der Wert wird auf volle Euro gerundet.",
        "currenciesTitle": "FREMDWÄHRUNGEN",
        "currencies1": "Für Werke, die in einer anderen Währung als EUR erworben wurden, wird acquisition_price_eur verwendet, sofern vorhanden.",
        "currencies2": "Andernfalls wird das Werk vom Gesamtwert ausgeschlossen und die Umrechnung als nicht verfügbar ausgewiesen.",
        "useTitle": "VERWENDUNG",
        "use1": "Dieser Wert kann als Mindestwert für Erbschaft, Versicherung oder eine indikative Vermögensübersicht dienen.",
        "use2": "Er ersetzt kein Verkehrswertgutachten.",
        "privacyTitle": "VERTRAULICHKEIT",
        "privacy1": "Dieses Dokument ist streng vertraulich und wird ausschließlich auf Wunsch des genannten Kunden erstellt.",
        "privacy2": "Es darf ohne schriftliche Zustimmung von QUANG & CO nicht an Dritte weitergegeben werden.",
        "legalUseTitle": "RECHTLICHE VERWENDUNG",
        "legalUse1": "Mindestwert für Erbschaftserklärungen und Versicherungsverträge.",
        "legalUse2": "Er ersetzt kein Verkehrswertgutachten."
      },
      "established": "Erstellt am {{date}}",
      "worksWithAcquisition": "{{count}} Werk mit Kaufpreis",
      "worksWithAcquisition_plural": "{{count}} Werke mit Kaufpreis",
      "referenceShort": "Referenz-VPI: {{value}} – {{date}}",
      "priceMissing": "Preis fehlt",
      "dateMissing": "Datum fehlt",
      "ipcMissing": "VPI nicht verfügbar",
      "confidential": "Schätzungen dienen nur zur Orientierung. QUANG & CO – Vertraulich.",
      "excludedCount": "{{count}} Werk von der Berechnung ausgeschlossen",
      "excludedCount_plural": "{{count}} Werke von der Berechnung ausgeschlossen",
      "companyExpert": "QUANG & CO – Unabhängige Expertise für Kunstbewertungen",
      "companyArtAdvisory": "QUANG & CO – Kunstberatung"
    }
  },
  "expertReport": {
    "back": "Meine Sammlung",
    "title": "Gutachten",
    "subtitle": "CUP-Bericht und Excel-Arbeitsmappe erstellen — QUANG & CO",
    "collection": "Sammlung",
    "select": "Auswählen…",
    "clientName": "Name des Kunden (für den Bericht)",
    "clientPlaceholder": "Beispiel: Galerie RX",
    "loading": "Werke werden geladen…",
    "stats": {
      "total": "Werke gesamt",
      "valued": "Bewertet",
      "cupComplete": "Vollständige CUP-Blätter",
      "totalValue": "Gesamter Schätzwert"
    },
    "detected": {
      "title": "Erkannte Option:",
      "basedOn": "Basierend auf {{count}} vollständigem CUP-Blatt",
      "basedOn_plural": "Basierend auf {{count}} vollständigen CUP-Blättern"
    },
    "options": {
      "synthese": {
        "label": "Option 1 — Zusammenfassung",
        "short": "Option 1",
        "description": "Gesamtübersicht",
        "price": "2.000 € zzgl. MwSt."
      },
      "cup_60": {
        "label": "Option 2 — 60 CUP-Blätter",
        "short": "Option 2",
        "description": "Bis zu 60 CUP-Blätter",
        "price": "3.500 € zzgl. MwSt."
      },
      "cup_200": {
        "label": "Option 3 — 200 CUP-Blätter",
        "short": "Option 3",
        "description": "Alle CUP-Blätter",
        "price": "7.800 € zzgl. MwSt."
      }
    },
    "incomplete": "{{count}} Blatt hat unvollständige Vergleichswerte. Der PDF-Bericht enthält nur vollständige CUP-Blätter. Excel enthält alle Werke.",
    "incomplete_plural": "{{count}} Blätter haben unvollständige Vergleichswerte. Der PDF-Bericht enthält nur vollständige CUP-Blätter. Excel enthält alle Werke.",
    "reportMode": "PDF-Berichtsmodus",
    "formatTitle": "Berichtsformat",
    "formats": {
      "pdf": "Professionelles Layout",
      "word": "Bearbeitbare .docx-Datei"
    },
    "alerts": {
      "selectFormat": "Wählen Sie mindestens ein Format (PDF oder Word).",
      "generation": "Fehler bei der Berichtserstellung: {{message}}",
      "excel": "Fehler bei der Excel-Erstellung: {{message}}"
    },
    "actions": {
      "generating": "Wird erstellt…",
      "downloadBoth": "PDF + Word herunterladen",
      "downloadWord": "Word (.docx) herunterladen",
      "downloadPdf": "PDF-Bericht herunterladen",
      "excelGenerating": "Excel wird erstellt…",
      "downloadExcel": "Excel-Arbeitsmappe herunterladen"
    },
    "common": {
      "untitled": "Ohne Titel",
      "unattributed": "Nicht zugeschrieben",
      "yes": "Ja",
      "no": "Nein",
      "unknown": "Unbekannt",
      "notProvided": "Nicht angegeben"
    },
    "methods": {
      "direct": "Direkter CUP — Auktionsergebnisse des Künstlers",
      "analogy": "CUP durch Analogie — Künstler mit ähnlichem Profil",
      "points": "Punktemethode — strukturierter Primärmarkt"
    },
    "risks": {
      "low": "Geringes Risiko",
      "medium": "Mittleres Risiko",
      "high": "Hohes Risiko"
    },
    "conditions": {
      "excellent": "Ausgezeichnet",
      "very_good": "Sehr gut",
      "good": "Gut",
      "fair": "Mittel",
      "very_poor": "Sehr mäßig",
      "poor": "Schlecht",
      "damaged": "Beschädigt",
      "heavily_damaged": "Stark beschädigt (restaurierbar)",
      "partially_restorable": "Teilweise restaurierbar",
      "to_restore": "Zu restaurieren",
      "irreparable": "Nicht wiederherstellbar"
    },
    "documents": {
      "invoice": "Rechnung",
      "certificate": "Zertifikat",
      "condition": "Zustands- / Konservierungsbericht",
      "count": "{{count}} Dokument",
      "count_plural": "{{count}} Dokumente"
    },
    "export": {
      "filePrefix": "Gutachten",
      "sheets": {
        "recap": "Zusammenfassung",
        "comparables": "CUP-Vergleichswerte",
        "artists": "Künstlerübersicht"
      },
      "excel": {
        "inventory": "Inventar-Nr.",
        "title": "Titel",
        "artist": "Künstler",
        "year": "Jahr",
        "medium": "Technik",
        "dimensions": "Maße",
        "estimated": "Schätzwert (€)",
        "low": "Untere Spanne",
        "high": "Obere Spanne",
        "method": "Methode",
        "expertDate": "Gutachtendatum",
        "complete": "Vollständiges CUP-Blatt",
        "artworkTitle": "Werktitel",
        "comparableNo": "Vergleich Nr.",
        "auctionHouse": "Auktionshaus",
        "saleDate": "Verkaufsdatum",
        "soldArtwork": "Verkauftes Werk",
        "hammer": "Zuschlagspreis (€)",
        "adjustment": "Anpassung (%)",
        "note": "Anmerkung",
        "count": "Anzahl Werke",
        "total": "Gesamtwert (€)",
        "average": "Durchschnittswert (€)"
      },
      "coverTitle": "GUTACHTEN",
      "coverSubtitle": "Bewertung einer Kunstsammlung",
      "coverMethod": "CUP-Methode — gemäß IFRS 13 / BOFiP",
      "company": "QUANG & CO — Kunstberatung",
      "summaryByArtist": "Zusammenfassung nach Künstler",
      "stats": {
        "evaluated": "BEWERTETE WERKE",
        "totalValue": "GESAMTER SCHÄTZWERT",
        "estimatedSheets": "BEWERTUNGSBLÄTTER"
      },
      "methodologyTitle": "BEWERTUNGSMETHODIK",
      "methodologyBase": "Grundlage: IFRS 13 / BOFiP",
      "sections": {
        "method": "GEWÄHLTE METHODE",
        "ranges": "BEIBEHALTENE SPANNEN",
        "artistSales": "AUKTIONSERGEBNISSE DES KÜNSTLERS",
        "referenceSales": "ALS REFERENZ BERÜCKSICHTIGTE AUKTIONSERGEBNISSE",
        "expertNote": "EXPERTENHINWEIS",
        "marketValue": "VERKEHRSWERT NACH EXPERTENMEINUNG",
        "unknownCondition": "ZUSTAND: UNBEKANNT (durch Expertenmeinung zu präzisieren)",
        "documentation": "DOKUMENTATION",
        "analogArtists": "ANALOGE KÜNSTLER",
        "storage": "STANDORT & LAGERBEDINGUNGEN",
        "signature": "SIGNATUR & AUTHENTIZITÄT",
        "reference": "REFERENZVERKÄUFE",
        "writeoff": "IRREPARABLE WERKE — WERT NULL (WRITE-OFF)",
        "losses": "VERLUST / DIEBSTAHL / ZERSTÖRUNG / IRREPARABEL — WERT NULL",
        "sold": "VERKAUFTE / ÜBERTRAGENE WERKE — AUSSERHALB DER SAMMLUNG",
        "pending": "WERKE, DEREN BEWERTUNG AUSSTEHT"
      },
      "table": {
        "artworkArtist": "Werk / Künstler",
        "source": "Quelle",
        "hammer": "Zuschlag",
        "artwork": "Werk",
        "detail": "Detail",
        "inventory": "Inventar",
        "artist": "Künstler",
        "titleYear": "Titel / Jahr",
        "medium": "Technik",
        "dimensions": "Maße",
        "theoretical": "Theoretischer Wert",
        "condition": "Zustand",
        "auctionDate": "Haus / Datum",
        "price": "PREIS",
        "count": "Anz.",
        "totalValue": "Gesamtwert",
        "averageValue": "Durchschnittswert"
      },
      "disclaimer": "Bewertungen beruhen auf Expertenmeinung. Sie stellen kein Echtheitszertifikat dar. QUANG & CO — Vertraulich.",
      "pendingDisclaimer": "Diese Werke werden ergänzend bewertet. QUANG & CO — Vertraulich.",
      "soldDisclaimer": "Diese Werke haben die Sammlung verlassen und sind nicht in der Bewertung enthalten. QUANG & CO — Vertraulich.",
      "lossDisclaimer": "Diese Werke werden zur Erinnerung mit einem Wert von null erfasst. QUANG & CO — Vertraulich.",
      "methodologyIntro": "Der in diesem Bericht angesetzte Wert ist der Verkehrswert nach IFRS 13: der Preis, zu dem ein Vermögenswert unter normalen Marktbedingungen zwischen informierten und unabhängigen Parteien ausgetauscht werden könnte. Je nach Tiefe des Sekundärmarkts des Künstlers werden drei Methoden angewendet.",
      "groups": {
        "aTitle": "GRUPPE A — DIREKTER CUP (Comparable Uncontrolled Price)",
        "a1": "Anwendbar bei dokumentiertem Sekundärmarkt mit aktuellen Ergebnissen.",
        "a2": "Prinzip: Ableitung aus öffentlichen Auktionsergebnissen des Künstlers.",
        "a3": "Quelle: Artprice-Ergebnisse, nach Aktualität gewichtet.",
        "a4": "Zuverlässigkeit: hoch bei ausreichendem Transaktionsvolumen.",
        "bTitle": "GRUPPE B — CUP DURCH ANALOGIE",
        "b1": "Anwendbar, wenn der Sekundärmarkt unzureichend oder veraltet ist.",
        "b2": "Prinzip: Vergleich mit Künstlern ähnlichen Profils.",
        "b3": "Quelle: vom Experten ausgewählte Verkäufe analoger Künstler, gegebenenfalls mit Sicherheitsabschlag.",
        "b4": "Zuverlässigkeit: mittel, da die Auswahl der Analoga eine Experteneinschätzung ist.",
        "cTitle": "GRUPPE C — PUNKTEMETHODE (Primärmarkt)",
        "c1": "Anwendbar, wenn kein etablierter Sekundärmarkt besteht.",
        "c2": "Prinzip: Mehrkriterienraster nach Maßen und Technik.",
        "c3": "Zusatzfaktoren: institutionelle Anerkennung, Ausstellungen, Publikationen und Galerievertretung.",
        "c4": "Zuverlässigkeit: indikativ, den Primärmarkt abbildend."
      },
      "adjustmentsTitle": "ANPASSUNGSTABELLE (für alle Methoden)",
      "adjustmentHeaders": {
        "criterion": "Kriterium",
        "impact": "Auswirkung",
        "description": "Beschreibung"
      },
      "adjustments": {
        "excellent": "Ausgezeichnet / Sehr gut / Gut",
        "none": "Kein Abschlag",
        "fair": "Mittel",
        "fairDesc": "Nicht strukturelle Gebrauchsspuren oder Kratzer",
        "veryPoor": "Sehr mäßig",
        "veryPoorDesc": "Deutliche Verschlechterung; Restaurierung empfohlen",
        "restorable": "Stark beschädigt, aber restaurierbar",
        "restorableDesc": "Restaurierung erforderlich",
        "irreparable": "Nicht wiederherstellbar",
        "zero": "Wert null",
        "totalLoss": "Vollständige Wertminderung",
        "certificate": "Echtheitszertifikat",
        "artistProvenance": "Direkte Provenienz vom Künstler",
        "documentBonus": "Dokumentationsaufschlag"
      },
      "fairValueDisclaimer": "Die Bewertungen stellen den beizulegenden Zeitwert zum Berichtsdatum dar. Sie garantieren keinen Verkaufspreis.",
      "confidentialShort": "QUANG & CO — Vertraulich.",
      "present": "Vorhanden",
      "absent": "Nicht vorhanden",
      "writeoffSummary": "{{count}} Werk | Angesetzter Wert: 0 EUR",
      "writeoffSummary_plural": "{{count}} Werke | Angesetzter Wert: 0 EUR",
      "writeoffIntro": "Diese Werke wurden konservatorisch untersucht und als irreparabel beschädigt eingestuft. Ihr aktueller Marktwert wird mit 0 EUR angesetzt. Der theoretische Wert vor dem Schaden dient nur zur Information und kann ohne zertifizierte Restaurierung nicht verwendet werden.",
      "irreparable": "Nicht wiederherstellbar",
      "theoreticalDisclaimer": "Der theoretische Wert vor dem Schaden wird anhand des Marktes zum Gutachtendatum geschätzt und stellt keinen Versicherungswert dar. QUANG & CO — Vertraulich.",
      "zeroValueCount": "{{count}} Werk — Wert null",
      "zeroValueCount_plural": "{{count}} Werke — Wert null",
      "event": "Ereignis",
      "coverDescription": "Bewertung einer Kunstsammlung",
      "analogues": "Vergleichskünstler: {{names}}",
      "lossTypes": {
        "vol": "Diebstahl",
        "loss": "Verlust",
        "destruction": "Zerstörung",
        "fire": "Brand",
        "flood": "Überschwemmung",
        "other": "Sonstiges Ereignis"
      }
    },
    "narrative": {
      "method": "Gewählte Methode: {{method}}.",
      "pointsRange": "Nach Punkten geschätzter Wert (Segment {{segment}}): {{low}} - {{high}}.",
      "retainedRange": "Beibehaltene Spanne: {{low}} - {{high}}.",
      "retainedValue": "Beibehaltener Verkehrswert: {{value}}.",
      "groupC": "Gruppe C — strukturierter Primärmarkt. Keine Auktionsergebnisse berücksichtigt.",
      "referenceRange": "Referenzspanne: {{low}} - {{high}} je Werk.",
      "directSales": "Berücksichtigte direkte Künstlerverkäufe: {{count}} Auktionsergebnis(se).",
      "selectedSales": "Berücksichtigte Verkäufe: {{direct}} direkt, {{extrapolations}} Extrapolation(en), {{analogies}} Analogie(n).",
      "references": "Vom Experten berücksichtigte Referenzen:",
      "row": "{{index}}. {{kind}}: {{artist}}, „{{title}}“, {{source}}, angesetzt mit {{price}}{{weight}}.",
      "weight": ", Gewicht {{weight}}",
      "pendingSales": "Künstlerverkäufe werden in die Expertenwissensbasis aufgenommen.",
      "kinds": {
        "direct": "Direktverkauf",
        "extrapolation": "Extrapolation",
        "analogy": "Analogie"
      },
      "artistMissing": "Künstler nicht angegeben",
      "sourceMissing": "Quelle nicht angegeben",
      "priceMissing": "Preis nicht angegeben"
    }
  },
  "suiviIAPage": {
    "backToArtwork": "Zurück zum Kunstwerk"
  },
  "exportDossiers": {
    "loading": "Wird geladen…",
    "authRequired": {
      "title": "Anmeldung erforderlich",
      "text": "Melden Sie sich an, um professionelle Dossiers zu erstellen.",
      "login": "Anmelden"
    },
    "title": "Professionelles Dossier erstellen",
    "subtitle": "Erstellen Sie museumsreife PDF-Dossiers für Ihre Kunstwerke.",
    "defaults": {
      "collector": "Sammler",
      "collectionName": "Meine Sammlung",
      "collectionType": "Zeitgenössische Kunst",
      "collectionFocus": "Privatsammlung",
      "collectionHistory": "Eine mit Leidenschaft aufgebaute Sammlung.",
      "themeContemporary": "Zeitgenössische Kunst",
      "themePainting": "Malerei",
      "themeSculpture": "Skulptur"
    },
    "formats": {
      "donation": {
        "title": "Schenkungsdossier",
        "pages": "20 bis 30 Seiten",
        "description": "Dauerhafte Schenkung an ein Museum"
      },
      "loan": {
        "title": "Leihdossier",
        "pages": "12 bis 15 Seiten",
        "description": "Befristete Leihgabe für eine Ausstellung"
      },
      "book": {
        "title": "Sammlungsbuch",
        "pages": "40 bis 60 Seiten",
        "description": "Hochwertiges Katalogformat"
      }
    },
    "descriptions": {
      "donation": {
        "title": "Schenkungsdossier",
        "text": "Für das Angebot einer dauerhaften Schenkung an ein Museum. Enthält Historie, steuerliche Aspekte und einen vorgeschlagenen Zeitplan.",
        "features": {
          "history": "Sammlungshistorie",
          "tax": "Steuerliche Aspekte",
          "schedule": "Vorgeschlagener Zeitplan",
          "appendices": "Dokumentanhänge"
        }
      },
      "loan": {
        "title": "Leihdossier",
        "text": "Kompaktes Format für eine befristete Leihgabe oder Ausstellung mit Schwerpunkt auf Versicherung, Transport und Konservierung.",
        "features": {
          "insurance": "Versicherungsbedingungen",
          "transport": "Spezialtransport",
          "conservation": "Detaillierte Konservierung",
          "facility": "Facility Report"
        }
      },
      "book": {
        "title": "Sammlungsbuch",
        "text": "Hochwertiges Format für Einzelausstellung, Katalog oder Kunstbuch mit optionalem kritischem Essay und flexibler Gliederung.",
        "features": {
          "essay": "Kritischer Essay",
          "organisation": "4 Gliederungsarten",
          "index": "Detaillierter Index",
          "colophon": "Professionelles Kolophon"
        }
      }
    },
    "actions": {
      "selectAll": "Alle auswählen",
      "deselectAll": "✓ Auswahl aufheben"
    },
    "selection": {
      "count": "{{selected}} / {{total}} Kunstwerke ausgewählt"
    },
    "artworks": {
      "loading": "Kunstwerke werden geladen…",
      "empty": "Ihre Sammlung enthält keine Kunstwerke",
      "add": "Kunstwerke hinzufügen",
      "fallbackArtwork": "Kunstwerk",
      "noImage": "Kein Bild",
      "unknownArtist": "Unbekannter Künstler",
      "untitled": "Ohne Titel",
      "mediumUnknown": "Medium nicht angegeben"
    }
  },
  "resetPasswordPage": {
    "errors": {
      "send": "Die E-Mail zum Zurücksetzen konnte nicht gesendet werden"
    },
    "success": {
      "title": "E-Mail gesendet ✅",
      "messageBefore": "Ein Link zum Zurücksetzen wurde gesendet an",
      "messageAfter": "Prüfen Sie auch Ihren Spam-Ordner, falls die Nachricht nicht erscheint.",
      "portalNote": "Family Offices, Experten und Partner nutzen dasselbe Anmeldeportal."
    },
    "actions": {
      "backToLogin": "Zurück zur Anmeldung",
      "explorePlatform": "Plattform erkunden",
      "explore": "Erkunden",
      "exploreFirst": "Ich möchte zuerst die Plattform erkunden"
    },
    "imageAlt": "Artkiv-Hintergrund",
    "hero": {
      "line1": "Passwort vergessen? Das kann passieren.",
      "line2": "Wir senden Ihnen einen sicheren Link für den Neustart."
    },
    "mobileIntro": "Wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
    "form": {
      "title": "Passwort zurücksetzen",
      "descriptionLine1": "Geben Sie Ihre E-Mail-Adresse ein, um einen sicheren Link zu erhalten.",
      "descriptionLine2": "Ohne diesen Link wird nichts geändert.",
      "emailLabel": "E-Mail",
      "emailPlaceholder": "ihre@email.de",
      "emailHint": "Verwenden Sie die E-Mail-Adresse Ihres Artkiv-Kontos als Kunde, Experte, Family Office oder Partner.",
      "sending": "Wird gesendet…",
      "submit": "Link senden"
    },
    "footerHelp": "Keine Nachricht erhalten? Prüfen Sie den Spam-Ordner und versuchen Sie es erneut."
  },
  "ficheDetailPage": {
    "backToGuides": "Zurück zu den Praxisleitfäden",
    "notFoundTitle": "Leitfaden nicht gefunden",
    "steps": "Schritte",
    "usefulLinks": "Nützliche Links",
    "otherGuides": "Weitere nützliche Leitfäden",
    "comingSoon": "demnächst verfügbar"
  },
  "authRedirect": {
    "redirecting": "Weiterleitung…"
  },
  "paymentSuccessPage": {
    "serverError": "Serverfehler"
  },
  "artBaselService": {
    "countries": {
      "us": "Vereinigte Staaten",
      "uk": "Vereinigtes Königreich",
      "china": "China",
      "france": "Frankreich"
    },
    "sectors": {
      "postWarContemporary": "Nachkriegskunst & Gegenwartskunst",
      "modernArt": "Moderne Kunst",
      "impressionist": "Impressionismus",
      "oldMasters": "Alte Meister"
    },
    "sectorInsights": {
      "postWarContemporary": "Der Wert sank, während das Transaktionsvolumen stieg und der Markt breiter wurde.",
      "modernArt": "Chancen im mittleren Marktsegment bei schwächerer Aktivität im Hochpreissegment.",
      "impressionist": "Knappes Angebot und eine höhere Zahl von Transaktionen.",
      "oldMasters": "Niedrigster Stand seit fünfzehn Jahren und nur wenige Lose über 10 Mio. US-Dollar."
    },
    "priceInsights": {
      "under50k": "Das einzige Segment mit Wertwachstum.",
      "between50k1m": "Der mittlere Markt bleibt unter Druck.",
      "over1m": "Starker Rückgang im Premiumsegment.",
      "over10m": "Deutlicher Rückgang außergewöhnlicher Lose."
    },
    "adminRecommendations": {
      "accessible": "Für neue Sammler das Segment unter 50.000 US-Dollar priorisieren.",
      "midMarket": "Auf Chancen zwischen 50.000 und 1 Mio. US-Dollar mit möglichem Abschlag hinweisen.",
      "premiumCaution": "Bei Bewertungen über 1 Mio. US-Dollar in einem sehr selektiven Markt vorsichtig bleiben.",
      "accessibleContemporary": "Zugängliche Gegenwartskunst gegenüber etablierten Hochpreiswerken bevorzugen.",
      "democratization": "Einen Demokratisierungsfaktor in das Kompatibilitäts-Scoring aufnehmen."
    },
    "profile": {
      "emergingWorks": "Aufstrebende Werke empfohlen",
      "diversification": "Diversifizierung empfohlen"
    },
    "market": {
      "trendContemporary": "Trend der Gegenwartskunst 2025",
      "digitalGrowth": "Digitaler Markt wächst",
      "investmentRecommended": "Investition empfohlen"
    },
    "matching": {
      "styleCompatibility": "Stilistische Kompatibilität",
      "budgetAligned": "Budget passt",
      "suggestion1": "Vorschlag 1",
      "suggestion2": "Vorschlag 2"
    },
    "context": {
      "internationalFairs": "Präsenz auf internationalen Messen",
      "establishedGallery": "Vertretung durch eine etablierte Galerie",
      "collectorInterest": "Wachsendes Sammlerinteresse",
      "artBaselTrend": "Art-Basel-Markttrend 2025"
    },
    "gallery": {
      "international": "Internationale Galerie",
      "artBasel": "Vertretung auf der Art Basel"
    },
    "personalized": {
      "emergingCreative": "Werke aufstrebender Künstler mit hohem kreativem Potenzial",
      "classicProvenance": "Klassische Werke mit gesicherter Provenienz",
      "boldContemporary": "Mutige Investitionen in Gegenwartskunst",
      "safeValues": "Etablierte Werte des Kunstmarkts",
      "buyBeforeRise": "Kaufchance vor dem erwarteten Anstieg",
      "entryPoint": "Idealer Einstieg für den Aufbau Ihrer Sammlung"
    },
    "longTerm": {
      "diversification": "Schrittweise Diversifizierung der Sammlung",
      "trendMonitoring": "Beobachtung der Art-Basel-Trends",
      "sectorExpertise": "Aufbau von Sektorexpertise"
    },
    "marketTiming": {
      "favorable": "Günstiger Zeitpunkt für einen Erwerb",
      "observation": "Phase der Beobachtung und Auswahl"
    },
    "trends": {
      "digitalArtists": "Aufstrebende Digitalkünstler",
      "sculpturalPractices": "Neue skulpturale Praktiken",
      "conceptualArt": "Zeitgenössische Konzeptkunst"
    },
    "heirFactors": {
      "styleAligned": "Passender künstlerischer Stil",
      "historicalInterest": "Historisch interessante Epoche",
      "budgetCompatible": "Passendes Budget",
      "displaySpace": "Geeigneter Ausstellungsraum"
    },
    "heirRecommendations": {
      "recommended": "Kunstwerk für dieses Profil empfohlen",
      "appreciation": "Ausgezeichnetes Wertsteigerungspotenzial",
      "tasteAlignment": "Übereinstimmung mit den angegebenen Vorlieben"
    }
  },
  "conservationReport": {
    "loading": "Wird geladen…",
    "analyzing": "KI-Analyse läuft…",
    "confirmDeleteImage": "Dieses Bild löschen?",
    "fields": {
      "lastFullReport": "Letzter vollständiger Bericht",
      "lastInspection": "Letzte Sichtprüfung",
      "lastTransport": "Letzter Transport",
      "riskLevel": "Risikostufe",
      "nextInspection": "Nächste Prüfung",
      "nextFullReport": "Nächster vollständiger Bericht",
      "photographedZone": "Fotografierter Bereich",
      "addHdPhotos": "HD-Fotos hinzufügen",
      "recommendation": "KI-/Expertenempfehlung"
    },
    "risks": {
      "low": "Niedrig",
      "moderate": "Mittel",
      "high": "Hoch"
    },
    "zones": {
      "surface": "Oberfläche",
      "topLeft": "Obere linke Ecke",
      "topRight": "Obere rechte Ecke",
      "bottomLeft": "Untere linke Ecke",
      "bottomRight": "Untere rechte Ecke",
      "reverse": "Rückseite",
      "frame": "Rahmen",
      "other": "Sonstiges",
      "unknown": "Unbekannter Bereich"
    },
    "images": {
      "previewAlt": "Vorschau {{number}}",
      "existingAlt": "Ansicht {{number}}",
      "clickToDelete": "Zum Löschen anklicken"
    },
    "actions": {
      "back": "Zurück zum Werk",
      "saving": "Wird gespeichert…",
      "update": "Aktualisieren",
      "create": "Erstellen"
    },
    "alerts": {
      "saved": "Bericht erfolgreich gespeichert.",
      "saveError": "Der Bericht konnte nicht gespeichert werden."
    }
  },
  "philanthropyAdvisor": {
    "title": "Philanthropie & Mäzenatentum",
    "subtitle": "Strategieassistent für den aktiven Mandanten des Family Office",
    "noActiveClient": "Für dieses Family Office ist kein aktiver Mandant ausgewählt.",
    "regimes": {
      "frFlatTax": "Frankreich — Pauschalsteuer von 6,5 % ab 5.000 € je Veräußerung",
      "frCapitalGain": "Frankreich — 19 % Veräußerungsgewinnsteuer plus 17,2 %, mit 5 % Abschlag pro Jahr nach zwei Jahren",
      "ukCgt": "Vereinigtes Königreich — vereinfachte CGT von 20 %, indikativ",
      "dePrivate": "Deutschland — indikative Steuerfreiheit nach mehr als einem Jahr Privatbesitz",
      "none": "Nicht ausgewählt"
    },
    "levers": {
      "loan": {
        "title": "Leihgaben an Institutionen",
        "detail1": "Befristete Hinterlegung oder langfristiger Leihvertrag",
        "detail2Fr": "Kosten für Erhaltung, Versicherung oder Restaurierung können gegebenenfalls abzugsfähig sein; bitte prüfen",
        "detail2Other": "Kosten können je nach Land abzugsfähig sein",
        "detail3": "Sichtbarkeit und institutionelle Anerkennung der Sammlung"
      },
      "dation": {
        "title": "Sachleistung zur Steuerzahlung in Frankreich",
        "detail1": "Begleichung der Erbschaftsteuer mit Kunstwerken",
        "detail2": "Bewertung zum Marktwert ohne Veräußerungsgewinnbesteuerung in diesem Verfahren",
        "detail3": "Nur für außergewöhnliche Werke und vorbehaltlich behördlicher Genehmigung"
      },
      "foundation": {
        "title": "Unternehmensstiftung oder Treuhandstiftung",
        "detail1": "Dauerhafte Struktur zur Verwaltung der Sammlung",
        "detail2": "Steuerlicher Abzug von Zuwendungen je nach Rechtsordnung",
        "detail3": "Organisation von Ausstellungen und Museumsleihgaben"
      },
      "usufruct": {
        "title": "Schenkung mit Nießbrauch oder bloßem Eigentum in Frankreich",
        "detail1": "Die Nutzung des Werkes bleibt erhalten",
        "detail2": "Sofortige Steuerermäßigung auf Grundlage des Werts des bloßen Eigentums",
        "detail3": "Schrittweise Übertragung kann die Erbschaftsbesteuerung mindern"
      }
    },
    "alerts": {
      "createdNotStored": "Der Plan wurde erstellt, konnte aber wegen einer nicht verfügbaren Tabelle nicht archiviert werden.",
      "createdStored": "Der Plan wurde erstellt und archiviert.",
      "pdfError": "Das PDF konnte nicht erstellt werden."
    },
    "actions": {
      "exportPdfTitle": "Plan als PDF exportieren",
      "exportPdfShort": "PDF-Export",
      "exportPdf": "PDF exportieren",
      "saving": "Wird gespeichert…",
      "createPlan": "Plan erstellen"
    },
    "clientCard": {
      "client": "Mandant",
      "taxRegime": "Steuerregime",
      "taxCountry": "Steuerland: {{country}}"
    },
    "plan": {
      "title": "Mäzenatentumsplan — Zusammenfassung",
      "estimatedBenefit": "Geschätzter Steuervorteil, indikativ"
    },
    "eligibility": {
      "eligible": "Geeignet",
      "notApplicable": "Nicht anwendbar"
    },
    "beyondTax": {
      "title": "Vorteile über die Besteuerung hinaus",
      "legitimacy": {
        "title": "Anerkennung & Expertise",
        "point1": "Zusammenarbeit mit Kuratoren und Experten",
        "point2": "Wissenschaftliche Dokumentation und stärkere Provenienz"
      },
      "network": {
        "title": "Zugang & Netzwerk",
        "point1": "Private Einladungen und Ankaufskomitees",
        "point2": "Netzwerk von Direktoren, Kuratoren und Sammlern"
      },
      "value": {
        "title": "Vermögensbezogene Aufwertung",
        "point1": "Öffentliche Sichtbarkeit kann den Wiederverkaufswert stützen",
        "point2": "Kataloge und Ausstellungshistorie"
      },
      "transmission": {
        "title": "Übertragung & Schutz",
        "point1": "Klare Rechte und verbesserter Versicherungsschutz",
        "point2": "Nachverfolgbarkeit und AML/KYC-Dokumentation"
      }
    },
    "note": {
      "label": "Notiz des Family Office",
      "placeholder": "Wichtige Punkte, mögliche Partner, Zielinstitutionen…"
    },
    "disclaimer": {
      "title": "Hinweis.",
      "text": "Unverbindliche Schätzungen auf Grundlage der in Artkiv verfügbaren Informationen. Prüfen Sie die geltenden Regeln mit einer Steuerberatung oder einem Rechtsanwalt. Vorgaben und Schwellenwerte unterscheiden sich je nach Rechtsordnung."
    }
  },
  "expertNews": {
    "empty": "Keine geteilte Sammlung erkannt",
    "artistCount": "{{count}} Künstler in den Sammlungen Ihrer Mandanten",
    "more": "{{count}} weitere Künstler"
  },
  "notFound": {
    "title": "Seite nicht gefunden",
    "message": "Die angeforderte Ressource existiert nicht oder ist nicht zugänglich."
  },
  "blockchainShowcase": {
    "current": {
      "title": "ARTKIV digitaler Fingerabdruck",
      "subtitle": "Integritätsnachweis für die in einer Werkakte gespeicherten Daten.",
      "available": "Verfügbar",
      "coming": "Demnächst",
      "fingerprint": {
        "title": "SHA-256-Fingerabdruck",
        "description": "ARTKIV erstellt aus einem Snapshot der Werkdaten einen eindeutigen Hash."
      },
      "timestamp": {
        "title": "Zeitstempel",
        "description": "Das Erstellungsdatum des Fingerabdrucks wird mit dem Snapshot gespeichert."
      },
      "verify": {
        "title": "Integritätsprüfung",
        "description": "Ein übereinstimmender Fingerabdruck bestätigt, dass die Daten dem ARTKIV-Eintrag entsprechen."
      },
      "tezos": {
        "title": "Öffentliche Tezos-Verankerung",
        "description": "Künftiger Schritt: Nur den Hash auf Tezos veröffentlichen, ohne private Werkdaten offenzulegen."
      },
      "scope": {
        "title": "Was damit belegt wird",
        "text": "Der Fingerabdruck dokumentiert die Integrität eines Datenstands. Er bestimmt nicht die künstlerische Authentizität eines Werks."
      },
      "privacy": {
        "title": "Private Daten",
        "text": "Die Werkdaten bleiben in ARTKIV. Eine künftige öffentliche Verankerung würde nur den Hash enthalten."
      }
    },
    "title": "Blockchain & Sicherheit",
    "subtitle": "Schützen und verfolgen Sie Ihre Kunstwerke mit Blockchain-Technologie",
    "partnership": {
      "technology": "Blockchain-Technologie",
      "europe": "Europa"
    },
    "roles": {
      "standard": "Standard",
      "premium": "Premium",
      "artAdvisor": "Art Advisor",
      "artAdvisorPremium": "Art Advisor Premium",
      "familyOffice": "Family Office"
    },
    "features": {
      "certificate": {
        "title": "Blockchain-Zertifikat",
        "description": "Jedes Kunstwerk erhält ein einzigartiges, manipulationssicheres Blockchain-Zertifikat, das international überprüft werden kann."
      },
      "history": {
        "title": "Manipulationssichere Historie",
        "description": "Bewegungen und Transaktionen können dauerhaft und transparent dokumentiert werden. Demnächst verfügbar."
      },
      "smartContracts": {
        "title": "Smart Contracts für Leihe und Vermietung",
        "description": "Automatisieren Sie Leih- und Mietverträge mit der Sicherheit der Blockchain."
      },
      "explorer": {
        "title": "Export in den Blockchain-Explorer",
        "description": "Exportieren und prüfen Sie Ihre Daten direkt im Blockchain-Explorer."
      },
      "auditTrail": {
        "title": "Vollständiger Audit-Trail",
        "description": "Audit-Trail für alle Änderungen und Zugriffe auf Sammlungen. Demnächst verfügbar."
      },
      "kyc": {
        "title": "Automatisierte AML-KYC-Compliance",
        "description": "Automatisierte Compliance-Prüfung für bedeutende Transaktionen. Demnächst verfügbar."
      }
    },
    "status": {
      "available": "Verfügbar",
      "viewOnly": "Nur Ansicht",
      "upgrade": "Tarif hochstufen"
    },
    "info": {
      "why": {
        "title": "Warum Tezos?",
        "text": "Tezos ist eine Blockchain der neuen Generation, die von Akteuren des europäischen Kunstmarkts genutzt wird. Ihr Konsensmechanismus hält Energieverbrauch und Transaktionskosten niedrig. Authentizitäts- und Provenienznachweise lassen sich mit einem geringeren ökologischen Fußabdruck speichern."
      },
      "security": {
        "title": "Sicherheit & europäische Datensouveränität",
        "text": "Artkiv stützt sich auf europäische Infrastruktur, um DSGVO-Konformität und Datenkontrolle zu unterstützen. Zertifikate sind mit Zeitstempel versehen und überprüfbar, während sensible Informationen in der sicheren Artkiv-Datenbank bleiben. Nur der Authentizitätsnachweis wird in der Blockchain gespeichert."
      },
      "how": {
        "title": "Wie funktioniert es?",
        "text": "Bei der Zertifizierung eines Kunstwerks erzeugt Artkiv einen eindeutigen digitalen Fingerabdruck, einen SHA-256-Hash, des Zertifikats. Dieser wird dauerhaft in der Tezos-Blockchain gespeichert. So lässt sich das Zertifikat prüfen, ohne vertrauliche Angaben zum Werk oder Eigentümer offenzulegen."
      }
    },
    "upgrade": {
      "title": "Alle Blockchain-Funktionen freischalten",
      "text": "Wechseln Sie zu Family Office, um alle Blockchain-Sicherheitswerkzeuge zu nutzen.",
      "button": "Family Office entdecken"
    }
  },
  "blockchainDemo": {
    "selectorLabel": "Entdecken Sie die Blockchain-Funktionen der einzelnen Tarife:",
    "monthlyPrice": "{{price}} / Monat",
    "roles": {
      "standard": "Standard",
      "premium": "Premium",
      "artAdvisor": "Art Advisor",
      "artAdvisorPremium": "Art Advisor Premium",
      "familyOffice": "Family Office"
    },
    "footer": {
      "title": "Bereit, Ihre Sammlung mit Blockchain zu sichern?",
      "text": "Schließen Sie sich Sammlern und Art Advisors an, die Artkiv nutzen, um Kunstwerke durch europäische Blockchain-Zertifizierung zu schützen und aufzuwerten.",
      "startTrial": "Kostenlos testen",
      "scheduleDemo": "Demo vereinbaren"
    }
  },
  "validationRequests": {
    "loading": "Ihre Anfragen werden geladen…",
    "title": "Meine Validierungsanfragen",
    "count": "{{count}} Anfragen",
    "empty": "Sie haben noch keine Validierungsanfrage.",
    "createEstimation": "Schätzung erstellen",
    "status": {
      "pending": "Ausstehend",
      "inProgress": "In Bearbeitung",
      "completed": "Validiert",
      "rejected": "Abgelehnt"
    },
    "requestedOn": "Beantragt am",
    "method": {
      "label": "Methode",
      "points": "Punktemethode",
      "comparables": "Vergleichswerte"
    },
    "cost": "Kosten",
    "free": "Kostenlos",
    "expertNotes": "Anmerkungen des Experten",
    "rejectionReason": "Ablehnungsgrund",
    "downloadReport": "Bericht herunterladen",
    "processingDelay": "Ihre Anfrage wird bearbeitet. Geschätzte Dauer: 48 bis 72 Geschäftsstunden."
  },
  "artistAuctions": {
    "dateUnavailable": "Datum nicht verfügbar",
    "emptyArtists": {
      "title": "Keine Künstler in Ihrer Sammlung oder Beobachtungsliste",
      "text": "Fügen Sie Werke hinzu oder folgen Sie Künstlern, um entsprechende Auktionen zu sehen."
    },
    "followingCount": "{{count}} Künstler beobachtet",
    "noUpcoming": "Diesen Monat gibt es keine bevorstehenden Auktionen zu Ihren Künstlern.",
    "title": "Auktionen zu Ihren Künstlern",
    "summary": "{{artists}} Künstler beobachtet · {{auctions}} bevorstehende Auktionen",
    "collectionArtists": "Künstler in Ihrer Sammlung"
  },
  "artworkAccessHistory": {
    "title": "Verlauf der Ansichten und Änderungen des Werkdatensatzes durch Ihren Experten",
    "tabs": {
      "all": "Alle",
      "views": "Ansichten",
      "edits": "Änderungen"
    },
    "error": "Fehler: {{message}}",
    "empty": "Keine Ereignisse in diesem Tab.",
    "actions": {
      "edit": "Änderung",
      "view": "Ansicht"
    },
    "user": "Benutzer",
    "note": "Notiz: {{note}}",
    "source": "Quelle: {{source}}"
  },
  "successionEstimation": {
    "title": "Nachlassplanung",
    "subtitle": "Simulieren Sie die steuerlichen Auswirkungen einer Vermögensübertragung und planen Sie mögliche Gestaltungen. Das Werkzeug unterstützt Family Office und Notar bei der Vorbereitung nach Artikel 764 des französischen Steuergesetzbuchs.",
    "reportTitle": "Simulation der Nachlassplanung",
    "common": {
      "toDetermine": "Noch festzulegen"
    },
    "methods": {
      "publicAuction": "Öffentliche Auktion, Artikel 764 des französischen Steuergesetzbuchs",
      "insuranceUnder10Years": "Versicherungsvertrag unter zehn Jahren, Artikel 764",
      "furnitureFlatRate": "Pauschale von 5 % für Hausrat, Artikel 764",
      "marketValue": "Verkehrswert am Todestag auf Grundlage eines Gutachtens"
    },
    "alerts": {
      "selectArtwork": "Bitte wählen Sie ein Kunstwerk aus.",
      "notConnected": "Der Benutzer ist nicht angemeldet.",
      "reportError": "Der Bericht konnte nicht erstellt werden.",
      "saveError": "Die Simulation konnte nicht gespeichert werden.",
      "success": "Die Simulation wurde gespeichert und der Bericht erfolgreich erstellt."
    },
    "artworkSection": {
      "title": "Betroffenes Kunstwerk",
      "selectLabel": "Wählen Sie das zu analysierende Kunstwerk",
      "selectPlaceholder": "Kunstwerk auswählen",
      "artist": "Künstler",
      "medium": "Technik",
      "currentValue": "Aktueller Schätzwert",
      "lastEstimation": "Datum der letzten Schätzung"
    },
    "parameters": {
      "title": "Simulationsparameter",
      "noteTitle": "Hinweis:",
      "noteText": "Als Simulationsdatum ist standardmäßig der 31. Dezember des Vorjahres festgelegt, um vorausschauende Berechnungen ohne persönliche Folgen zu erleichtern.",
      "simulationDate": "Simulationsdatum",
      "artworkStatus": "Status des Kunstwerks",
      "furnitureHelp": "Ein in einer Wohnung aufgehängtes Gemälde kann als Hausrat gelten und unter die 5-%-Pauschale fallen.",
      "totalEstateValue": "Gesamtwert des Nachlasses",
      "totalEstatePlaceholder": "500000",
      "flatRateHelp": "Das Kunstwerk wird nach der Pauschalmethode mit 5 % dieses Gesamtwerts bewertet."
    },
    "status": {
      "identifiedCollection": "Identifizierte Sammlung",
      "furniture": "Hausrat / Dekoration"
    },
    "valuationMethods": {
      "title": "Steuerliche Bewertungsmethoden, Artikel 764",
      "auction": "Öffentliche Auktion innerhalb von fünf Jahren",
      "hammerPrice": "Zuschlagspreis",
      "hammerPricePlaceholder": "25000",
      "saleDate": "Auktionsdatum",
      "insurance": "Versicherungsvertrag unter zehn Jahren",
      "insuredValue": "Versicherungswert",
      "insuredValuePlaceholder": "30000",
      "contractDate": "Vertragsdatum",
      "expert": "Konsultierter Experte, optional",
      "expertPlaceholder": "Name des Auktionators oder Experten"
    },
    "notes": {
      "label": "Zusätzliche Notizen",
      "placeholder": "Kontext, Provenienz, Besonderheiten…"
    },
    "results": {
      "title": "Simulationsergebnisse",
      "fiscalValue": "Geschätzter Steuerwert",
      "inheritanceTax": "Erbschaftsteuer",
      "averageRate": "Durchschnittliche Schätzung mit 25 %",
      "dation": "Sachleistung zur Steuerzahlung",
      "recommended": "Empfohlen",
      "notNecessary": "Nicht erforderlich",
      "aboveThreshold": "Wert über 150.000 €",
      "belowThreshold": "Wert unter 150.000 €",
      "method": "Gewählte Bewertungsmethode",
      "dationRecommendation": "Empfehlung: Aufgrund des hohen Werts sollte eine Sachleistung zur Steuerzahlung geprüft werden, vorbehaltlich ministerieller Genehmigung und fachlicher Beratung."
    },
    "actions": {
      "back": "Zurück zu den Schätzungen",
      "saveAndGenerate": "Simulation speichern und Bericht erstellen"
    },
    "legal": {
      "title": "Hinweis:",
      "text": "Dieses Dokument ist eine unverbindliche Simulation der Nachlassplanung. Es ersetzt keine eingehende rechtliche und steuerliche Beratung durch Notar, Steueranwalt oder Auktionator. Sätze, Freibeträge und Regeln können sich ändern."
    },
    "pdf": {
      "title": "SIMULATION DER NACHLASSPLANUNG",
      "confidential": "Vertraulicher Bericht — Arbeitsdokument",
      "generatedOn": "Erstellt am: {{date}}",
      "sections": {
        "artwork": "1. BETROFFENES KUNSTWERK",
        "assumptions": "2. SIMULATIONSANNAHMEN",
        "fiscalValuation": "3. STEUERLICHE BEWERTUNG, ARTIKEL 764",
        "inheritanceTax": "4. GESCHÄTZTE ERBSCHAFTSTEUER",
        "recommendations": "5. EMPFEHLUNGEN"
      },
      "fields": {
        "title": "Titel: {{value}}",
        "artist": "Künstler: {{value}}",
        "medium": "Technik: {{value}}",
        "dimensions": "Maße: {{value}}",
        "simulationDate": "Simulationsdatum: {{date}}",
        "artworkStatus": "Status des Kunstwerks: {{value}}",
        "method": "Gewählte Methode: {{value}}",
        "fiscalValue": "Geschätzter Steuerwert: {{value}}",
        "estimatedTax": "Geschätzte Steuer bei durchschnittlichem Satz: {{value}}"
      },
      "taxNoteLine1": "Der tatsächliche Betrag hängt vom Verwandtschaftsverhältnis, den Freibeträgen und",
      "taxNoteLine2": "dem bei der Nachlassabwicklung geltenden progressiven Tarif ab.",
      "dation": {
        "title": "Sachleistung zur Steuerzahlung empfohlen",
        "line1": "Der Wert des Kunstwerks rechtfertigt die Prüfung einer Sachleistung für die Steuer.",
        "line2": "Unter bestimmten Bedingungen kann das Werk zur Begleichung der Erbschaftsteuer",
        "line3": "nach Genehmigung der zuständigen Behörden an den Staat übertragen werden."
      },
      "recommendations": {
        "expertise": "• Gutachten eines zugelassenen Auktionators oder Experten einholen",
        "documents": "• Vollständige Unterlagen zusammenstellen: Provenienz, Zertifikate und Zustand",
        "donation": "• Schenkung zu Lebzeiten mit Nießbrauchsvorbehalt prüfen",
        "notary": "• Notar mit Spezialisierung auf Kunstrecht konsultieren"
      },
      "disclaimerLine1": "Diese Simulation dient nur zur Information und ersetzt keine",
      "disclaimerLine2": "eingehende rechtliche und steuerliche Beratung durch Fachleute.",
      "footer": "Vertrauliches Dokument — Nur für internen Gebrauch",
      "page": "Seite {{current}}/{{total}}"
    }
  },
  "round36": {
    "actualitesModule": {
      "dateUnavailable": "Datum nicht verfügbar",
      "exhibitions": {
        "emptyDescription": "Ausstellungen mit Ihren Künstlern werden hier angezeigt.",
        "emptyTitle": "Keine kommenden Ausstellungen",
        "loadError": "Ausstellungen konnten nicht geladen werden.",
        "technicalError": "Technischer Fehler beim Laden der Ausstellungen."
      },
      "saleFallback": "Auktion",
      "view": "Ansehen"
    },
    "artistMarketRatio": {
      "actions": {
        "addToEstimation": "Zur Bewertung hinzufügen",
        "calculating": "Berechnung…",
        "loadSales": "Verkäufe laden",
        "saveRatio": "Verhältnis speichern"
      },
      "description": "Für Fälle mit wenigen direkten Vergleichswerten: Wählen Sie einen Referenzkünstler aus den validierten Analogien und bilden Sie zwei vergleichbare Verkaufskörbe.",
      "enoughData": "Ausreichende Stichproben zur Berechnung des Verhältnisses.",
      "errors": {
        "selectArtists": "Wählen Sie vor dem Laden der Verkäufe einen Referenz- und einen Zielkünstler.",
        "supabase": "Fehler beim Laden der Marktdaten."
      },
      "extrapolationComment": "ARTKIV-Extrapolation: {{price}} × Verhältnis {{ratio}} × Vorsicht {{caution}}. Verhältnis-ID: {{ratioId}}.",
      "fields": {
        "analogSource": "Analogien aus dem Künstler-Marktprofil vorgeschlagen.",
        "caution": "Vorsichtsfaktor",
        "chooseValidatedAnalog": "Validierte Analogie auswählen",
        "format": "Format",
        "mediumBucket": "Medienkategorie",
        "noAnalogPlaceholder": "Keine validierte Analogie",
        "otherArtist": "Anderer Künstler…",
        "periodEnd": "Zeitraum Ende",
        "periodStart": "Zeitraum Beginn",
        "pivotArtist": "Referenzkünstler",
        "pivotPlaceholder": "Name des Referenzkünstlers",
        "referencePlaceholder": "Preis des Referenzverkaufs",
        "referenceSale": "Referenzpreis des Vergleichskünstlers",
        "targetArtist": "Zielkünstler"
      },
      "match": "Übereinstimmung {{score}}/100",
      "medium": {
        "other": "Sonstiges",
        "painting": "Malerei",
        "print": "Druckgrafik / Edition",
        "sculptureObject": "Skulptur / Objekt",
        "workOnPaper": "Arbeit auf Papier"
      },
      "notEnoughData": "Wählen Sie in jedem Korb mindestens zwei Verkäufe aus.",
      "notSaved": "nicht gespeichert",
      "pendingEstimation": "Berechnen Sie das Verhältnis, um einen extrapolierten Wert zu erhalten.",
      "pivotMedian": "Referenzmedian: {{value}}",
      "ratioCaution": "Marktverhältnis: {{ratio}} · Vorsicht: {{caution}}",
      "result": "Extrapolierter Wert",
      "savedComment": "Verhältnis aus {{pivot}} Referenzverkäufen und {{target}} Zielverkäufen berechnet. Unverkaufte Lose ausgeschlossen.",
      "size": {
        "all": "Alle Formate",
        "large": "Großformat",
        "medium": "Mittelformat",
        "small": "Kleinformat"
      },
      "targetMedian": "Zielmedian: {{value}}",
      "title": "Extrapolation anhand eines Künstler-Marktverhältnisses",
      "unknownDate": "Datum unbekannt",
      "unknownDimensions": "Maße unbekannt",
      "unknownHouse": "Auktionshaus nicht angegeben",
      "unknownMedium": "Technik unbekannt",
      "untitled": "Ohne Titel"
    },
    "clientManagement": {
      "actions": {
        "cancel": "Abbrechen",
        "corporateReports": "Unternehmensberichte",
        "report": "Bericht",
        "requestAccess": "Kundenzugriff anfragen",
        "view": "Ansehen"
      },
      "cards": {
        "activeClients": "Aktive Kunden",
        "notYetOnArtkiv": "davon {{count}} noch nicht bei Artkiv",
        "pending": "Ausstehend",
        "trackedArtworks": "Betreute Kunstwerke"
      },
      "columns": {
        "actions": "Aktionen",
        "artworks": "Kunstwerke",
        "client": "Kunde",
        "collections": "Sammlungen",
        "status": "Status",
        "type": "Typ"
      },
      "confirm": {
        "cancelRequest": "Diese Anfrage abbrechen?"
      },
      "description": "Verwalten Sie Zugriffsanfragen und betreuen Sie Ihre Kunden.",
      "duplicate": {
        "accepted": "Sie haben bereits Zugriff auf diesen Kunden.",
        "pending": "Für diesen Kunden ist bereits eine Anfrage ausstehend."
      },
      "empty": "Keine Anfrage gesendet.",
      "errors": {
        "cancel": "Fehler beim Abbrechen",
        "invalidEmail": "Ungültige E-Mail-Adresse",
        "send": "Fehler beim Senden",
        "updateClientType": "Fehler beim Aktualisieren des Kundentyps"
      },
      "form": {
        "clientType": "Kundentyp *",
        "corporateDescription": "Unternehmen, Stiftung, Hotel oder Kanzlei, mit Prüfbericht",
        "description": "Ist der Kunde bereits bei Artkiv, erhält er sofort eine Benachrichtigung. Andernfalls wird er bei der Kontoerstellung informiert.",
        "email": "E-Mail des Kunden *",
        "emailPlaceholder": "kunde@beispiel.de",
        "message": "Nachricht (optional)",
        "messagePlaceholder": "Guten Tag, ich würde gerne auf Ihre Sammlungen zugreifen…",
        "privateDescription": "Privatsammler, Zugriff auf seine Sammlung",
        "send": "Anfrage senden",
        "sending": "Wird gesendet…",
        "title": "Zugriff auf einen Kunden anfragen"
      },
      "health": {
        "noPhoto": "{{count}} ohne Foto",
        "noValue": "{{count}} ohne Wert"
      },
      "loading": "Wird geladen…",
      "notOnArtkiv": "Noch nicht bei Artkiv",
      "note": {
        "add": "Notiz hinzufügen",
        "editTitle": "Zum Bearbeiten klicken",
        "placeholder": "Notiz zu diesem Kunden…",
        "saveError": "Fehler beim Speichern",
        "saved": "Notiz gespeichert"
      },
      "sections": {
        "corporate": "Unternehmenskunden",
        "counts": "{{active}} aktiv · {{pending}} ausstehend",
        "none": "Kein {{type}}er Kunde.",
        "private": "Privatkunden"
      },
      "status": {
        "accepted": "Angenommen",
        "cancelled": "Abgebrochen",
        "declined": "Abgelehnt",
        "expired": "Abgelaufen",
        "pending": "Ausstehend"
      },
      "success": {
        "cancelled": "Anfrage abgebrochen",
        "sentFuture": "Anfrage an {{email}} gesendet. Der Kunde wird benachrichtigt, sobald er Artkiv beitritt.",
        "sentKnown": "Anfrage an {{name}} gesendet."
      },
      "title": "Meine Kunden",
      "types": {
        "corporate": "Unternehmen",
        "corporateLower": "Unternehmen",
        "private": "Privatkunde",
        "privateLower": "privat"
      }
    },
    "collectionBreakdown": {
      "allCollections": "Alle Sammlungen",
      "artworkCount": "{{count}} Kunstwerk(e)",
      "byArtworkCount": "Verteilung nach Anzahl der Kunstwerke",
      "charts": {
        "medium": "Verteilung nach Medium",
        "period": "Verteilung nach Zeitraum",
        "top10Artists": "Top 10 Künstler",
        "top5Artists": "Top 5 Künstler",
        "type": "Verteilung nach Kunstart",
        "valueByCollection": "Wert nach Sammlung",
        "valueByLocation": "Wert nach Standort",
        "valueByMedium": "Wert nach Medium"
      },
      "collectionLabel": "Sammlung",
      "loadError": "Fehler beim Laden der Kunstwerke.",
      "loading": "Analysen werden geladen…",
      "modeAria": "Verteilungsmodus auswählen",
      "modes": {
        "collections": "Sammlungen",
        "locations": "Standorte"
      },
      "noArtworkAvailable": "Keine Kunstwerke verfügbar.",
      "noArtworkSelection": "Keine Kunstwerke für diese Auswahl.",
      "numberOfArtworks": "Anzahl der Kunstwerke",
      "periodUnknownNote": "{{count}} Werk(e) ohne erfasstes Entstehungsjahr (oben nicht dargestellt).",
      "periodUnknownLotNote": "Davon {{count}} in einem Los: Jahr des Loses angeben, um sie zu datieren.",
      "summary": "{{count}} Kunstwerk(e) · Gesamtwert {{value}}",
      "totalValue": "Gesamtwert",
      "unclassified": "Nicht klassifiziert",
      "unknownArtist": "Unbekannter Künstler",
      "unlocated": "Nicht lokalisiert",
      "untitled": "Ohne Titel"
    },
    "collectionDetail": {
      "actions": {
        "delete": "Löschen",
        "edit": "Bearbeiten",
        "editTitle": "Sammlung bearbeiten",
        "expert": "Experte",
        "expertise": "Expertise anfragen",
        "exportComplete": "Vollständiger Export (ZIP + Bilder)",
        "lot": "Los erstellen",
        "ocr": "Per OCR anreichern",
        "present": "Präsentation teilen",
        "report": "Bericht erstellen",
        "share": "Teilen"
      },
      "share": {
        "access": "Zugriff (Rechte)",
        "presentation": "Präsentation"
      },
      "sidebar": {
        "artworks": "Werke",
        "exports": "Exporte & Dossiers",
        "manage": "Verwaltung",
        "share": "Teilen & Präsentation",
        "viewPresentation": "Präsentation ansehen"
      },
      "authRequired": {
        "button": "Anmelden",
        "description": "Melden Sie sich an, um diese Sammlung anzusehen.",
        "title": "Anmeldung erforderlich"
      },
      "banners": {
        "deposit": {
          "complete": "Angaben zur Verwahrung ergänzen",
          "description": "Diese Kunstwerke gehören einem Dritten und sind nicht Teil Ihres Kunstvermögens.",
          "title": "Sammlung in Verwahrung"
        },
        "donation": {
          "clarify": "Rechtsstatus präzisieren",
          "description": "Diese Kunstwerke wurden durch Schenkung oder Vermächtnis erhalten. Ihr Rechtsstatus muss dokumentiert werden.",
          "title": "Schenkung oder Vermächtnis"
        },
        "foundationDeposit": {
          "complete": "Verwahrungsvereinbarung ergänzen",
          "description": "Die Stiftung verwahrt diese Kunstwerke im Auftrag eines institutionellen Dritten.",
          "title": "Institutionelle Verwahrung"
        },
        "foundationOwned": {
          "description": "Diese Kunstwerke gehören der Stiftung und werden in ihrer Vermögensbewertung berücksichtigt.",
          "title": "Eigentum der Stiftung"
        },
        "founderLoan": {
          "complete": "Angaben zum Leihgeber ergänzen",
          "description": "Diese Kunstwerke werden vom Gründer ohne Eigentumsübertragung zur Verfügung gestellt.",
          "title": "Gründerleihgabe"
        },
        "inalienable": {
          "clarify": "Rechtsstatus präzisieren",
          "description": "Der Wert ist indikativ; Veräußerungen unterliegen der geltenden Rechtsregelung.",
          "title": "Unveräußerliche Sammlung"
        }
      },
      "convention": "Vereinbarung: {{value}}",
      "legalStatus": {
        "a_clarifier": "Zu klären",
        "autre": "Andere Regelung",
        "dation": "Sachleistung an den Staat",
        "don_avec_reserve_usufruit": "Schenkung unter Nießbrauchsvorbehalt",
        "don_legs_inalienable": "Schenkung / Vermächtnis mit Unveräußerlichkeitsklausel",
        "etat_musees_de_france": "Französischer Staat, Musées de France",
        "fondation_abritee": "Treuhandstiftung",
        "pret_artiste_vivant": "Leihgabe eines lebenden Künstlers",
        "pret_institution": "Leihgabe einer Institution",
        "tresor_national": "Klassifiziertes nationales Kulturgut"
      },
      "lenderLabel": "Leihgeber",
      "loading": "Wird geladen…",
      "loadingCollection": "Sammlung wird geladen…",
      "loanValidUntil": "Leihgabe gültig bis {{date}}",
      "notFound": {
        "back": "Zurück zu den Sammlungen",
        "description": "Diese Sammlung existiert nicht oder Sie haben keinen Zugriff darauf.",
        "title": "Sammlung nicht gefunden"
      },
      "ownerLabel": "Eigentümer",
      "reference": "Referenz: {{value}}",
      "sharedWithYou": "Mit Ihnen geteilte Sammlung",
      "stats": {
        "artworks": "Kunstwerke",
        "estimatedValue": "Geschätzter Wert"
      },
      "translationUnavailable": "Übersetzung nicht verfügbar",
      "unnamedCollection": "Sammlung ohne Titel",
      "validUntil": "Gültig bis {{date}}"
    },
    "collectionEdit": {
      "imagePreviewAlt": "Sammlungsvorschau",
      "importCsvXlsx": "CSV-/XLSX-Datei importieren",
      "inventoryMissing": "Inventarreferenz nicht angegeben",
      "inventoryNumber": "Inventarreferenz: {{number}}"
    },
    "collectionTypeBadge": {
      "types": {
        "deposit": "In Verwahrung",
        "foundation_deposit": "Institutionelle Verwahrung",
        "foundation_donation": "Schenkung / Vermächtnis",
        "foundation_founder": "Gründerleihgabe",
        "foundation_owned": "Eigentum der Stiftung",
        "inalienable": "Unveräußerlich",
        "private": "Privat"
      }
    },
    "collectionTypeSelector": {
      "fields": {
        "conditions": "Besondere Bedingungen (optional)",
        "contractEnd": "Vertragsende",
        "contractReference": "Vertragsreferenz (optional)",
        "contractStart": "Vertragsbeginn",
        "conventionReference": "Referenz der Vereinbarung (optional)",
        "insuredBy": "Versicherung getragen von",
        "legalReference": "Aktenzeichen / Klassifizierungsnummer (optional)",
        "legalStatus": "Rechtsstatus",
        "ownerName": "Name des Eigentümers",
        "ownerType": "Eigentümertyp",
        "partyEnd": "Ende der Überlassung",
        "partyName": "Name des Dritten",
        "partyStart": "Beginn der Überlassung",
        "partyType": "Art des Dritten"
      },
      "hints": {
        "deposit": "Kunstwerke in Verwahrung werden nicht in Ihr Kunstvermögen eingerechnet.",
        "foundation": "Diese Angaben unterscheiden Werke im Eigentum der Stiftung von Werken, die für Dritte verwahrt werden.",
        "foundationDeposit": "Diese Kunstwerke bleiben Eigentum des angegebenen Dritten und werden nicht in den Vermögenswert der Stiftung einbezogen.",
        "foundationDonation": "Dokumentieren Sie Schenkungs- oder Vermächtnisklauseln, um Verwaltung und mögliche Einschränkungen abzusichern.",
        "inalienable": "Diese Kunstwerke werden mit dem Hinweis „indikativer Wert, nicht am Markt realisierbar“ angezeigt."
      },
      "insuredBy": {
        "foundation": "Die Stiftung",
        "owner": "Der Eigentümer",
        "shared": "Geteilt",
        "unspecified": "Noch anzugeben"
      },
      "label": "Sammlungstyp",
      "legalStatuses": {
        "a_clarifier": "Zu klären",
        "autre": "Andere Regelung",
        "dation": "Sachleistung an den Staat",
        "don_avec_reserve_usufruit": "Schenkung unter Nießbrauchsvorbehalt",
        "don_legs_inalienable": "Schenkung / Vermächtnis mit Unveräußerlichkeitsklausel",
        "etat_musees_de_france": "Französischer Staat, Musées de France",
        "fondation_abritee": "Treuhandstiftung",
        "pret_artiste_vivant": "Leihgabe eines lebenden Künstlers",
        "pret_institution": "Leihgabe einer Institution",
        "tresor_national": "Klassifiziertes nationales Kulturgut"
      },
      "ownerTypes": {
        "a_clarifier": "Zu klären",
        "family_succession": "Familie / Nachlass",
        "institution": "Institution (Museum, Stiftung)",
        "private_collector": "Privatsammler"
      },
      "panels": {
        "depositTitle": "Angaben zur Verwahrung",
        "foundationLegalTitle": "Rechtsstatus der Stiftung",
        "founderLender": "Angaben zum Leihgeber",
        "inalienableTitle": "Details zum Rechtsstatus",
        "realOwner": "Rechtlicher Eigentümer / Hinterleger"
      },
      "partyTypes": {
        "a_clarifier": "Zu klären",
        "artiste": "Künstler",
        "autre": "Sonstiges",
        "donateur_prive": "Spender / Familie",
        "etat": "Französischer Staat",
        "fondation": "Andere Stiftung",
        "institution": "Private Institution",
        "musee": "Öffentliches Museum"
      },
      "placeholders": {
        "conditions": "Versicherung, Einschränkungen, weitere Klauseln…",
        "contractReference": "z. B. Leihvertrag vom 15.03.2026",
        "conventionReference": "z. B. Vereinbarung Nr. 2026-04",
        "legalReference": "z. B. Akte Nr. 2018-345",
        "ownerName": "Name oder Firmenname",
        "partyName": "Name des Staates, Museums, der Institution oder des Spenders"
      },
      "types": {
        "deposit": {
          "description": "Von einem Dritten überlassene Werke. Nicht Teil des Vermögens, vertraglich geregelt.",
          "title": "Verwahrung"
        },
        "foundation_deposit": {
          "description": "Von der Stiftung verwahrte Werke. Eigentümer: Staat, Museum oder Institution.",
          "title": "Institutionelle Verwahrung"
        },
        "foundation_donation": {
          "description": "Durch Schenkung oder Vermächtnis erhaltene Werke. Sie können an Institutionen weitergegeben werden.",
          "title": "Schenkung / Vermächtnis"
        },
        "foundation_founder": {
          "description": "Persönliche Sammlung des Gründers, die der Stiftung zur Verfügung gestellt wird.",
          "title": "Gründerleihgabe"
        },
        "foundation_owned": {
          "description": "Von der Stiftung erworbene Werke. Aktive Bewertung und vollständige Verwaltung.",
          "title": "Eigentum der Stiftung"
        },
        "inalienable": {
          "description": "Geschützter Kulturgutstatus. Indikative Bewertung; Veräußerung genehmigungspflichtig.",
          "title": "Unveräußerliche Werke"
        },
        "private": {
          "description": "Volles Eigentum. Freie Verwaltung, Bewertung und Veräußerung erlaubt.",
          "title": "Privatsammlung"
        }
      }
    },
    "collectionsList": {
      "tabs": {
        "all": "Alle",
        "own": "Meine Sammlungen",
        "shared": "Kundensammlungen"
      },
      "transfer": {
        "button": "Sammlungen übertragen",
        "title": "Meine Sammlungen übertragen"
      }
    },
    "diagnosticImport": {
      "actions": {
        "analyzing": "Analyse läuft…",
        "fix": "Automatisch korrigieren",
        "fixing": "Korrektur läuft…",
        "run": "Diagnose starten",
        "technicalDetails": "Technische Details anzeigen"
      },
      "alerts": {
        "fixError": "Fehler bei der Korrektur: {{error}}",
        "fixSuccess": "Korrektur erfolgreich. {{count}} Kunstwerk(e) korrigiert. Aktualisieren Sie die Seite, um sie zu sehen.",
        "selectCollection": "Bitte wählen Sie zuerst eine Sammlung aus."
      },
      "checks": {
        "allArtworks": {
          "found": "Insgesamt {{count}} Kunstwerk(e) gefunden",
          "name": "Kunstwerke ohne client_id-Filter"
        },
        "clientId": {
          "name": "client_id-Analyse",
          "ok": "Alle client_id-Werte stimmen überein.",
          "problem": "Problem erkannt: {{count}} Kunstwerk(e) haben eine falsche client_id."
        },
        "collection": {
          "found": "Sammlung gefunden. Eigentümer: {{owner}}",
          "name": "Sammlung",
          "notFound": "Sammlung nicht gefunden: {{error}}"
        },
        "generalError": "Allgemeiner Fehler",
        "visibleArtworks": {
          "found": "{{count}} Kunstwerk(e) für Ihr Konto sichtbar",
          "name": "Kunstwerke mit client_id-Filter"
        }
      },
      "common": {
        "errorWithMessage": "Fehler: {{error}}",
        "none": "keine"
      },
      "confirm": {
        "fixClientIds": "ACHTUNG\n\nDiese Aktion ändert die client_id aller Kunstwerke dieser Sammlung.\n\nMöchten Sie fortfahren?"
      },
      "description": "Diese Diagnose prüft, warum importierte Kunstwerke nicht angezeigt werden, und kann sie automatisch korrigieren.",
      "labels": {
        "collectionId": "Sammlungs-ID",
        "count": "Anzahl: {{count}}",
        "userId": "Ihre ID"
      },
      "recommendations": {
        "allGood": "Alles funktioniert korrekt. Alle {{count}} Kunstwerk(e) sind sichtbar.",
        "causeLabel": "Ursache",
        "causeText": "Die client_id der importierten Kunstwerke stimmt nicht mit Ihrer Benutzer-ID überein.",
        "foundIds": "Gefundene ID(s)",
        "mixed": "Gemischte Situation. Prüfen Sie die Details oben.",
        "noArtwork": "In diese Sammlung wurde kein Kunstwerk importiert.",
        "partial": "Teilweise sichtbar: {{visible}}/{{total}} Kunstwerk(e).",
        "partialCause": "Einige Kunstwerke wurden wahrscheinlich mit einer falschen client_id importiert.",
        "problemDetected": "Problem erkannt: {{count}} Kunstwerk(e) sind in der Datenbank, aber keines ist sichtbar.",
        "title": "Empfehlungen",
        "toFix": "Zu korrigierende Kunstwerke",
        "useFixButton": "Verwenden Sie oben die Schaltfläche „Automatisch korrigieren“, um das Problem zu lösen.",
        "useFixButtonShort": "Verwenden Sie „Automatisch korrigieren“, um alle Kunstwerke zu korrigieren."
      },
      "title": "Importdiagnose"
    },
    "estimationSemblables": {
      "actions": {
        "addExternal": "Manuellen Vergleichswert hinzufügen",
        "remove": "Entfernen",
        "save": "Bewertung speichern"
      },
      "alerts": {
        "artworkUpdateError": "Der Bericht wurde erstellt, aber der Kunstwerkdatensatz konnte nicht aktualisiert werden.",
        "maxExternal": "Sie können höchstens fünf manuelle externe Vergleichswerte hinzufügen.",
        "saveError": "Fehler beim Speichern der Bewertung.",
        "saved": "Bewertung erfolgreich gespeichert.",
        "selectForVision": "Wählen Sie ein Kunstwerk und mindestens drei Vergleichswerte aus, bevor Sie Vision starten.",
        "uploadError": "Fehler beim Erstellen oder Hochladen des Berichts."
      },
      "averageLabel": "Geschätzter Durchschnitt",
      "clientContext": "Kunde: {{client}} · Rolle: {{role}} · Tarif: {{plan}}",
      "counts": "{{internal}} intern · {{imported}} importiert · {{manual}} manuell",
      "description": "Wählen Sie mindestens drei interne, importierte oder manuelle Vergleichswerte für die Bewertung aus.",
      "errors": {
        "notConnected": "Benutzer nicht angemeldet",
        "vision": "Vision-Fehler",
        "visionAnalysis": "Fehler bei der Vision-Analyse.",
        "visionNotConfigured": "Vision-API ist nicht konfiguriert."
      },
      "fields": {
        "artwork": "Zu bewertendes Kunstwerk",
        "selectArtwork": "Kunstwerk auswählen"
      },
      "global": "global",
      "importedHint": "Wählen Sie Ergebnisse aus, die tatsächlich mit dem untersuchten Kunstwerk vergleichbar sind.",
      "loadingImported": "Importierte Vergleichswerte werden geladen…",
      "minimumComparables": "Mindestens drei Vergleichswerte sind erforderlich.",
      "noDetails": "Keine Details",
      "noEstimatedValue": "Wert nicht angegeben",
      "noImported": "Keine importierten Vergleichswerte verfügbar.",
      "pdf": {
        "artwork": "Bewertetes Kunstwerk: {{title}}",
        "date": "Datum: {{date}}",
        "estimatedValue": "Geschätzter Wert: {{value}}",
        "externalComparables": "Manuelle externe Vergleichswerte:",
        "importedComparables": "Importierte Vergleichswerte:",
        "internalComparables": "Interne Vergleichswerte:",
        "title": "Bewertungsbericht, vergleichbare Kunstwerke",
        "visionConfidence": "Vision-Konfidenzwert: {{value}}",
        "visionReading": "Vision-Auswertung:",
        "visionValue": "Vision-Verfeinerung: {{value}}"
      },
      "placeholders": {
        "artist": "Künstler",
        "comment": "Kommentar",
        "dimensions": "Maße",
        "medium": "Technik",
        "source": "Quelle / Auktionshaus",
        "title": "Titel",
        "value": "Wert"
      },
      "sections": {
        "imported": "Importierte Vergleichswerte",
        "internal": "Interne Vergleichswerte",
        "manual": "Manuelle externe Vergleichswerte"
      },
      "title": "Bewertung anhand vergleichbarer Kunstwerke",
      "unknownArtist": "Unbekannter Künstler",
      "unknownArtwork": "Unbekanntes Kunstwerk",
      "unknownSource": "Unbekannte Quelle",
      "untitled": "Ohne Titel",
      "visibilityContext": "{{visibility}} · Kunde {{client}}",
      "vision": {
        "action": "Vision starten",
        "confidence": "Konfidenz: {{value}}",
        "loading": "Vision-Analyse…",
        "range": "Spanne: {{low}} bis {{high}}",
        "result": "Vision-Schätzung",
        "saveHint": "Der Vision-Wert wird beim Speichern übernommen.",
        "title": "Vision-Verfeinerung"
      }
    },
    "expertClientAccessStatus": {
      "checking": "Freigabestatus wird geprüft…",
      "pending": "Warten auf die Freigabe durch den Kunden",
      "readError": "Fehler beim Lesen der Berechtigungen",
      "shared": "Freigegeben",
      "sharedOn": "Freigegeben am {{date}}"
    },
    "messagesButton": {
      "label": "Nachrichten"
    },
    "museumLoanExport": {
      "actions": {
        "cancel": "Abbrechen",
        "generatePdf": "PDF erstellen",
        "generating": "Wird erstellt…"
      },
      "button": "Leihdossier ({{count}})",
      "errors": {
        "generation": "Das Leihdossier konnte nicht erstellt werden."
      },
      "fields": {
        "curatorText": "Kuratorischer Präsentationstext",
        "endDate": "Ausstellungsende",
        "exhibitionTheme": "Ausstellungsthema",
        "exhibitionTitle": "Ausstellungstitel",
        "installationDate": "Installationsdatum",
        "museumName": "Museum / Institution",
        "photographyAllowed": "Fotografieren erlaubt",
        "restitutionDate": "Rückgabedatum",
        "startDate": "Ausstellungsbeginn",
        "transportMethod": "Transportart"
      },
      "modal": {
        "title": "Leihdossier konfigurieren"
      },
      "pdf": {
        "acquiredFrom": "Erworben von {{source}}",
        "acquisitionToComplete": "Erwerbsangaben zu ergänzen",
        "annotationPlaceholder": "Anmerkungen / markierte Bereiche / Hinweise zur Konservierung",
        "annotationZones": "ANMERKUNGSFELDER",
        "arrivalMuseum": "Ankunft im Museum",
        "artist": "Künstler",
        "artworkConditionsSheet": "WERKBLATT {{current}}/{{total}}, BEDINGUNGEN",
        "artworkCount": "• Anzahl vorgeschlagener Kunstwerke: {{count}}",
        "artworkVisualSheet": "WERKBLATT {{current}}/{{total}}, ABBILDUNG",
        "authorized": "erlaubt",
        "collection": "Sammlung {{name}}",
        "conditionPlaceholder": "Sehr gut / Gut / Mittel",
        "conditionReport": "Detaillierter Zustandsbericht vor Abreise zu erstellen",
        "conditionSection": "ZUSTAND",
        "conditionToSpecify": "Zustand anzugeben",
        "contact": "Kontakt: {{value}}",
        "coverImagePlaceholder": "Titelbild",
        "coverTitle": "LEIHANGEBOT",
        "credit": "Bildnachweis",
        "currentPrivateCollection": "Derzeitige Privatsammlung",
        "deductibleBorrower": "Ein Selbstbehalt geht zulasten des Entleihers",
        "defaultCredit": "Mit freundlicher Genehmigung der Sammlung {{name}}",
        "defaultPresentation": "Für Ihre Ausstellung „{{title}}“ möchte ich die Leihgabe von {{count}} Kunstwerk(en) aus meiner Sammlung vorschlagen, die mit Ihrem kuratorischen Ansatz zu {{theme}} in Resonanz stehen. Diese Auswahl würde den Ausstellungsparcours bereichern und zusätzliche Perspektiven eröffnen.",
        "departureCollection": "Abgang aus der Sammlung",
        "exhibition": "Ausstellung: {{start}} bis {{end}}",
        "exhibitionPeriod": "• Ausstellungszeitraum: {{dates}}",
        "facilityReport": "FACILITY REPORT, MUSEUMSTEIL",
        "generalConditions": "ALLGEMEINE LEIHBEDINGUNGEN",
        "image": "Bild",
        "imagePlaceholder": "Bildplatzhalter",
        "installation": "Installation: {{date}}",
        "installationRestitution": "• Installation: {{installation}} | Rückgabe: {{restitution}}",
        "insuranceTotal": "• Gesamtversicherungswert: {{value}}",
        "keyInformation": "WICHTIGE ANGABEN",
        "lighting": "An das Medium angepasste Beleuchtung",
        "loanConditionsReference": "Die Leihgabe unterliegt den nachstehenden Bedingungen und der beigefügten Vereinbarung.",
        "loanDuration": "LEIHDAUER",
        "museum": "• Museum: {{name}}",
        "museumPacking": "Verpackung und Auspacken durch qualifiziertes Personal",
        "nailToNail": "Nagel-zu-Nagel-Versicherung auf Kosten des Entleihers",
        "noArtworkSelected": "Kein Kunstwerk ausgewählt.",
        "noDirectSun": "Kein direktes Sonnenlicht",
        "noThumbnails": "Keine Vorschaubilder verfügbar.",
        "notAuthorized": "nicht erlaubt",
        "observations": "Bemerkungen:",
        "phonePlaceholder": "Telefon:",
        "photographyCredit": "Bildnachweis: {{credit}}",
        "photographyPermission": "Fotografieren: {{status}}",
        "placeholders": {
          "contactDetails": "Name, Funktion, E-Mail, Telefon",
          "date": "[Datum]",
          "dates": "[Daten]",
          "endDate": "[Ende]",
          "exhibitionDates": "[Ausstellungsdaten]",
          "exhibitionName": "[Name der Ausstellung]",
          "ifApplicable": "[falls zutreffend]",
          "museumName": "[Name des Museums]",
          "name": "[Name]",
          "startDate": "[Beginn]",
          "theme": "[Thema]",
          "title": "[Titel]"
        },
        "presentation": "Präsentation",
        "proposedArtworks": "Vorgeschlagene Kunstwerke",
        "proposedThumbnails": "Vorgeschlagene Kunstwerke, Vorschaubilder",
        "provenance": "KURZPROVENIENZ",
        "referGeneralConditions": "Siehe beigefügte allgemeine Bedingungen.",
        "restitution": "Rückgabe: {{date}}",
        "roundTripConditionReport": "Zustandsbericht bei Abreise und Rückkehr",
        "secureDisplay": "Sichere Präsentation und Handhabung",
        "summaryNotes": "Zusammenfassung / Notizen",
        "temperature": "Stabile Temperatur und Luftfeuchtigkeit",
        "toCompleteByConservation": "Von der Restaurierungsabteilung auszufüllen",
        "toCompleteByMuseum": "Von der entleihenden Institution auszufüllen und zu unterzeichnen.",
        "unknownArtist": "Unbekannter Künstler",
        "unspecifiedDimensions": "Maße nicht angegeben",
        "unspecifiedMedium": "Technik nicht angegeben",
        "untitled": "Ohne Titel",
        "visitAvailability": "Verfügbarkeit für eine Vorbesichtigung: {{value}}",
        "visitAvailabilityPlaceholder": "Ja / Nein / Termine"
      },
      "placeholders": {
        "curatorText": "Beschreiben Sie die Auswahl und ihre Bedeutung für die Ausstellung…",
        "exhibitionTheme": "Thema oder kuratorisches Konzept",
        "exhibitionTitle": "Ausstellungstitel",
        "museumName": "Name des Museums oder der Institution",
        "photographyCredit": "Gewünschter Bildnachweis"
      },
      "transport": {
        "other": "Mit dem Museum festzulegen",
        "self": "Transport durch den Leihgeber",
        "specialized": "Spezialisierter Kunsttransport"
      }
    },
    "museumProposal": {
      "actions": {
        "add": "Hinzufügen",
        "addExhibition": "Ausstellung hinzufügen",
        "cancel": "Abbrechen",
        "continuePayment": "Weiter zur Zahlung",
        "delete": "Löschen",
        "downloadCompletePdf": "Vollständiges Dossier herunterladen",
        "downloadPdf": "PDF herunterladen",
        "generating": "Wird erstellt…",
        "generatingPdf": "PDF wird erstellt…",
        "preview": "Vorschau",
        "requestCancellation": "Stornierung anfragen",
        "sendProposal": "Vorschlag senden"
      },
      "cancellationPending": "Stornierung angefragt",
      "chooseArtwork": "Kunstwerk auswählen",
      "confirm": {
        "cancel": "Stornierung anfragen?",
        "delete": "Löschen bestätigen?"
      },
      "defaults": {
        "artistBio": "{{artist}} ist ein zeitgenössischer Künstler, der hauptsächlich mit {{medium}} arbeitet.",
        "artisticRelevance": "Dieses Werk ist Teil einer relevanten Praxis, die zeitgenössische Themen durch {{medium}} untersucht.",
        "artworkDescription": "{{title}} {{year}} {{medium}} stellt {{subject}} auf eine eigenständige und fesselnde Weise dar.",
        "subject": "ein Thema",
        "thisArtwork": "Dieses Werk",
        "thisTechnique": "diese Technik"
      },
      "emailHint": "Wird nur zur Vorbereitung Ihres eigenständigen Versands verwendet.",
      "errors": {
        "cancel": "Fehler bei der Stornierungsanfrage: {{error}}",
        "cancelGeneric": "Bei der Stornierungsanfrage ist ein Fehler aufgetreten.",
        "delete": "Fehler beim Löschen: {{error}}",
        "deleteGeneric": "Beim Löschen ist ein Fehler aufgetreten.",
        "exhibitionRequired": "Geben Sie mindestens Titel, Ort und Beginn der Ausstellung an.",
        "pdf": "Fehler beim Erstellen des PDF-Dossiers.",
        "selectArtwork": "Bitte wählen Sie ein Kunstwerk aus.",
        "selectArtworkFirst": "Wählen Sie zuerst ein Kunstwerk aus.",
        "submit": "Fehler beim Senden: {{error}}",
        "unknown": "Unbekannter Fehler"
      },
      "exhibition": {
        "fields": {
          "description": "Beschreibung",
          "endDate": "Ende",
          "location": "Stadt / Land",
          "startDate": "Beginn",
          "title": "Titel",
          "venue": "Ort / Institution"
        },
        "title": "Ausstellung hinzufügen"
      },
      "fields": {
        "artistBio": "Künstlerbiografie",
        "artwork": "Wählen Sie Ihr Kunstwerk",
        "artworkDescription": "Werkbeschreibung",
        "email": "E-Mail der Institution",
        "institution": "Zielinstitution",
        "presentationMessage": "Präsentationsnachricht",
        "previousExhibitions": "Frühere Ausstellungen",
        "relevance": "Künstlerische und kulturelle Relevanz"
      },
      "loadingArtworks": "Kunstwerke werden geladen…",
      "noArtwork": "Keine Kunstwerke verfügbar. Fügen Sie Ihrer Sammlung zunächst Kunstwerke hinzu.",
      "noExhibitions": "Keine Ausstellung angegeben.",
      "placeholders": {
        "artistBio": "Beschreiben Sie kurz Werdegang und Praxis des Künstlers…",
        "artworkDescription": "Beschreiben Sie das Werk, seine Technik und sein Thema…",
        "email": "kontakt@institution.org",
        "institution": "z. B. Museum of Modern Art, Centre Pompidou…",
        "presentationMessage": "Beschreiben Sie Ihren Ansatz und den Grund für diesen Vorschlag…",
        "relevance": "Erläutern Sie die Relevanz dieses Werks im heutigen künstlerischen und kulturellen Kontext…"
      },
      "preview": {
        "artworkAlt": "Vorgeschlagenes Kunstwerk",
        "exhibitionProposal": "Ausstellungsvorschlag",
        "fields": {
          "artist": "Künstler",
          "medium": "Technik",
          "title": "Titel",
          "year": "Jahr"
        },
        "hint": "Diese Vorschau zeigt die Angaben, die in das Dossier aufgenommen werden.",
        "noBiography": "Keine Biografie angegeben.",
        "noDescription": "Keine Beschreibung angegeben.",
        "noMessage": "Keine Präsentationsnachricht.",
        "noRelevance": "Keine Relevanzbegründung angegeben.",
        "notSpecified": "Nicht angegeben",
        "title": "Dossiervorschau",
        "unknownArtist": "Unbekannter Künstler",
        "untitled": "Ohne Titel"
      },
      "sections": {
        "artistArtwork": "Informationen zu Künstler und Werk",
        "details": "Details des Vorschlags",
        "previousProposals": "Frühere Vorschläge",
        "submissionMethod": "Versandart"
      },
      "self": {
        "description": "Laden Sie das Dossier herunter und senden Sie es selbst an die Institution.",
        "free": "Kostenlos",
        "manage": "Sie verwalten Korrespondenz und Nachfassaktionen",
        "ready": "Versandfertiges Dossier",
        "title": "Eigenständiger Versand"
      },
      "service": {
        "additionalFees": "Mögliche Zusatzkosten je nach Auftrag",
        "description": "Artkiv bereitet Ihren Vorschlag vor, prüft und verfolgt ihn.",
        "fixedFee": "Servicepauschale",
        "followUp": "Nachverfolgung des Vorschlags",
        "monthlyReport": "Monatlicher Bericht",
        "title": "Artkiv-Service"
      },
      "status": {
        "paid": "Bezahlt",
        "pending": "Ausstehend"
      },
      "title": "Ein Kunstwerk einem Museum oder einer Institution vorschlagen",
      "types": {
        "auction": "Auktion",
        "museum": "Museum / Institution"
      },
      "untitledArtwork": "Werk ohne Titel"
    },
    "pendingExpertAccess": {
      "acceptedOn": "Angenommen am {{date}}",
      "alerts": {
        "error": "Fehler: {{error}}",
        "shared": "Sammlungen wurden für den Experten freigegeben."
      },
      "description": "Diese Experten haben Ihre Einladung angenommen und warten darauf, dass Sie Ihre Sammlungen freigeben.",
      "expertFallback": "Experte",
      "loading": "Wird geladen…",
      "message": "Nachricht: {{message}}",
      "shareNow": "Jetzt freigeben",
      "sharing": "Wird geteilt…",
      "title": "{{count}} Experte(n) warten auf Freigabe"
    },
    "purchaseProposal": {
      "alerts": {
        "sent": "Ihr Kaufangebot wurde gesendet. Wir werden Sie in Kürze kontaktieren."
      },
      "errors": {
        "unavailable": "Kunstwerk nicht gefunden oder nicht verfügbar."
      },
      "fields": {
        "email": "Ihre E-Mail-Adresse",
        "message": "Nachricht / Angebot",
        "name": "Ihr Name",
        "placeholder": "Ich möchte ein Angebot in Höhe von … abgeben"
      },
      "loading": "Wird geladen…",
      "price": "Angezeigter Preis: € {{price}} (zzgl. Steuern und Gebühren)",
      "submit": "Mein Angebot senden",
      "summary": "Künstler: {{artist}} | Jahr: {{year}} | Technik: {{medium}}",
      "title": "Angebot für „{{title}}“ abgeben",
      "undefined": "Nicht angegeben",
      "warning": "Achtung:"
    },
    "saleModal": {
      "actions": {
        "cancel": "Abbrechen",
        "confirm": "Verkauf speichern",
        "saving": "Wird gespeichert…"
      },
      "errors": {
        "priceRequired": "Geben Sie einen gültigen Verkaufspreis ein.",
        "save": "Fehler beim Speichern des Verkaufs."
      },
      "fields": {
        "buyer": "Käufer",
        "buyerPlaceholder": "Name des Käufers",
        "notes": "Notizen",
        "notesPlaceholder": "Zusätzliche Informationen zum Verkauf",
        "saleDate": "Verkaufsdatum",
        "salePrice": "Verkaufspreis (€)"
      },
      "success": "Verkauf gespeichert.",
      "title": "Verkauf erfassen"
    }
  },
  "partnerBilling": {
    "title": "Partnerabrechnung — {{type}}",
    "partnerTypes": {
      "transport": "Transport",
      "insurance": "Versicherung"
    },
    "description": "Diese Rechnungen betreffen ARTKIV-Provisionen oder Gebühren im Zusammenhang mit Ihren Leistungen.",
    "invoiceFallback": "Rechnung",
    "issuedOn": "Ausgestellt am {{date}}",
    "dueOn": "Fällig am {{date}}",
    "noDueDate": "Ohne Fälligkeitsdatum",
    "pay": "Bezahlen",
    "empty": "Keine Rechnungen vorhanden.",
    "status": {
      "paid": "Bezahlt",
      "pending": "Ausstehend",
      "open": "Offen",
      "overdue": "Überfällig",
      "void": "Storniert",
      "draft": "Entwurf",
      "unknown": "Unbekannter Status"
    }
  },
  "estimationPointMethod": {
    "loading": "Wird geladen…",
    "title": "Bewertung nach der Punktmethode",
    "formula": "Moderne Formel: (Höhe + Breite) × Künstlerfaktor",
    "common": {
      "untitled": "Ohne Titel"
    },
    "errors": {
      "load": "Das Kunstwerk konnte nicht geladen werden: {{message}}",
      "requiredFields": "Bitte füllen Sie alle Pflichtfelder aus.",
      "depthRequired": "Bitte geben Sie bei einer Skulptur die Tiefe an."
    },
    "actions": {
      "backToEstimations": "Zurück zu den Bewertungen",
      "backToArtwork": "Zurück zum Kunstwerk",
      "calculate": "Bewertung berechnen",
      "requestValidation": "Expertenvalidierung anfragen"
    },
    "missingDimensions": {
      "title": "Fehlende Abmessungen",
      "description": "Für die Punktmethode müssen Höhe und Breite des Kunstwerks in Ihrer Sammlung erfasst sein.",
      "add": "Abmessungen hinzufügen"
    },
    "parameters": {
      "title": "Parameter",
      "artworkType": "Werktyp",
      "type2d": "Malerei / Zeichnung (2D)",
      "type3d": "Skulptur (3D)",
      "dimensions": "Abmessungen (cm)",
      "prefilled": "✓ Aus Ihrer Sammlung übernommen",
      "height": "Höhe",
      "width": "Breite",
      "depth": "Tiefe",
      "artistRating": "Künstlerfaktor"
    },
    "categories": {
      "young": {
        "label": "Junge Talente und Hochschulabsolventen",
        "description": "Erste Ausstellungen und noch geringe Markterfahrung"
      },
      "regional": {
        "label": "Etablierte regionale Künstler",
        "description": "Regionale Bekanntheit, regelmäßige Ausstellungen und Galerievertretung"
      },
      "national": {
        "label": "National anerkannte Künstler",
        "description": "Nationale Präsenz und gelegentliche Auktionsergebnisse"
      },
      "international": {
        "label": "Etablierte internationale Künstler",
        "description": "Präsenz in Sammlungen, Museen und renommierten Galerien"
      },
      "iconic": {
        "label": "Ikonen der Kunstgeschichte",
        "description": "Historische Bedeutung und hochrangige Verkäufe"
      }
    },
    "result": {
      "title": "Ergebnis",
      "empty": "Füllen Sie die Parameter aus und klicken Sie anschließend auf „Bewertung berechnen“.",
      "calculation": "Berechnung:",
      "indicativePrice": "Richtwert:",
      "range": "Spanne (±20 %):"
    },
    "validation": {
      "title": "💳 Validierungsservice",
      "standard": "• Standard: 10 Validierungen pro Monat inklusive, danach 150 € je Validierung",
      "premium": "• Premium: 50 Validierungen pro Monat inklusive, danach 150 € je Validierung",
      "responseTime": "Bearbeitungszeit: 48–72 Geschäftsstunden"
    }
  },
  "estimationSuccessionFiscal": {
    "title": "Erbschaftsteuerbericht",
    "subtitle": "Vorausschauende Steueranalyse für die Nachlassplanung",
    "common": {
      "unknownHeir": "Unbekannter Erbe",
      "untitled": "Ohne Titel"
    },
    "alerts": {
      "loadError": "Die Daten konnten nicht geladen werden: {{message}}",
      "selectPlan": "Wählen Sie einen Nachlassplan aus.",
      "uploadError": "Der PDF-Bericht konnte nicht hochgeladen werden.",
      "generated": "Erbschaftsteuerbericht wurde erstellt."
    },
    "reportTitle": "Erbschaftsteuerbericht – {{name}}",
    "plan": {
      "title": "Nachlassplan",
      "loading": "Pläne werden geladen…",
      "empty": "Es wurde kein Nachlassplan gefunden. Erstellen Sie zunächst im Dashboard einen Plan mit den Erben und der vorgesehenen Verteilung der Kunstwerke.",
      "choose": "— Plan auswählen —",
      "heirs": "Erben",
      "artworks": "Kunstwerke",
      "status": "Status"
    },
    "status": {
      "draft": "Entwurf",
      "pending": "Ausstehend",
      "active": "Aktiv",
      "completed": "Abgeschlossen",
      "archived": "Archiviert"
    },
    "heirTypes": {
      "child": "Kind",
      "daughter": "Tochter",
      "son": "Sohn",
      "spouse": "Ehepartner",
      "sibling": "Geschwister",
      "family": "Familie",
      "institution": "Institution",
      "other": "Sonstige"
    },
    "summary": {
      "title": "Steuerübersicht",
      "totalValue": "Gesamtwert",
      "inheritanceTax": "Erbschaftsteuer",
      "dation": "Sachleistung",
      "recommended": "✓ Empfohlen",
      "notNecessary": "Nicht erforderlich"
    },
    "distribution": {
      "title": "Verteilung nach Erben",
      "typeAndCount": "{{type}} · {{count}} Kunstwerk(e)",
      "taxes": "Steuer: {{value}}",
      "assignedWorks": "Nach Affinitätswert zugeteilte Kunstwerke",
      "moreWorks": "… und {{count}} weitere Kunstwerk(e)",
      "moreWorks_one": "… und 1 weiteres Kunstwerk",
      "moreWorks_other": "… und {{count}} weitere Kunstwerke"
    },
    "actions": {
      "back": "← Zurück",
      "generatePdf": "PDF-Bericht erstellen"
    },
    "difference": {
      "title": "⚠️ Wichtiger Unterschied",
      "validationTitle": "Artkiv-Validierung",
      "validationIntro": "Interne Prüfung durch unsere Experten. Geeignet für:",
      "personalCollection": "Verwaltung einer privaten Sammlung",
      "insuranceUnder": "Versicherung von Kunstwerken unter 80.000 €",
      "firstEvaluation": "Erste Bewertung vor einem Verkauf",
      "validationPrice": "Preis: je nach Tarif 10–50 Validierungen pro Monat, danach 150 € je Validierung",
      "cnesTitle": "CNES-Gutachten",
      "cnesIntro": "Physische Begutachtung durch einen anerkannten Experten. Erforderlich für:",
      "insuranceOver": "Versicherung von Kunstwerken über 80.000 €",
      "majorEstate": "Bedeutender Nachlass",
      "auction": "Auktionsverkauf",
      "bankGuarantee": "Bankgarantie oder Rechtsstreit",
      "cnesPrice": "Preis: ab 300 €, einschließlich Anfahrt und zertifiziertem Bericht",
      "contact": "💡 Artkiv kann Sie für hochwertige Kunstwerke oder rechtliche Anforderungen mit anerkannten CNES-Experten verbinden."
    },
    "pdf": {
      "title": "ERBSCHAFTSTEUERBERICHT",
      "plan": "Plan: {{name}}",
      "date": "Datum: {{date}}",
      "valuation": "BEWERTUNG",
      "totalValue": "Gesamtwert: {{value}}",
      "estimatedTaxes": "Geschätzte Steuer: {{value}}",
      "distribution": "VERTEILUNG NACH ERBEN",
      "receivedValue": "Erhaltener Wert: {{value}}",
      "taxes": "Steuer: {{value}}",
      "artworks": "Kunstwerke: {{count}}",
      "artworks_one": "Kunstwerk: 1",
      "artworks_other": "Kunstwerke: {{count}}"
    }
  },
  "autoCUPAssistant": {
    "header": {
      "eyebrow": "CUP-Assistent",
      "title": "Voranalyse importierter Vergleichswerke",
      "description": "Analysiert Artprice-Lose, liest die persönliche Künstlerbewertung des Experten und berücksichtigt Analogien der Gruppe B.",
      "premiumOnly": "Nur für Art Advisor Premium",
      "active": "Aktiv"
    },
    "loading": "Importierte Vergleichswerke werden geladen…",
    "errors": {
      "load": "Importierte Vergleichswerke konnten nicht geladen werden."
    },
    "methodGroups": {
      "directCup": "Gruppe A — Direkte CUP",
      "analogyCup": "Gruppe B — CUP durch Analogie",
      "pointMethod": "Gruppe C — Punktmethode",
      "directCupPrudent": "Vorsichtige direkte CUP",
      "analogyCupRatio": "Analoge CUP anhand eines Verhältnisses",
      "hybridPointsCup": "Hybrid aus Punkten + Vergleichswerken",
      "unknown": "Methode nicht angegeben"
    },
    "mediums": {
      "painting": "Malerei",
      "sculpture": "Skulptur",
      "photography": "Fotografie",
      "drawing": "Zeichnung",
      "print": "Druckgrafik",
      "mixed_media": "Mischtechnik",
      "installation": "Installation",
      "video": "Video",
      "textile": "Textil",
      "ceramic": "Keramik",
      "nft": "NFT / Digitale Kunst",
      "other": "Sonstiges",
      "oil_on_canvas": "Öl auf Leinwand",
      "acrylic_on_canvas": "Acryl auf Leinwand",
      "ink_on_paper": "Tusche auf Papier",
      "watercolor_on_paper": "Aquarell auf Papier",
      "pencil_on_paper": "Bleistift auf Papier",
      "charcoal_on_paper": "Kohle auf Papier",
      "mixed_media_on_paper": "Mischtechnik auf Papier"
    },
    "supports": {
      "oil_canvas": "Öl auf Leinwand",
      "acrylic_canvas": "Acryl auf Leinwand",
      "paper_mounted_canvas": "auf Leinwand kaschiertes Papier",
      "paper_work": "Arbeit auf Papier",
      "canvas": "Leinwand"
    },
    "exclusions": {
      "condition": "Irreparabler Zustand: von der Berechnung ausgeschlossen und als Kontext beibehalten.",
      "freshness": "Ergebnis älter als fünf Jahre oder uneinheitliches Datum: von der Berechnung ausgeschlossen und als Kontext beibehalten."
    },
    "marketSegments": {
      "primary": "Hauptsegment",
      "secondary": "Benachbartes Segment",
      "own_context": "Gleicher Künstler · entfernte Technik",
      "analog_same_segment": "Analogiewerk im selben Segment",
      "analog_context": "Kontextuelles Analogiewerk",
      "unclassified": "Nicht klassifiziertes Segment"
    },
    "minimum": {
      "groupA": "Mindestens 3 Vergleichswerke in Gruppe A",
      "groupB": "Mindestens 5 Referenzen in Gruppe B",
      "pointMethod": "Punktmethode"
    },
    "quote": {
      "loaded": "Persönliche Künstlerbewertung geladen",
      "date": "Datum: {{date}}",
      "analogies": "Analogien: {{names}}"
    },
    "empty": {
      "title": "Für diesen Künstler oder seine Analogien wurden keine importierten Vergleichswerke gefunden.",
      "description": "Importieren Sie Artprice-Datensätze. In Gruppe B sucht der Assistent auch nach den in der persönlichen Künstlerbewertung definierten Vergleichskünstlern.",
      "import": "Artprice-Datensätze importieren"
    },
    "metrics": {
      "comparables": "Vergleichswerke",
      "minimum": "{{current}}/{{minimum}} mindestens",
      "breakdown": "{{primary}} Hauptsegment · {{secondary}} benachbart · {{analog}} analog · {{sameSegment}} gleiches Segment",
      "calculationStatus": "Berechnungsstatus",
      "weightedMedian": "Gewichteter Median",
      "proposedRange": "Vorgeschlagene Spanne",
      "confidence": "Vertrauen"
    },
    "status": {
      "finalizable": "Finalisierbar",
      "provisional": "Vorläufig",
      "insufficient": "Unzureichend"
    },
    "notices": {
      "provisional": "Eine Vorabschätzung wurde aus {{count}} Referenz(en) berechnet. Die vollständige CUP-Validierung bleibt gesperrt, bis die fachliche Schwelle erreicht ist: {{minimum}}.",
      "insufficient": "Fügen Sie mindestens drei verwertbare Verkäufe hinzu, um eine Vorabschätzung anzuzeigen. {{minimum}} zur Finalisierung.",
      "marketStructure": "Die Technik strukturiert den Teilmarkt: Hauptsegment = gleicher Künstler und gleiche Technik, benachbartes Segment = gleicher Künstler und verwandte Technikfamilie, Analogien = Marktkontext. Analogien werden angezeigt, haben im Median jedoch nur ein geringes Gewicht."
    },
    "badges": {
      "analogyB": "Analogie B",
      "ownGroupB": "Eigenes Ergebnis · Gruppe B",
      "directGroupA": "Direkte Gruppe A"
    },
    "row": {
      "technique": "Technik",
      "supportDriver": "maßgeblicher Träger: {{support}}",
      "decision": "Entscheidung: Zustand {{condition}} · Abm. {{dimensions}} · Technik {{technique}} · Nähe {{proximity}} · Aktualität {{freshness}} · Gewicht {{weight}}",
      "afterDiscount": "Nach Abschlag: {{value}}",
      "estimateRange": "Schätzung {{low}} – {{high}}",
      "match": "Übereinstimmung {{score}}/100"
    },
    "analog": {
      "reasonFallback": "Künstlervergleich der Gruppe B"
    },
    "summary": {
      "analogDiscount": "Analogie Gruppe B, Abschlag {{discount}} %",
      "analog": "Analogie Gruppe B",
      "ownGroupB": "Eigenes Ergebnis · qualitative Expertenanpassung (Gruppe B)",
      "directGroupA": "Gruppe A — Direkte CUP"
    },
    "stock": {
      "eyebrow": "Vollständiger Künstlerbestand",
      "found": "{{count}} Auktionsergebnis(se) für {{artist}} gefunden",
      "found_one": "1 Auktionsergebnis für {{artist}} gefunden",
      "found_other": "{{count}} Auktionsergebnisse für {{artist}} gefunden",
      "auditHelp": "Die CUP basiert weiterhin auf den stärksten Vergleichswerken; dieser Bestand dient der Prüfung und Expertenauswahl.",
      "tabs": {
        "all": "Alle Auktionsergebnisse",
        "sameTechnique": "Gleiche Technik",
        "sameFamily": "Verwandte Technikfamilie",
        "priced": "Verkäufe mit Preis",
        "estimates": "Nur Schätzungen"
      },
      "empty": "Kein Auktionsergebnis in diesem Reiter.",
      "autoSelected": "automatisch von CUP ausgewählt",
      "addedToForm": "zum Formular hinzugefügt",
      "family": "Familie",
      "technique": "Technik",
      "supportDriver": "Maßgeblicher Träger: {{support}}",
      "priceUnpublished": "Preis nicht veröffentlicht",
      "alreadyAdded": "Bereits hinzugefügt",
      "addToForm": "Zum Formular hinzufügen"
    },
    "sources": {
      "artprice": "Artprice öffnen",
      "invaluable": "Invaluable öffnen",
      "artnet": "Artnet öffnen",
      "sothebys": "Sotheby’s öffnen",
      "christies": "Christie’s öffnen",
      "named": "Quelle {{name}} öffnen",
      "generic": "Quelle öffnen"
    },
    "suggestion": {
      "finalizable": "Finalisierbarer Vorschlag: die stärksten gewichteten Vergleichswerke anwenden.",
      "provisional": "Vorläufiger Vorschlag: Die Berechnung ist sichtbar, die endgültige Validierung muss jedoch mit den fehlenden Referenzen ergänzt werden.",
      "expertControl": "Der Experte behält die Kontrolle über den Abschlag der Gruppe B und die endgültige Anpassung.",
      "apply": "Vorschlag anwenden"
    },
    "locked": {
      "title": "Automatische Voranalyse ist Premium vorbehalten",
      "description": "Mit Art Advisor Standard erfasst der Experte seine Vergleichswerke manuell. Mit Art Advisor Premium liest ARTKIV Artprice-Importe und schlägt eine nutzbare CUP-Spanne vor."
    },
    "common": {
      "untitled": "Ohne Titel",
      "thisArtist": "diesen Künstler"
    }
  },
  "auctionProposalPage": {
    "title": "Kunstwerk einem Auktionshaus vorschlagen",
    "loading": "Kunstwerk wird geladen…",
    "artworkSection": {
      "title": "Angaben zum Kunstwerk"
    },
    "summary": {
      "title": "Titel",
      "artist": "Künstler",
      "year": "Jahr",
      "medium": "Technik",
      "dimensions": "Maße",
      "value": "Wert"
    },
    "fallbacks": {
      "untitled": "Ohne Titel",
      "untitledArtwork": "Kunstwerk ohne Titel",
      "unknownArtist": "Unbekannter Künstler",
      "notSpecifiedFeminine": "Nicht angegeben",
      "notSpecifiedMasculine": "Nicht angegeben",
      "notSpecifiedPlural": "Nicht angegeben",
      "artwork": "Kunstwerk",
      "artworkFile": "kunstwerk",
      "auctionHouseFile": "auktionshaus"
    },
    "form": {
      "title": "Angaben zum Vorschlag",
      "auctionHouse": "Auktionshaus",
      "auctionHousePlaceholder": "z. B. Christie’s, Sotheby’s, Drouot…",
      "message": "Vorstellungstext",
      "messagePlaceholder": "Weitere Angaben zum Kunstwerk, seiner Provenienz und seinem Zustand…",
      "email": "Ihre E-Mail-Adresse für den Bericht",
      "emailPlaceholder": "ihre@email.de",
      "emailHelp": "Wir senden den formatierten Bericht an diese Adresse."
    },
    "actions": {
      "preview": "Vorschau",
      "downloadPdf": "PDF herunterladen",
      "generating": "Wird erstellt…",
      "submit": "Vorschlag absenden",
      "closePreview": "Vorschau schließen",
      "generatingPdf": "PDF wird erstellt…",
      "downloadFullPdf": "Vollständiges PDF herunterladen"
    },
    "preview": {
      "title": "Vorschau des Vorschlags",
      "heading": "Vorschlag zur Einlieferung in eine Auktion"
    },
    "notFound": {
      "title": "Kunstwerk nicht gefunden",
      "description": "Das Kunstwerk wurde in der Datenbank nicht gefunden.",
      "back": "Zurück zum Dashboard"
    },
    "errors": {
      "loadArtwork": "Die Angaben zum Kunstwerk konnten nicht geladen werden.",
      "pdf": "Der PDF-Bericht konnte nicht erstellt werden.",
      "required": "Bitte füllen Sie alle Pflichtfelder aus.",
      "submit": "Der Vorschlag konnte nicht gesendet werden: {{message}}",
      "unknown": "Unbekannter Fehler"
    },
    "pdf": {
      "filePrefix": "auktionsvorschlag"
    }
  },
  "readiness": {
    "dimensions": {
      "identification": "Identifikation",
      "documentation": "Dokumentation",
      "provenance": "Authentizität / Provenienz",
      "valuation": "Aktuelle Bewertung",
      "insurance": "Versicherung",
      "conservation": "Erhaltungszustand dokumentiert",
      "property": "Eigentum geklärt",
      "transmission": "Nachfolge vorbereitet"
    },
    "actions": {
      "identification_one": "Identifikation für {{count}} Werk vervollständigen",
      "identification_other": "Identifikation für {{count}} Werke vervollständigen",
      "documentation_one": "Rechnung / Zertifikat für {{count}} Werk hinzufügen",
      "documentation_other": "Rechnung / Zertifikat für {{count}} Werke hinzufügen",
      "provenance_one": "Provenienz für {{count}} Werk dokumentieren",
      "provenance_other": "Provenienz für {{count}} Werke dokumentieren",
      "valuation_one": "Bewertung für {{count}} Werk aktualisieren",
      "valuation_other": "Bewertungen für {{count}} Werke aktualisieren",
      "insurance_one": "Versicherung für {{count}} Werk prüfen",
      "insurance_other": "Versicherung für {{count}} Werke prüfen",
      "conservation_one": "Erhaltungszustand für {{count}} Werk erfassen",
      "conservation_other": "Erhaltungszustand für {{count}} Werke erfassen",
      "property_one": "Eigentumsstatus für {{count}} Werk klären",
      "property_other": "Eigentumsstatus für {{count}} Werke klären",
      "transmission_one": "Nachfolge für {{count}} Werk vorbereiten",
      "transmission_other": "Nachfolge für {{count}} Werke vorbereiten",
      "generic_one": "{{count}} Werk",
      "generic_other": "{{count}} Werke"
    },
    "priority": {
      "high": "Hoch",
      "medium": "Mittel",
      "low": "Niedrig"
    },
    "cards": {
      "artwork": {
        "eyebrow": "Art Asset Readiness",
        "subtitle": "Vermögensbezogene Vorbereitung des Kunstwerks",
        "missingPrefix": "Zu vervollständigen:",
        "dossierTitle": "Strukturiertes Vermögensdossier erstellen (Identifikation, Eigentum, Bewertung, Markt, Risiko)",
        "dossierButton": "Vermögensdossier vorbereiten (PDF)"
      },
      "advisor": {
        "eyebrow": "Sammlungen im Mandat",
        "title": "Zu bearbeiten: Vermögensvorbereitung",
        "subtitle_one": "{{count}} Werk in Ihrem Mandatsbereich. Prioritäre Maßnahmen stehen unten.",
        "subtitle_other": "{{count}} Werke in Ihrem Mandatsbereich. Prioritäre Maßnahmen stehen unten.",
        "average": "Durchschnittliche Readiness",
        "exceptional_one": "⚠️ {{count}} außergewöhnliches Werk ohne Nachfolgeplanung.",
        "exceptional_other": "⚠️ {{count}} außergewöhnliche Werke ohne Nachfolgeplanung.",
        "allCovered": "Alle Readiness-Dimensionen sind in Ihrem Mandatsbereich abgedeckt."
      },
      "collection": {
        "eyebrow": "Vermögensstatus",
        "title": "Vorbereitung Ihrer Sammlung",
        "subtitle_one": "Was bereit ist und was Ihre Aufmerksamkeit erfordert, für {{count}} Werk.",
        "subtitle_other": "Was bereit ist und was Ihre Aufmerksamkeit erfordert, für {{count}} Werke.",
        "readinessLabel": "Collection Readiness",
        "exceptional_one": "⚠️ {{count}} außergewöhnliches Werk ohne Nachfolgeplanung.",
        "exceptional_other": "⚠️ {{count}} außergewöhnliche Werke ohne Nachfolgeplanung.",
        "actionsTitle": "So verbessern Sie Ihre Vorbereitung",
        "viewCollection": "Meine Sammlung ansehen →"
      },
      "portfolio": {
        "eyebrow": "Betreutes Kunstvermögen",
        "title": "Portfolio Readiness",
        "subtitle": "Vermögensvorbereitung nach Familie, mit strikter Datentrennung.",
        "consolidated": "Konsolidiert",
        "columns": {
          "family": "Familie",
          "artValue": "Kunstwert",
          "readiness": "Collection Readiness",
          "priority": "Priorität"
        }
      }
    }
  },
  "artAssetDossierPdf": {
    "common": {
      "yes": "Ja",
      "no": "Nein",
      "present": "Vorhanden",
      "missing": "Fehlend"
    },
    "header": {
      "eyebrow": "VERMÖGENSDOSSIER — ART ASSET DOSSIER",
      "untitled": "Werk ohne Titel",
      "completeness": "Vollständigkeit des Dossiers"
    },
    "ownership": {
      "full": "Volleigentum",
      "usufruct": "Nießbrauch",
      "bare_ownership": "Nacktes Eigentum"
    },
    "condition": {
      "excellent": "Ausgezeichnet",
      "very_good": "Sehr gut",
      "good": "Gut",
      "fair": "Mittel",
      "very_poor": "Sehr schlecht",
      "poor": "Schlecht",
      "heavily_damaged": "Stark beschädigt (restaurierbar)",
      "partially_restorable": "Teilweise restaurierbar",
      "irreparable": "Irreparabel"
    },
    "sections": {
      "identification": {
        "title": "Identifikation",
        "artist": "Künstler",
        "artworkTitle": "Titel",
        "year": "Jahr",
        "medium": "Medium",
        "dimensions": "Maße",
        "inventory": "Inventar-Nr."
      },
      "acquisition": {
        "title": "Eigentum & Erwerb",
        "owner": "Eigentümer",
        "ownershipStatus": "Eigentumsstatus",
        "date": "Erwerbsdatum",
        "source": "Quelle",
        "price": "Erwerbspreis",
        "documents": "Nachweise"
      },
      "authenticity": {
        "title": "Authentizität & Dokumentation",
        "invoice": "Rechnung",
        "certificate": "Echtheitszertifikat",
        "provenance": "Provenienz",
        "signature": "Signatur"
      },
      "valuation": {
        "title": "Bewertung",
        "currentValue": "Aktueller Wert",
        "range": "Untere / obere Schätzung",
        "method": "Methode",
        "comparables": "Vergleichswerke",
        "date": "Bewertungsdatum"
      },
      "market": {
        "title": "Markt (indikativ)",
        "liquidity": "Indikative Liquidität",
        "trend": "Trend",
        "demand": "Nachfrage"
      },
      "risk": {
        "title": "Physisches Risiko",
        "condition": "Erhaltungszustand",
        "lastInspection": "Letzte Prüfung",
        "storage": "Aufbewahrung",
        "insurance": "Versicherung",
        "insured": "Versichert",
        "uninsured": "Nicht versichert"
      }
    },
    "missing": {
      "title": "Fehlende Angaben für ein vollständiges Dossier"
    },
    "footer": {
      "disclaimer": "Dossier erstellt über ARTKIV am {{date}}. ARTKIV stellt strukturierte, nachvollziehbare und teilbare Daten bereit; Entscheidungen zu Finanzierung, Veräußerung oder Expertise bleiben menschlich und professionell. Marktindikatoren dienen nur zur Orientierung und unterliegen methodischen Hinweisen."
    },
    "file": {
      "prefix": "kunstvermoegensdossier",
      "untitledSlug": "kunstwerk"
    }
  },
  "familyOfficeReportPdf": {
    "header": {
      "eyebrow": "FAMILY OFFICE REPORT — KUNSTVERMÖGEN",
      "defaultName": "Family Office",
      "portfolioReadiness": "Portfolio Readiness"
    },
    "summary": {
      "supervisedFamilies": "Betreute Familien",
      "consolidatedArtValue": "Konsolidierter Kunstwert"
    },
    "families": {
      "title": "Readiness nach Familie",
      "columns": {
        "family": "Familie",
        "artValue": "Kunstwert",
        "readiness": "Collection Readiness",
        "priority": "Priorität"
      }
    },
    "attention": {
      "title": "Konsolidierte Aufmerksamkeitspunkte",
      "valuation": "Zu aktualisierende Bewertungen",
      "insurance": "Unterversicherte Werke",
      "documentation": "Zu vervollständigende Dokumentation",
      "provenance": "Zu vervollständigende Provenienz",
      "conservation": "Zu dokumentierender Erhaltungszustand",
      "exceptional": "Außergewöhnliche Werke ohne Nachfolgeplanung"
    },
    "footer": {
      "disclaimer": "Konsolidierter Bericht erstellt über ARTKIV am {{date}}. Zwischen den Familien gilt eine strikte Datentrennung; jede Familie behält die Kontrolle über ihre Daten. ARTKIV strukturiert die Vermögensdaten; Entscheidungen und Freigaben liegen bei den hierzu befugten Fachleuten."
    },
    "file": {
      "prefix": "family-office-report"
    }
  },
  "aiConsentInfoPage": {
    "backToProfile": "Zurück zu meinem Profil",
    "eyebrow": "Künstliche Intelligenz & Daten",
    "title": "Wie ARTKIV KI und die Daten Ihrer Kunstwerke verwendet",
    "intro": "Diese Seite erläutert die KI-Funktionen von ARTKIV, die dafür verwendbaren Daten, ihre Grenzen und die Entscheidungen, die jederzeit bei Ihnen bleiben.",
    "principle": {
      "title": "ARTKIV-Grundsatz",
      "body": "KI unterstützt Dokumentation, Analyse und die Vorbereitung von Entscheidungen. Sie soll nicht an Ihrer Stelle entscheiden. Die endgültige Freigabe bleibt bei Ihnen."
    },
    "access": {
      "title": "Zugang zu KI-Funktionen",
      "body": "Der Zugang zu KI-Modulen hängt von Ihrer ARTKIV-Rolle und Ihrem Tarif ab. Ist eine KI-Funktion in Ihrem Tarif enthalten, bleibt sie deaktiviert, bis Sie die KI auf Kontoebene aktivieren.",
      "standardTitle": "Konto ohne KI-Zugang",
      "standardBody": "Sie können Ihre Sammlung weiterhin manuell verwalten. Funktionen, die KI benötigen, bleiben nicht verfügbar, solange Ihr Tarif sie nicht umfasst.",
      "eligibleTitle": "KI-berechtigtes Konto",
      "eligibleBody": "Ihre Einwilligung erlaubt die Nutzung von KI-Funktionen, wenn Sie diese aktiv aufrufen. Sie startet keine automatische Analyse Ihrer gesamten Sammlung."
    },
    "purposes": {
      "title": "Wofür werden die KI-Module verwendet?",
      "visual": {
        "title": "Visuelle Analyse",
        "body": "Klassifikation, Stil, Schlagwörter oder beschreibende Elemente anhand von Werkbildern vorschlagen."
      },
      "documents": {
        "title": "Dokumente & OCR",
        "body": "Rechnungen, Zertifikate oder andere Dokumente lesen und Angaben für die Werkakte vorschlagen. Vorgeschlagene Daten müssen vor der Übernahme geprüft werden."
      },
      "conservation": {
        "title": "Konservierung",
        "body": "Zustandsbeobachtungen strukturieren, zu beobachtende Punkte erkennen und die Dokumentation vorbereiten. Diese Unterstützung ersetzt keine professionelle Zustandsprüfung."
      },
      "valuation": {
        "title": "KI-gestützte Bewertung",
        "body": "Werkdaten mit Vergleichswerten und verfügbaren Informationen verknüpfen, um Wertindikationen und Analysehinweise zu erstellen."
      }
    },
    "data": {
      "title": "Welche Daten können verarbeitet werden?",
      "intro": "Je nach verwendeter Funktion kann ARTKIV dem jeweiligen Modul nur die für die angeforderte Aufgabe erforderlichen Elemente übermitteln, darunter:",
      "items": {
        "images": "Werkbilder, die Sie zur Analyse auswählen;",
        "documents": "Dokumente, die Sie für OCR oder Dokumentenanalyse bereitstellen;",
        "metadata": "relevante Metadaten der Werkakte, etwa Künstler, Titel, Datum, Technik oder Maße;",
        "condition": "Zustandsbeobachtungen und Informationen, die für das jeweilige Konservierungsmodul erforderlich sind;",
        "valuation": "Bewertungsdaten, Vergleichswerte und Marktinformationen, die für Berechnung oder Analyse relevant sind;",
        "outputs": "von den Modulen erzeugte Ergebnisse, damit sie angezeigt, geprüft oder der Werkakte zugeordnet werden können."
      }
    },
    "control": {
      "title": "Sie behalten die Kontrolle",
      "items": {
        "onDemand": "Die Aktivierung des Kontos analysiert nicht automatisch jedes Werk. Eine KI-Funktion wird verwendet, wenn Sie die entsprechende Aktion starten.",
        "review": "KI-Ergebnisse sind Vorschläge, die Sie je nach Workflow prüfen, korrigieren, übernehmen oder ignorieren können.",
        "noSilentWrite": "Sensible Daten aus OCR oder KI-Vorschlägen sollen nicht ohne den in der Oberfläche vorgesehenen Prüfschritt still in fachliche Felder geschrieben werden.",
        "permissions": "Die Aktivierung der KI verändert weder bestehende Freigaberegeln noch Zugriffsrechte oder Berechtigungen Ihrer Sammlungen."
      }
    },
    "limits": {
      "title": "Was ARTKIV-KI nicht leistet",
      "items": {
        "indicative": "KI-Analysen und Bewertungen sind indikativ und können Fehler oder Unsicherheiten enthalten.",
        "noAuthentication": "Eine KI-Analyse ist für sich genommen keine Authentifizierung, kein Echtheitsnachweis und keine formelle Expertise.",
        "noProfessionalReplacement": "Sie ersetzt nicht die Beurteilung durch Experten, Restauratoren, Versicherer, Auktionatoren, Rechtsberater oder Notare, wenn eine professionelle Prüfung erforderlich ist.",
        "uncertainty": "Sind die verfügbaren Informationen unzureichend, widersprüchlich oder unsicher, muss das Ergebnis von einer Person geprüft und ergänzt werden."
      }
    },
    "statistics": {
      "title": "Aggregierte Statistiken: eine getrennte Entscheidung",
      "body": "Die Einwilligung in KI-Funktionen auf Kontoebene ist getrennt vom Opt-in eines Kunstwerks für anonymisierte aggregierte ARTKIV-Statistiken und Analysen. Die Aktivierung der KI aktiviert dieses Werk-Opt-in niemals automatisch. Es wird separat in der Werkakte verwaltet."
    },
    "consent": {
      "title": "Aktivierung und Widerruf",
      "body": "Wenn Ihr Tarif KI-Zugang umfasst, können Sie die Funktionen in Ihrem Profil aktivieren. ARTKIV speichert Ihre Entscheidung und deren Datum, damit die Zugangsregeln korrekt angewendet werden können.",
      "withdrawal": "Sie können Ihre Einwilligung über dieselbe Einstellung widerrufen. Der Widerruf blockiert neue KI-Verarbeitungen, die diese Einwilligung voraussetzen.",
      "afterWithdrawal": "Der Widerruf löscht nicht automatisch Daten, Dokumente oder Ergebnisse, die bereits in Ihrer ARTKIV-Akte gespeichert sind. Für deren Verwaltung gelten weiterhin die normalen Kontoregeln und verfügbaren Löschfunktionen."
    },
    "privacy": {
      "title": "Vertraulichkeit und Berechtigungen",
      "permissions": "Die Aktivierung der KI gewährt Dritten keine zusätzlichen Rechte und umgeht niemals bestehende ARTKIV-Berechtigungen.",
      "noPublicity": "Die Aktivierung von KI-Funktionen macht Ihre Sammlung nicht öffentlich und verwandelt keine private Werkakte in eine öffentliche.",
      "technicalDetails": "Technische Angaben, die sich ändern können, darunter Dienstleister, Hosting, Aufbewahrungsfristen oder mögliche Übermittlungen, sollten in der jeweils aktuellen ARTKIV-Datenschutzdokumentation beschrieben bleiben. Diese Seite beschreibt das Produktverhalten und ersetzt diese Dokumentation nicht."
    },
    "footer": {
      "title": "Meine Auswahl ändern",
      "body": "Die KI-Aktivierung bleibt in Ihrem Profil verfügbar. Enthält Ihr Tarif keine KI-Funktionen, bleiben Ihre Sammlungsdaten zugänglich und können weiterhin manuell verwaltet werden.",
      "cta": "Zurück zu den KI-Einstellungen"
    }
  }
};

export default de;
